var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var painelDeFases;
        (function (painelDeFases) {
            'use strict';
            /** @ngInject * */
            config.$inject = ["$translatePartialLoaderProvider", "$stateProvider", "msNavigationServiceProvider"];
            function config($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
                $translatePartialLoaderProvider.addPart('app/main/tarefas/painel-de-fases');
                var boardList = [{
                        id: 'processo-de-autuacao',
                        name: 'Processo De Autuacao'
                    }, {
                        id: 'recebimento-de-remessas',
                        name: 'Recebimento De Remessas'
                    }, {
                        id: 'distribuicao-de-processos',
                        name: 'Distribuicao De Processos'
                    }];
                $stateProvider.state('app.tarefas.painel-de-fases', {
                    url: '/painel-de-fases',
                    views: {
                        'content@app.autenticado': {
                            templateUrl: 'app/main/tarefas/painel-de-fases/painel-de-fases.html',
                            controller: painelDeFases.PainelDeFasesController,
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        boardList: function () {
                            return boardList;
                        }
                    }
                });
                msNavigationServiceProvider.saveItem('tarefas.painel-de-fases', {
                    title: 'Painel de Fases',
                    icon: 'icon-view-week',
                    state: 'app.tarefas.painel-de-fases',
                    translation: 'TAREFAS.PAINEL-DE-FASES.PAINEL-DE-FASES',
                    weight: 1
                });
                boardList.forEach(function (board) {
                    $stateProvider.state('app.tarefas.painel-de-fases.' + board.id, {
                        url: '/' + board.id,
                        views: {
                            'content@app.autenticado': {
                                templateUrl: 'app/main/tarefas/painel-de-fases/painel/painel.html',
                                controller: 'TarefasPainelDeFasesPainelController',
                                controllerAs: 'vm'
                            }
                        },
                        resolve: {
                            boardData: /** @ngInject **/ ["BoardService", function (/** @ngInject **/ BoardService) {
                                return BoardService.getBoardData(board.id);
                            }]
                        }
                    });
                    msNavigationServiceProvider.saveItem('tarefas.painel-de-fases.' + board.id, {
                        title: board.name,
                        icon: 'icon-trello',
                        state: 'app.tarefas.painel-de-fases.' + board.id,
                        translation: 'TAREFAS.PAINEL-DE-FASES.' + board.id.toUpperCase(),
                        weight: 1
                    });
                });
            }
            angular
                .module('app.tarefas.painel-de-fases', ['app.tarefas'])
                .config(config);
        })(painelDeFases = tarefas.painelDeFases || (tarefas.painelDeFases = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var painelDeFases;
        (function (painelDeFases) {
            var MembersMenuController = /** @class */ (function () {
                /** @ngInject **/
                MembersMenuController.$inject = ["$document", "$translate", "$mdDialog", "BoardService"];
                function MembersMenuController($document, $translate, $mdDialog, BoardService) {
                    this.$document = $document;
                    this.$translate = $translate;
                    this.$mdDialog = $mdDialog;
                    this.newMemberSearchInput = "";
                    this.board = BoardService.data;
                    this.newMemberSearchInput = "";
                }
                /**
                 * Add New Member
                 */
                MembersMenuController.prototype.addNewMember = function () {
                    // Add new member
                };
                /**
                 * Remove member
                 *
                 * @param ev
                 * @param memberId
                 */
                MembersMenuController.prototype.removeMember = function (ev, memberId) {
                    var _this = this;
                    var confirm = this.$mdDialog.confirm()
                        .title(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-MEMBRO"))
                        .parent(this.$document.find("#scrumboard"))
                        .textContent(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-MEMBRO-CONFIRMACAO"))
                        .ariaLabel(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-MEMBRO"))
                        .targetEvent(ev)
                        .clickOutsideToClose(true)
                        .escapeToClose(true)
                        .ok(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER"))
                        .cancel(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.CANCELAR"));
                    this.$mdDialog.show(confirm).then(function () {
                        var arr = _this.board.members;
                        arr.splice(arr.indexOf(arr.getById(memberId)), 1);
                        angular.forEach(_this.board.cards, function (card) {
                            if (card.idMembers && card.idMembers.indexOf(memberId) > -1) {
                                card.idMembers.splice(card.idMembers.indexOf(memberId), 1);
                            }
                        });
                    });
                };
                return MembersMenuController;
            }());
            angular
                .module("app.tarefas.painel-de-fases")
                .controller("app.tarefas.painel-de-fases.MembersMenuController", MembersMenuController);
        })(painelDeFases = tarefas.painelDeFases || (tarefas.painelDeFases = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var painelDeFases;
        (function (painelDeFases) {
            var LabelsMenuController = /** @class */ (function () {
                /** @ngInject **/
                LabelsMenuController.$inject = ["$document", "$translate", "$mdColorPalette", "$mdDialog", "fuseGenerator", "msUtils", "BoardService"];
                function LabelsMenuController($document, $translate, $mdColorPalette, $mdDialog, fuseGenerator, msUtils, BoardService) {
                    this.$document = $document;
                    this.$translate = $translate;
                    this.$mdDialog = $mdDialog;
                    this.msUtils = msUtils;
                    this.hue = 500;
                    this.newLabelColor = "red";
                    this.newLabelName = "";
                    this.board = BoardService.data;
                    this.palettes = $mdColorPalette;
                    this.rgba = fuseGenerator.rgba;
                }
                /**
                 * Add New Label
                 */
                LabelsMenuController.prototype.addNewLabel = function () {
                    this.board.labels.push({
                        id: this.msUtils.guidGenerator(),
                        name: this.newLabelName,
                        color: this.newLabelColor
                    });
                    this.newLabelName = "";
                };
                /**
                 * Remove label
                 *
                 * @param ev
                 * @param labelId
                 */
                LabelsMenuController.prototype.removeLabel = function (ev, labelId) {
                    var _this = this;
                    var confirm = this.$mdDialog.confirm()
                        .title(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-ROTULO"))
                        .parent(this.$document.find("#scrumboard"))
                        .textContent(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-ROTULO-CONFIRMACAO"))
                        .ariaLabel(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-ROTULO"))
                        .targetEvent(ev)
                        .clickOutsideToClose(true)
                        .escapeToClose(true)
                        .ok(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER"))
                        .cancel(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.CANCELAR"));
                    this.$mdDialog.show(confirm).then(function () {
                        var arr = _this.board.labels;
                        arr.splice(arr.indexOf(arr.getById(labelId)), 1);
                        angular.forEach(_this.board.cards, function (card) {
                            if (card.idLabels && card.idLabels.indexOf(labelId) > -1) {
                                card.idLabels.splice(card.idLabels.indexOf(labelId), 1);
                            }
                        });
                    });
                };
                return LabelsMenuController;
            }());
            angular
                .module("app.tarefas.painel-de-fases")
                .controller("app.tarefas.painel-de-fases.LabelsMenuController", LabelsMenuController);
        })(painelDeFases = tarefas.painelDeFases || (tarefas.painelDeFases = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var painelDeFases;
        (function (painelDeFases) {
            var ColorMenuController = /** @class */ (function () {
                /** @ngInject **/
                ColorMenuController.$inject = ["$mdColorPalette", "BoardService"];
                function ColorMenuController($mdColorPalette, BoardService) {
                    this.board = BoardService.data;
                    this.palettes = $mdColorPalette;
                }
                return ColorMenuController;
            }());
            angular
                .module("app.tarefas.painel-de-fases")
                .controller("app.tarefas.painel-de-fases.ColorMenuController", ColorMenuController);
        })(painelDeFases = tarefas.painelDeFases || (tarefas.painelDeFases = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var painelDeFases;
        (function (painelDeFases) {
            var SettingsSidenavController = /** @class */ (function () {
                /** @ngInject **/
                SettingsSidenavController.$inject = ["$mdColorPalette", "BoardService"];
                function SettingsSidenavController($mdColorPalette, BoardService) {
                    this.selectedMenu = "CONFIGURACOES";
                    this.board = BoardService.data;
                    this.palettes = $mdColorPalette;
                }
                return SettingsSidenavController;
            }());
            angular
                .module("app.tarefas.painel-de-fases")
                .controller("app.tarefas.painel-de-fases.SettingsSidenavController", SettingsSidenavController);
        })(painelDeFases = tarefas.painelDeFases || (tarefas.painelDeFases = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var painelDeFases;
        (function (painelDeFases) {
            var FiltersSidenavController = /** @class */ (function () {
                /** @ngInject **/
                FiltersSidenavController.$inject = ["msUtils", "BoardService", "CardFilters"];
                function FiltersSidenavController(msUtils, BoardService, CardFilters) {
                    //Data
                    this.board = BoardService.data;
                    this.cardFilters = CardFilters;
                    this.labels = this.board.labels;
                    this.members = this.board.members;
                    this.selectedMenu = "Settings";
                    // Methods
                    this.exists = msUtils.exists;
                    this.toggleInArray = msUtils.toggleInArray;
                    this.clearFilters = CardFilters.clear;
                    this.filteringIsOn = CardFilters.isOn;
                }
                return FiltersSidenavController;
            }());
            angular
                .module("app.tarefas.painel-de-fases")
                .controller("app.tarefas.painel-de-fases.FiltersSidenavController", FiltersSidenavController);
        })(painelDeFases = tarefas.painelDeFases || (tarefas.painelDeFases = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var painelDeFases;
        (function (painelDeFases) {
            var ScrumboardCardDialogController = /** @class */ (function () {
                /** @ngInject **/
                ScrumboardCardDialogController.$inject = ["$document", "$mdDialog", "fuseTheming", "fuseGenerator", "msUtils", "$translate", "BoardService", "cardId"];
                function ScrumboardCardDialogController($document, $mdDialog, fuseTheming, fuseGenerator, msUtils, $translate, BoardService, cardId) {
                    this.$document = $document;
                    this.$mdDialog = $mdDialog;
                    this.fuseTheming = fuseTheming;
                    this.fuseGenerator = fuseGenerator;
                    this.msUtils = msUtils;
                    this.$translate = $translate;
                    //Data
                    this.board = BoardService.data;
                    this.card = this.board.cards.getById(cardId);
                    this.newLabelColor = "red";
                    this.members = this.board.members;
                    this.labels = this.board.labels;
                    // Methods
                    this.palettes = this.fuseTheming.getRegisteredPalettes();
                    this.rgba = this.fuseGenerator.rgba;
                    this.toggleInArray = this.msUtils.toggleInArray;
                    this.exists = this.msUtils.exists;
                    // Convert due date to the date object
                    if (this.card.due) {
                        this.card.due = new Date(this.card.due);
                    }
                }
                /**
                 * Close Dialog
                 */
                ScrumboardCardDialogController.prototype.closeDialog = function () {
                    this.$mdDialog.hide();
                };
                /**
                 * Get Card List
                 */
                ScrumboardCardDialogController.prototype.getCardList = function () {
                    var response;
                    for (var i = 0, len = this.board.lists.length; i < len; i++) {
                        if (this.board.lists[i].idCards.indexOf(this.card.id) > -1) {
                            response = this.board.lists[i];
                            break;
                        }
                    }
                    return response;
                };
                /**
                 * Remove card
                 *
                 * @param ev
                 */
                ScrumboardCardDialogController.prototype.removeCard = function (ev) {
                    var _this = this;
                    var confirm = this.$mdDialog.confirm().
                        title(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-CARTAO"))
                        .parent(this.$document.find("#scrumboard"))
                        .textContent(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-CARTAO-CONFIRMACAO"))
                        .ariaLabel(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-CARTAO"))
                        .targetEvent(ev)
                        .clickOutsideToClose(true)
                        .escapeToClose(true)
                        .ok(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER"))
                        .cancel(this.$translate.instant("TAREFAS.PAINEL-DE-FASES.DIALOGO.CANCELAR"));
                    this.$mdDialog.show(confirm).then(function () {
                        var cardList = _this.getCardList();
                        cardList.idCards.splice(cardList.idCards.indexOf(_this.card.id), 1);
                        _this.board.cards.splice(_this.board.cards.indexOf(_this.card), 1);
                    });
                };
                /**
                 * Toggle cover image
                 *
                 * @param attachmentId
                 */
                ScrumboardCardDialogController.prototype.toggleCoverImage = function (attachmentId) {
                    if (attachmentId === this.card.idAttachmentCover) {
                        this.card.idAttachmentCover = null;
                    }
                    else {
                        this.card.idAttachmentCover = attachmentId;
                    }
                };
                /**
                 * Remove attachment
                 *
                 * @param item
                 */
                ScrumboardCardDialogController.prototype.removeAttachment = function (item) {
                    if (this.card.idAttachmentCover === item.id) {
                        this.card.idAttachmentCover = "";
                    }
                    this.card.attachments.splice(this.card.attachments.indexOf(item), 1);
                };
                /**
                 * Add label chips
                 *
                 * @param query
                 * @returns {filterFn}
                 */
                ScrumboardCardDialogController.prototype.labelQuerySearch = function (query) {
                    return query ? this.labels.filter(this.createFilterFor(query)) : [];
                };
                /**
                 * Label filter
                 *
                 * @param label
                 * @returns {boolean}
                 */
                ScrumboardCardDialogController.prototype.filterLabel = function (label) {
                    if (!this.labelSearchText || this.labelSearchText === "") {
                        return true;
                    }
                    return angular.lowercase(label.name).indexOf(angular.lowercase(this.labelSearchText)) >= 0;
                };
                /**
                 * Add new label
                 */
                ScrumboardCardDialogController.prototype.addNewLabel = function () {
                    this.board.labels.push({
                        "id": this.msUtils.guidGenerator(),
                        "name": this.newLabelName,
                        "color": this.newLabelColor
                    });
                    this.newLabelName = "";
                };
                /**
                 * Remove label
                 */
                ScrumboardCardDialogController.prototype.removeLabel = function () {
                    var _this = this;
                    var arr = this.board.labels;
                    arr.splice(arr.indexOf(arr.getById(this.editLabelId)), 1);
                    angular.forEach(this.board.cards, function (card) {
                        if (card.idLabels && card.idLabels.indexOf(_this.editLabelId) > -1) {
                            card.idLabels.splice(card.idLabels.indexOf(_this.editLabelId), 1);
                        }
                    });
                    this.newLabelName = "";
                };
                /**
                 * Add member chips
                 *
                 * @param query
                 * @returns {Array}
                 */
                ScrumboardCardDialogController.prototype.memberQuerySearch = function (query) {
                    return query ? this.members.filter(this.createFilterFor(query)) : [];
                };
                /**
                 * Member filter
                 *
                 * @param member
                 * @returns {boolean}
                 */
                ScrumboardCardDialogController.prototype.filterMember = function (member) {
                    if (!this.memberSearchText || this.memberSearchText === "") {
                        return true;
                    }
                    return angular.lowercase(member.name).indexOf(angular.lowercase(this.memberSearchText)) >= 0;
                };
                /**
                 * Update check list stats
                 * @param list
                 */
                ScrumboardCardDialogController.prototype.updateCheckedCount = function (list) {
                    var checkItems = list.checkItems;
                    var checkedItems = 0;
                    var allCheckedItems = 0;
                    var allCheckItems = 0;
                    angular.forEach(checkItems, function (checkItem) {
                        if (checkItem.checked) {
                            checkedItems++;
                        }
                    });
                    list.checkItemsChecked = checkedItems;
                    angular.forEach(this.card.checklists, function (item) {
                        allCheckItems += item.checkItems.length;
                        allCheckedItems += item.checkItemsChecked;
                    });
                    this.card.checkItems = allCheckItems;
                    this.card.checkItemsChecked = allCheckedItems;
                };
                /**
                 * Add checklist item
                 *
                 * @param text
                 * @param checkList
                 */
                ScrumboardCardDialogController.prototype.addCheckItem = function (text, checkList) {
                    if (!text || text === "") {
                        return;
                    }
                    var newCheckItem = {
                        "name": text,
                        "checked": false
                    };
                    checkList.checkItems.push(newCheckItem);
                    this.updateCheckedCount(checkList);
                };
                /**
                 * Remove checklist
                 *
                 * @param item
                 */
                ScrumboardCardDialogController.prototype.removeChecklist = function (item) {
                    var _this = this;
                    this.card.checklists.splice(this.card.checklists.indexOf(item), 1);
                    angular.forEach(this.card.checklists, function (list) {
                        _this.updateCheckedCount(list);
                    });
                };
                /**
                 * Create checklist
                 */
                ScrumboardCardDialogController.prototype.createCheckList = function () {
                    this.card.checklists.push({
                        "id": this.msUtils.guidGenerator(),
                        "name": this.newCheckListTitle,
                        "checkItemsChecked": 0,
                        "checkItems": []
                    });
                    this.newCheckListTitle = "";
                };
                /**
                 * Add new comment
                 *
                 * @param newCommentText
                 */
                ScrumboardCardDialogController.prototype.addNewComment = function (newCommentText) {
                    var newComment = {
                        "idMember": "36027j1930450d8bf7b10158",
                        "message": newCommentText,
                        "time": "now"
                    };
                    this.card.comments.unshift(newComment);
                };
                /**
                 * Filter for chips
                 *
                 * @param query
                 * @returns {filterFn}
                 */
                ScrumboardCardDialogController.prototype.createFilterFor = function (query) {
                    var lowercaseQuery = angular.lowercase(query);
                    return function filterFn(item) {
                        return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
                    };
                };
                return ScrumboardCardDialogController;
            }());
            angular
                .module("app.tarefas.painel-de-fases")
                .controller("app.tarefas.painel-de-fases.ScrumboardCardDialogController", ScrumboardCardDialogController);
        })(painelDeFases = tarefas.painelDeFases || (tarefas.painelDeFases = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            "use strict";
            /** @ngInject **/
            config.$inject = ["$translatePartialLoaderProvider", "$stateProvider", "msNavigationServiceProvider"];
            run.$inject = ["$rootScope", "$timeout", "app.tarefas.minhas-tarefas.MinhasTarefasService"];
            autoOpen.$inject = ["$timeout"];
            function config($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
                $translatePartialLoaderProvider.addPart("app/main/tarefas/minhas-tarefas");
                $stateProvider.state("app.tarefas.minhas-tarefas", {
                    url: "",
                    views: {
                        "content@app.autenticado": {
                            templateUrl: "app/main/tarefas/minhas-tarefas/minhas-tarefas.html",
                            controller: minhasTarefas.MinhasTarefasController,
                            controllerAs: "vm"
                        }
                    },
                    resolve: {
                        iframe: ['$q', function ($q) {
                                if (window !== parent) {
                                    parent.postMessage({ "type": "iframe", "operation": "abrir-tarefas" }, "*");
                                    return $q.reject('Abrir tarefas');
                                }
                            }],
                        user: /** @ngInject */ ["authService", function (authService) {
                            return authService.isAuthenticated();
                        }],
                        userGroups: /** @ngInject */ ["app.tarefas.minhas-tarefas.MinhasTarefasService", function (minhasTarefasService) {
                            return minhasTarefasService.listGroups();
                        }],
                        canPrioritize: /** @ngInject */ ["authorizationService", function (authorizationService) {
                            return authorizationService.findPermission("priorizar-tarefa", null)
                                .then(function () { return true; })
                                .catch(function () { return false; });
                        }],
                        canAnnotate: /** @ngInject */ ["authorizationService", function (authorizationService) {
                            return authorizationService.findPermission("anotar-tarefa", null)
                                .then(function () { return true; })
                                .catch(function () { return false; });
                        }],
                        canTag: /** @ngInject */ ["authorizationService", function (authorizationService) {
                            return authorizationService.findPermission("adicionar-rotulo-tarefa", "integracoes-tarefas")
                                .then(function () { return true; })
                                .catch(function () { return false; });
                        }],
                        canRemoveTags: /** @ngInject */ ["authorizationService", function (authorizationService) {
                            return authorizationService.findPermission("remover-rotulo-tarefa", "integracoes-tarefas")
                                .then(function () { return true; })
                                .catch(function () { return false; });
                        }],
                        manualTags: /** @ngInject */ ["app.tarefas.minhas-tarefas.RotulosService", function (rotulosService) {
                            return rotulosService.loadManualTags();
                        }]
                    }
                }).state("app.tarefas.minhas-tarefas.historico", {
                    url: "/historico",
                    views: {
                        "content@app.autenticado": {
                            templateUrl: "app/main/tarefas/minhas-tarefas/historico.html",
                            controller: minhasTarefas.HistoricoTarefasController,
                            controllerAs: "vm"
                        }
                    },
                    resolve: {
                        user: /** @ngInject */ ["authService", function (authService) {
                            return authService.isAuthenticated();
                        }],
                        userGroups: /** @ngInject */ ["app.tarefas.minhas-tarefas.MinhasTarefasService", function (minhasTarefasService) {
                            return minhasTarefasService.listGroups();
                        }]
                    }
                });
                msNavigationServiceProvider["saveItem"]("tarefas.minhas-tarefas", {
                    title: "Todas Tarefas",
                    icon: "icon-view-list",
                    state: "app.tarefas.minhas-tarefas",
                    translation: "TAREFAS.MEUS-PAINEIS.MEUS-PAINEIS",
                    weight: 1
                    /*badge : {
                        content : 1,
                        color : '#03A9F3'
                    }*/
                });
            }
            /** @ngInject **/
            function run($rootScope, $timeout, minhasTarefasService) {
                $rootScope.$on("task:created", function (event, notification) {
                    $timeout(function () { return minhasTarefasService.notifyOpenTask(notification); }, 1000);
                });
                $rootScope.$on("task:completed", function (event, notification) {
                    minhasTarefasService.deleteTaskDraftByNotification(notification);
                });
            }
            /** @ngInject **/
            function autoOpen($timeout) {
                return {
                    restrict: 'A',
                    require: 'mdDatepicker',
                    link: function (scope, element, attrs, DatePickerCtrl) {
                        scope.$watch(attrs.autoOpen, function (value) {
                            if (value) {
                                $timeout(function () {
                                    DatePickerCtrl.openCalendarPane({
                                        target: element[0].children[0]
                                    });
                                });
                            }
                        });
                    }
                };
            }
            angular
                .module("app.tarefas.minhas-tarefas", ["app.tarefas"])
                .directive('autoOpen', autoOpen)
                .config(config)
                .run(run);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var UpdateTagsController = /** @class */ (function () {
                /** @ngInject **/
                UpdateTagsController.$inject = ["$mdDialog", "tags"];
                function UpdateTagsController($mdDialog, tags) {
                    this.$mdDialog = $mdDialog;
                    this.tags = tags;
                    this.selectedTag = null;
                    this.name = null;
                    this.color = null;
                    this.tooltip = null;
                }
                UpdateTagsController.prototype.updateTag = function () {
                    this.$mdDialog.hide(__assign({}, angular.copy(this.selectedTag), { color: this.color, name: this.name, tooltip: this.tooltip }));
                    this.selectedTag.name = this.name;
                    this.selectedTag.color = this.color;
                    this.selectedTag.tooltip = this.tooltip;
                    this.selectedTag = null;
                };
                UpdateTagsController.prototype.selectTag = function () {
                    if (!!this.selectedTag) {
                        if (this.selectedTag.color === "blue") {
                            this.color = "#0000ff";
                        }
                        else {
                            this.color = this.selectedTag.color;
                        }
                        this.name = this.selectedTag.name;
                        this.tooltip = this.selectedTag.tooltip;
                    }
                };
                UpdateTagsController.prototype.closeDialog = function () {
                    this.$mdDialog.cancel();
                };
                return UpdateTagsController;
            }());
            minhasTarefas.UpdateTagsController = UpdateTagsController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.UpdateTagsController", UpdateTagsController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var UnAssignTagController = /** @class */ (function () {
                /** @ngInject **/
                UnAssignTagController.$inject = ["$mdDialog", "app.tarefas.minhas-tarefas.MinhasTarefasService", "tasks", "tags"];
                function UnAssignTagController($mdDialog, minhasTarefasService, tasks, tags) {
                    this.$mdDialog = $mdDialog;
                    this.minhasTarefasService = minhasTarefasService;
                    this.tasks = tasks;
                    this.tags = tags;
                    this.cmd = new minhasTarefas.UnAssigneeTagTasksCommand(tasks);
                }
                UnAssignTagController.prototype.unassigntagsTasks = function () {
                    this.$mdDialog.hide(this.cmd);
                };
                UnAssignTagController.prototype.closeDialog = function () {
                    this.$mdDialog.hide(null);
                };
                return UnAssignTagController;
            }());
            minhasTarefas.UnAssignTagController = UnAssignTagController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.UnAssignTagController", UnAssignTagController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var TagsController = /** @class */ (function () {
                /** @ngInject **/
                TagsController.$inject = ["$mdDialog", "app.tarefas.minhas-tarefas.MinhasTarefasService", "task", "tags"];
                function TagsController($mdDialog, minhasTarefasService, task, tags) {
                    this.$mdDialog = $mdDialog;
                    this.minhasTarefasService = minhasTarefasService;
                    this.task = task;
                    this.tags = tags;
                    this.cmd = new minhasTarefas.SetTagsTaskCommand(task.context, task.id);
                }
                TagsController.prototype.tagTask = function () {
                    var _this = this;
                    this.minhasTarefasService.setTags(this.cmd)
                        .then(function () {
                        var _a;
                        (_a = _this.task.etags).push.apply(_a, _this.cmd.tags);
                        _this.$mdDialog.hide();
                    });
                };
                TagsController.prototype.closeDialog = function () {
                    this.$mdDialog.hide();
                };
                return TagsController;
            }());
            minhasTarefas.TagsController = TagsController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.TagsController", TagsController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var RemoveTagsController = /** @class */ (function () {
                /** @ngInject **/
                RemoveTagsController.$inject = ["$mdDialog", "tags"];
                function RemoveTagsController($mdDialog, tags) {
                    this.$mdDialog = $mdDialog;
                    this.tags = tags;
                    this.selectedTags = [];
                }
                RemoveTagsController.prototype.removeTags = function () {
                    this.$mdDialog.hide(this.selectedTags);
                };
                RemoveTagsController.prototype.closeDialog = function () {
                    this.$mdDialog.cancel();
                };
                return RemoveTagsController;
            }());
            minhasTarefas.RemoveTagsController = RemoveTagsController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.RemoveTagsController", RemoveTagsController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var CreateTagController = /** @class */ (function () {
                /** @ngInject **/
                CreateTagController.$inject = ["$mdDialog", "authService"];
                function CreateTagController($mdDialog, authService) {
                    this.$mdDialog = $mdDialog;
                    this.authService = authService;
                    this.color = "#0000ff";
                    this.tenants = [];
                    this.nameTenant = "";
                    this.tenantsSelects = [];
                    this.searchTenant();
                }
                CreateTagController.prototype.createTag = function () {
                    var tenantsList = this.tenantsSelects.map(function (tenant) { return tenant.codigo; });
                    this.$mdDialog.hide({ color: this.color, name: this.name, tooltip: this.tooltip, tenantsPermitidos: tenantsList });
                };
                CreateTagController.prototype.closeDialog = function () {
                    this.$mdDialog.cancel();
                };
                CreateTagController.prototype.searchTenant = function () {
                    var _this = this;
                    this.authService
                        .getUser()
                        .then(function (user) {
                        _this.tenants = user.contas;
                    });
                };
                return CreateTagController;
            }());
            minhasTarefas.CreateTagController = CreateTagController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.CreateTagController", CreateTagController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var AssignTagController = /** @class */ (function () {
                /** @ngInject **/
                AssignTagController.$inject = ["$mdDialog", "app.tarefas.minhas-tarefas.MinhasTarefasService", "tasks", "tags"];
                function AssignTagController($mdDialog, minhasTarefasService, tasks, tags) {
                    this.$mdDialog = $mdDialog;
                    this.minhasTarefasService = minhasTarefasService;
                    this.tasks = tasks;
                    this.tags = tags;
                    this.cmd = new minhasTarefas.AssigneeTagTasksCommand(tasks);
                }
                AssignTagController.prototype.addtagsTasks = function () {
                    var _this = this;
                    this.minhasTarefasService.setTagsTasks(this.cmd)
                        .then(function () {
                        _this.tasks.forEach(function (task) {
                            var _a;
                            if (task.etags != null) {
                                (_a = task.etags).push.apply(_a, _this.cmd.tags);
                            }
                            else {
                                task.etags = _this.cmd.tags;
                            }
                        });
                        _this.$mdDialog.hide();
                    });
                };
                AssignTagController.prototype.closeDialog = function () {
                    this.$mdDialog.hide();
                };
                return AssignTagController;
            }());
            minhasTarefas.AssignTagController = AssignTagController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.AssignTagController", AssignTagController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var AnnotateController = /** @class */ (function () {
                /** @ngInject **/
                AnnotateController.$inject = ["$mdDialog", "app.tarefas.minhas-tarefas.MinhasTarefasService", "task"];
                function AnnotateController($mdDialog, minhasTarefasService, task) {
                    this.$mdDialog = $mdDialog;
                    this.minhasTarefasService = minhasTarefasService;
                    this.task = task;
                    this.canDelete = false;
                    this.cmd = new minhasTarefas.SetNotesTaskCommand(task.context, task.id);
                    if (!!task.notes) {
                        this.cmd.notes = task.notes;
                        this.canDelete = true;
                    }
                }
                AnnotateController.prototype.deleteTaskNotes = function () {
                    this.cmd.notes = null;
                    this.annotateTask();
                };
                AnnotateController.prototype.annotateTask = function () {
                    var _this = this;
                    this.minhasTarefasService.setNotes(this.cmd)
                        .then(function () {
                        _this.task.notes = _this.cmd.notes;
                        _this.$mdDialog.hide();
                    });
                };
                AnnotateController.prototype.closeDialog = function () {
                    this.$mdDialog.hide();
                };
                return AnnotateController;
            }());
            minhasTarefas.AnnotateController = AnnotateController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.AnnotateController", AnnotateController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var ExportarTarefasController = /** @class */ (function () {
                /** @ngInject **/
                ExportarTarefasController.$inject = ["$mdDialog", "app.tarefas.minhas-tarefas.ExportarTarefasService", "messagesService", "tasks", "usersNames", "fromDate", "toDate", "fileName"];
                function ExportarTarefasController($mdDialog, exportarTarefasService, messagesService, tasks, usersNames, fromDate, toDate, fileName) {
                    this.$mdDialog = $mdDialog;
                    this.exportarTarefasService = exportarTarefasService;
                    this.messagesService = messagesService;
                    this.tasks = tasks;
                    this.usersNames = usersNames;
                    this.fromDate = fromDate;
                    this.toDate = toDate;
                    this.fileName = fileName;
                    this.formato = false;
                    this.exportando = false;
                    this.camposExportacao = [
                        { nome: "title", descricao: "Nome da tarefa", isAtivo: true, tipo: 'text', funcaoDeFormatacao: '' },
                        { nome: "claimDate", descricao: "Data de atribuição", isAtivo: true, tipo: 'date', funcaoDeFormatacao: '' },
                        { nome: "startDate", descricao: "Data de criação", isAtivo: true, tipo: 'date', funcaoDeFormatacao: '' },
                        { nome: "", descricao: "Data de conclusão/cancelamento", isAtivo: true, tipo: 'date', funcaoDeFormatacao: 'formatDataConclusaoCancelamento' },
                        { nome: "extraInfo", descricao: "Informações extras", isAtivo: true, tipo: 'array', funcaoDeFormatacao: '' },
                        { nome: "", descricao: "Resultado da conclusão/Justificativa do cancelamento", isAtivo: true, tipo: 'text', funcaoDeFormatacao: 'formatResultadoJustificativa' },
                        { nome: "tags", descricao: "Rótulos", isAtivo: true, tipo: 'array', funcaoDeFormatacao: '' },
                        { nome: "", descricao: "Situação final", isAtivo: true, tipo: 'text', funcaoDeFormatacao: 'formatResultadoFinal' },
                        { nome: "assignee", descricao: "Usuário responsável", isAtivo: true, tipo: 'text', funcaoDeFormatacao: '' },
                    ];
                }
                ExportarTarefasController.prototype.exportarHistoricoTarefas = function (formato) {
                    var _this = this;
                    this.exportando = true;
                    var camposPermitidos = this.camposExportacao.filter(function (i) { return i.isAtivo; });
                    var nomeRelatorio = this.montarNomeRelatorio(formato, this.fromDate, this.toDate);
                    return this.exportarTarefasService
                        .exportarHistoricoTarefas(this.tasks, this.usersNames, camposPermitidos, nomeRelatorio).then(function () {
                        _this.messagesService.success("Exportação realizada com sucesso!", 4000);
                    }, function () {
                        _this.messagesService.error("Erro na exportação de resultados!");
                    }).finally(function () {
                        _this.exportando = false;
                        return _this.fechar();
                    });
                };
                ExportarTarefasController.prototype.fechar = function () {
                    this.$mdDialog.hide();
                };
                ExportarTarefasController.prototype.montarNomeRelatorio = function (formato, dataInicial, dataFinal) {
                    var baseName = this.fileName + "-" + dataInicial + "-a-" + dataFinal;
                    if (formato === 'Excel') {
                        return baseName + ".xlsx";
                    }
                    return baseName + ".csv";
                };
                ExportarTarefasController.prototype.isValid = function () {
                    var camposInativos = this.camposExportacao.filter(function (field) { return !field.isAtivo; });
                    return this.formato && !this.exportando && camposInativos.length !== this.camposExportacao.length;
                };
                return ExportarTarefasController;
            }());
            minhasTarefas.ExportarTarefasController = ExportarTarefasController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.ExportarTarefasController", ExportarTarefasController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var CancellationController = /** @class */ (function () {
                /** @ngInject **/
                CancellationController.$inject = ["$mdDialog", "app.tarefas.minhas-tarefas.MinhasTarefasService", "app.tarefas.minhas-tarefas.TarefasCacheService", "tasks"];
                function CancellationController($mdDialog, minhasTarefasService, tarefasCacheService, tasks) {
                    this.$mdDialog = $mdDialog;
                    this.minhasTarefasService = minhasTarefasService;
                    this.tarefasCacheService = tarefasCacheService;
                    this.tasks = tasks;
                    this.cmd = new minhasTarefas.CancelTasksCommand();
                    this.cmd.addTasks(tasks);
                }
                CancellationController.prototype.cancelTasks = function () {
                    var _this = this;
                    this.minhasTarefasService.cancelTasks(this.cmd)
                        .then(function () {
                        _this.tasks.forEach(function (task) { return _this.tarefasCacheService.remove(task); });
                        _this.$mdDialog.hide();
                    });
                };
                CancellationController.prototype.closeDialog = function () {
                    this.$mdDialog.hide();
                };
                return CancellationController;
            }());
            minhasTarefas.CancellationController = CancellationController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.CancellationController", CancellationController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var AssigneeGroupController = /** @class */ (function () {
                /** @ngInject **/
                AssigneeGroupController.$inject = ["$mdDialog", "$filter", "app.tarefas.minhas-tarefas.MinhasTarefasService", "tasks", "groups"];
                function AssigneeGroupController($mdDialog, $filter, minhasTarefasService, tasks, groups) {
                    this.$mdDialog = $mdDialog;
                    this.$filter = $filter;
                    this.minhasTarefasService = minhasTarefasService;
                    this.tasks = tasks;
                    this.groups = groups;
                    this.cmd = new minhasTarefas.AssigneeGroupTasksCommand();
                    this.cmd.addTasks(tasks);
                }
                AssigneeGroupController.prototype.assignGroupTasks = function () {
                    var _this = this;
                    this.minhasTarefasService.assignGroupTasks(this.cmd)
                        .then(function () {
                        _this.tasks.forEach(function (task) {
                            task.selected = false;
                            task.assigneeGroup = _this.cmd.assigneeGroup;
                        });
                        _this.$mdDialog.hide();
                    });
                };
                AssigneeGroupController.prototype.changeAssigneeGroup = function () {
                    if (this.assigneeGroup) {
                        this.cmd.assigneeGroup = this.assigneeGroup.id;
                    }
                    else {
                        this.cmd.assigneeGroup = null;
                    }
                };
                AssigneeGroupController.prototype.closeDialog = function () {
                    this.$mdDialog.hide();
                };
                AssigneeGroupController.prototype.filterGroups = function (searchText) {
                    return this.$filter("accentInsensitiveOrderBy")(this.$filter("accentInsensitiveFilter")(this.groups, searchText), "value");
                };
                return AssigneeGroupController;
            }());
            minhasTarefas.AssigneeGroupController = AssigneeGroupController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.AssigneeGroupController", AssigneeGroupController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var AssigneeController = /** @class */ (function () {
                /** @ngInject **/
                AssigneeController.$inject = ["$mdDialog", "$filter", "app.tarefas.minhas-tarefas.MinhasTarefasService", "tasks", "users", "resources"];
                function AssigneeController($mdDialog, $filter, minhasTarefasService, tasks, users, resources) {
                    this.$mdDialog = $mdDialog;
                    this.$filter = $filter;
                    this.minhasTarefasService = minhasTarefasService;
                    this.tasks = tasks;
                    this.users = users;
                    this.resources = resources;
                    this.filterBySetor = true;
                    this.cmd = new minhasTarefas.AssigneeTasksCommand();
                    this.cmd.addTasks(tasks);
                }
                AssigneeController.prototype.assignTasks = function () {
                    var _this = this;
                    this.minhasTarefasService.assignTasks(this.cmd)
                        .then(function () {
                        _this.tasks.forEach(function (task) {
                            task.selected = false;
                            // essa linha abaixo dá a ilusão de atualização pelo evento "task:assigned".
                            // É por isso que algumas propriedades das tarefas (claim_date) não mudam quando
                            // há mudança de assignee na tela de tarefas
                            task.assignee = _this.cmd.assignee;
                        });
                        _this.$mdDialog.hide();
                    });
                };
                AssigneeController.prototype.changeAssignee = function () {
                    if (this.assignee) {
                        this.cmd.assignee = this.assignee.login;
                    }
                    else {
                        this.cmd.assignee = null;
                    }
                };
                AssigneeController.prototype.changeFilterBySetor = function () {
                    var _this = this;
                    this.minhasTarefasService.listUsersByResources(this.resources, this.filterBySetor)
                        .then(function (users) {
                        var _a;
                        _this.users.splice(0, _this.users.length);
                        (_a = _this.users).push.apply(_a, users);
                    });
                };
                AssigneeController.prototype.closeDialog = function () {
                    this.$mdDialog.hide();
                };
                AssigneeController.prototype.filterUsers = function (searchText) {
                    var accentInsensitiveOrderBy = this.$filter("accentInsensitiveOrderBy");
                    var accentInsensitiveFilter = this.$filter("accentInsensitiveFilter");
                    return accentInsensitiveOrderBy(accentInsensitiveFilter(this.users, searchText), "value");
                };
                return AssigneeController;
            }());
            minhasTarefas.AssigneeController = AssigneeController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.AssigneeController", AssigneeController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var toolbar;
    (function (toolbar) {
        'use strict';
        /** @ngInject */
        config.$inject = ["$translatePartialLoaderProvider"];
        function config($translatePartialLoaderProvider) {
            $translatePartialLoaderProvider.addPart('app/main/toolbar');
        }
        angular
            .module('app.toolbar', [])
            .config(config);
    })(toolbar = app.toolbar || (app.toolbar = {}));
})(app || (app = {}));



var app;
(function (app) {
    var toolbar;
    (function (toolbar) {
        "use strict";
        var AlterarContaController = /** @class */ (function () {
            /** @ngInject **/
            AlterarContaController.$inject = ["$mdDialog", "$translate", "$window", "$state", "messagesService", "app.toolbar.alterar-conta.GestaoContaService", "authService", "setorId"];
            function AlterarContaController($mdDialog, $translate, $window, $state, messagesService, gestaoContaService, authService, setorId) {
                this.$mdDialog = $mdDialog;
                this.$translate = $translate;
                this.$window = $window;
                this.$state = $state;
                this.messagesService = messagesService;
                this.gestaoContaService = gestaoContaService;
                this.authService = authService;
                this.setorId = setorId;
            }
            AlterarContaController.prototype.cancel = function () {
                this.$mdDialog.cancel();
            };
            AlterarContaController.prototype.confirm = function () {
                var _this = this;
                this.gestaoContaService.alterarContaAtual(this.setorId)
                    .then(function (result) {
                    _this.authService.clearCache();
                    _this.$mdDialog.hide();
                    _this.messagesService.success(_this.$translate.instant("TOOLBAR.ALTERAR_CONTA.CONTA_ALTERADA_SUCESSO"));
                    _this.$window.location.href = "/tarefas";
                });
            };
            return AlterarContaController;
        }());
        toolbar.AlterarContaController = AlterarContaController;
        angular
            .module("app.toolbar")
            .controller("app.toolbar.AlterarContaController", AlterarContaController);
    })(toolbar = app.toolbar || (app.toolbar = {}));
})(app || (app = {}));



(function () {
    "use strict";
    DialogService.$inject = ["$mdDialog", "$document"];
    angular
        .module("app.tarefas.painel-de-fases")
        .factory("DialogService", DialogService);
    /** @ngInject */
    function DialogService($mdDialog, $document) {
        var service = {
            openCardDialog: openCardDialog
        };
        //////////
        /**
         * Open card dialog
         *
         * @param ev
         * @param cardId
         */
        function openCardDialog(ev, cardId) {
            $mdDialog.show({
                templateUrl: "app/main/tarefas/painel-de-fases/dialogs/card/card-dialog.html",
                controller: "ScrumboardCardDialogController",
                controllerAs: "vm",
                parent: $document.find("#scrumboard"),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    cardId: cardId
                }
            });
        }
        return service;
    }
})();



(function () {
    "use strict";
    angular
        .module("app.tarefas.painel-de-fases")
        .factory("CardFilters", CardFiltersService);
    /** @ngInject */
    function CardFiltersService() {
        var service = {
            name: "",
            labels: [],
            clear: clear,
            isOn: isOn
        };
        /**
         * Clear
         */
        function clear() {
            service.name = "";
            service.labels = [];
        }
        /**
         * Is on
         *
         * @returns {boolean}
         */
        function isOn() {
            return ((service.name !== "") ||
                (service.labels.length !== 0));
        }
        return service;
    }
})();



(function () {
    "use strict";
    BoardService.$inject = ["$q", "$http"];
    angular
        .module("app.tarefas.painel-de-fases")
        .factory("BoardService", BoardService);
    /** @ngInject */
    function BoardService($q, $http) {
        var service = {
            getBoardData: getBoardData,
            data: {}
        };
        /**
         * Get board data from the server
         *
         * @param boardId
         * @returns {*}
         */
        function getBoardData(boardId) {
            var deferred = $q.defer();
            $http.get("app/data/sample/tarefas/painel-de-fases/" + boardId + ".json").then(function (response) {
                service.data = response.data;
                deferred.resolve(response.data);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }
        return service;
    }
})();



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var painelDeFases;
        (function (painelDeFases) {
            var TarefasPainelDeFasesPainelController = /** @class */ (function () {
                /** @ngInject **/
                TarefasPainelDeFasesPainelController.$inject = ["$document", "$mdDialog", "$mdSidenav", "msUtils", "BoardList", "BoardService", "CardFilters", "DialogService"];
                function TarefasPainelDeFasesPainelController($document, $mdDialog, $mdSidenav, msUtils, BoardList, BoardService, CardFilters, DialogService) {
                    this.$document = $document;
                    this.$mdDialog = $mdDialog;
                    this.$mdSidenav = $mdSidenav;
                    this.msUtils = msUtils;
                    this.currentView = "board";
                    this.card = {};
                    this.cardOptions = {};
                    this.newListName = "";
                    // Data
                    this.currentView = "board";
                    this.board = BoardService.data;
                    this.boardList = BoardList.data;
                    this.cardFilters = CardFilters;
                    this.filteringIsOn = CardFilters.isOn;
                    this.openCardDialog = DialogService.openCardDialog;
                    this.clearFilters = CardFilters.clear;
                    this.sortableListOptions = {
                        axis: "x",
                        delay: 75,
                        distance: 7,
                        items: "> .list-wrapper",
                        handle: ".list-header",
                        placeholder: "list-wrapper list-sortable-placeholder",
                        tolerance: "pointer",
                        start: function (event, ui) {
                            var width = ui.item[0].children[0].clientWidth;
                            var height = ui.item[0].children[0].clientHeight;
                            ui.placeholder.css({
                                "min-width": width + "px",
                                "width": width + "px",
                                "height": height + "px"
                            });
                        }
                    };
                    this.sortableCardOptions = {
                        appendTo: "body",
                        connectWith: ".list-cards",
                        delay: 75,
                        distance: 7,
                        forceHelperSize: true,
                        forcePlaceholderSize: true,
                        handle: this.msUtils.isMobile() ? ".list-card-sort-handle" : false,
                        helper: function (event, el) {
                            return el.clone().addClass("list-card-sort-helper");
                        },
                        placeholder: "list-card card-sortable-placeholder",
                        tolerance: "pointer",
                        scroll: true,
                        sort: function (event, ui) {
                            var listContentEl = ui.placeholder.closest(".list-content");
                            var boardContentEl = ui.placeholder.closest("#board");
                            if (listContentEl) {
                                var listContentElHeight = listContentEl[0].clientHeight, listContentElScrollHeight = listContentEl[0].scrollHeight;
                                if (listContentElHeight !== listContentElScrollHeight) {
                                    var itemTop = ui.position.top, itemBottom = itemTop + ui.item.height(), listTop = listContentEl.offset().top, listBottom = listTop + listContentElHeight;
                                    if (itemTop < listTop + 25) {
                                        listContentEl.scrollTop(listContentEl.scrollTop() - 25);
                                    }
                                    if (itemBottom > listBottom - 25) {
                                        listContentEl.scrollTop(listContentEl.scrollTop() + 25);
                                    }
                                }
                            }
                            if (boardContentEl) {
                                var boardContentElWidth = boardContentEl[0].clientWidth;
                                var boardContentElScrollWidth = boardContentEl[0].scrollWidth;
                                if (boardContentElWidth !== boardContentElScrollWidth) {
                                    var itemLeft = ui.position.left, itemRight = itemLeft + ui.item.width(), boardLeft = boardContentEl.offset().left, boardRight = boardLeft + boardContentElWidth;
                                    if (itemLeft < boardLeft + 25) {
                                        boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
                                    }
                                    if (itemRight > boardRight) {
                                        boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
                                    }
                                }
                            }
                        }
                    };
                    Object.defineProperty(Array.prototype, "getById", {
                        enumerable: false,
                        value: function (value) {
                            return this.find(function (x) { return x.id === value; });
                        }
                    });
                }
                /**
                 * Toggle sidenav
                 *
                 * @param sidenavId
                 */
                TarefasPainelDeFasesPainelController.prototype.toggleSidenav = function (sidenavId) {
                    this.$mdSidenav(sidenavId).toggle();
                };
                /**
                 * Card filter
                 *
                 * @param cardId
                 * @returns {*}
                 */
                TarefasPainelDeFasesPainelController.prototype.cardFilter = function (cardId) {
                    var _this = this;
                    var card = this.board.cards.find(function (card) { return card.id === cardId; });
                    try {
                        if (angular.lowercase(card.name).indexOf(angular.lowercase(this.cardFilters.name)) < 0) {
                            throw false;
                        }
                        angular.forEach(this.cardFilters.labels, function (label) {
                            if (!_this.msUtils.exists(label, card.idLabels)) {
                                throw false;
                            }
                        });
                    }
                    catch (err) {
                        return err;
                    }
                    return true;
                };
                /**
                 * Is the card overdue?
                 *
                 * @param cardDate
                 * @returns {boolean}
                 */
                TarefasPainelDeFasesPainelController.prototype.isOverdue = function (cardDate) {
                    return new Date() > cardDate;
                };
                return TarefasPainelDeFasesPainelController;
            }());
        })(painelDeFases = tarefas.painelDeFases || (tarefas.painelDeFases = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            "use strict";
            var ITaskTagOrigem;
            (function (ITaskTagOrigem) {
                ITaskTagOrigem["MANUAL"] = "MANUAL";
                ITaskTagOrigem["AUTOMATICA"] = "AUTOMATICA";
            })(ITaskTagOrigem = minhasTarefas.ITaskTagOrigem || (minhasTarefas.ITaskTagOrigem = {}));
            var TaskCommand = /** @class */ (function () {
                function TaskCommand(context, taskId) {
                    this.context = context;
                    this.taskId = taskId;
                }
                return TaskCommand;
            }());
            minhasTarefas.TaskCommand = TaskCommand;
            var SetPriorityTaskCommand = /** @class */ (function (_super) {
                __extends(SetPriorityTaskCommand, _super);
                function SetPriorityTaskCommand() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.priority = false;
                    return _this;
                }
                return SetPriorityTaskCommand;
            }(TaskCommand));
            minhasTarefas.SetPriorityTaskCommand = SetPriorityTaskCommand;
            var SetNotesTaskCommand = /** @class */ (function (_super) {
                __extends(SetNotesTaskCommand, _super);
                function SetNotesTaskCommand() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.notes = "";
                    return _this;
                }
                return SetNotesTaskCommand;
            }(TaskCommand));
            minhasTarefas.SetNotesTaskCommand = SetNotesTaskCommand;
            var SetTagsTaskCommand = /** @class */ (function (_super) {
                __extends(SetTagsTaskCommand, _super);
                function SetTagsTaskCommand() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.tags = [];
                    return _this;
                }
                return SetTagsTaskCommand;
            }(TaskCommand));
            minhasTarefas.SetTagsTaskCommand = SetTagsTaskCommand;
            var RemoveTagTaskCommand = /** @class */ (function (_super) {
                __extends(RemoveTagTaskCommand, _super);
                function RemoveTagTaskCommand() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return RemoveTagTaskCommand;
            }(TaskCommand));
            minhasTarefas.RemoveTagTaskCommand = RemoveTagTaskCommand;
            var ContextTasksCommand = /** @class */ (function () {
                function ContextTasksCommand() {
                }
                ContextTasksCommand.prototype.addTasks = function (tasks) {
                    var _this = this;
                    if (angular.isArray(tasks)) {
                        tasks.forEach(function (task) { return _this.addTask(task); });
                    }
                };
                ContextTasksCommand.prototype.addTask = function (task) {
                    if (this.contextTasks && this.contextTasks[task.context]) {
                        this.contextTasks[task.context].push(task.id);
                    }
                    else {
                        this.contextTasks = {};
                        this.contextTasks[task.context] = [task.id];
                    }
                };
                return ContextTasksCommand;
            }());
            minhasTarefas.ContextTasksCommand = ContextTasksCommand;
            var AssumeTasksCommand = /** @class */ (function (_super) {
                __extends(AssumeTasksCommand, _super);
                function AssumeTasksCommand() {
                    return _super.call(this) || this;
                }
                return AssumeTasksCommand;
            }(ContextTasksCommand));
            minhasTarefas.AssumeTasksCommand = AssumeTasksCommand;
            var AssigneeTasksCommand = /** @class */ (function (_super) {
                __extends(AssigneeTasksCommand, _super);
                function AssigneeTasksCommand() {
                    return _super.call(this) || this;
                }
                return AssigneeTasksCommand;
            }(ContextTasksCommand));
            minhasTarefas.AssigneeTasksCommand = AssigneeTasksCommand;
            var AssigneeTasksCommandValidator = /** @class */ (function () {
                function AssigneeTasksCommandValidator() {
                }
                AssigneeTasksCommandValidator.prototype.isValid = function (command) {
                    return !!command.contextTasks;
                };
                return AssigneeTasksCommandValidator;
            }());
            minhasTarefas.AssigneeTasksCommandValidator = AssigneeTasksCommandValidator;
            var AssigneeGroupTasksCommand = /** @class */ (function (_super) {
                __extends(AssigneeGroupTasksCommand, _super);
                function AssigneeGroupTasksCommand() {
                    return _super.call(this) || this;
                }
                return AssigneeGroupTasksCommand;
            }(ContextTasksCommand));
            minhasTarefas.AssigneeGroupTasksCommand = AssigneeGroupTasksCommand;
            var AssigneeTagTasksCommand = /** @class */ (function () {
                function AssigneeTagTasksCommand(tasks) {
                    this.tasks = tasks;
                    this.tags = [];
                }
                return AssigneeTagTasksCommand;
            }());
            minhasTarefas.AssigneeTagTasksCommand = AssigneeTagTasksCommand;
            var UnAssigneeTagTasksCommand = /** @class */ (function () {
                function UnAssigneeTagTasksCommand(tasks) {
                    this.tasks = tasks;
                    this.tags = [];
                }
                return UnAssigneeTagTasksCommand;
            }());
            minhasTarefas.UnAssigneeTagTasksCommand = UnAssigneeTagTasksCommand;
            var AssigneeGroupTasksCommandValidator = /** @class */ (function () {
                function AssigneeGroupTasksCommandValidator() {
                }
                AssigneeGroupTasksCommandValidator.prototype.isValid = function (command) {
                    return !!command.contextTasks;
                };
                return AssigneeGroupTasksCommandValidator;
            }());
            minhasTarefas.AssigneeGroupTasksCommandValidator = AssigneeGroupTasksCommandValidator;
            var CancelTasksCommand = /** @class */ (function (_super) {
                __extends(CancelTasksCommand, _super);
                function CancelTasksCommand() {
                    return _super.call(this) || this;
                }
                return CancelTasksCommand;
            }(ContextTasksCommand));
            minhasTarefas.CancelTasksCommand = CancelTasksCommand;
            var CancelTasksCommandValidator = /** @class */ (function () {
                function CancelTasksCommandValidator() {
                }
                CancelTasksCommandValidator.prototype.isValid = function (command) {
                    if (!!command.reason) {
                        if (command.reason.length === 1) {
                            command.reason = command.reason.trim();
                        }
                        return command.reason.length > 0 && command.reason.length <= 500 && !!command.contextTasks;
                    }
                    return false;
                };
                return CancelTasksCommandValidator;
            }());
            minhasTarefas.CancelTasksCommandValidator = CancelTasksCommandValidator;
            var SetNotesTaskCommandValidator = /** @class */ (function () {
                function SetNotesTaskCommandValidator() {
                }
                SetNotesTaskCommandValidator.prototype.isValid = function (command) {
                    if (!!command.notes) {
                        if (command.notes.length === 1) {
                            command.notes = command.notes.trim();
                        }
                        return command.notes.length > 0 && command.notes.length <= 500;
                    }
                    return false;
                };
                return SetNotesTaskCommandValidator;
            }());
            minhasTarefas.SetNotesTaskCommandValidator = SetNotesTaskCommandValidator;
            var SetTagsTaskCommandValidator = /** @class */ (function () {
                function SetTagsTaskCommandValidator() {
                }
                SetTagsTaskCommandValidator.prototype.isValid = function (command) {
                    if (!!command.tags) {
                        return command.tags.length > 0;
                    }
                    return false;
                };
                return SetTagsTaskCommandValidator;
            }());
            minhasTarefas.SetTagsTaskCommandValidator = SetTagsTaskCommandValidator;
            var RemoveTagTaskCommandValidator = /** @class */ (function () {
                function RemoveTagTaskCommandValidator() {
                }
                RemoveTagTaskCommandValidator.prototype.isValid = function (command) {
                    return !!command.tag;
                };
                return RemoveTagTaskCommandValidator;
            }());
            minhasTarefas.RemoveTagTaskCommandValidator = RemoveTagTaskCommandValidator;
            var CamposExportacaoTarefa = /** @class */ (function () {
                function CamposExportacaoTarefa(nome, descricao, isAtivo, tipo, funcaoDeFormatacao) {
                    if (nome === void 0) { nome = ''; }
                    if (funcaoDeFormatacao === void 0) { funcaoDeFormatacao = ''; }
                    this.nome = nome;
                    this.descricao = descricao;
                    this.isAtivo = isAtivo;
                    this.tipo = tipo;
                    this.funcaoDeFormatacao = funcaoDeFormatacao;
                }
                return CamposExportacaoTarefa;
            }());
            minhasTarefas.CamposExportacaoTarefa = CamposExportacaoTarefa;
            var MinhasTarefasService = /** @class */ (function () {
                /** @ngInject **/
                MinhasTarefasService.$inject = ["$http", "$q", "$document", "$state", "$mdDialog", "commandService", "messagesService", "authService", "properties", "identidadesService"];
                function MinhasTarefasService($http, $q, $document, $state, $mdDialog, commandService, messagesService, authService, properties, identidadesService) {
                    this.$http = $http;
                    this.$q = $q;
                    this.$document = $document;
                    this.$state = $state;
                    this.$mdDialog = $mdDialog;
                    this.commandService = commandService;
                    this.messagesService = messagesService;
                    this.authService = authService;
                    this.properties = properties;
                    this.identidadesService = identidadesService;
                    this.apiTarefas = properties.apiUrl + "/integracoes-modulos/api/tasks";
                    this.apiTarefasHistorico = properties.apiUrl + "/integracoes-tarefas/api/tasks";
                    this.apiUsuarios = properties.apiUrl + "/integracoes-identidades/api/acessos";
                    this.commandService.addValidator("atribuir-tarefas", new AssigneeTasksCommandValidator());
                    this.commandService.addValidator("atribuir-tarefas-grupo", new AssigneeGroupTasksCommandValidator());
                    this.commandService.addValidator("cancelar-tarefas", new CancelTasksCommandValidator());
                    this.commandService.addValidator("anotar-tarefa", new SetNotesTaskCommandValidator());
                    this.commandService.addValidator("rotular-tarefa", new SetTagsTaskCommandValidator());
                    this.commandService.addValidator("remover-rotulo-tarefa", new RemoveTagTaskCommandValidator());
                }
                MinhasTarefasService.prototype.get = function () {
                    return this.$http.get(this.apiTarefas);
                };
                MinhasTarefasService.prototype.getNomesUsuarios = function (logins) {
                    return this.identidadesService.getNomeApresentacao(logins);
                };
                MinhasTarefasService.prototype.loadTaskDraft = function (task) {
                    return this.$http.get(this.apiTarefas + "/draft/" + task.context + "/" + task.id);
                };
                MinhasTarefasService.prototype.deleteTaskDraft = function (task) {
                    return this.$http.delete(this.apiTarefas + "/draft/" + task.context + "/" + task.id);
                };
                MinhasTarefasService.prototype.setPriority = function (cmd) {
                    return this.$http.post(this.apiTarefas + "/priority", cmd);
                };
                MinhasTarefasService.prototype.setNotes = function (cmd) {
                    return this.$http.post(this.apiTarefas + "/notes", cmd);
                };
                MinhasTarefasService.prototype.setTags = function (cmd) {
                    return this.$http.post(this.properties.apiUrl + "/" + cmd.context + "/api/tasks/" + cmd.taskId + "/tags", cmd);
                };
                MinhasTarefasService.prototype.setTagsTasks = function (cmd) {
                    var _this = this;
                    var promisses = [];
                    cmd.tasks.forEach(function (task) {
                        var command = new SetTagsTaskCommand(task.context, task.id);
                        command.tags = cmd.tags;
                        promisses.push(_this.setTags(command));
                    });
                    return this.$q.all(promisses);
                };
                MinhasTarefasService.prototype.unsetTagsTasks = function (cmd) {
                    var _this = this;
                    var promisses = [];
                    if (!!cmd.tasks && !!cmd.tags) {
                        cmd.tasks.forEach(function (task) {
                            var promise = _this.$q.resolve({});
                            cmd.tags
                                .filter(function (tag) { return task.tags.some(function (t) { return t.id === tag; }); })
                                .forEach(function (tag) {
                                var command = new RemoveTagTaskCommand(task.context, task.id);
                                command.tag = tag;
                                promise = promise.then(function () { return _this.removeTag(command); });
                            });
                            promisses.push(promise);
                        });
                    }
                    return this.$q.all(promisses);
                };
                MinhasTarefasService.prototype.removeTag = function (cmd) {
                    return this.$http.delete(this.properties.apiUrl + "/" + cmd.context + "/api/tasks/" + cmd.taskId + "/tags/" + cmd.tag);
                };
                MinhasTarefasService.prototype.assignTasks = function (cmd) {
                    return this.$http.post(this.apiTarefas + "/assignment", cmd);
                };
                MinhasTarefasService.prototype.assignGroupTasks = function (cmd) {
                    return this.$http.post(this.apiTarefas + "/group/assignment", cmd);
                };
                MinhasTarefasService.prototype.assumeTasks = function (cmd) {
                    return this.$http.post(this.apiTarefas + "/user", cmd);
                };
                MinhasTarefasService.prototype.cancelTasks = function (cmd) {
                    cmd.reason = cmd.reason.trim();
                    return this.$http.post(this.apiTarefas + "/canceled", cmd);
                };
                MinhasTarefasService.prototype.listCanceledTasks = function (from, to, filterDefault) {
                    var config = {
                        params: {
                            from: from,
                            to: to,
                            filterDefault: filterDefault,
                        }
                    };
                    return this.$http
                        .get(this.apiTarefasHistorico + "/canceled", config)
                        .then(function (response) { return response.data; }, function () { return []; });
                };
                MinhasTarefasService.prototype.listCompletedTasks = function (from, to, filterDefault) {
                    var config = {
                        params: {
                            from: from,
                            to: to,
                            filterDefault: filterDefault
                        }
                    };
                    return this.$http
                        .get(this.apiTarefasHistorico + "/completed", config)
                        .then(function (response) { return response.data; }, function () { return []; });
                };
                MinhasTarefasService.prototype.listUsersByResources = function (resources, filterBySetorUsuario) {
                    var _this = this;
                    var query = { permissoes: resources, lotacao: null };
                    var login = this.authService.getUserLogin();
                    if (filterBySetorUsuario) {
                        return this.authService.getUser()
                            .then(function (user) {
                            query.lotacao = user.lotacao;
                            return _this.$http.post(_this.apiUsuarios + "/usuarios/recursos", query)
                                .then(function (response) {
                                return response.data.filter(function (user) { return user.login !== login; });
                            });
                        });
                    }
                    return this.$http.post(this.apiUsuarios + "/usuarios/recursos", query)
                        .then(function (response) {
                        return response.data.filter(function (user) { return user.login !== login; });
                    });
                };
                MinhasTarefasService.prototype.listGroups = function () {
                    var _this = this;
                    return this.$http.get(this.apiUsuarios + "/usuario/grupos?tipo=FILTRO_TAREFA", { cache: true })
                        .then(function (response) {
                        var groups = [];
                        response.data.forEach(function (g) { return _this.addSubgroups(g, groups); });
                        return _.orderBy(groups, "nomeArvore");
                    });
                };
                MinhasTarefasService.prototype.notifyOpenTask = function (notification) {
                    var _this = this;
                    var task = notification.content;
                    this.$q.all([this.commandService.findByIdAndContext(task.command, task.context), this.authService.getUser()])
                        .then(function (values) {
                        if (values[0].notifyToOpenTask && values[1].login === notification.sender) {
                            _this.messagesService.task("Tarefa criada \"" + task.title + "\"", "Abrir")
                                .then(function (response) {
                                if (response === "ok") {
                                    _this.openTask(task);
                                }
                            });
                        }
                    });
                };
                MinhasTarefasService.prototype.openTask = function (task) {
                    var _this = this;
                    this.authService.getUser().then(function (user) {
                        if (task.assignee === null) {
                            var cmd = new AssumeTasksCommand();
                            cmd.addTask(task);
                            return _this.assumeTasks(cmd)
                                .then(function () {
                                _this.loadTask(task);
                                task.assignee = user.login;
                                task.selfAssigned = true;
                                return task;
                            });
                        }
                        else {
                            if (task.assignee !== user.login) {
                                _this.getNomesUsuarios([task.assignee]).then(function (resultado) {
                                    var nomeUsuario = task.assignee;
                                    for (var _i = 0, _a = Object.entries(resultado); _i < _a.length; _i++) {
                                        var _b = _a[_i], key = _b[0], value = _b[1];
                                        nomeUsuario = value;
                                    }
                                    _this.assumeDialog(task, nomeUsuario).then(function (response) {
                                        var cmd = new AssumeTasksCommand();
                                        cmd.addTask(task);
                                        _this.assumeTasks(cmd)
                                            .then(function () {
                                            task.assignee = user.login;
                                            task.selfAssigned = true;
                                            _this.loadTask(task);
                                        });
                                    });
                                });
                            }
                            else {
                                _this.loadTask(task);
                            }
                        }
                    });
                };
                MinhasTarefasService.prototype.assumeTask = function (task) {
                    var _this = this;
                    return this.authService.getUser().then(function (user) {
                        if (task.assignee === null) {
                            var cmd = new AssumeTasksCommand();
                            cmd.addTask(task);
                            return _this.assumeTasks(cmd)
                                .then(function () {
                                task.assignee = user.login;
                                task.selfAssigned = true;
                                return task;
                            });
                        }
                        else if (task.assignee !== user.login) {
                            _this.getNomesUsuarios([task.assignee]).then(function (resultado) {
                                var nomeUsuario = task.assignee;
                                for (var _i = 0, _a = Object.entries(resultado); _i < _a.length; _i++) {
                                    var _b = _a[_i], key = _b[0], value = _b[1];
                                    nomeUsuario = value;
                                }
                                return _this.assumeDialog(task, nomeUsuario).then(function (response) {
                                    var cmd = new AssumeTasksCommand();
                                    cmd.addTask(task);
                                    return _this.assumeTasks(cmd).then(function () {
                                        task.assignee = user.login;
                                        task.selfAssigned = true;
                                        return task;
                                    });
                                });
                            });
                        }
                        else {
                            return task;
                        }
                    });
                };
                MinhasTarefasService.prototype.isTaskAssignedToLoggedUser = function (task) {
                    return this.authService.getUser().then(function (user) {
                        return task.assignee === user.login;
                    });
                };
                MinhasTarefasService.prototype.viewTask = function (task, additionalParams) {
                    this.loadTask(task, additionalParams, true);
                };
                MinhasTarefasService.prototype.deleteTaskDraftByNotification = function (notification) {
                    var _this = this;
                    this.authService.getUser().then(function (user) {
                        if (notification.sender === user.login) {
                            var task = notification.content;
                            _this.deleteTaskDraft(task);
                        }
                    });
                };
                MinhasTarefasService.prototype.assumeDialog = function (task, nomeUsuario) {
                    var _this = this;
                    return this.authService.getUser().then(function (user) {
                        var title;
                        var content;
                        if (task.assignee && task.assignee !== user.login) {
                            title = "Tarefa atribu\u00EDda a outro usu\u00E1rio!";
                            content = "A tarefa '" + task.title + "' foi atribu\u00EDda a '" + nomeUsuario + "'. ";
                        }
                        else {
                            title = "Assumir tarefa?";
                            content = "A tarefa n\u00E3o possui respons\u00E1vel. ";
                        }
                        content += "Deseja assumi-la?";
                        return _this.$mdDialog.show(_this.$mdDialog.confirm()
                            .title(title)
                            .textContent(content)
                            .clickOutsideToClose(false)
                            .parent(_this.$document.find("body"))
                            .ok("Assumir")
                            .cancel("Cancelar"));
                    });
                };
                MinhasTarefasService.prototype.loadTask = function (task, additionalParams, isView) {
                    var _this = this;
                    if (isView === void 0) { isView = false; }
                    this.authService.getUser().then(function (user) {
                        task.isView = isView;
                        if (task.assignee && task.assignee === user.login) {
                            task.selfAssigned = true;
                        }
                        _this.commandService.findByIdAndContext(task.command, task.context)
                            .then(function (command) { return _this.openTaskWithDraft(task, command, additionalParams); })
                            .catch(function (reason) {
                            _this.messagesService.error("Voc\u00EA n\u00E3o tem permiss\u00E3o para abrir a tarefa: " + task.title + ".");
                            throw new Error(reason);
                        });
                    });
                };
                MinhasTarefasService.prototype.openTaskWithDraft = function (task, command, additionalParams) {
                    var _this = this;
                    var contextTask = angular.copy(task);
                    if (!command.route || !command.route.types || command.route.types.find(function (x) { return x == 'ui1'; })) {
                        if (task.draft && task.draft.modifiedBy && task.draft.modifiedDate) {
                            var draft_1;
                            this.loadTaskDraft(task)
                                .then(function (taskDraft) {
                                if (taskDraft) {
                                    draft_1 = taskDraft.commandJSON;
                                }
                            }).finally(function () {
                                _this.$state.go(command.route.stateName, Object.assign({ task: contextTask, draft: draft_1 }, additionalParams));
                            });
                        }
                        else {
                            this.$state.go(command.route.stateName, Object.assign({ task: contextTask }, additionalParams));
                        }
                    }
                    else if (command.route.types.find(function (x) { return 'ui2'; })) {
                        this.$state.go('app.upgraded', Object.assign({ url: "tarefas/" + task.context + "/" + task.id }));
                    }
                };
                MinhasTarefasService.prototype.addSubgroups = function (group, groups) {
                    var _this = this;
                    groups.push(group);
                    if (!!group.subgrupos && group.subgrupos.length > 0) {
                        group.subgrupos
                            .filter(function (g) { return groups.findIndex(function (group) { return group.id === g.id; }) == -1; })
                            .forEach(function (g) { return _this.addSubgroups(g, groups); });
                        group.subgrupos = [];
                    }
                };
                return MinhasTarefasService;
            }());
            minhasTarefas.MinhasTarefasService = MinhasTarefasService;
            var SERVICE_NAME = "app.tarefas.minhas-tarefas.MinhasTarefasService";
            var config = /** @ngInject */ ["errorHandlerProvider", "httpPromiseTransformationProvider", "$provide", function (errorHandlerProvider, httpPromiseTransformationProvider, $provide) {
                httpPromiseTransformationProvider.decorate($provide, SERVICE_NAME);
                errorHandlerProvider.decorate($provide, SERVICE_NAME);
            }];
            config.$inject = ["errorHandlerProvider", "httpPromiseTransformationProvider", "$provide"];
            angular
                .module("app.tarefas.minhas-tarefas")
                .service(SERVICE_NAME, MinhasTarefasService)
                .config(config);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            "use strict";
            var TarefasCacheService = /** @class */ (function () {
                /** @ngInject **/
                TarefasCacheService.$inject = ["$state", "authorizationService", "authService", "$timeout", "$rootScope"];
                function TarefasCacheService($state, authorizationService, authService, $timeout, $rootScope) {
                    var _this = this;
                    this.$state = $state;
                    this.authorizationService = authorizationService;
                    this.authService = authService;
                    this.$timeout = $timeout;
                    this.tasks = [];
                    this.loaded = false;
                    $rootScope.$on("$stateChangeSuccess", function (event, toState) {
                        if (toState.name === "app.login") {
                            _this.clear();
                        }
                    });
                    $rootScope.$on("task:created", function (event, notification) {
                        _this.onTaskCreated(notification);
                    });
                    $rootScope.$on("task:assigned", function (event, notification) {
                        _this.onTaskAssigned(notification);
                    });
                    $rootScope.$on("task:tagged", function (event, notification) {
                        _this.onTaskTagged(notification);
                    });
                    $rootScope.$on("task:renamed", function (event, notification) {
                        _this.onTaskRenamed(notification);
                    });
                    angular.forEach(["task:completed", "task:canceled", "task:removed", "task:hidden"], function (removeEvent) {
                        $rootScope.$on(removeEvent, function (event, notification) {
                            _this.onTaskRemoved(notification);
                        });
                    });
                    angular.forEach({ assigneeGroup: "task:assigned-group", priority: "task:prioritized",
                        notes: "task:annotated", draft: "task:saved", extraInfo: "task:informed",
                        restricted: "task:restricted" }, function (eventName, property) {
                        $rootScope.$on(eventName, function (event, notification) {
                            _this.onTaskPropertyModified(notification, property);
                        });
                    });
                }
                TarefasCacheService.prototype.register = function (tasks) {
                    var _a;
                    this.tasks.splice(0, this.tasks.length);
                    (_a = this.tasks).push.apply(_a, tasks);
                    this.loaded = true;
                };
                TarefasCacheService.prototype.get = function () {
                    return this.tasks;
                };
                TarefasCacheService.prototype.isLoaded = function () {
                    return this.loaded;
                };
                TarefasCacheService.prototype.clear = function () {
                    this.tasks.splice(0, this.tasks.length);
                    this.loaded = false;
                };
                TarefasCacheService.prototype.remove = function (task) {
                    var tasksRemoved = _.remove(this.tasks, function (t) { return t.id === task.id && t.context === task.context; });
                    if (tasksRemoved.length > 0) {
                        this.executeCallback(this.taskCallbackFn);
                    }
                };
                TarefasCacheService.prototype.registerTaskCreatedCallbackFn = function (cb) {
                    this.taskCreatedCallbackFn = cb;
                };
                TarefasCacheService.prototype.registerTaskAssignedCallbackFn = function (cb) {
                    this.taskAssignedCallbackFn = cb;
                };
                TarefasCacheService.prototype.registerTaskTaggedCallbackFn = function (cb) {
                    this.taskTaggedCallbackFn = cb;
                };
                TarefasCacheService.prototype.registerTaskCallbackFn = function (cb) {
                    this.taskCallbackFn = cb;
                };
                TarefasCacheService.prototype.unregisterCallbacks = function () {
                    this.taskAssignedCallbackFn = undefined;
                    this.taskCreatedCallbackFn = undefined;
                    this.taskTaggedCallbackFn = undefined;
                    this.taskCallbackFn = undefined;
                };
                TarefasCacheService.prototype.onTaskCreated = function (notification) {
                    var _this = this;
                    var task = notification.content;
                    var taskFound = this.findTask(task.context, task.id);
                    if (!taskFound) {
                        this.authorizationService.findPermission(task.command, task.context, false)
                            .then(function (permission) { return _this.loadCreatedTask(task, (!!permission ? false : true)); })
                            .catch(function () { return _this.loadCreatedTask(task, true); });
                        this.executeCallback(this.taskCreatedCallbackFn, task);
                    }
                };
                TarefasCacheService.prototype.onTaskAssigned = function (notification, retries) {
                    var _this = this;
                    if (retries === void 0) { retries = 0; }
                    var task = notification.content;
                    var taskFound = this.findTask(task.context, task.id);
                    if (taskFound) {
                        taskFound.assignee = task.assignee;
                        taskFound.claimDate = task.claimDate;
                        taskFound.assignor = task.assignor;
                        taskFound.selfAssigned = taskFound.assignee === this.authService.getUserLogin();
                        this.executeCallback(this.taskAssignedCallbackFn, taskFound);
                    }
                    else {
                        this.retry(function (nextRetries) { return _this.onTaskAssigned(notification, nextRetries); }, retries);
                    }
                };
                TarefasCacheService.prototype.onTaskTagged = function (notification, retries) {
                    var _this = this;
                    if (retries === void 0) { retries = 0; }
                    var task = notification.content;
                    var taskFound = this.findTask(task.context, task.id);
                    if (taskFound) {
                        taskFound.etags = notification.content.tags;
                        this.executeCallback(this.taskTaggedCallbackFn, taskFound);
                    }
                    else {
                        this.retry(function (nextRetries) { return _this.onTaskTagged(notification, nextRetries); }, retries);
                    }
                };
                TarefasCacheService.prototype.onTaskRenamed = function (notification, retries) {
                    var _this = this;
                    if (retries === void 0) { retries = 0; }
                    var task = notification.content;
                    var taskFound = this.findTask(task.context, task.id);
                    if (taskFound) {
                        taskFound.title = task.title;
                        if (!!task.searchableId && task.searchableId.length > 0) {
                            taskFound.searchableId = task.searchableId;
                        }
                        if (!!task.informationId && task.informationId.length > 0) {
                            taskFound.informationId = task.informationId;
                        }
                        this.executeCallback(this.taskCallbackFn, taskFound);
                    }
                    else {
                        this.retry(function (nextRetries) { return _this.onTaskRenamed(notification, nextRetries); }, retries);
                    }
                };
                TarefasCacheService.prototype.onTaskRemoved = function (notification, retries) {
                    var _this = this;
                    if (retries === void 0) { retries = 0; }
                    var task = notification.content;
                    var tasksRemoved = _.remove(this.tasks, function (t) { return t.id === task.id && t.context === task.context; });
                    if (tasksRemoved.length > 0) {
                        this.executeCallback(this.taskCallbackFn);
                    }
                    else {
                        this.retry(function (nextRetries) { return _this.onTaskRemoved(notification, nextRetries); }, retries);
                    }
                };
                TarefasCacheService.prototype.onTaskPropertyModified = function (notification, property, retries) {
                    var _this = this;
                    if (retries === void 0) { retries = 0; }
                    var task = notification.content;
                    var taskFound = this.findTask(task.context, task.id);
                    if (taskFound) {
                        taskFound[property] = task[property];
                        this.executeCallback(this.taskCallbackFn, taskFound);
                    }
                    else {
                        this.retry(function (nextRetries) { return _this.onTaskPropertyModified(notification, property, nextRetries); }, retries);
                    }
                };
                TarefasCacheService.prototype.loadCreatedTask = function (task, readOnly) {
                    task.readOnly = readOnly;
                    task.startDate = new Date(task.startDate).toISOString();
                    this.tasks.push(task);
                };
                TarefasCacheService.prototype.findTask = function (context, id) {
                    return this.tasks.find(function (task) { return task.id === id && task.context === context; });
                };
                TarefasCacheService.prototype.executeCallback = function (cb, task) {
                    if (!!cb && this.isTaskState()) {
                        cb(task);
                    }
                };
                TarefasCacheService.prototype.retry = function (eventFn, retries) {
                    if (retries <= TarefasCacheService.MAX_RETRIES) {
                        this.$timeout(function () {
                            retries++;
                            eventFn(retries);
                        }, TarefasCacheService.DELAY);
                    }
                };
                TarefasCacheService.prototype.isTaskState = function () {
                    return this.$state.current.name === "app.tarefas.minhas-tarefas";
                };
                TarefasCacheService.DELAY = 500;
                TarefasCacheService.MAX_RETRIES = 3;
                return TarefasCacheService;
            }());
            minhasTarefas.TarefasCacheService = TarefasCacheService;
            var SERVICE_NAME = "app.tarefas.minhas-tarefas.TarefasCacheService";
            angular
                .module("app.tarefas.minhas-tarefas")
                .service(SERVICE_NAME, TarefasCacheService);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            "use strict";
            var API_ROTULOS = "tasks/tags.json";
            var TYPE_DEFAULT = "AAA";
            var RotulosService = /** @class */ (function () {
                /** @ngInject **/
                RotulosService.$inject = ["$http", "properties", "$log", "$mdDialog", "$q"];
                function RotulosService($http, properties, $log, $mdDialog, $q) {
                    this.$http = $http;
                    this.properties = properties;
                    this.$log = $log;
                    this.$mdDialog = $mdDialog;
                    this.$q = $q;
                    this.cancelableTag = {
                        id: "ui:cancelable",
                        tasks: [],
                        name: "Cancelável",
                        type: TYPE_DEFAULT,
                        color: "#000000"
                    };
                }
                RotulosService.prototype.load = function (task, manualTags) {
                    var _this = this;
                    if (manualTags === void 0) { manualTags = []; }
                    return this.$http.get(this.properties.apiUrl + "/" + task.context + "/" + API_ROTULOS, { cache: true })
                        .then(function (response) {
                        var _a;
                        try {
                            task.tags = [];
                            if (angular.isArray(response.data)) {
                                (_a = response.data).push.apply(_a, manualTags);
                                response.data.filter(function (tag) { return _this.filterTag(task, tag); })
                                    .forEach(function (tag) { return _this.pushTag(task, tag); });
                                if (task.cancelable) {
                                    _this.pushTag(task, _this.cancelableTag);
                                }
                                task.tags.sort(function (t1, t2) {
                                    if (t1.name > t2.name) {
                                        return 1;
                                    }
                                    if (t1.name < t2.name) {
                                        return -1;
                                    }
                                    return 0;
                                });
                            }
                        }
                        catch (err) {
                            _this.$log.error("Erro ao carregar tags do contexto " + task.context);
                        }
                    });
                };
                RotulosService.prototype.loadManualTags = function () {
                    return this.$http.get(this.properties.apiUrl + "/integracoes-tarefas/api/tags")
                        .then(function (response) {
                        response.data.forEach(function (t) {
                            t.tasks = [t.id];
                            t.type = (!t.type) ? "Manuais" : t.type;
                        });
                        return response.data;
                    }, function () { return []; });
                };
                RotulosService.prototype.create = function (tag) {
                    return this.$http({
                        method: "post",
                        url: this.properties.apiUrl + "/integracoes-tarefas/api/tags",
                        data: tag,
                        transformResponse: function (value) { return value; }
                    })
                        .then(function (response) {
                        return {
                            id: response.data,
                            name: tag.name,
                            tasks: [response.data],
                            color: tag.color,
                            tooltip: tag.tooltip,
                            tenantsPermitidos: tag.tenantsPermitidos,
                            type: "Manuais"
                        };
                    });
                };
                RotulosService.prototype.update = function (tag) {
                    var cmd = {
                        id: tag.id,
                        name: tag.name,
                        color: tag.color
                    };
                    return this.$http.put(this.properties.apiUrl + "/integracoes-tarefas/api/tags/" + tag.id, cmd)
                        .then(function (response) { return response.data; });
                };
                RotulosService.prototype.remove = function (tags) {
                    var _this = this;
                    var deletes = tags.map(function (tag) {
                        return _this.$http.delete(_this.properties.apiUrl + "/integracoes-tarefas/api/tags/" + tag);
                    });
                    return this.$q.all(deletes)
                        .then(function () { return tags; });
                };
                RotulosService.prototype.pushTag = function (task, tag) {
                    if (!tag.type) {
                        tag.type = TYPE_DEFAULT;
                    }
                    task.tags.push(tag);
                };
                RotulosService.prototype.filterTag = function (task, tag) {
                    return tag.tasks.indexOf(task.command) > -1 ||
                        (!!task.etags && tag.tasks.some(function (t) { return task.etags.indexOf(t) > -1; }));
                };
                return RotulosService;
            }());
            minhasTarefas.RotulosService = RotulosService;
            angular
                .module("app.tarefas.minhas-tarefas")
                .service("app.tarefas.minhas-tarefas.RotulosService", RotulosService);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            "use strict";
            var ExportarTarefasService = /** @class */ (function () {
                /** @ngInject **/
                ExportarTarefasService.$inject = ["$q", "$filter"];
                function ExportarTarefasService($q, $filter) {
                    this.$q = $q;
                    this.$filter = $filter;
                    this.sheet_name = "Histórico de tarefas";
                    this.header = [
                        "Nome da tarefa",
                        "Data de criação",
                        'Data de atribuição',
                        'Usuário responsável',
                        'Situação final',
                        'Data de conclusão/cancelamento',
                        'Resultado da conclusão/Justificativa do cancelamento',
                        'Informações extras',
                        'Rótulos'
                    ];
                    this.usersNames = new Map();
                }
                ExportarTarefasService.prototype.exportarHistoricoTarefas = function (tasks, usersNames, parametros, nomeRelatorio) {
                    this.usersNames = usersNames;
                    var defer = this.$q.defer();
                    var conteudo = this.formatarConteudoRelatorio(tasks, parametros);
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet([]);
                    var cabecalho = this.header.filter(function (h) { return parametros.filter(function (p) { return p.descricao === h; }).length > 0; });
                    var wscols = [];
                    // definindo o tamanho das colunas de acordo com o tamanho do titulo
                    cabecalho.forEach(function (c) {
                        if (c.length > 25)
                            wscols.push({ wch: c.length });
                        else
                            wscols.push({ wch: 25 });
                    });
                    ws["!cols"] = wscols;
                    XLSX.utils.sheet_add_aoa(ws, [cabecalho]);
                    XLSX.utils.sheet_add_json(ws, conteudo, { origin: 'A2', skipHeader: true });
                    XLSX.utils.book_append_sheet(wb, ws, this.sheet_name);
                    XLSX.writeFile(wb, nomeRelatorio, function (err) {
                        (err) ? defer.reject(err) : defer.resolve();
                    });
                    defer.resolve();
                    return defer.promise;
                };
                ExportarTarefasService.prototype.formatarConteudoRelatorio = function (tasks, parametros) {
                    var _this = this;
                    var conteudo = [];
                    tasks.forEach(function (tarefa) {
                        var taskValues = {}, result = [];
                        // Formata os campos de acordo com regras de cada um
                        parametros.forEach(function (param) {
                            var descricao = param["descricao"];
                            if (!!param.nome) {
                                taskValues[descricao] = _this.aplicarRegras(tarefa, param.nome, param);
                            }
                            else if (!!param.funcaoDeFormatacao) {
                                var text = _this[param.funcaoDeFormatacao](tarefa);
                                taskValues[descricao] = text;
                            }
                        });
                        // Ordena o conteúdo
                        _this.header.forEach(function (header) {
                            if (!!taskValues[header])
                                result.push(taskValues[header]);
                        });
                        conteudo.push(result);
                    });
                    return conteudo;
                };
                ExportarTarefasService.prototype.aplicarRegras = function (tarefa, fieldName, param) {
                    if (param.tipo === 'array' && !!tarefa[fieldName]) {
                        if (fieldName === 'extraInfo') {
                            return this.formatarExtraInfo(tarefa[fieldName]);
                        }
                        else if (!!tarefa[fieldName][0] && !!tarefa[fieldName][0]['name']) {
                            return tarefa[fieldName].map(function (t) { return t.name; }).join(', ');
                        }
                    }
                    else if (param.tipo === 'date') {
                        return this.formatDate(tarefa[fieldName]);
                    }
                    else if (!tarefa[fieldName] || tarefa[fieldName] == '') {
                        return '-';
                    }
                    else if (fieldName === 'assignee') {
                        return this.formatNomeUsuario(tarefa[fieldName]);
                    }
                    return tarefa[fieldName];
                };
                ExportarTarefasService.prototype.formatDate = function (date) {
                    if (!!date)
                        return this.$filter("date")(date, "dd/MM/yyyy HH:mm:ss");
                    return '-';
                };
                ExportarTarefasService.prototype.formatarExtraInfo = function (extraInfo) {
                    var text = '';
                    for (var chave in extraInfo) {
                        if (!!extraInfo[chave]) {
                            text += chave + ": " + extraInfo[chave] + "; ";
                        }
                    }
                    if (text == '')
                        text = '-';
                    return text.trim();
                };
                ExportarTarefasService.prototype.formatDataConclusaoCancelamento = function (tarefa) {
                    if (tarefa.completed) {
                        return this.formatDate(tarefa.completedDate);
                    }
                    else if (!!tarefa.cancellation && !!tarefa.cancellation.canceledDate) {
                        return this.formatDate(tarefa.cancellation.canceledDate);
                    }
                    return '-';
                };
                ExportarTarefasService.prototype.formatResultadoJustificativa = function (tarefa) {
                    if (!!tarefa.completed && !!tarefa.extraInfo && !!tarefa.extraInfo.Resultado) {
                        return tarefa.extraInfo.Resultado;
                    }
                    else if (!tarefa.completed && !!tarefa.cancellation && !!tarefa.cancellation.reason) {
                        return tarefa.cancellation.reason;
                    }
                    return '-';
                };
                ExportarTarefasService.prototype.formatNomeUsuario = function (assignee) {
                    if (assignee && this.usersNames && this.usersNames.has(assignee)) {
                        return this.usersNames.get(assignee) + " (" + assignee + ")";
                    }
                    return assignee;
                };
                ExportarTarefasService.prototype.formatResultadoFinal = function (tarefa) {
                    if (!!tarefa.completed) {
                        return 'Concluída';
                    }
                    else if (!tarefa.completed && !!tarefa.cancellation && !!tarefa.cancellation.reason) {
                        return 'Cancelada';
                    }
                    return '-';
                };
                return ExportarTarefasService;
            }());
            minhasTarefas.ExportarTarefasService = ExportarTarefasService;
            angular
                .module("app.tarefas.minhas-tarefas")
                .service("app.tarefas.minhas-tarefas.ExportarTarefasService", ExportarTarefasService);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var NotasController = /** @class */ (function () {
                /** @ngInject */
                NotasController.$inject = ["$scope", "$mdDialog", "$document"];
                function NotasController($scope, $mdDialog, $document) {
                    var _this = this;
                    this.$mdDialog = $mdDialog;
                    this.$document = $document;
                    this.tarefa = $scope.tarefa;
                    $scope.$on("task:annotated", function (event, notification) {
                        var tarefa = notification.content;
                        if (tarefa.id === _this.tarefa.id && tarefa.context === _this.tarefa.context) {
                            _this.tarefa.notes = tarefa.notes;
                        }
                    });
                }
                NotasController.prototype.setNotas = function () {
                    this.$mdDialog.show({
                        controller: minhasTarefas.AnnotateController,
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/notes/notes.html",
                        parent: this.$document.find('body'),
                        clickOutsideToClose: true,
                        locals: { task: this.tarefa }
                    });
                };
                return NotasController;
            }());
            var NotasDirective = /** @class */ (function () {
                function NotasDirective() {
                    this.restrict = "AE";
                    this.templateUrl = "app/main/tarefas/minhas-tarefas/directives/notas.tpl.html";
                    this.controllerAs = "vm";
                    this.controller = NotasController;
                    this.scope = {
                        tarefa: "="
                    };
                }
                NotasDirective.factory = function () {
                    return function () { return new NotasDirective(); };
                };
                return NotasDirective;
            }());
            angular.module("app.tarefas.minhas-tarefas").directive("notasTarefa", NotasDirective.factory());
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var dashboards;
        (function (dashboards) {
            'use strict';
            angular
                .module('app.support.dashboards', ['app.support', 'oc.lazyLoad']);
        })(dashboards = support.dashboards || (support.dashboards = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var dashboards;
        (function (dashboards) {
            'use strict';
            var DashletDirective = /** @class */ (function () {
                function DashletDirective($timeout, dashletRegistry, $compile) {
                    var _this = this;
                    this.$timeout = $timeout;
                    this.dashletRegistry = dashletRegistry;
                    this.$compile = $compile;
                    this.restrict = 'E';
                    this.scope = {
                        value: '='
                    };
                    this.link = function (scope, element, attrs) {
                        _this.$timeout(function () {
                            var dashletName = scope.value;
                            var dashlet = _this.dashletRegistry.recoverDashlet(dashletName);
                            var controller = dashlet.controller;
                            var template = dashlet.template;
                            var alias = dashlet.controllerAs;
                            var directiveHtml = "<div data-ng-controller=\"" + controller + " as " + alias + "\" class=\"p-8\">" + template + "</div>";
                            element.html(directiveHtml);
                            var link = _this.$compile(element.contents());
                            link(scope);
                        });
                    };
                }
                DashletDirective.factory = function () {
                    return ["$timeout", "dashletRegistry", "$compile", function ($timeout, dashletRegistry, $compile) {
                        "ngInject";
                        return new DashletDirective($timeout, dashletRegistry, $compile);
                    }];
                };
                return DashletDirective;
            }());
            angular.module('app.support.dashboards').directive('dashlet', DashletDirective.factory());
        })(dashboards = support.dashboards || (support.dashboards = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var dashboards;
        (function (dashboards) {
            'use strict';
            var DashboardController = /** @class */ (function () {
                /** @ngInject **/
                DashboardController.$inject = ["$scope", "dashboardLayoutManagerRegistry"];
                function DashboardController($scope, dashboardLayoutManagerRegistry) {
                    var _this = this;
                    this.$scope = $scope;
                    this.dashboardLayoutManagerRegistry = dashboardLayoutManagerRegistry;
                    this.$scope.$watch('value', function () {
                        var dashboard;
                        if (_this.$scope.value) {
                            dashboard = _this.$scope.value;
                            var dashlets = void 0;
                            if (dashboard.dashlets) {
                                dashlets = dashboard.dashlets;
                            }
                            else {
                                dashlets = [];
                            }
                            if (dashboard.layoutManager) {
                                _this.layout = dashboardLayoutManagerRegistry.recoverLayoutManager(dashboard.layoutManager.id).layout(dashlets, dashboard.layoutManager.params);
                            }
                            else {
                                _this.layout = dashboardLayoutManagerRegistry.recoverLayoutManager("default").layout(dashlets);
                            }
                        }
                    });
                }
                return DashboardController;
            }());
            var DashboardDirective = /** @class */ (function () {
                function DashboardDirective() {
                    this.restrict = 'E';
                    this.templateUrl = 'app/main/support/dashboards/directives/dashboard.tpl.html';
                    this.scope = {
                        value: "="
                    };
                    this.controller = DashboardController;
                    this.controllerAs = 'vm';
                }
                DashboardDirective.factory = function () {
                    return function () {
                        return new DashboardDirective();
                    };
                };
                return DashboardDirective;
            }());
            angular
                .module('app.support.dashboards')
                .directive('dashboard', DashboardDirective.factory());
        })(dashboards = support.dashboards || (support.dashboards = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var quickPanel;
    (function (quickPanel) {
        'use strict';
        /** @ngInject */
        config.$inject = ["$translatePartialLoaderProvider"];
        function config($translatePartialLoaderProvider) {
            $translatePartialLoaderProvider.addPart('app/main/quick-panel');
        }
        angular
            .module('app.quick-panel', ['app.support'])
            .config(config);
    })(quickPanel = app.quickPanel || (app.quickPanel = {}));
})(app || (app = {}));



var app;
(function (app) {
    var quickPanel;
    (function (quickPanel) {
        var notification;
        (function (notification_1) {
            "use strict";
            var FeedService = /** @class */ (function () {
                /** @ngInject */
                FeedService.$inject = ["$http", "$rootScope", "$cookies", "properties", "identidadesService"];
                function FeedService($http, $rootScope, $cookies, properties, identidadesService) {
                    this.$http = $http;
                    this.$rootScope = $rootScope;
                    this.$cookies = $cookies;
                    this.identidadesService = identidadesService;
                    this.apiNotifications = '/integracoes-modulos/api/notifications';
                    this.apiNotifications = properties.apiUrl + this.apiNotifications;
                }
                FeedService.prototype.list = function () {
                    var _this = this;
                    return this.$http.get(this.apiNotifications)
                        .then(function (response) {
                        var notifications = response.data;
                        var unread = 0;
                        var feed = notifications
                            .filter(function (notification) { return !!notification; })
                            .map(function (notification) {
                            unread += (notification.read ? 0 : 1);
                            return _this.toFeedItem(notification);
                        });
                        _this.$rootScope.$broadcast('feed:unread', unread);
                        return feed;
                    });
                };
                FeedService.prototype.read = function (itens) {
                    if (!angular.isArray(itens)) {
                        throw new Error("Notificações não informadas!");
                    }
                    var uuids = [];
                    itens.forEach(function (item) {
                        item.read = !item.read;
                        uuids.push(item.uuid);
                    });
                    return this.$http.post(this.apiNotifications, uuids);
                };
                FeedService.prototype.remove = function (uuid) {
                    return this.$http.delete(this.apiNotifications + "/" + uuid);
                };
                FeedService.prototype.removeAll = function () {
                    return this.$http.delete(this.apiNotifications + "/all");
                };
                FeedService.prototype.toFeedItem = function (notification) {
                    var feedItem = notification.content;
                    feedItem.uuid = notification.uuid;
                    feedItem.sender = notification.sender;
                    feedItem.creationDate = notification.creationDate;
                    return feedItem;
                };
                FeedService.prototype.getNomeApresentacao = function (loginUsuarios) {
                    return this.identidadesService.getNomeApresentacao(loginUsuarios);
                };
                return FeedService;
            }());
            notification_1.FeedService = FeedService;
            angular
                .module("app.quick-panel")
                .service("app.quick-panel.FeedService", FeedService);
        })(notification = quickPanel.notification || (quickPanel.notification = {}));
    })(quickPanel = app.quickPanel || (app.quickPanel = {}));
})(app || (app = {}));



var app;
(function (app) {
    var quickPanel;
    (function (quickPanel) {
        var notification;
        (function (notification_1) {
            "use strict";
            var FeedController = /** @class */ (function () {
                function FeedController($scope, feedService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.feedService = feedService;
                    this.feed = [];
                    this.usersNames = new Map();
                    feedService.list().then(function (feed) {
                        _this.feed = feed;
                        _this.loadUsersNames(_this.feed);
                    });
                    $scope.$on("feed", function (event, notification) {
                        var newFeed = _this.feedService.toFeedItem(notification);
                        _this.feed.unshift(newFeed);
                        _this.loadUsersNames([newFeed]);
                    });
                    $scope.$on('feed:readed', function (event) {
                        _this.feedService.read(_this.feed);
                    });
                }
                FeedController.prototype.remove = function (item) {
                    var _this = this;
                    this.feedService.remove(item.uuid)
                        .then(function () {
                        _this.feed.splice(_this.feed.findIndex(function (i) { return i.uuid === item.uuid; }), 1);
                    });
                };
                FeedController.prototype.removeAll = function () {
                    var _this = this;
                    this.feedService.removeAll()
                        .then(function () {
                        _this.feed = [];
                    });
                };
                FeedController.prototype.loadMore = function () {
                    var _this = this;
                    this.feedService.list().then(function (feed) {
                        _this.feed = feed;
                        _this.loadUsersNames(_this.feed);
                    });
                };
                FeedController.prototype.loadUsersNames = function (itens) {
                    var _this = this;
                    var usuarios = new Set();
                    itens.forEach(function (item) {
                        if (item.sender && !_this.usersNames.has(item.sender.toLowerCase()))
                            usuarios.add(item.sender.toLowerCase());
                    });
                    if (usuarios && usuarios.size > 0) {
                        this.feedService.getNomeApresentacao(Array.from(usuarios)).then(function (resultado) {
                            for (var _i = 0, _a = Object.entries(resultado); _i < _a.length; _i++) {
                                var _b = _a[_i], login = _b[0], nome = _b[1];
                                _this.usersNames.set(login, nome);
                            }
                        });
                    }
                };
                FeedController.$inject = ["$scope", "app.quick-panel.FeedService"];
                return FeedController;
            }());
            notification_1.FeedController = FeedController;
            angular
                .module("app.quick-panel")
                .controller("app.quick-panel.FeedController", FeedController);
        })(notification = quickPanel.notification || (quickPanel.notification = {}));
    })(quickPanel = app.quickPanel || (app.quickPanel = {}));
})(app || (app = {}));



var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        'use strict';
        /** @ngInject **/
        config.$inject = ["$translatePartialLoaderProvider", "$stateProvider", "msNavigationServiceProvider", "properties"];
        function config($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider, properties) {
            $translatePartialLoaderProvider.addPart('app/main/pesquisa-avancada');
            $stateProvider.state('app.pesquisa-avancada', {
                parent: 'app.autenticado',
                url: '/pesquisa-avancada',
                abstract: true
            });
        }
        function run(pesquisaAvancadaService) {
            pesquisaAvancadaService.loadQueries();
        }
        run.$inject = ['app.pesquisa-avancada.PesquisaAvancadaService'];
        angular
            .module('app.pesquisa-avancada', ['app.autenticado', 'app.support'])
            .config(config)
            .run(run);
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));



var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        "use strict";
        var SaveSearchController = /** @class */ (function () {
            /** @ngInject **/
            SaveSearchController.$inject = ["$rootScope", "$log", "$mdDialog", "$translate", "messagesService", "app.pesquisa-avancada.PesquisaAvancadaService", "search"];
            function SaveSearchController($rootScope, $log, $mdDialog, $translate, messagesService, pesquisaAvancadaService, search) {
                this.$rootScope = $rootScope;
                this.$log = $log;
                this.$mdDialog = $mdDialog;
                this.$translate = $translate;
                this.messagesService = messagesService;
                this.pesquisaAvancadaService = pesquisaAvancadaService;
                this.search = search;
            }
            SaveSearchController.prototype.cancel = function () {
                this.$mdDialog.cancel();
            };
            SaveSearchController.prototype.confirm = function () {
                var _this = this;
                this.pesquisaAvancadaService.saveSearch(this.search)
                    .then(function (search) {
                    _this.$rootScope.$broadcast("save-search:confirm");
                    _this.messagesService.success(_this.$translate.instant("PESQUISA-AVANCADA.PESQUISA-SALVA"));
                }).catch(function (reason) {
                    _this.messagesService.error(_this.$translate.instant("PESQUISA-AVANCADA.PESQUISA-NAO-SALVA"));
                    _this.$log.error(reason);
                }).finally(function () { return _this.$mdDialog.cancel(); });
            };
            return SaveSearchController;
        }());
        pesquisaAvancada.SaveSearchController = SaveSearchController;
        angular
            .module("app.pesquisa-avancada")
            .controller("app.pesquisa-avancada.SaveSearchController", SaveSearchController);
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));



var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        "use strict";
        var ComparisonOperator = /** @class */ (function () {
            function ComparisonOperator() {
            }
            Object.defineProperty(ComparisonOperator, "EQUALS", {
                get: function () { return "EQUALS"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ComparisonOperator, "CONTAINS", {
                get: function () { return "CONTAINS"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ComparisonOperator, "BETWEEN", {
                get: function () { return "BETWEEN"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ComparisonOperator, "GREATER_THAN", {
                get: function () { return "GREATER_THAN"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ComparisonOperator, "LESS_THAN", {
                get: function () { return "LESS_THAN"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ComparisonOperator, "EXISTS", {
                get: function () { return "EXISTS"; },
                enumerable: true,
                configurable: true
            });
            return ComparisonOperator;
        }());
        pesquisaAvancada.ComparisonOperator = ComparisonOperator;
        var LogicalOperator = /** @class */ (function () {
            function LogicalOperator() {
            }
            Object.defineProperty(LogicalOperator, "MUST", {
                get: function () { return "MUST"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LogicalOperator, "SHOULD", {
                get: function () { return "SHOULD"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LogicalOperator, "MUST_NOT", {
                get: function () { return "MUST_NOT"; },
                enumerable: true,
                configurable: true
            });
            return LogicalOperator;
        }());
        pesquisaAvancada.LogicalOperator = LogicalOperator;
        var TraitListItem = /** @class */ (function () {
            function TraitListItem(id, value) {
                this.id = id;
                this.value = value;
            }
            ;
            return TraitListItem;
        }());
        pesquisaAvancada.TraitListItem = TraitListItem;
        var Criterion = /** @class */ (function () {
            function Criterion(logicalOperator, trait) {
                this.logicalOperator = logicalOperator;
                this.trait = trait;
                this.comparisonOperator = ComparisonOperator.EQUALS;
                this.valid = false;
                if (trait) {
                    if (trait.dataType === "constant") {
                        this.comparisonOperator = ComparisonOperator.EXISTS;
                        this.value = trait.name;
                    }
                    else if (trait.dataType === "date") {
                        this.comparisonOperator = ComparisonOperator.BETWEEN;
                    }
                    else if (trait.dataType === "string") {
                        this.comparisonOperator = ComparisonOperator.CONTAINS;
                    }
                }
                if (!logicalOperator) {
                    this.logicalOperator = LogicalOperator.MUST;
                }
            }
            return Criterion;
        }());
        pesquisaAvancada.Criterion = Criterion;
        var SearchBuilderDirective = /** @class */ (function () {
            function SearchBuilderDirective() {
                this.restrict = "E";
                this.templateUrl = "app/main/pesquisa-avancada/directives/search-builder/search-builder.html";
                this.scope = {
                    traits: "=",
                    search: "="
                };
                this.controller = pesquisaAvancada.SearchBuilderController;
                this.controllerAs = "vm";
            }
            SearchBuilderDirective.factory = function () {
                return function () { return new SearchBuilderDirective(); };
            };
            return SearchBuilderDirective;
        }());
        angular
            .module("app.pesquisa-avancada")
            .directive("searchBuilder", SearchBuilderDirective.factory());
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));



var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        "use strict";
        var SearchBuilderController = /** @class */ (function () {
            /** @ngInject **/
            SearchBuilderController.$inject = ["$scope", "$http", "properties"];
            function SearchBuilderController($scope, $http, properties) {
                var _a;
                var _this = this;
                this.$scope = $scope;
                this.$http = $http;
                this.properties = properties;
                this.logicalOperators = [pesquisaAvancada.LogicalOperator.MUST, pesquisaAvancada.LogicalOperator.SHOULD, pesquisaAvancada.LogicalOperator.MUST_NOT];
                this.comparisonOperators = (_a = {},
                    _a[pesquisaAvancada.ComparisonOperator.EQUALS] = ["keyword", "number", "currency", "list"],
                    _a[pesquisaAvancada.ComparisonOperator.CONTAINS] = ["string"],
                    _a[pesquisaAvancada.ComparisonOperator.BETWEEN] = ["number", "currency", "date"],
                    _a[pesquisaAvancada.ComparisonOperator.GREATER_THAN] = ["number", "currency", "date"],
                    _a[pesquisaAvancada.ComparisonOperator.LESS_THAN] = ["number", "currency", "date"],
                    _a[pesquisaAvancada.ComparisonOperator.EXISTS] = ["constant", "string", "keyword", "number", "currency", "date", "list"],
                    _a);
                this.traitSearchText = "";
                this.newCriterion = new pesquisaAvancada.Criterion();
                $scope.traits.forEach(function (trait) { return _this.loadTraitValuesIfNeeded(trait); });
                this.traits = $scope.traits;
                this.search = $scope.search;
            }
            SearchBuilderController.prototype.setCriterionLogicalOperator = function (criterion, operator) {
                criterion.logicalOperator = operator;
            };
            SearchBuilderController.prototype.removeCriterion = function (i) {
                _.pullAt(this.search.criteria, i);
            };
            SearchBuilderController.prototype.querySearch = function (query) {
                return query ? _.filter(this.traits, this.createFilterFor(query)) : this.traits;
            };
            SearchBuilderController.prototype.addNewCriterion = function () {
                var trait = angular.copy(this.newCriterion.trait);
                var logicalOperator = angular.copy(this.newCriterion.logicalOperator);
                var criterion = new pesquisaAvancada.Criterion(logicalOperator, trait);
                this.search.criteria.unshift(criterion);
            };
            SearchBuilderController.prototype.selectedItemChange = function (item) {
                if (!item) {
                    return;
                }
                this.addNewCriterion();
            };
            SearchBuilderController.prototype.cleanSelection = function (e) {
                if (!e.charCode) {
                    this.traitSearchText = "";
                }
            };
            SearchBuilderController.prototype.getComparisonOperators = function (dataType) {
                var operatorMapping = this.comparisonOperators;
                var ops = _.keys(operatorMapping);
                return _.reject(ops, function (op) { return !_.includes(operatorMapping[op], dataType); });
            };
            SearchBuilderController.prototype.createFilterFor = function (query) {
                var lowercaseQuery = _.deburr(angular.lowercase(query));
                return function (trait) { return (_.deburr(trait.name.toLowerCase()).indexOf(lowercaseQuery) !== -1); };
            };
            SearchBuilderController.prototype.loadTraitValuesIfNeeded = function (trait) {
                if (trait.api && !trait.values) {
                    trait.values = [];
                    this.$http.get(this.properties.apiUrl + trait.api, { cache: true })
                        .then(function (response) {
                        response.data.forEach(function (item) {
                            var id = trait.apiIdLowercase ? _.toLower(item[trait.apiId]) : item[trait.apiId];
                            var obj = new pesquisaAvancada.TraitListItem(id, item[trait.apiValue]);
                            trait.values.push(obj);
                        });
                    });
                }
            };
            return SearchBuilderController;
        }());
        pesquisaAvancada.SearchBuilderController = SearchBuilderController;
        angular
            .module("app.pesquisa-avancada")
            .controller("app.pesquisa-avancada.SearchBuilderController", SearchBuilderController);
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));



var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        "use strict";
        var OperatorColor = /** @class */ (function () {
            function OperatorColor() {
                this.restrict = "A";
                this.scope = {
                    operator: "=operatorColor"
                };
                this.link = OperatorColor.fnLink();
            }
            OperatorColor.fnLink = function () {
                return function ($scope, el, attr) {
                    var key = el[0].tagName.toLowerCase(), config = OperatorColor.defaults[key] || OperatorColor.defaults.other;
                    $scope.$watch("operator", function (value) {
                        var classes = _.union(_.values(config), [attr.operatorColorNegative, attr.operatorColorAfirmative]);
                        angular.forEach(classes, function (cl) { attr.$removeClass(cl); });
                        attr.$addClass(value === pesquisaAvancada.LogicalOperator.MUST_NOT ?
                            (attr.operatorColorNegative || config.negativeClass) :
                            (attr.operatorColorAfirmative || config.afirmativeClass));
                    });
                };
            };
            OperatorColor.factory = function () {
                return function () { return new OperatorColor(); };
            };
            OperatorColor.defaults = {
                button: {
                    afirmativeClass: "md-accent",
                    negativeClass: "md-warn"
                },
                i: {
                    afirmativeClass: "md-accent-fg",
                    negativeClass: "md-warn-fg"
                },
                other: {
                    afirmativeClass: "md-accent-bg",
                    negativeClass: "md-warn-bg"
                }
            };
            return OperatorColor;
        }());
        angular
            .module("app.pesquisa-avancada")
            .directive("operatorColor", OperatorColor.factory());
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));



var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        "use strict";
        var CriterionValueInputController = /** @class */ (function () {
            /** @ngInject **/
            CriterionValueInputController.$inject = ["$scope", "$mdDateLocale", "$filter", "$rootScope"];
            function CriterionValueInputController($scope, $mdDateLocale, $filter, $rootScope) {
                this.$scope = $scope;
                this.$mdDateLocale = $mdDateLocale;
                this.$filter = $filter;
                this.$rootScope = $rootScope;
                $scope.$watch("criterion.selectedItem", function () {
                    if ($scope.criterion.trait.dataType === "list" && _.isObject($scope.criterion.selectedItem)) {
                        $scope.criterion.display = $scope.criterion.selectedItem.value;
                        $scope.criterion.value = $scope.criterion.selectedItem.id.toString();
                    }
                    else if ($scope.criterion.selectedItem === null) {
                        $scope.criterion.display = null;
                        $scope.criterion.value = null;
                    }
                    CriterionValueInputController.updateCriteriaValidity($scope.criterion);
                });
                $scope.$watch("criterion.value[0]", function () {
                    CriterionValueInputController.updateCriteriaValidity($scope.criterion);
                });
                $scope.$watch("criterion.value[1]", function () {
                    CriterionValueInputController.updateCriteriaValidity($scope.criterion);
                });
                $scope.$watch("criterion.comparisonOperator", function (op) {
                    var criterion = $scope.criterion, value = criterion.value;
                    if (op == pesquisaAvancada.ComparisonOperator.BETWEEN) {
                        criterion.value = _.isArray(value) ? value : [value];
                    }
                    else {
                        criterion.value = _.isArray(value) ? value[0] : value;
                    }
                    CriterionValueInputController.updateCriteriaValidity(criterion);
                });
            }
            CriterionValueInputController.prototype.initBetween = function (index) {
                var startOfDay = (index ? false : true);
                this.$scope.date = this.$scope.date || [];
                this.$scope.criterion.value = this.$scope.criterion.value || [];
                this.$scope.date[index] = this.strToDate(this.$scope.criterion.value[index]);
                this.$scope.criterion.value[index] = this.dateToStr(this.$scope.date[index], startOfDay);
            };
            ;
            CriterionValueInputController.prototype.changeCriterionValue = function (value, index) {
                if (index === void 0) { index = null; }
                if (index !== null) {
                    this.$scope.criterion.value[index] = value;
                }
                else {
                    this.$scope.criterion.value = value;
                }
            };
            CriterionValueInputController.prototype.strToDate = function (str) {
                var m = moment(str, "YYYY-MM-DDTHH:mm:ss", true);
                return (m.isValid() ? m : moment()).toDate();
            };
            CriterionValueInputController.prototype.dateToStr = function (date, startOfDay) {
                if (date) {
                    return (startOfDay ? moment(date).startOf("day") : moment(date).endOf("day")).format("YYYY-MM-DDTHH:mm:ss");
                }
                return;
            };
            CriterionValueInputController.prototype.cleanSelection = function (e) {
                if (!e.charCode) {
                    this.$scope.criterion.selectedItem = null;
                }
            };
            CriterionValueInputController.prototype.ifEnterDoSearch = function ($event) {
                if ($event.keyCode === 13) {
                    this.$rootScope.$broadcast("ui:advancedSearch:doSearch");
                }
            };
            ;
            CriterionValueInputController.prototype.filterItems = function (items, searchText) {
                return this.$filter("accentInsensitiveOrderBy")(this.$filter("accentInsensitiveFilter")(items, searchText), "value");
            };
            CriterionValueInputController.updateCriteriaValidity = function (criterion) {
                if (criterion.value === undefined && criterion.comparisonOperator !== pesquisaAvancada.ComparisonOperator.EXISTS) {
                    criterion.valid = false;
                    return;
                }
                switch (criterion.comparisonOperator) {
                    case pesquisaAvancada.ComparisonOperator.EQUALS:
                    case pesquisaAvancada.ComparisonOperator.CONTAINS:
                    case pesquisaAvancada.ComparisonOperator.GREATER_THAN:
                    case pesquisaAvancada.ComparisonOperator.LESS_THAN:
                        if (criterion.trait.dataType == "date") {
                            criterion.valid = (!!criterion.value);
                        }
                        else {
                            criterion.valid = ((!!criterion.value) && (criterion.value.length > 0));
                        }
                        break;
                    case pesquisaAvancada.ComparisonOperator.BETWEEN:
                        if (criterion.trait.dataType == "date") {
                            criterion.valid = ((!!criterion.value[0]) && (!!criterion.value[1]));
                        }
                        else {
                            criterion.valid = ((!!criterion.value[0]) && (!!criterion.value[1]) &&
                                (criterion.value[0].length > 0) && (criterion.value[1].length > 0));
                        }
                        break;
                    case pesquisaAvancada.ComparisonOperator.EXISTS:
                        criterion.valid = true;
                        break;
                }
            };
            return CriterionValueInputController;
        }());
        var CriterionValueInputDirective = /** @class */ (function () {
            function CriterionValueInputDirective() {
                this.restrict = "E";
                this.templateUrl = "app/main/pesquisa-avancada/directives/criterion-value-input/criterion-value-input.html";
                this.scope = {
                    criterion: "="
                };
                this.controller = CriterionValueInputController;
                this.controllerAs = "vm";
            }
            CriterionValueInputDirective.factory = function () {
                return function () { return new CriterionValueInputDirective(); };
            };
            return CriterionValueInputDirective;
        }());
        angular
            .module("app.pesquisa-avancada")
            .directive("criterionValueInput", CriterionValueInputDirective.factory());
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));



var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        "use strict";
        var CriteriaSummaryDirective = /** @class */ (function () {
            function CriteriaSummaryDirective() {
                this.restrict = "E";
                this.scope = {
                    criteria: "="
                };
                this.templateUrl = "app/main/pesquisa-avancada/directives/criteria-summary/criteria-summary.html";
            }
            CriteriaSummaryDirective.factory = function () {
                return function () { return new CriteriaSummaryDirective(); };
            };
            return CriteriaSummaryDirective;
        }());
        angular
            .module("app.pesquisa-avancada")
            .directive("criteriaSummary", CriteriaSummaryDirective.factory());
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));



var app;
(function (app) {
    var gestao;
    (function (gestao) {
        var meusPaineis;
        (function (meusPaineis) {
            'use strict';
            config.$inject = ["$translatePartialLoaderProvider", "$stateProvider", "msNavigationServiceProvider"];
            run.$inject = ["app.support.dashboards.DashboardService", "msNavigationService", "$rootScope"];
            function run(dashboardService, msNavigationService, $rootScope) {
                function setUpDashboard() {
                    dashboardService.hasDashboards().then(function (hasDashboards) {
                        if (hasDashboards)
                            msNavigationService.saveItem('gestao.meus-paineis', {
                                title: 'Meus Painéis',
                                icon: 'icon-view-dashboard',
                                state: 'app.gestao.meus-paineis.dashboard',
                                translation: 'GESTAO.MEUS-PAINEIS.MEUS-PAINEIS',
                                weight: 1
                            });
                    });
                }
                $rootScope.$on('user:logged', function () {
                    setUpDashboard();
                });
                setUpDashboard();
            }
            /** @ngInject **/
            function config($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
                $translatePartialLoaderProvider.addPart('app/main/gestao/meus-paineis');
                $stateProvider.state('app.gestao.meus-paineis', {
                    url: '/meus-paineis',
                    resolve: {
                        dashboards: ['app.support.dashboards.DashboardService', function (dashboardService) {
                                return dashboardService.dashboards();
                            }]
                    }
                }).state('app.gestao.meus-paineis.dashboard', {
                    url: '/:dashboardId',
                    views: {
                        'content@app.autenticado': {
                            templateUrl: 'app/main/gestao/meus-paineis/meus-paineis.html',
                            controller: meusPaineis.PaineisController,
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        dashlets: ['$q', '$stateParams', 'dashboards', 'app.support.dashboards.DashboardService',
                            function ($q, $stateParams, dashboards, dashboardService) {
                                return $q(function (resolve, reject) {
                                    // Lógica para carregamento dos módulos nos quais estão definidos os dashlets usados pelo dashboard atual.
                                    var dashboard;
                                    var dashboardId = $stateParams['dashboardId'];
                                    if (!dashboardId) {
                                        if (dashboards.length > 0) {
                                            dashboard = dashboards[0]; // Dashboard padrão será o primeiro da lista.
                                        }
                                        else {
                                            resolve([]);
                                            return;
                                        }
                                    }
                                    else {
                                        for (var _i = 0, dashboards_1 = dashboards; _i < dashboards_1.length; _i++) {
                                            var d = dashboards_1[_i];
                                            if (d.id === dashboardId) {
                                                dashboard = d;
                                                break;
                                            }
                                        }
                                    }
                                    if (!dashboard) {
                                        reject("Dashboard com Id " + dashboardId + " não encontrado.");
                                        return;
                                    }
                                    dashboardService.loadDashlets(dashboard).then(function (dashlets) {
                                        resolve(dashlets);
                                    }, function () {
                                        reject('Erro ao carregar os dashlets.');
                                    });
                                });
                            }]
                    }
                }).state('app.gestao.meus-paineis.principal', {
                    url: '/principal',
                }).state('app.gestao.meus-paineis.peticoes', {
                    url: '/peticoes',
                }).state('app.gestao.meus-paineis.autuacoes', {
                    url: '/autuacoes',
                }).state('app.gestao.meus-paineis.produtividade-do-time', {
                    url: '/produtividade-do-time',
                });
            }
            // config.$inject = ['app.support.dashboards.DashboardService'];
            angular
                .module('app.gestao.meus-paineis', ['app.gestao', 'app.support.dashboards'])
                .config(config)
                .run(run);
        })(meusPaineis = gestao.meusPaineis || (gestao.meusPaineis = {}));
    })(gestao = app.gestao || (app.gestao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var gestao;
    (function (gestao) {
        var meusPaineis;
        (function (meusPaineis) {
            var ProdutividadeDoTimeController = /** @class */ (function () {
                /** @ngInject **/
                ProdutividadeDoTimeController.$inject = ["app.gestao.meus-paineis.MeusPaineisService"];
                function ProdutividadeDoTimeController(meusPaineisService) {
                    this.meusPaineisService = meusPaineisService;
                    this.widget11 = meusPaineisService.loadDashboardWidget("Widget11");
                }
                return ProdutividadeDoTimeController;
            }());
            meusPaineis.ProdutividadeDoTimeController = ProdutividadeDoTimeController;
            angular
                .module("app.gestao.meus-paineis")
                .controller("app.gestao.meus-paineis.ProdutividadeDoTimeController", ProdutividadeDoTimeController);
        })(meusPaineis = gestao.meusPaineis || (gestao.meusPaineis = {}));
    })(gestao = app.gestao || (app.gestao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var gestao;
    (function (gestao) {
        var meusPaineis;
        (function (meusPaineis) {
            "use strict";
            var PrincipalController = /** @class */ (function () {
                /** @ngInject **/
                PrincipalController.$inject = ["app.gestao.meus-paineis.MeusPaineisService"];
                function PrincipalController(meusPaineisService) {
                    this.meusPaineisService = meusPaineisService;
                    this.widget1 = meusPaineisService.loadDashboardWidget("Widget1");
                    this.widget2 = meusPaineisService.loadDashboardWidget("Widget2");
                    this.widget3 = meusPaineisService.loadDashboardWidget("Widget3");
                    this.widget4 = meusPaineisService.loadDashboardWidget("Widget4");
                    this.widget5 = meusPaineisService.loadDashboardWidget("Widget5");
                    this.widget6 = meusPaineisService.loadDashboardWidget("Widget6");
                    this.widget7 = meusPaineisService.loadDashboardWidget("Widget7");
                }
                return PrincipalController;
            }());
            meusPaineis.PrincipalController = PrincipalController;
            angular
                .module("app.gestao.meus-paineis")
                .controller("app.gestao.meus-paineis.PrincipalController", PrincipalController);
        })(meusPaineis = gestao.meusPaineis || (gestao.meusPaineis = {}));
    })(gestao = app.gestao || (app.gestao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var gestao;
    (function (gestao) {
        var meusPaineis;
        (function (meusPaineis) {
            'use strict';
            var PeticoesController = /** @class */ (function () {
                /** @ngInject **/
                PeticoesController.$inject = ["app.gestao.meus-paineis.MeusPaineisService"];
                function PeticoesController(meusPaineisService) {
                    this.meusPaineisService = meusPaineisService;
                    this.chart1 = meusPaineisService.loadDashboardWidget('Chart1');
                    this.chart2 = meusPaineisService.loadDashboardWidget('Chart2');
                }
                return PeticoesController;
            }());
            meusPaineis.PeticoesController = PeticoesController;
            angular
                .module('app.gestao.meus-paineis')
                .controller('app.gestao.meus-paineis.PeticoesController', PeticoesController);
        })(meusPaineis = gestao.meusPaineis || (gestao.meusPaineis = {}));
    })(gestao = app.gestao || (app.gestao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var gestao;
    (function (gestao) {
        var meusPaineis;
        (function (meusPaineis) {
            'use strict';
            var AutuacoesController = /** @class */ (function () {
                /** @ngInject **/
                AutuacoesController.$inject = ["app.gestao.meus-paineis.MeusPaineisService"];
                function AutuacoesController(meusPaineisService) {
                    this.meusPaineisService = meusPaineisService;
                    this.widget8 = meusPaineisService.loadDashboardWidget('Widget8');
                    this.widget9 = meusPaineisService.loadDashboardWidget('Widget9');
                    this.widget10 = meusPaineisService.loadDashboardWidget('Widget10');
                }
                return AutuacoesController;
            }());
            meusPaineis.AutuacoesController = AutuacoesController;
            angular
                .module('app.gestao.meus-paineis')
                .controller('app.gestao.meus-paineis.AutuacoesController', AutuacoesController);
        })(meusPaineis = gestao.meusPaineis || (gestao.meusPaineis = {}));
    })(gestao = app.gestao || (app.gestao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var documentos;
    (function (documentos) {
        "use strict";
        angular.module("app.documentos", ["app.autenticado", "app.support"])
            .run(["properties", "app.documentos.OnlyofficeService", function (properties, onlyofficeService) {
                var url = onlyofficeService.recuperarUrlArquivoApi();
                $('body').append('<script src="' + url + '"></script>');
            }]);
    })(documentos = app.documentos || (app.documentos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var documentos;
    (function (documentos) {
        /**
         * Permite realizar o upload de arquivos para o contexto
         * de documentos.
         *
         * @author Tomas.Godoi
         * @since 0.0.1
         */
        var StfUploaderDirective = /** @class */ (function () {
            function StfUploaderDirective() {
            }
            //TODO Extrair o código do peticionamento e trazer para cá.
            StfUploaderDirective.factory = function () {
                return function () {
                    return new StfUploaderDirective();
                };
            };
            return StfUploaderDirective;
        }());
        documentos.StfUploaderDirective = StfUploaderDirective;
        angular.module('app.documentos').directive('stfUploaderDirective', StfUploaderDirective.factory());
    })(documentos = app.documentos || (app.documentos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var documentos;
    (function (documentos) {
        // Funções utilitárias
        function key(scope, readOnly) {
            if (readOnly) {
                var time = new Date().getTime();
                if (!!scope.config.document.id) {
                    return scope.contexto + "-" + scope.config.document.id + "-" + time;
                }
                else {
                    return scope.contexto + "-" + scope.config.document.key + "-" + time;
                }
            }
            return scope.config.document.key;
        }
        function getDocumentType(ext) {
            if (".docx.doc.odt.rtf.txt.html.htm.mht.pdf.djvu.fb2.epub.xps".indexOf(ext) != -1)
                return "text";
            if (".xls.xlsx.ods.csv".indexOf(ext) != -1)
                return "spreadsheet";
            if (".pps.ppsx.ppt.pptx.odp".indexOf(ext) != -1)
                return "presentation";
            return null;
        }
        var OnlyofficeDirective = /** @class */ (function () {
            function OnlyofficeDirective($timeout, onlyofficeService, $q) {
                this.$timeout = $timeout;
                this.onlyofficeService = onlyofficeService;
                this.$q = $q;
                this.restrict = 'AE';
                this.template = '<div id="{{placeholderId}}"></div>';
                this.scope = {
                    config: "=onlyoffice",
                    readOnly: "=readOnly",
                    historyEnabled: "=historyEnabled",
                    contexto: "@",
                    api: "=?",
                    configOverride: "="
                };
            }
            OnlyofficeDirective.prototype.link = function ($scope, el, attrs) {
                var _this = this;
                $scope.placeholderId = "onlyoffice-editor-" + pseudorandomId();
                $scope.$watch('config.document.src', function (newVal) {
                    if (!newVal) {
                        return;
                    }
                    var editorConfig = $scope.config.editorConfig;
                    var documentConfig = $scope.config.document;
                    var readOnly = editorConfig.mode === "view" ? true : $scope.readOnly;
                    var docUrl = documentConfig.src;
                    var docTitle = documentConfig.name || docUrl;
                    var docKey = key($scope, readOnly);
                    var docType = docUrl.split('?')[0].substring(docUrl.lastIndexOf(".") + 1).trim().toLowerCase();
                    var callbackUrl = documentConfig.callbackUrl;
                    var historyEnabled = $scope.historyEnabled ? $scope.historyEnabled : false;
                    if (!editorConfig.plugins) {
                        var pluginsConfig = {
                            autostart: [],
                            pluginsData: [],
                            pluginsParams: []
                        };
                        editorConfig.plugins = pluginsConfig;
                    }
                    _this.onlyofficeService.recuperarUrlPlugins($scope.contexto).then(function (urlPlugins) {
                        _this.prependDefaultPlugins(urlPlugins, editorConfig.plugins);
                        var config = {
                            type: "desktop",
                            width: "100%",
                            height: "100%",
                            documentType: "text",
                            document: {
                                fileType: docType,
                                key: docKey,
                                title: docTitle,
                                url: docUrl,
                                permissions: {
                                    edit: !readOnly,
                                    download: true,
                                    reader: true,
                                    print: true
                                },
                            },
                            editorConfig: {
                                callbackUrl: callbackUrl,
                                lang: editorConfig.lang,
                                mode: editorConfig.mode,
                                customization: editorConfig.customization,
                                user: {
                                    id: editorConfig.user.id,
                                    name: editorConfig.user.name
                                },
                                plugins: editorConfig.plugins
                            },
                            events: {
                                onAppReady: function () {
                                    this.$timeout(function () {
                                        $scope.ready = true;
                                    }, 0);
                                }
                            }
                        };
                        _this.$q.when(historyEnabled).then(function (historyEnabled) {
                            if (historyEnabled) {
                                return _this.onlyofficeService.isHistoryEnabled($scope.contexto).then(function (enabled) {
                                    if (enabled) {
                                        config.events.onRequestHistory = function () {
                                            _this.onlyofficeService.recuperarHistorico(documentConfig.id, $scope.contexto).then(function (history) {
                                                var historyData = {
                                                    currentVersion: "0",
                                                    history: []
                                                };
                                                if (!!history && history.length > 0) {
                                                    var version = _.maxBy(history, function (h) { return parseInt(h.version); }).version;
                                                    var serverVersion_1 = DocsAPI.DocEditor.version();
                                                    history.forEach(function (h) {
                                                        h.serverVersion = serverVersion_1;
                                                    });
                                                    historyData.currentVersion = version;
                                                    historyData.history = history;
                                                }
                                                $scope.docEditor.refreshHistory(historyData);
                                            });
                                        };
                                        config.events.onRequestHistoryData = function (event) {
                                            var version = event.data;
                                            var key1 = Math.random().toString(36).substr(2, 9);
                                            var key2 = Math.random().toString(36).substr(2, 9);
                                            _this.onlyofficeService.recuperarUrlChanges(documentConfig.id, version, $scope.contexto)
                                                .then(function (urlChanges) {
                                                _this.$q.all([_this.onlyofficeService.recuperarUrlDocumentVersion(documentConfig.id, version, $scope.contexto), _this.onlyofficeService.recuperarUrlDocumentVersion(documentConfig.id, version - 1, $scope.contexto)]).then(function (urls) {
                                                    _this.onlyofficeService.existeChanges(documentConfig.id, version, $scope.contexto).then(function (existe) {
                                                        var historyData;
                                                        if (existe) {
                                                            historyData = {
                                                                changesUrl: urlChanges,
                                                                key: key1,
                                                                previous: {
                                                                    key: key2,
                                                                    url: urls[1],
                                                                },
                                                                url: urls[0],
                                                                version: version
                                                            };
                                                        }
                                                        else {
                                                            historyData = {
                                                                key: key1,
                                                                url: urls[0],
                                                                version: version
                                                            };
                                                        }
                                                        if (_this.onlyofficeService.isSecure()) {
                                                            _this.onlyofficeService.generateJwtTokenHistoryData(historyData, $scope.contexto).then(function (tokenObj) {
                                                                historyData.token = tokenObj.token;
                                                                $scope.docEditor.setHistoryData(historyData);
                                                            });
                                                        }
                                                        else {
                                                            $scope.docEditor.setHistoryData(historyData);
                                                        }
                                                    });
                                                });
                                            });
                                        };
                                        config.events.onRequestHistoryClose = function () {
                                            _this.fecharHistoricoRecarregar($scope, config);
                                        };
                                        config.events.onRequestRestore = function (event) {
                                            var version = event.data.version;
                                            _this.onlyofficeService.restaurarVersao(documentConfig.id, version, $scope.contexto)
                                                .then(function () {
                                                _this.fecharHistoricoRecarregar($scope, config);
                                            });
                                        };
                                    }
                                });
                            }
                        }).finally(function () {
                            _this.loadEditor($scope, config);
                            $scope.$on("$destroy", function () {
                                $scope.docEditor.destroyEditor();
                            });
                        });
                    });
                });
            };
            OnlyofficeDirective.prototype.fecharHistoricoRecarregar = function ($scope, config) {
                var _this = this;
                $scope.docEditor.destroyEditor();
                this.onlyofficeService.excluirNumeroEdicao($scope.config.document.id, false, $scope.contexto)
                    .then(function () {
                    _this.onlyofficeService.gerarNumeroEdicao($scope.config.document.id, false, $scope.contexto)
                        .then(function (edicao) {
                        config.document.key = edicao.numero;
                        _this.loadEditor($scope, config);
                    });
                });
            };
            OnlyofficeDirective.prototype.loadEditor = function ($scope, config) {
                var _this = this;
                var overriddenConfig = this.overrideConfig(config, $scope.configOverride);
                if (this.onlyofficeService.isSecure()) {
                    this.onlyofficeService.generateJwtToken(overriddenConfig, $scope.contexto).then(function (tokenObj) {
                        overriddenConfig.token = tokenObj.token;
                        _this.loadOnlyofficeDirectiveApi($scope, overriddenConfig);
                        $scope.docEditor = new DocsAPI.DocEditor($scope.placeholderId, overriddenConfig);
                    });
                }
                else {
                    this.loadOnlyofficeDirectiveApi($scope, overriddenConfig);
                    $scope.docEditor = new DocsAPI.DocEditor($scope.placeholderId, overriddenConfig);
                }
            };
            OnlyofficeDirective.prototype.overrideConfig = function (config, configOverride) {
                return angular.merge({}, config, configOverride);
            };
            OnlyofficeDirective.prototype.prependDefaultPlugins = function (urlPlugins, plugins) {
                plugins.pluginsData.unshift(urlPlugins + "/move-cursor-start/config.json");
                plugins.pluginsData.unshift(urlPlugins + "/content-control-blocker/config.json");
                plugins.pluginsData.unshift(urlPlugins + "/enable-content-controls/config.json");
                plugins.pluginsData.unshift(urlPlugins + "/autoloader/config.json");
                plugins.pluginsParams.unshift({
                    id: "autoloader",
                    params: {
                    //                    // Exemplo de como carregar um "addon" via autoloader, passando parâmetros.
                    //                    "hello-world": {
                    //                        type: "addon",
                    //                        params: {
                    //                            msg: "Hello, World!"
                    //                        }
                    //                    }
                    }
                });
                plugins.pluginsParams.unshift({
                    id: "shared-params",
                    params: {
                        "onlyoffice-version": DocsAPI.DocEditor.version()
                    }
                });
                return plugins;
            };
            OnlyofficeDirective.prototype.loadOnlyofficeDirectiveApi = function ($scope, config) {
                $scope.api = new documentos.OnlyofficeDirectiveApiImpl($scope, config, this.$q);
            };
            OnlyofficeDirective.factory = function () {
                return ["$timeout", "app.documentos.OnlyofficeService", "$q", function ($timeout, onlyofficeService, $q) {
                    "ngInject";
                    return new OnlyofficeDirective($timeout, onlyofficeService, $q);
                }];
            };
            return OnlyofficeDirective;
        }());
        function pseudorandomId() {
            return new Date().getTime().toString() + Math.floor(Math.random() * 65536);
        }
        angular.module('app.documentos').directive('onlyoffice', OnlyofficeDirective.factory());
    })(documentos = app.documentos || (app.documentos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var documentos;
    (function (documentos) {
        var OnlyofficeDirectiveApiImpl = /** @class */ (function () {
            function OnlyofficeDirectiveApiImpl($scope, config, $q) {
                var _this = this;
                this.$scope = $scope;
                this.config = config;
                this.$q = $q;
                this.pluginsDispatchers = {};
                config.events["onInternalMessage"] = function (data) { return _this.onInternalMessage(data); };
                if (config.editorConfig.plugins) {
                    for (var _i = 0, _a = config.editorConfig.plugins.pluginsData; _i < _a.length; _i++) {
                        var plugin = _a[_i];
                        var urlComponents = plugin.split("/");
                        var pluginName = urlComponents[urlComponents.length - 2];
                        this.pluginsDispatchers[pluginName] = new PluginDispatcher(pluginName, this.$scope, this.$q);
                    }
                }
            }
            OnlyofficeDirectiveApiImpl.prototype.onInternalMessage = function (message) {
                if (message.data.type && message.data.type.indexOf("plugin-call:") === 0) {
                    var callId = PluginGatewayCallId.fromString(message.data.type);
                    if (this.pluginsDispatchers[callId.getPluginName()]) {
                        var pluginDispatcher = this.pluginsDispatchers[callId.getPluginName()];
                        pluginDispatcher.onCallMessage(callId, message);
                    }
                }
                else if (message.data.type && message.data.type.indexOf("plugin-event:") === 0) {
                    var eventId = PluginGatewayEventId.fromString(message.data.type);
                    if (this.pluginsDispatchers[eventId.getPluginName()]) {
                        var pluginDispatcher = this.pluginsDispatchers[eventId.getPluginName()];
                        pluginDispatcher.onEventMessage(eventId, message);
                    }
                }
            };
            OnlyofficeDirectiveApiImpl.prototype.plugin = function (name) {
                if (this.pluginsDispatchers[name]) {
                    return this.pluginsDispatchers[name];
                }
                else {
                    throw "Plugin " + name + " n\u00E3o ser\u00E1 carregado.";
                }
            };
            return OnlyofficeDirectiveApiImpl;
        }());
        documentos.OnlyofficeDirectiveApiImpl = OnlyofficeDirectiveApiImpl;
        var PluginDispatcher = /** @class */ (function () {
            function PluginDispatcher(name, $scope, $q) {
                this.name = name;
                this.$scope = $scope;
                this.$q = $q;
                this.pendingRequests = {};
                this.eventsCallbacks = {};
            }
            PluginDispatcher.prototype.onCallMessage = function (callId, message) {
                if (this.pendingRequests[callId.toMethodString()]) {
                    var pendingRequest = this.pendingRequests[callId.toMethodString()];
                    delete this.pendingRequests[callId.toMethodString()];
                    pendingRequest.resolve(message.data.data);
                }
            };
            PluginDispatcher.prototype.onEventMessage = function (eventId, message) {
                if (this.eventsCallbacks[eventId.toEventString()]) {
                    var eventCallbacks = this.eventsCallbacks[eventId.toEventString()];
                    for (var _i = 0, eventCallbacks_1 = eventCallbacks; _i < eventCallbacks_1.length; _i++) {
                        var eventCallback = eventCallbacks_1[_i];
                        eventCallback(message.data.data);
                    }
                }
            };
            PluginDispatcher.prototype.call = function (method, params) {
                var deferred = this.$q.defer();
                var callId = new PluginGatewayCallId(this.name, method, pseudorandomId());
                this.pendingRequests[callId.toMethodString()] = deferred;
                this.$scope.docEditor.serviceCommand(callId.toFullQualifiedString(), params);
                return deferred.promise;
            };
            PluginDispatcher.prototype.on = function (eventName, callbackFn) {
                var eventId = new PluginGatewayEventId(this.name, eventName);
                if (!this.eventsCallbacks[eventId.toEventString()]) {
                    this.eventsCallbacks[eventId.toEventString()] = [];
                }
                this.eventsCallbacks[eventId.toEventString()].push(callbackFn);
                return function unsubscribe() {
                    _.remove(this.eventsCallbacks[eventId.toEventString()], function (e) { return e === callbackFn; });
                };
            };
            return PluginDispatcher;
        }());
        documentos.PluginDispatcher = PluginDispatcher;
        var PluginGatewayCallId = /** @class */ (function () {
            function PluginGatewayCallId(pluginName, methodName, requestId) {
                this.pluginName = pluginName;
                this.methodName = methodName;
                this.requestId = requestId;
            }
            PluginGatewayCallId.fromString = function (pluginGatewayCallIdStr) {
                var atComponents = pluginGatewayCallIdStr.split("@");
                var collonComponents = atComponents[0].split(":");
                return new PluginGatewayCallId(collonComponents[1], collonComponents[2], atComponents[1]);
            };
            PluginGatewayCallId.prototype.getPluginName = function () {
                return this.pluginName;
            };
            PluginGatewayCallId.prototype.toFullQualifiedString = function () {
                return "plugin-call:" + this.pluginName + ":" + this.methodName + "@" + this.requestId;
            };
            PluginGatewayCallId.prototype.toMethodString = function () {
                return this.methodName + "@" + this.requestId;
            };
            return PluginGatewayCallId;
        }());
        documentos.PluginGatewayCallId = PluginGatewayCallId;
        var PluginGatewayEventId = /** @class */ (function () {
            function PluginGatewayEventId(pluginName, eventName) {
                this.pluginName = pluginName;
                this.eventName = eventName;
            }
            PluginGatewayEventId.fromString = function (pluginGatewayCallIdStr) {
                var collonComponents = pluginGatewayCallIdStr.split(":");
                return new PluginGatewayEventId(collonComponents[1], collonComponents[2]);
            };
            PluginGatewayEventId.prototype.getPluginName = function () {
                return this.pluginName;
            };
            PluginGatewayEventId.prototype.toFullQualifiedString = function () {
                return "plugin-event:" + this.pluginName + ":" + this.eventName;
            };
            PluginGatewayEventId.prototype.toEventString = function () {
                return "" + this.eventName;
            };
            return PluginGatewayEventId;
        }());
        documentos.PluginGatewayEventId = PluginGatewayEventId;
        function pseudorandomId() {
            return new Date().getTime().toString() + Math.floor(Math.random() * 65536);
        }
    })(documentos = app.documentos || (app.documentos = {}));
})(app || (app = {}));



var DocsAPI;
(function (DocsAPI) {
})(DocsAPI || (DocsAPI = {}));



var app;
(function (app) {
    var documentos;
    (function (documentos) {
        var EditorDirective = /** @class */ (function () {
            function EditorDirective() {
                this.restrict = 'AE';
                this.templateUrl = 'app/main/documentos/directives/editor/editor.tpl.html';
                this.scope = {
                    api: "=?",
                    documento: "=onlyofficeEditor",
                    edicaoConcluida: "&",
                    edicaoIniciada: "&",
                    edicaoTimeout: "&",
                    aguardarConclusao: "@",
                    editorHeight: "@",
                    save: "=",
                    showMaximizeButton: "=",
                    contexto: "@",
                    readOnly: "=readOnly",
                    historyEnabled: "=historyEnabled",
                    plugins: "=plugins",
                    callbackOmitToken: "=",
                    configOverride: "="
                };
                this.controller = documentos.EditorController;
                this.controllerAs = 'vm';
                this.templateUrl = 'app/main/documentos/directives/editor/editor.tpl.html';
            }
            EditorDirective.factory = function () {
                return function () {
                    return new EditorDirective();
                };
            };
            return EditorDirective;
        }());
        angular.module('app.documentos').directive('onlyofficeEditor', EditorDirective.factory());
    })(documentos = app.documentos || (app.documentos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var documentos;
    (function (documentos) {
        var EditorController = /** @class */ (function () {
            /** @ngInject **/
            EditorController.$inject = ["$q", "$interval", "$scope", "app.documentos.OnlyofficeService", "authService"];
            function EditorController($q, $interval, $scope, onlyofficeService, authService) {
                var _this = this;
                this.$q = $q;
                this.$interval = $interval;
                this.$scope = $scope;
                this.onlyofficeService = onlyofficeService;
                this.authService = authService;
                this.showEditor = true;
                this.showProgress = false;
                this.edicaoIniciada = false;
                this.tentativasVerificaoEdicaoCompleta = 0;
                this.tentativasVerificaoEdicaoIniciada = 0;
                this.documento = $scope.documento;
                this.contexto = $scope.contexto;
                if (!this.documento.id && !this.documento.textoId) {
                    throw new Error("O id do documento ou do texto deve ser especificado!");
                }
                $scope.api = {
                    salvar: function () {
                        if (_this.$scope.readOnly) {
                            return _this.$q.when();
                        }
                        return _this.api.plugin("save-sync").call("save").then(function (data) {
                            if ($scope.aguardarConclusao == "true") {
                                _this.showEditor = false;
                                _this.showProgress = true;
                                return _this.verificarEdicaoCompleta().then(function () { return $scope.edicaoConcluida(); }, function () {
                                    _this.showEditor = true;
                                    _this.showProgress = false;
                                    $scope.edicaoTimeout();
                                    return _this.$q.reject();
                                });
                            }
                            else if ($scope.aguardarConclusao == "false") {
                                $scope.edicaoConcluida();
                                return _this.$q.when({});
                            }
                        });
                    },
                    plugin: function (name) {
                        return _this.api.plugin(name);
                    }
                };
                if (!this.documento.id && this.documento.textoId) {
                    this.onlyofficeService.recuperarDocumentoId(this.documento.textoId, this.contexto)
                        .then(function (documentoId) {
                        _this.documento.id = documentoId;
                        _this.configurarEditor();
                    });
                }
                else {
                    this.configurarEditor();
                }
            }
            EditorController.prototype.configurarEditor = function () {
                var _this = this;
                this.authService.getUser().then(function (usuario) {
                    if (_this.$scope.readOnly) {
                        _this.iniciarEditor(null, usuario);
                    }
                    else {
                        _this.onlyofficeService.gerarNumeroEdicao(_this.documento.id, _this.documento.temporario, _this.contexto)
                            .then(function (edicao) { return _this.iniciarEditor(edicao.numero, usuario); });
                    }
                });
            };
            EditorController.prototype.iniciarEditor = function (numeroEdicao, usuario) {
                var _this = this;
                this.$q.all([this.onlyofficeService
                        .criarUrlConteudoDocumento(this.documento.id, this.documento.temporario, this.contexto),
                    this.onlyofficeService
                        .recuperarUrlCallback(this.documento.id, this.documento.temporario, this.$scope.save, this.contexto, this.$scope.callbackOmitToken),
                    this.onlyofficeService
                        .recuperarUrlPlugins(this.contexto)])
                    .then(function (urls) {
                    _this.config = {
                        editorConfig: {
                            lang: 'pt-BR',
                            customization: {
                                about: true,
                                chat: true,
                                compactToolbar: false
                            },
                            mode: _this.$scope.readOnly ? "view" : "edit",
                            user: {
                                id: usuario.login,
                                name: usuario.nome
                            },
                            plugins: _this.buildPluginConfig(urls[2], _this.$scope.plugins)
                        },
                        document: {
                            id: _this.documento.id,
                            src: urls[0],
                            key: numeroEdicao,
                            name: _this.documento.nome,
                            callbackUrl: _this.$scope.readOnly ? undefined : urls[1],
                            temp: _this.documento.temporario ? true : false
                        }
                    };
                    _this.verificarEdicaoIniciada().then(function () {
                        _this.edicaoIniciada = true;
                        _this.$scope.edicaoIniciada();
                    });
                });
            };
            EditorController.prototype.buildPluginConfig = function (urlPlugins, plugins) {
                var pluginsConfig = {
                    autostart: [],
                    pluginsData: [],
                    pluginsParams: []
                };
                pluginsConfig.pluginsData.push(urlPlugins + "/save-sync/config.json");
                if (plugins) {
                    for (var _i = 0, plugins_1 = plugins; _i < plugins_1.length; _i++) {
                        var plugin = plugins_1[_i];
                        pluginsConfig.pluginsData.push(urlPlugins + "/" + plugin.id + "/config.json");
                        if (plugin.autostart) {
                            pluginsConfig.autostart.push(plugin.autostart.guid);
                        }
                        pluginsConfig.pluginsParams.push({
                            id: plugin.id,
                            params: plugin.params
                        });
                    }
                }
                return pluginsConfig;
            };
            EditorController.prototype.verificarEdicaoCompleta = function () {
                this.tentativasVerificaoEdicaoCompleta = 0;
                this.deferredEdicaoCompleta = this.$q.defer();
                this.iteracaoVerificarEdicaoCompleta();
                return this.deferredEdicaoCompleta.promise;
            };
            EditorController.prototype.iteracaoVerificarEdicaoCompleta = function () {
                var _this = this;
                if (this.$scope.readOnly) {
                    return this.deferredEdicaoCompleta.resolve();
                }
                this.onlyofficeService.recuperarNumeroEdicao(this.documento.id, this.documento.temporario, this.contexto)
                    .then(function (edicao) {
                    console.info(edicao);
                    if (_this.tentativasVerificaoEdicaoCompleta % 5 === 0) {
                        _this.onlyofficeService.removerUsuariosEdicao(edicao, _this.contexto);
                    }
                    _this.tentativasVerificaoEdicaoCompleta++;
                    if (_this.tentativasVerificaoEdicaoCompleta < 20) {
                        _this.$interval(function () { return _this.iteracaoVerificarEdicaoCompleta(); }, 1000, 1);
                    }
                    else {
                        _this.deferredEdicaoCompleta.reject();
                    }
                }, function (edicao) {
                    console.info(edicao);
                    if (edicao.status === 404) {
                        _this.deferredEdicaoCompleta.resolve();
                    }
                    else {
                        _this.deferredEdicaoCompleta.reject();
                    }
                });
            };
            EditorController.prototype.verificarEdicaoIniciada = function () {
                this.tentativasVerificaoEdicaoIniciada = 0;
                this.deferredEdicaoIniciada = this.$q.defer();
                this.iteracaoVerificarEdicaoIniciada();
                return this.deferredEdicaoIniciada.promise;
            };
            EditorController.prototype.iteracaoVerificarEdicaoIniciada = function () {
                var _this = this;
                if (this.$scope.readOnly) {
                    return this.deferredEdicaoIniciada.resolve();
                }
                this.onlyofficeService.recuperarNumeroEdicao(this.documento.id, this.documento.temporario, this.contexto)
                    .then(function (edicao) {
                    console.info(edicao);
                    if (edicao.ativo) {
                        _this.deferredEdicaoIniciada.resolve();
                    }
                    else {
                        _this.tratarNaoAtivo();
                    }
                }, function (edicao) {
                    console.info(edicao);
                    _this.tratarNaoAtivo();
                });
            };
            EditorController.prototype.tratarNaoAtivo = function () {
                var _this = this;
                this.tentativasVerificaoEdicaoIniciada++;
                if (this.tentativasVerificaoEdicaoIniciada < 20) {
                    this.$interval(function () { return _this.iteracaoVerificarEdicaoIniciada(); }, 1000, 1);
                }
                else {
                    this.deferredEdicaoIniciada.reject();
                }
            };
            return EditorController;
        }());
        documentos.EditorController = EditorController;
        angular.module('app.documentos').controller('app.documentos.EditorController', EditorController);
    })(documentos = app.documentos || (app.documentos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var painelDeFases;
        (function (painelDeFases) {
            'use strict';
            var PainelDeFasesController = /** @class */ (function () {
                /** @ngInject **/
                PainelDeFasesController.$inject = ["boardList"];
                function PainelDeFasesController(boardList) {
                    this.boardList = boardList;
                }
                return PainelDeFasesController;
            }());
            painelDeFases.PainelDeFasesController = PainelDeFasesController;
            angular
                .module('app.tarefas.painel-de-fases')
                .controller('app.tarefas.painel-de-fases.PaineDeFasesController', PainelDeFasesController);
        })(painelDeFases = tarefas.painelDeFases || (tarefas.painelDeFases = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            "use strict";
            var SearchCondition;
            (function (SearchCondition) {
                SearchCondition[SearchCondition["AND"] = 0] = "AND";
                SearchCondition[SearchCondition["OR"] = 1] = "OR";
            })(SearchCondition = minhasTarefas.SearchCondition || (minhasTarefas.SearchCondition = {}));
            var MinhasTarefasController = /** @class */ (function () {
                /** @ngInject **/
                MinhasTarefasController.$inject = ["$document", "$mdDialog", "$filter", "$scope", "$window", "$timeout", "$state", "messagesService", "app.tarefas.minhas-tarefas.MinhasTarefasService", "app.tarefas.minhas-tarefas.TarefasCacheService", "app.tarefas.minhas-tarefas.RotulosService", "user", "userGroups", "canPrioritize", "canAnnotate", "canTag", "canRemoveTags", "manualTags", "alertService"];
                function MinhasTarefasController($document, $mdDialog, $filter, $scope, $window, $timeout, $state, messagesService, minhasTarefasService, tarefasCacheService, rotulosService, user, userGroups, canPrioritize, canAnnotate, canTag, canRemoveTags, manualTags, alertService) {
                    var _a;
                    var _this = this;
                    this.$document = $document;
                    this.$mdDialog = $mdDialog;
                    this.$filter = $filter;
                    this.$scope = $scope;
                    this.$window = $window;
                    this.$timeout = $timeout;
                    this.$state = $state;
                    this.messagesService = messagesService;
                    this.minhasTarefasService = minhasTarefasService;
                    this.tarefasCacheService = tarefasCacheService;
                    this.rotulosService = rotulosService;
                    this.userGroups = userGroups;
                    this.canPrioritize = canPrioritize;
                    this.canAnnotate = canAnnotate;
                    this.canTag = canTag;
                    this.canRemoveTags = canRemoveTags;
                    this.manualTags = manualTags;
                    this.alertService = alertService;
                    this.pagination = {
                        currentPage: 0,
                        pageSize: 20,
                        numberOfPages: 1,
                        total: 0
                    };
                    this.taskFilters = {
                        priority: { value: false, active: false },
                        assignee: { value: [], active: true },
                        assigneeGroup: { value: [], active: false },
                        tags: { value: [], active: true }
                    };
                    this.taskDateFilter = "startDate";
                    this.taskOrder = "startDate";
                    this.taskOrderDescending = true;
                    this.taskViewExpanded = false;
                    this.msScrollOptions = {
                        suppressScrollX: true
                    };
                    this.loadingTasks = false;
                    this.tags = [];
                    this.users = [];
                    this.usersNames = new Map();
                    this.filteredTasks = [];
                    this.exactlySearch = true;
                    this.searchCondition = SearchCondition.AND;
                    this.fromDateFilter = moment().startOf("d").toDate();
                    this.toDateFilter = moment().endOf("d").toDate();
                    this.maxDateFilter = this.toDateFilter;
                    this.patterns = [{
                            regex: /^([a-zA-Z]+)(\s+)([0-9]{7})$/g,
                            replaceFn: function (completo, sigla, espacos, numero) {
                                return sigla + " " + numero.replace(/^0+/, "");
                            }
                        }, {
                            regex: /^([0-9]{8})(\-)([0-9]{4})$/g,
                            replaceFn: function (completo, numero, traco, ano) {
                                return numero.replace(/^0+/, "") + traco + ano;
                            }
                        }, {
                            regex: /^([0-9]{7})([0-9]{4})$/g,
                            replaceFn: function (completo, numero, ano) {
                                return numero.replace(/^0+/, "") + "/" + ano;
                            }
                        }];
                    this.userLogged = user.login;
                    this.taskFilters.assignee.value.push(this.userLogged);
                    this.taskFiltersDefaults = angular.copy(this.taskFilters);
                    (_a = this.tags).push.apply(_a, manualTags);
                    this.tarefasCacheService.registerTaskCallbackFn(function () { return _this.applyTaskFilters(); });
                    this.tarefasCacheService.registerTaskCreatedCallbackFn(function (task) { return _this.onTaskCreated(task); });
                    this.tarefasCacheService.registerTaskAssignedCallbackFn(function (task) { return _this.onTaskAssigned(task); });
                    this.tarefasCacheService.registerTaskTaggedCallbackFn(function (task) { return _this.onTaskTagged(task); });
                    $scope.$on("$destroy", function () { return _this.tarefasCacheService.unregisterCallbacks(); });
                    this.$scope.$on("stf:ui:tag-manual-criada", function (event, notificationEvent) {
                        var tagCriada = notificationEvent.content;
                        // Setando o tipo da tag como o esperado
                        tagCriada.type = minhasTarefas.ITaskTagOrigem[tagCriada.origem] === minhasTarefas.ITaskTagOrigem.AUTOMATICA ? "Manuais" : tagCriada.type;
                        // remapeando as tags de cada tarefa na listagem
                        _this.updateTagFromName(tagCriada);
                        _this.refreshTasks();
                        _this.applyTaskFilters();
                    });
                    this.$scope.$on("stf:ui:tag-manual-atualizada", function (event, notificationEvent) {
                        var tagAtualizada = notificationEvent.content;
                        // Setando o tipo da tag como o esperado
                        tagAtualizada.type = minhasTarefas.ITaskTagOrigem[tagAtualizada.origem] === minhasTarefas.ITaskTagOrigem.AUTOMATICA ? "Manuais" : tagAtualizada.type;
                        _this.toggleArrayFilter('tags', tagAtualizada, true);
                        _this.updateTagFromId(tagAtualizada);
                        _this.toggleArrayFilter("tags", tagAtualizada, true);
                        // remapeando as tags de cada tarefa na listagem
                        _this.remapTagsOnTasks(tagAtualizada);
                        _this.refreshTasks();
                        _this.applyTaskFilters();
                    });
                    this.$scope.$on("stf:ui:tags-removidas", function (event, notificationEvent) {
                        var tags = notificationEvent.content;
                        tags.forEach(function (tag) {
                            _this.spliceTag(tag, _this.tags);
                            _this.spliceTag(tag, _this.manualTags);
                            _this.tasks.forEach(function (task) { return _this.spliceTag(tag, task.tags); });
                        });
                        _this.taskFilters.tags = angular.copy(_this.taskFiltersDefaults.tags);
                        _this.applyTaskFilters();
                    });
                    this.openDialogAlerts();
                }
                Object.defineProperty(MinhasTarefasController, "LIMIT_TEXT_EXTRA_INFO", {
                    get: function () { return 470; },
                    enumerable: true,
                    configurable: true
                });
                ;
                MinhasTarefasController.prototype.updateTagFromName = function (tagCriada) {
                    var _tags = angular.copy(this.tags);
                    var _manualTags = angular.copy(this.manualTags);
                    // Removendo as tags com o mesmo nome
                    _.remove(_tags, function (t) { return t.name === tagCriada.name; });
                    _.remove(_manualTags, function (t) { return t.name === tagCriada.name; });
                    // Incluindo a tag criada
                    _tags.push(tagCriada);
                    _tags.sort(function (u1, u2) { return u1.name.localeCompare(u2.name); });
                    _manualTags.push(tagCriada);
                    _manualTags.sort(function (u1, u2) { return u1.name.localeCompare(u2.name); });
                    this.tags = [];
                    this.manualTags = [];
                    this.tags = _tags;
                    this.manualTags = _manualTags;
                };
                MinhasTarefasController.prototype.updateTagFromId = function (tagAtualizada) {
                    var _this = this;
                    var tagComMesmoId = function (tag) {
                        var remover = tag.id === tagAtualizada.id;
                        if (remover) {
                            // mantendo as tasks que já estavam com a tag
                            tagAtualizada.tasks = tag.tasks;
                        }
                        return remover;
                    };
                    _.remove(this.tags, tagComMesmoId);
                    _.delay(function () {
                        _this.tags.push(tagAtualizada);
                        _this.tags.sort(function (u1, u2) { return u1.name.localeCompare(u2.name); });
                    }, 10);
                    _.remove(this.manualTags, tagComMesmoId);
                    _.delay(function () {
                        _this.manualTags.push(tagAtualizada);
                        _this.manualTags.sort(function (u1, u2) { return u1.name.localeCompare(u2.name); });
                    }, 10);
                };
                MinhasTarefasController.prototype.remapTagsOnTasks = function (tag) {
                    var remapTags = function (_tags) {
                        return angular.copy(_tags || [])
                            .map(function (item) { return item.id === tag.id ? tag : item; });
                    };
                    this.tasks.forEach(function (task) {
                        var _taskTags = remapTags(task.tags);
                        task.tags = [];
                        _.delay(function (tags) { return task.tags = tags; }, 10, _taskTags);
                    });
                };
                MinhasTarefasController.prototype.$onInit = function () {
                    var _this = this;
                    this.loadingTasks = true;
                    this.tasks = this.tarefasCacheService.get();
                    var init = function (first) {
                        _this.loadUsersNames(_this.tasks);
                        _this.loadFilters();
                        _this.initSearchData(first);
                        _this.loadingTasks = false;
                    };
                    if (this.tarefasCacheService.isLoaded()) {
                        init(false);
                    }
                    else {
                        this.minhasTarefasService.get()
                            .then(function (tasks) {
                            _this.tarefasCacheService.register(tasks);
                            init(true);
                        });
                    }
                };
                MinhasTarefasController.prototype.getUserName = function (login) {
                    if (this.usersNames && login && login != "" && this.usersNames.has(login)) {
                        return this.usersNames.get(login);
                    }
                    return login;
                };
                MinhasTarefasController.prototype.loadUsersNames = function (tasks) {
                    var _this = this;
                    var usuarios = new Set();
                    tasks.forEach(function (task) {
                        if (task.assignee && !_this.usersNames.has(task.assignee))
                            usuarios.add(task.assignee);
                        if (task.assignor && !_this.usersNames.has(task.assignor))
                            usuarios.add(task.assignor);
                        if (task.cancellation && task.cancellation.canceledBy && !_this.usersNames.has(task.cancellation.canceledBy))
                            usuarios.add(task.cancellation.canceledBy);
                        if (task.draft && task.draft.modifiedBy && !_this.usersNames.has(task.draft.modifiedBy))
                            usuarios.add(task.draft.modifiedBy);
                    });
                    if (usuarios && usuarios.size > 0) {
                        this.minhasTarefasService.getNomesUsuarios(Array.from(usuarios)).then(function (resultado) {
                            for (var _i = 0, _a = Object.entries(resultado); _i < _a.length; _i++) {
                                var _b = _a[_i], key = _b[0], value = _b[1];
                                _this.usersNames.set(key, value);
                                _this.users.sort(function (u1, u2) { return _this.getUserName(u1).localeCompare(_this.getUserName(u2)); });
                            }
                        });
                    }
                };
                MinhasTarefasController.prototype.onTaskCreated = function (task) {
                    this.loadUsersNames([task]);
                    var startDate = new Date(task.startDate);
                    var momentStartDate = moment(startDate);
                    if (momentStartDate.isAfter(this.maxDateFilter, "day")) {
                        this.maxDateFilter = momentStartDate.endOf("d").toDate();
                    }
                    this.loadTags(task);
                    this.applyTaskFilters();
                };
                MinhasTarefasController.prototype.onTaskAssigned = function (task) {
                    this.loadUsersNames([task]);
                    this.loadUser(task);
                    this.applyTaskFilters();
                };
                MinhasTarefasController.prototype.onTaskTagged = function (task) {
                    this.loadUsersNames([task]);
                    this.loadTags(task);
                    this.applyTaskFilters();
                };
                MinhasTarefasController.prototype.loadFilters = function () {
                    var _this = this;
                    this.tasks.forEach(function (task) {
                        _this.loadTags(task);
                        _this.loadUser(task);
                        var startDate = moment(task.startDate);
                        if (startDate.isBefore(_this.minDateFilter)) {
                            _this.minDateFilter = startDate.toDate();
                        }
                    });
                    this.fromDateFilter = this.minDateFilter;
                };
                MinhasTarefasController.prototype.initSearchData = function (first) {
                    var _this = this;
                    if (first === void 0) { first = false; }
                    this.loadSavedSearchData(first);
                    this.$scope.$watch(function () { return _this.taskFilters; }, function () { return _this.watchListener("taskFilters"); }, true);
                    this.$scope.$watchCollection(function () { return _this.pagination; }, function () { return _this.watchListener("pagination"); });
                    angular.forEach(["searchTask", "exactlySearch", "searchCondition", "taskOrder",
                        "taskOrderDescending", "taskDateFilter", "fromDateFilter",
                        "toDateFilter", "taskViewExpanded"], function (prop) {
                        _this.$scope.$watch(function () { return _this[prop]; }, function () { return _this.watchListener(prop); });
                    });
                };
                MinhasTarefasController.prototype.watchListener = function (property) {
                    this.applyTaskFilters();
                    this.saveSearchData(property, this[property]);
                };
                MinhasTarefasController.prototype.saveSearchData = function (property, data) {
                    var ls = this.$window.localStorage;
                    var stringData = ls.getItem("searchData");
                    var searchData;
                    if (!!stringData) {
                        searchData = angular.fromJson(stringData);
                    }
                    else {
                        searchData = {};
                    }
                    searchData[property] = data;
                    ls.setItem("searchData", angular.toJson(searchData));
                };
                MinhasTarefasController.prototype.loadSavedSearchData = function (first) {
                    if (first === void 0) { first = false; }
                    var ls = this.$window.localStorage;
                    var stringData = ls.getItem("searchData");
                    if (!!stringData) {
                        var searchData = angular.fromJson(stringData);
                        for (var key in searchData) {
                            if (key === "pagination") {
                                this.pagination.pageSize = searchData.pagination.pageSize;
                                this.pagination.currentPage = searchData.pagination.currentPage;
                            }
                            else if (key === "fromDateFilter" || (key === "toDateFilter" && !first)) {
                                this[key] = moment(searchData[key]).toDate();
                            }
                            else if (key !== "toDateFilter") {
                                this[key] = searchData[key];
                            }
                        }
                    }
                };
                MinhasTarefasController.prototype.refreshTasks = function () {
                    var _this = this;
                    this.loadingTasks = true;
                    this.tarefasCacheService.clear();
                    this.minhasTarefasService.get()
                        .then(function (tasks) {
                        _this.tarefasCacheService.register(tasks);
                        _this.loadFilters();
                        _this.toDateFilter = moment().endOf("d").toDate();
                        _this.maxDateFilter = _this.toDateFilter;
                        _this.applyTaskFilters();
                        _this.loadingTasks = false;
                        _this.loadUsersNames(_this.tasks);
                    });
                };
                MinhasTarefasController.prototype.clearFilters = function () {
                    this.taskFilters = angular.copy(this.taskFiltersDefaults);
                    this.applyTaskFilters();
                };
                MinhasTarefasController.prototype.openTask = function (task) {
                    this.minhasTarefasService.openTask(task);
                };
                MinhasTarefasController.prototype.viewTask = function (task) {
                    this.minhasTarefasService.viewTask(task);
                };
                MinhasTarefasController.prototype.filterByTaskLabels = function (task, searchText) {
                    var _this = this;
                    if (!searchText || searchText.length < 2) {
                        return true;
                    }
                    if (this.exactlySearch) {
                        return this.find(task, searchText);
                    }
                    else {
                        var filteredText = searchText.split(" ").filter(function (text) { return text !== ""; });
                        var finder = function (text) { return _this.find(task, text); };
                        if (this.searchCondition === SearchCondition.AND) {
                            return _.every(filteredText, finder);
                        }
                        else {
                            return _.some(filteredText, finder);
                        }
                    }
                };
                MinhasTarefasController.prototype.filterByTags = function (task, tags) {
                    if (tags.length === 0) {
                        return true;
                    }
                    else {
                        var groupTags_1 = _.groupBy(tags, "type");
                        return _.every(Object.keys(groupTags_1), function (type) {
                            return _.intersectionBy(task.tags, groupTags_1[type], "id").length > 0;
                        });
                    }
                };
                MinhasTarefasController.prototype.filterByValues = function (task, values, filter) {
                    if (values.length === 0) {
                        return true;
                    }
                    else {
                        return _.some(values, function (v) {
                            return (v === "!!") ? !!task[filter] : task[filter] === v;
                        });
                    }
                };
                MinhasTarefasController.prototype.filterByValue = function (task, filter) {
                    if (this.taskFilters[filter].active) {
                        return task[filter] === this.taskFilters[filter].value;
                    }
                    else {
                        return true;
                    }
                };
                MinhasTarefasController.prototype.filterByDates = function (task) {
                    if (!this.taskDateFilter) {
                        return true;
                    }
                    return moment(task[this.taskDateFilter]).isBetween(this.fromDateFilter, this.toDateFilter, "day", "[]");
                };
                MinhasTarefasController.prototype.applyTaskFilters = function () {
                    var _this = this;
                    this.$timeout(function () {
                        var tasks = _this.tasks
                            .filter(function (task) {
                            return _this.filterByValue(task, "priority")
                                && _this.filterByValues(task, _this.taskFilters.assignee.value, "assignee")
                                && _this.filterByValues(task, _this.taskFilters.assigneeGroup.value, "assigneeGroup")
                                && _this.filterByTags(task, _this.taskFilters.tags.value)
                                && _this.filterByDates(task)
                                && _this.filterByTaskLabels(task, _this.searchTask);
                        });
                        tasks = _.orderBy(tasks, [function (task) { return task[_this.taskOrder] || ""; }], [_this.taskOrderDescending ? "desc" : "asc"]);
                        _this.filteredTasks = _this.paginationFilter(tasks);
                    }, 500);
                };
                MinhasTarefasController.prototype.toggleFilter = function (filter, value) {
                    this.taskFilters[filter].active = !this.taskFilters[filter].active;
                    if (this.taskFilters[filter].active) {
                        this.taskFilters[filter].value = value;
                    }
                    else {
                        this.taskFilters[filter].value = this.taskFiltersDefaults[filter].value;
                    }
                };
                MinhasTarefasController.prototype.toggleArrayFilter = function (filter, value, idSearch) {
                    if (!this.isArrayFilterExists(filter, value, idSearch)) {
                        this.taskFilters[filter].value.push(value);
                    }
                    else if (idSearch) {
                        _.remove(this.taskFilters[filter].value, function (v) { return v["id"] === value["id"]; });
                    }
                    else {
                        _.remove(this.taskFilters[filter].value, function (v) { return v === value; });
                    }
                };
                MinhasTarefasController.prototype.isArrayFilterExists = function (filter, value, idSearch) {
                    if (idSearch) {
                        return this.taskFilters[filter].value.findIndex(function (o) { return o.id === value['id']; }) > -1;
                    }
                    return this.taskFilters[filter].value.indexOf(value) > -1;
                };
                MinhasTarefasController.prototype.hasFilteredItems = function (filter, values, idSearch) {
                    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                        var item = values_1[_i];
                        var searchItem = !idSearch && item['id'] ? item['id'] : item;
                        var filtered = this.isArrayFilterExists(filter, searchItem, idSearch);
                        if (filtered) {
                            return true;
                        }
                    }
                    ;
                    return false;
                };
                MinhasTarefasController.prototype.countTasksWithFilter = function (filter, comparator) {
                    return this.$filter("filter")(this.tasks, filter, comparator).length;
                };
                MinhasTarefasController.prototype.hasSelectedTasks = function () {
                    var selecteds = this.filteredTasks.filter(function (task) { return task.selected; });
                    return selecteds.length > 0;
                };
                MinhasTarefasController.prototype.hasAssumableSelectedTasks = function () {
                    var selecteds = this.filteredTasks
                        .filter(function (task) { return task.selected && !task.readOnly && !task.restricted; });
                    return selecteds.length > 0;
                };
                MinhasTarefasController.prototype.hasCancelableSelectedTasks = function () {
                    var selecteds = this.filteredTasks
                        .filter(function (task) { return task.selected && task.cancelable && !task.readOnly && !task.restricted; });
                    return selecteds.length > 0;
                };
                MinhasTarefasController.prototype.unSelect = function (tasks) {
                    tasks.forEach(function (task) { return task.selected = false; });
                };
                MinhasTarefasController.prototype.openTaskWithSearchableId = function () {
                    var tasks = this.filteredTasks.filter(function (task) { return !task.readOnly && !task.restricted; });
                    if (tasks.length === 1) {
                        this.minhasTarefasService.openTask(tasks[0]);
                    }
                    else if (tasks.length > 0) {
                        this.messagesService.error("Há mais de uma tarefa, por favor selecione qual deseja abrir.");
                    }
                    else {
                        this.messagesService.error("Nenhuma tarefa encontrada para abrir, por favor faça outra pesquisa.");
                    }
                };
                MinhasTarefasController.prototype.setPriority = function (task) {
                    var cmd = new minhasTarefas.SetPriorityTaskCommand(task.context, task.id);
                    cmd.priority = !task.priority;
                    this.minhasTarefasService.setPriority(cmd);
                };
                MinhasTarefasController.prototype.setNotes = function (task) {
                    if (this.canAnnotate) {
                        this.annotateTaskDialog(task);
                    }
                };
                MinhasTarefasController.prototype.assignTask = function (task) {
                    this.assignTasksDialog([task]);
                };
                MinhasTarefasController.prototype.assignTasks = function () {
                    var tasks = this.filteredTasks
                        .filter(function (task) { return task.selected; });
                    this.assignTasksDialog(tasks);
                };
                MinhasTarefasController.prototype.assignGroupTasks = function () {
                    var tasks = this.filteredTasks
                        .filter(function (task) { return task.selected && !task.restricted; });
                    this.assignGroupTasksDialog(tasks);
                };
                MinhasTarefasController.prototype.assignTagTasks = function () {
                    var _this = this;
                    var tasks = this.filteredTasks
                        .filter(function (task) { return task.selected; });
                    this.assignTagTasksDialog(tasks).then(function () {
                        _this.unSelect(tasks);
                    }).catch(function () {
                        _this.messagesService.error("Não foi possível atribuir rótulo.");
                    });
                };
                MinhasTarefasController.prototype.unassignTagTasks = function () {
                    var _this = this;
                    var tasks = this.filteredTasks
                        .filter(function (task) { return task.selected; });
                    this.unassignTagTasksDialog(tasks).then(function () {
                        _this.unSelect(tasks);
                    }).catch(function () {
                        _this.messagesService.error("Não foi possível remover atribuição de rótulo.");
                    });
                };
                MinhasTarefasController.prototype.assumeTasks = function () {
                    var _this = this;
                    var selectedTasks = this.filteredTasks
                        .filter(function (task) { return task.selected; });
                    if (selectedTasks.length > 0) {
                        var tasks = selectedTasks
                            .filter(function (task) { return task.assignee !== _this.userLogged &&
                            !task.readOnly && !task.restricted; });
                        if (tasks.length > 0) {
                            var cmd = new minhasTarefas.AssumeTasksCommand();
                            cmd.addTasks(tasks);
                            this.minhasTarefasService.assumeTasks(cmd)
                                .then(function () { return _this.unSelect(selectedTasks); });
                        }
                        else {
                            this.unSelect(selectedTasks);
                        }
                    }
                };
                MinhasTarefasController.prototype.formatDateDDMMYYYY = function (date) {
                    return moment(date).format("DD-MM-YYYY");
                };
                MinhasTarefasController.prototype.exportarResultado = function (ev) {
                    var selectedTasks = this.filteredTasks
                        .filter(function (task) { return task.selected; });
                    this.$mdDialog.show({
                        controller: "app.tarefas.minhas-tarefas.ExportarTarefasController",
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/exportar/exportar-tarefas-dialog.html",
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            tasks: selectedTasks,
                            usersNames: this.usersNames,
                            fromDate: this.formatDateDDMMYYYY(this.minDateFilter),
                            toDate: this.formatDateDDMMYYYY(this.maxDateFilter),
                            fileName: "relatorio-tarefas"
                        }
                    });
                };
                MinhasTarefasController.prototype.cancelTasks = function () {
                    var tasks = this.filteredTasks
                        .filter(function (task) { return task.selected && task.cancelable && !task.readOnly; });
                    this.cancelTasksDialog(tasks);
                };
                MinhasTarefasController.prototype.taskTrack = function (task) {
                    return task.context + "-" + task.id;
                };
                MinhasTarefasController.prototype.openHistoricTasks = function () {
                    this.$state.go("app.tarefas.minhas-tarefas.historico");
                };
                MinhasTarefasController.prototype.selectAllFilteredTasks = function (selected) {
                    this.filteredTasks.forEach(function (task) { return task.selected = selected; });
                };
                MinhasTarefasController.prototype.isAllFilteredTasksSelected = function () {
                    var tasks = this.filteredTasks;
                    if (tasks.length === 0) {
                        return false;
                    }
                    return tasks.length === tasks.filter(function (task) { return task.selected; }).length;
                };
                MinhasTarefasController.prototype.isUserGroup = function (groupId) {
                    return this.userGroups.some(function (g) { return g.id === groupId; });
                };
                MinhasTarefasController.prototype.groupName = function (groupId) {
                    var group = this.userGroups.find(function (g) { return g.id === groupId; });
                    return group ? group.nomeArvore : "Não pertencente";
                };
                MinhasTarefasController.prototype.groupNameParent = function (group) {
                    var names = group.nomeArvore.split(" > ");
                    names.splice(-1);
                    return names.join(" > ");
                };
                MinhasTarefasController.prototype.paginationFilter = function (tasks) {
                    this.validatePageSize();
                    this.pagination.total = tasks.length;
                    this.pagination.numberOfPages = Math.ceil(tasks.length / this.pagination.pageSize);
                    if (this.pagination.numberOfPages === 0) {
                        this.pagination.numberOfPages = 1;
                    }
                    if (this.pagination.currentPage >= this.pagination.numberOfPages) {
                        this.pagination.currentPage = this.pagination.numberOfPages - 1;
                    }
                    var start = this.pagination.currentPage * this.pagination.pageSize;
                    var pageSize = this.pagination.pageSize;
                    start = +start;
                    pageSize = +pageSize;
                    while (start > tasks.length) {
                        start -= pageSize;
                    }
                    if (start < 0) {
                        start = 0;
                    }
                    return tasks.slice(start, start + this.pagination.pageSize);
                };
                MinhasTarefasController.prototype.validatePageSize = function () {
                    if (!this.pagination.pageSize || this.pagination.pageSize < 1) {
                        this.pagination.pageSize = 1;
                    }
                    else if (this.pagination.pageSize > 9999) {
                        this.pagination.pageSize = 9999;
                    }
                };
                MinhasTarefasController.prototype.paginationPrevious = function () {
                    var page = this.pagination.currentPage - 1;
                    if (page >= 0) {
                        this.pagination.currentPage = page;
                    }
                    else {
                        this.pagination.currentPage = 0;
                    }
                };
                MinhasTarefasController.prototype.paginationNext = function () {
                    var page = this.pagination.currentPage + 1;
                    if (page >= this.pagination.numberOfPages) {
                        this.pagination.currentPage = this.pagination.numberOfPages - 1;
                    }
                    else {
                        this.pagination.currentPage = page;
                    }
                };
                MinhasTarefasController.prototype.paginationFirst = function () {
                    this.pagination.currentPage = 0;
                };
                MinhasTarefasController.prototype.paginationLast = function () {
                    this.pagination.currentPage = this.pagination.numberOfPages - 1;
                };
                MinhasTarefasController.prototype.formatDate = function (date) {
                    return this.$filter("date")(date, "dd/MM/yyyy HH:mm:ss");
                };
                MinhasTarefasController.prototype.setTags = function (task) {
                    var _this = this;
                    return this.setTaskTagsDialog(task)
                        .then(function () {
                        _this.loadTags(task);
                    });
                };
                MinhasTarefasController.prototype.removeTag = function (task, tag) {
                    var _this = this;
                    return this.removeTaskTagsDialog(task, tag)
                        .then(function () {
                        _this.loadTags(task);
                    });
                };
                MinhasTarefasController.prototype.createTag = function () {
                    var _this = this;
                    return this.$mdDialog.show({
                        controller: minhasTarefas.CreateTagController,
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/create-tag.html",
                        parent: this.$document.find("body"),
                        clickOutsideToClose: true
                    }).then(function (newTag) {
                        _this.rotulosService.create(newTag)
                            .then(function (tag) {
                            _this.$scope.$broadcast("stf:ui:tag-manual-criada", { content: tag });
                            _this.messagesService.success("Rótulo criado com sucesso!");
                        })
                            .catch(function (e) {
                            var message = JSON.parse(e.data);
                            _this.messagesService.error(message.errors[0].userMessage);
                        });
                    });
                };
                MinhasTarefasController.prototype.removeTags = function () {
                    var _this = this;
                    return this.$mdDialog.show({
                        controller: minhasTarefas.RemoveTagsController,
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/remove-tags.html",
                        parent: this.$document.find("body"),
                        clickOutsideToClose: true,
                        locals: {
                            tags: this.manualTags
                        }
                    }).then(function (tags) {
                        _this.rotulosService.remove(tags)
                            .then(function (tags) {
                            _this.$scope.$broadcast("stf:ui:tags-removidas", { content: tags });
                            var plural = tags.length > 1 ? "s" : "";
                            _this.messagesService.success("R\u00F3tulo" + plural + " removido" + plural + " com sucesso!");
                        }, function () { return _this.messagesService.error("Erro ao remover rótulos selecionados!"); });
                    });
                };
                MinhasTarefasController.prototype.updateTags = function () {
                    var _this = this;
                    return this.$mdDialog.show({
                        controller: minhasTarefas.UpdateTagsController,
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/update-tags.html",
                        parent: this.$document.find("body"),
                        clickOutsideToClose: true,
                        locals: {
                            tags: this.manualTags
                        }
                    }).then(function (tagAtualizada) {
                        _this.rotulosService.update(tagAtualizada)
                            .then(function () {
                            _this.$scope.$broadcast("stf:ui:tag-manual-atualizada", { content: tagAtualizada });
                            _this.messagesService.success("Rótulo alterado com sucesso!");
                        }, function () { return _this.messagesService.error("Erro ao alterar rótulo!"); });
                    });
                };
                MinhasTarefasController.prototype.loadCreatedTask = function (task, readOnly) {
                    var startDate = new Date(task.startDate);
                    var momentStartDate = moment(startDate);
                    task.readOnly = readOnly;
                    task.startDate = startDate.toISOString();
                    if (momentStartDate.isAfter(this.maxDateFilter, "day")) {
                        this.maxDateFilter = momentStartDate.endOf("d").toDate();
                    }
                    this.tasks.push(task);
                    this.loadTags(task);
                    this.applyTaskFilters();
                };
                MinhasTarefasController.prototype.assignTasksDialog = function (tasks) {
                    var _this = this;
                    var selectedTasks = tasks.filter(function (task) { return !task.restricted; });
                    var resources = [];
                    for (var _i = 0, selectedTasks_1 = selectedTasks; _i < selectedTasks_1.length; _i++) {
                        var task = selectedTasks_1[_i];
                        resources.push({
                            nome: task.command,
                            contexto: task.context,
                            tipo: "ACAO",
                            somenteLeitura: false
                        });
                    }
                    /** @ts-ignore */
                    this.$mdDialog.show({
                        controller: minhasTarefas.AssigneeController,
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/assignee/assignee.html",
                        parent: this.$document.find("body"),
                        clickOutsideToClose: true,
                        locals: {
                            tasks: selectedTasks,
                            resources: resources
                        },
                        resolve: {
                            users: function () {
                                return _this.minhasTarefasService.listUsersByResources(resources, true);
                            }
                        }
                    });
                };
                MinhasTarefasController.prototype.assignGroupTasksDialog = function (tasks) {
                    this.$mdDialog.show({
                        controller: minhasTarefas.AssigneeGroupController,
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/assignee-group/assignee-group.html",
                        parent: this.$document.find("body"),
                        clickOutsideToClose: true,
                        locals: {
                            tasks: tasks,
                            groups: this.userGroups
                        }
                    });
                };
                MinhasTarefasController.prototype.cancelTasksDialog = function (tasks) {
                    this.$mdDialog.show({
                        controller: minhasTarefas.CancellationController,
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/cancellation/cancellation.html",
                        parent: this.$document.find("body"),
                        clickOutsideToClose: true,
                        locals: { tasks: tasks }
                    });
                };
                MinhasTarefasController.prototype.annotateTaskDialog = function (task) {
                    this.$mdDialog.show({
                        controller: minhasTarefas.AnnotateController,
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/notes/notes.html",
                        parent: this.$document.find("body"),
                        clickOutsideToClose: true,
                        locals: { task: task }
                    });
                };
                MinhasTarefasController.prototype.setTaskTagsDialog = function (task) {
                    return this.$mdDialog.show({
                        controller: minhasTarefas.TagsController,
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/tags.html",
                        parent: this.$document.find("body"),
                        clickOutsideToClose: true,
                        locals: {
                            task: task,
                            tags: this.manualTags.filter(function (t) { return !_.some(task.etags, function (id) { return id === t.id; }); })
                        }
                    });
                };
                MinhasTarefasController.prototype.assignTagTasksDialog = function (tasks) {
                    return this.$mdDialog.show({
                        controller: minhasTarefas.AssignTagController,
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/assign-tags.html",
                        parent: this.$document.find("body"),
                        clickOutsideToClose: true,
                        locals: { tasks: tasks, tags: this.manualTags }
                    });
                };
                MinhasTarefasController.prototype.unassignTagTasksDialog = function (tasks) {
                    var _this = this;
                    var selectedTags = this.getTagsFromSelectedTasks(tasks);
                    var tags = this.manualTags.filter(function (t) { return _.some(selectedTags, function (id) { return id === t.id; }); });
                    return this.$mdDialog.show({
                        controller: minhasTarefas.UnAssignTagController,
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/unassign-tags.html",
                        parent: this.$document.find("body"),
                        clickOutsideToClose: true,
                        locals: { tasks: tasks, tags: tags }
                    }).then(function (command) {
                        if (command !== null) {
                            _this.minhasTarefasService.unsetTagsTasks(command).then(function () {
                                command.tasks.forEach(function (task) {
                                    _this.removeTagsTask(task, command.tags);
                                });
                                _this.unSelect(tasks);
                                _this.messagesService.success("Atribuições de rótulos removidas com sucesso!");
                            });
                        }
                    });
                };
                MinhasTarefasController.prototype.removeTaskTagsDialog = function (task, tag) {
                    var _this = this;
                    var confirm = this.$mdDialog.confirm()
                        .title("Excluir rótulo")
                        .textContent("Deseja excluir o r\u00F3tulo \"" + tag.name + "\" ?")
                        .ariaLabel("Excluir rótulo")
                        .ok("Confirmar")
                        .cancel("Cancelar");
                    return this.$mdDialog.show(confirm)
                        .then(function () {
                        var cmd = new minhasTarefas.RemoveTagTaskCommand(task.context, task.id);
                        cmd.tag = tag.id;
                        return _this.minhasTarefasService.removeTag(cmd);
                    });
                };
                MinhasTarefasController.prototype.sizeMaxAllowed = function (valor) {
                    if (valor.length > MinhasTarefasController.LIMIT_TEXT_EXTRA_INFO) {
                        return true;
                    }
                    return false;
                };
                MinhasTarefasController.prototype.sliceTextSize = function (valor) {
                    if (valor.length > MinhasTarefasController.LIMIT_TEXT_EXTRA_INFO) {
                        var text = valor.slice(0, MinhasTarefasController.LIMIT_TEXT_EXTRA_INFO);
                        var lastSpace = text.lastIndexOf(" ");
                        return text.slice(0, lastSpace);
                    }
                    return valor;
                };
                MinhasTarefasController.prototype.openDialogExtraInfo = function (chave, valor) {
                    var dialog = this.$mdDialog.alert()
                        .title(this.convertTextToCapitalize(chave))
                        .ok("Fechar")
                        .textContent(valor);
                    return this.$mdDialog.show(dialog);
                };
                MinhasTarefasController.prototype.loadUser = function (task) {
                    var _this = this;
                    if (task.assignee) {
                        if (task.assignee === this.userLogged) {
                            task.selfAssigned = true;
                        }
                        else {
                            task.selfAssigned = false;
                            var indexFound = this.users.indexOf(task.assignee);
                            if (indexFound === -1) {
                                this.users.push(task.assignee);
                                this.users.sort(function (u1, u2) { return _this.getUserName(u1).localeCompare(_this.getUserName(u2)); });
                            }
                        }
                    }
                };
                MinhasTarefasController.prototype.loadTags = function (task) {
                    var _this = this;
                    this.rotulosService.load(task, this.manualTags)
                        .then(function () {
                        if (task.tags) {
                            task.tags.forEach(function (tag) {
                                var indexFound = _this.tags.findIndex(function (t) { return t.id === tag.id; });
                                if (indexFound === -1) {
                                    _this.tags.push(tag);
                                }
                            });
                        }
                        else {
                            task.tags = [];
                        }
                    });
                };
                MinhasTarefasController.prototype.find = function (item, searchText) {
                    return this.findBySearchbleId(item, searchText) ||
                        this.findByTitle(item, searchText) ||
                        this.findByGroupName(item, searchText) ||
                        this.findByTagName(item, searchText) ||
                        this.findByNotes(item, searchText) ||
                        this.findByAssignee(item, searchText) ||
                        this.findByStartDate(item, searchText) ||
                        this.findByExtraInfo(item, searchText) ||
                        this.findByModifiedBy(item, searchText) ||
                        this.findByModifiedDate(item, searchText);
                };
                MinhasTarefasController.prototype.findBySearchbleId = function (item, text) {
                    if (!!item.searchableId) {
                        for (var _i = 0, _a = this.patterns; _i < _a.length; _i++) {
                            var pattern = _a[_i];
                            pattern.regex.lastIndex = 0;
                            if (pattern.regex.test(text)) {
                                pattern.regex.lastIndex = 0;
                                text = text.replace(pattern.regex, pattern.replaceFn);
                                return item.searchableId && item.searchableId.toUpperCase() === text.toUpperCase();
                            }
                        }
                    }
                    return false;
                };
                MinhasTarefasController.prototype.findByTitle = function (item, text) {
                    if (!!item.title) {
                        return _.deburr(item.title.toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1;
                    }
                    return false;
                };
                MinhasTarefasController.prototype.findByAssignee = function (item, text) {
                    if (!!item.assignee) {
                        return item.assignee.toUpperCase().indexOf(text.toUpperCase()) !== -1;
                    }
                    return false;
                };
                MinhasTarefasController.prototype.findByGroupName = function (item, text) {
                    if (!!item.assigneeGroup) {
                        return this.groupName(item.assigneeGroup).toUpperCase().indexOf(text.toUpperCase()) !== -1;
                    }
                    return false;
                };
                MinhasTarefasController.prototype.findByTagName = function (item, text) {
                    if (!!item.tags) {
                        return item.tags
                            .filter(function (tag) { return !!tag.name; })
                            .some(function (tag) { return _.deburr(tag.name.toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1; });
                    }
                    return false;
                };
                MinhasTarefasController.prototype.findByNotes = function (item, text) {
                    if (!!item.notes) {
                        return item.notes.toUpperCase().indexOf(text.toUpperCase()) !== -1;
                    }
                    return false;
                };
                MinhasTarefasController.prototype.findByStartDate = function (item, text) {
                    if (!!item.startDate) {
                        var data = this.formatDate(item.startDate);
                        return data.indexOf(text) !== -1;
                    }
                    return false;
                };
                MinhasTarefasController.prototype.findByModifiedDate = function (item, text) {
                    if (!!item.draft && !!item.draft.modifiedDate) {
                        var data = this.formatDate(item.draft.modifiedDate);
                        return data.indexOf(text) !== -1;
                    }
                    return false;
                };
                MinhasTarefasController.prototype.findByModifiedBy = function (item, text) {
                    if (!!item.draft && !!item.draft.modifiedBy) {
                        return item.draft.modifiedBy.toUpperCase().indexOf(text.toUpperCase()) !== -1;
                    }
                    return false;
                };
                MinhasTarefasController.prototype.findByExtraInfo = function (item, text) {
                    if (!!item.extraInfo) {
                        for (var key in item.extraInfo) {
                            if (item.extraInfo[key] !== null) {
                                var encontrou = _.deburr(item.extraInfo[key].toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1;
                                if (encontrou) {
                                    return true;
                                }
                            }
                        }
                    }
                    return false;
                };
                MinhasTarefasController.prototype.convertTextToCapitalize = function (text) {
                    return text[0].toUpperCase() + text.substr(1);
                };
                MinhasTarefasController.prototype.spliceTag = function (id, tags) {
                    var index = tags.findIndex(function (t) { return t.id === id; });
                    if (index > -1) {
                        tags.splice(index, 1);
                    }
                };
                MinhasTarefasController.prototype.removeTagsTask = function (task, tags) {
                    this.tasks.forEach(function (task) {
                        tags.forEach(function (tag) {
                            if (task.etags !== null) {
                                var index = task.etags.findIndex(function (t) { return t === tag; });
                                if (index > -1) {
                                    task.etags.splice(index, 1);
                                }
                            }
                        });
                    });
                };
                MinhasTarefasController.prototype.getTagsFromSelectedTasks = function (tasks) {
                    var tagsSelectedTasks = [];
                    tasks.forEach(function (task) {
                        if (task.etags !== null) {
                            task.etags.forEach(function (tag) {
                                var existsInSelectedTasks = tagsSelectedTasks.findIndex(function (t) { return t === tag; });
                                if (existsInSelectedTasks === -1) {
                                    tagsSelectedTasks.push(tag);
                                }
                            });
                            task.tags.forEach(function (tag) {
                                if (tag.type === "Manuais") {
                                    var existsInSelectedTasks = tagsSelectedTasks.findIndex(function (t) { return t === tag.id; });
                                    if (existsInSelectedTasks === -1) {
                                        tagsSelectedTasks.push(tag.id);
                                    }
                                }
                            });
                        }
                    });
                    return tagsSelectedTasks;
                };
                MinhasTarefasController.prototype.openDialogAlerts = function () {
                    var _this = this;
                    return this.alertService.recuperarAlertasNaoLidos()
                        .then(function (alertas) {
                        if (alertas.length > 0) {
                            return _this.$mdDialog.show({
                                controller: "app.support.alert.AlertController",
                                controllerAs: "vm",
                                templateUrl: "app/main/support/alert/alert-dialog.html",
                                parent: _this.$document.find("body"),
                                clickOutsideToClose: true,
                                locals: {
                                    alertas: alertas
                                }
                            });
                        }
                    });
                };
                return MinhasTarefasController;
            }());
            minhasTarefas.MinhasTarefasController = MinhasTarefasController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.MinhasTarefasController", MinhasTarefasController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            'use strict';
            var HistoricoTarefasController = /** @class */ (function () {
                /** @ngInject **/
                HistoricoTarefasController.$inject = ["$filter", "$scope", "$window", "$timeout", "$state", "$mdDialog", "app.tarefas.minhas-tarefas.MinhasTarefasService", "app.tarefas.minhas-tarefas.RotulosService", "user", "userGroups"];
                function HistoricoTarefasController($filter, $scope, $window, $timeout, $state, $mdDialog, minhasTarefasService, rotulosService, user, userGroups) {
                    var _this = this;
                    this.$filter = $filter;
                    this.$scope = $scope;
                    this.$window = $window;
                    this.$timeout = $timeout;
                    this.$state = $state;
                    this.$mdDialog = $mdDialog;
                    this.minhasTarefasService = minhasTarefasService;
                    this.rotulosService = rotulosService;
                    this.userGroups = userGroups;
                    this.pagination = {
                        currentPage: 0,
                        pageSize: 20,
                        numberOfPages: 1,
                        total: 0
                    };
                    this.taskFilters = {
                        priority: { value: false, active: false },
                        assignee: { value: [], active: true },
                        assigneeGroup: { value: [], active: false },
                        completed: { value: true, active: false },
                        cancellation: { value: "!!", active: false },
                        tags: { value: [], active: true }
                    };
                    this.taskOrder = "startDate";
                    this.taskOrderDescending = true;
                    this.taskViewExpanded = false;
                    this.msScrollOptions = {
                        suppressScrollX: true
                    };
                    this.tags = [];
                    this.users = [];
                    this.usersNames = new Map();
                    this.filteredTasks = [];
                    this.filteredTasksNoPagination = [];
                    this.exactlySearch = true;
                    this.searchCondition = minhasTarefas.SearchCondition.AND;
                    this.isTasksCompletedLoaded = false;
                    this.isTasksCanceledLoaded = false;
                    this.fromDate = moment().subtract(29, "d").startOf("d").toDate();
                    this.toDate = moment().endOf("d").toDate();
                    this.filterDefault = true;
                    this.patterns = [{
                            regex: /^([a-zA-Z]+)(\s+)([0-9]{7})$/g,
                            replaceFn: function (completo, sigla, espacos, numero) {
                                return sigla + " " + numero.replace(/^0+/, "");
                            }
                        }, {
                            regex: /^([0-9]{8})(\-)([0-9]{4})$/g,
                            replaceFn: function (completo, numero, traco, ano) {
                                return numero.replace(/^0+/, "") + traco + ano;
                            }
                        }, {
                            regex: /^([0-9]{7})([0-9]{4})$/g,
                            replaceFn: function (completo, numero, ano) {
                                return numero.replace(/^0+/, "") + "/" + ano;
                            }
                        }];
                    this.tasks = [];
                    this.openToDate = false;
                    this.userLogged = user.login;
                    this.taskFilters.assignee.value.push(this.userLogged);
                    this.taskFiltersDefaults = angular.copy(this.taskFilters);
                    this.loadSavedSearchData();
                    this.$scope.$watch(function () { return _this.taskFilters; }, function () { return _this.watchListener("taskFilters"); }, true);
                    this.$scope.$watchCollection(function () { return _this.pagination; }, function () { return _this.watchListener("pagination"); });
                    angular.forEach(["searchTask", "exactlySearch", "searchCondition",
                        "taskOrder", "taskOrderDescending", "toDate",
                        "fromDate", "taskViewExpanded"], function (prop) {
                        _this.$scope.$watch(function () { return _this[prop]; }, function () { return _this.watchListener(prop); });
                    });
                    this.loadCompletedTasks(this.fromDate.getTime(), this.toDate.getTime(), this.filterDefault);
                    this.loadCanceledTasks(this.fromDate.getTime(), this.toDate.getTime(), this.filterDefault);
                }
                HistoricoTarefasController.prototype.watchListener = function (property) {
                    this.applyTaskFilters();
                    this.saveSearchData(property, this[property]);
                };
                HistoricoTarefasController.prototype.saveSearchData = function (property, data) {
                    var ls = this.$window.localStorage;
                    var stringData = ls.getItem("searchHistoricData");
                    var searchData;
                    if (!!stringData) {
                        searchData = angular.fromJson(stringData);
                    }
                    else {
                        searchData = {};
                    }
                    searchData[property] = data;
                    ls.setItem("searchHistoricData", angular.toJson(searchData));
                };
                HistoricoTarefasController.prototype.loadSavedSearchData = function () {
                    var ls = this.$window.localStorage;
                    var stringData = ls.getItem("searchHistoricData");
                    if (!!stringData) {
                        var searchData = angular.fromJson(stringData);
                        for (var key in searchData) {
                            if (key === "pagination") {
                                this.pagination.pageSize = searchData.pagination.pageSize;
                                this.pagination.currentPage = searchData.pagination.currentPage;
                            }
                            else if (_.includes(["fromDate", "toDate", "fromDateFilter", "toDateFilter"], key)) {
                                this[key] = moment(searchData[key]).toDate();
                            }
                            else {
                                this[key] = searchData[key];
                            }
                        }
                    }
                };
                HistoricoTarefasController.prototype.clearFilters = function () {
                    this.taskFilters = angular.copy(this.taskFiltersDefaults);
                    this.applyTaskFilters();
                };
                HistoricoTarefasController.prototype.filterByTaskLabels = function (task, searchText) {
                    var _this = this;
                    if (!searchText || searchText.length < 2) {
                        return true;
                    }
                    if (this.exactlySearch) {
                        return this.find(task, searchText);
                    }
                    else {
                        var filteredText = searchText.split(" ").filter(function (text) { return text !== ""; });
                        var finder = function (text) { return _this.find(task, text); };
                        if (this.searchCondition === minhasTarefas.SearchCondition.AND) {
                            return _.every(filteredText, finder);
                        }
                        else {
                            return _.some(filteredText, finder);
                        }
                    }
                };
                HistoricoTarefasController.prototype.filterByTags = function (task, tags) {
                    if (tags.length === 0) {
                        return true;
                    }
                    else {
                        var groupTags_1 = _.groupBy(tags, "type");
                        return _.every(Object.keys(groupTags_1), function (type) {
                            return _.intersectionBy(task.tags, groupTags_1[type], "id").length > 0;
                        });
                    }
                };
                HistoricoTarefasController.prototype.filterByValues = function (task, values, filter) {
                    if (values.length === 0) {
                        return true;
                    }
                    else {
                        return _.some(values, function (v) {
                            return (v === "!!") ? !!task[filter] : task[filter] === v;
                        });
                    }
                };
                HistoricoTarefasController.prototype.applyTaskFilters = function () {
                    var _this = this;
                    this.$timeout(function () {
                        var tasks = _this.tasks
                            .filter(function (task) {
                            return _.every(["priority", "completed", "cancellation"], function (filter) {
                                if (_this.taskFilters[filter].active) {
                                    var value = _this.taskFilters[filter].value;
                                    if ((filter === "completed" && _this.taskFilters.cancellation.active) ||
                                        (filter === "cancellation" && _this.taskFilters.completed.active)) {
                                        return true;
                                    }
                                    else {
                                        return (value === "!!") ? !!task[filter] : task[filter] === value;
                                    }
                                }
                                else {
                                    return true;
                                }
                            }) && _this.filterByValues(task, _this.taskFilters["assignee"].value, "assignee")
                                && _this.filterByValues(task, _this.taskFilters["assigneeGroup"].value, "assigneeGroup")
                                && _this.filterByTags(task, _this.taskFilters["tags"].value)
                                && _this.filterByTaskLabels(task, _this.searchTask);
                        });
                        tasks = _.orderBy(tasks, _this.taskOrder, [_this.taskOrderDescending ? "desc" : "asc"]);
                        _this.filteredTasks = _this.paginationFilter(tasks);
                        _this.filteredTasksNoPagination = tasks;
                    }, 500);
                };
                HistoricoTarefasController.prototype.toggleFilter = function (filter, value) {
                    this.taskFilters[filter].active = !this.taskFilters[filter].active;
                    if (this.taskFilters[filter].active) {
                        this.taskFilters[filter].value = value;
                    }
                    else {
                        this.taskFilters[filter].value = this.taskFiltersDefaults[filter].value;
                    }
                };
                HistoricoTarefasController.prototype.toggleArrayFilter = function (filter, value, idSearch) {
                    if (!this.isArrayFilterExists(filter, value, idSearch)) {
                        this.taskFilters[filter].value.push(value);
                    }
                    else if (idSearch) {
                        _.remove(this.taskFilters[filter].value, function (v) { return v["id"] === value["id"]; });
                    }
                    else {
                        _.remove(this.taskFilters[filter].value, function (v) { return v === value; });
                    }
                };
                HistoricoTarefasController.prototype.isArrayFilterExists = function (filter, value, idSearch) {
                    if (idSearch) {
                        return this.taskFilters[filter].value.findIndex(function (o) { return o.id === value.id; }) > -1;
                    }
                    return this.taskFilters[filter].value.indexOf(value) > -1;
                };
                HistoricoTarefasController.prototype.hasFilteredItems = function (filter, values, idSearch) {
                    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                        var item = values_1[_i];
                        var searchItem = !idSearch && item['id'] ? item['id'] : item;
                        var filtered = this.isArrayFilterExists(filter, searchItem, idSearch);
                        if (filtered) {
                            return true;
                        }
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.countTasksWithFilter = function (filter, comparator) {
                    return this.$filter('filter')(this.tasks, filter, comparator).length;
                };
                HistoricoTarefasController.prototype.taskTrack = function (task) {
                    return task.context + "-" + task.id;
                };
                HistoricoTarefasController.prototype.openActiveTasks = function () {
                    this.$state.go("app.tarefas.minhas-tarefas");
                };
                HistoricoTarefasController.prototype.searchHistoricTasks = function () {
                    this.tasks = [];
                    if (!this.fromDate && !this.toDate) {
                        return;
                    }
                    this.fromDate = this.fromDate || moment(this.toDate).subtract(1, 'd').startOf("d").toDate();
                    this.toDate = this.toDate || moment().endOf("d").toDate();
                    this.tasks = this.tasks.filter(function (task) { return !task.completed; });
                    this.loadCanceledTasks(this.fromDate.getTime(), this.toDate.getTime(), this.filterDefault);
                    this.loadCompletedTasks(this.fromDate.getTime(), this.toDate.getTime(), this.filterDefault);
                    this.openToDate = false;
                };
                HistoricoTarefasController.prototype.loadCanceledTasks = function (from, to, filterByCreateDate) {
                    var _this = this;
                    this.isTasksCanceledLoaded = false;
                    this.minhasTarefasService.listCanceledTasks(from, to, filterByCreateDate)
                        .then(function (canceledTasks) {
                        _this.loadHistoricTasks(canceledTasks);
                        _this.isTasksCanceledLoaded = true;
                    });
                };
                HistoricoTarefasController.prototype.loadCompletedTasks = function (from, to, filterByCreateDate) {
                    var _this = this;
                    this.isTasksCompletedLoaded = false;
                    this.minhasTarefasService.listCompletedTasks(from, to, filterByCreateDate)
                        .then(function (completedTasks) {
                        _this.loadHistoricTasks(completedTasks);
                        _this.isTasksCompletedLoaded = true;
                    });
                };
                HistoricoTarefasController.prototype.loadHistoricTasks = function (tasks) {
                    var _this = this;
                    tasks.forEach(function (task) {
                        _this.loadTags(task);
                        _this.loadUser(task);
                        _this.tasks.push(task);
                    });
                    this.sortTags();
                    this.applyTaskFilters();
                    this.loadUsersNames(tasks);
                };
                HistoricoTarefasController.prototype.isUserGroup = function (groupId) {
                    return this.userGroups.some(function (g) { return g.id === groupId; });
                };
                HistoricoTarefasController.prototype.groupName = function (groupId) {
                    var group = this.userGroups.find(function (g) { return g.id === groupId; });
                    return group ? group.nomeArvore : "Não pertencente";
                };
                HistoricoTarefasController.prototype.groupNameParent = function (group) {
                    var names = group.nomeArvore.split(" > ");
                    names.splice(-1);
                    return names.join(" > ");
                };
                HistoricoTarefasController.prototype.paginationFilter = function (tasks) {
                    this.validatePageSize();
                    this.pagination.total = tasks.length;
                    this.pagination.numberOfPages = Math.ceil(tasks.length / this.pagination.pageSize);
                    if (this.pagination.numberOfPages === 0) {
                        this.pagination.numberOfPages = 1;
                    }
                    if (this.pagination.currentPage >= this.pagination.numberOfPages) {
                        this.pagination.currentPage = this.pagination.numberOfPages - 1;
                    }
                    var start = this.pagination.currentPage * this.pagination.pageSize;
                    var pageSize = this.pagination.pageSize;
                    start = +start;
                    pageSize = +pageSize;
                    while (start > tasks.length) {
                        start -= pageSize;
                    }
                    if (start < 0) {
                        start = 0;
                    }
                    return tasks.slice(start, start + this.pagination.pageSize);
                };
                HistoricoTarefasController.prototype.validatePageSize = function () {
                    if (!this.pagination.pageSize || this.pagination.pageSize < 1) {
                        this.pagination.pageSize = 1;
                    }
                    else if (this.pagination.pageSize > 9999) {
                        this.pagination.pageSize = 9999;
                    }
                };
                HistoricoTarefasController.prototype.paginationPrevious = function () {
                    var page = this.pagination.currentPage - 1;
                    if (page >= 0) {
                        this.pagination.currentPage = page;
                    }
                    else {
                        this.pagination.currentPage = 0;
                    }
                };
                HistoricoTarefasController.prototype.paginationNext = function () {
                    var page = this.pagination.currentPage + 1;
                    if (page >= this.pagination.numberOfPages) {
                        this.pagination.currentPage = this.pagination.numberOfPages - 1;
                    }
                    else {
                        this.pagination.currentPage = page;
                    }
                };
                HistoricoTarefasController.prototype.paginationFirst = function () {
                    this.pagination.currentPage = 0;
                };
                HistoricoTarefasController.prototype.paginationLast = function () {
                    this.pagination.currentPage = this.pagination.numberOfPages - 1;
                };
                HistoricoTarefasController.prototype.formatDate = function (date) {
                    return this.$filter("date")(date, "dd/MM/yyyy HH:mm:ss");
                };
                HistoricoTarefasController.prototype.findTask = function (context, id) {
                    return this.tasks.find(function (task) { return task.id === id && task.context === context; });
                };
                HistoricoTarefasController.prototype.loadUser = function (task) {
                    var _this = this;
                    if (task.assignee && task.assignee !== this.userLogged) {
                        var indexFound = this.users.indexOf(task.assignee);
                        if (indexFound === -1) {
                            this.users.push(task.assignee);
                            this.users.sort(function (u1, u2) { return _this.getUserName(u1).localeCompare(_this.getUserName(u2)); });
                        }
                    }
                };
                HistoricoTarefasController.prototype.getUserName = function (login) {
                    if (this.usersNames && login && login != "" && this.usersNames.has(login)) {
                        return this.usersNames.get(login);
                    }
                    return login;
                };
                HistoricoTarefasController.prototype.loadUsersNames = function (tasks) {
                    var _this = this;
                    var usuarios = new Set();
                    tasks.forEach(function (task) {
                        if (task.assignee && !_this.usersNames.has(task.assignee))
                            usuarios.add(task.assignee);
                        if (task.assignor && !_this.usersNames.has(task.assignor))
                            usuarios.add(task.assignor);
                        if (task.cancellation && task.cancellation.canceledBy && !_this.usersNames.has(task.cancellation.canceledBy))
                            usuarios.add(task.cancellation.canceledBy);
                        if (task.draft && task.draft.modifiedBy && !_this.usersNames.has(task.draft.modifiedBy))
                            usuarios.add(task.draft.modifiedBy);
                    });
                    if (usuarios && usuarios.size > 0) {
                        this.minhasTarefasService.getNomesUsuarios(Array.from(usuarios)).then(function (resultado) {
                            for (var _i = 0, _a = Object.entries(resultado); _i < _a.length; _i++) {
                                var _b = _a[_i], key = _b[0], value = _b[1];
                                _this.usersNames.set(key, value);
                                _this.users.sort(function (u1, u2) { return _this.getUserName(u1).localeCompare(_this.getUserName(u2)); });
                            }
                        });
                    }
                };
                HistoricoTarefasController.prototype.loadTags = function (task) {
                    var _this = this;
                    this.rotulosService.load(task)
                        .then(function () {
                        if (task.tags) {
                            task.tags.forEach(function (tag) {
                                var indexFound = _this.tags.findIndex(function (t) { return t.id === tag.id; });
                                if (indexFound === -1) {
                                    _this.tags.push(tag);
                                }
                            });
                        }
                        else {
                            task.tags = [];
                        }
                    });
                };
                HistoricoTarefasController.prototype.sortTags = function () {
                    this.tags = _.sortBy(this.tags, ['type', 'name']);
                };
                HistoricoTarefasController.prototype.find = function (item, searchText) {
                    return this.findBySearchbleId(item, searchText) ||
                        this.findByTitle(item, searchText) ||
                        this.findByGroupName(item, searchText) ||
                        this.findByTagName(item, searchText) ||
                        this.findByNotes(item, searchText) ||
                        this.findByAssignee(item, searchText) ||
                        this.findByStartDate(item, searchText) ||
                        this.findByExtraInfo(item, searchText) ||
                        this.findByModifiedBy(item, searchText) ||
                        this.findByModifiedDate(item, searchText) ||
                        this.findByCanceledBy(item, searchText) ||
                        this.findByCanceledDate(item, searchText) ||
                        this.findByCanceledReason(item, searchText);
                };
                HistoricoTarefasController.prototype.findBySearchbleId = function (item, text) {
                    if (!!item.searchableId) {
                        for (var _i = 0, _a = this.patterns; _i < _a.length; _i++) {
                            var pattern = _a[_i];
                            pattern.regex.lastIndex = 0;
                            if (pattern.regex.test(text)) {
                                pattern.regex.lastIndex = 0;
                                text = text.replace(pattern.regex, pattern.replaceFn);
                                return item.searchableId && item.searchableId.toUpperCase() === text.toUpperCase();
                            }
                        }
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByTitle = function (item, text) {
                    if (!!item.title) {
                        return _.deburr(item.title.toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1;
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByAssignee = function (item, text) {
                    if (!!item.assignee) {
                        return item.assignee.toUpperCase().indexOf(text.toUpperCase()) !== -1;
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByGroupName = function (item, text) {
                    if (!!item.assigneeGroup) {
                        return this.groupName(item.assigneeGroup).toUpperCase().indexOf(text.toUpperCase()) !== -1;
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByTagName = function (item, text) {
                    if (!!item.tags) {
                        return item.tags
                            .filter(function (tag) { return !!tag.name; })
                            .some(function (tag) { return _.deburr(tag.name.toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1; });
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByNotes = function (item, text) {
                    if (!!item.notes) {
                        return item.notes.toUpperCase().indexOf(text.toUpperCase()) !== -1;
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByStartDate = function (item, text) {
                    if (!!item.startDate) {
                        var data = this.formatDate(item.startDate);
                        return data.indexOf(text) !== -1;
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByModifiedDate = function (item, text) {
                    if (!!item.draft && !!item.draft.modifiedDate) {
                        var data = this.formatDate(item.draft.modifiedDate);
                        return data.indexOf(text) !== -1;
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByModifiedBy = function (item, text) {
                    if (!!item.draft && !!item.draft.modifiedBy) {
                        return item.draft.modifiedBy.toUpperCase().indexOf(text.toUpperCase()) !== -1;
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByCanceledDate = function (item, text) {
                    if (!!item.cancellation && !!item.cancellation.canceledDate) {
                        var data = this.formatDate(item.cancellation.canceledDate);
                        return data.indexOf(text) !== -1;
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByCanceledBy = function (item, text) {
                    if (!!item.cancellation && !!item.cancellation.canceledBy) {
                        return item.cancellation.canceledBy.toUpperCase().indexOf(text.toUpperCase()) !== -1;
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByCanceledReason = function (item, text) {
                    if (!!item.cancellation && !!item.cancellation.reason) {
                        return _.deburr(item.cancellation.reason.toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1;
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.findByExtraInfo = function (item, text) {
                    if (!!item.extraInfo) {
                        for (var key in item.extraInfo) {
                            if (item.extraInfo[key]) {
                                var encontrou = _.deburr(item.extraInfo[key].toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1;
                                if (encontrou) {
                                    return true;
                                }
                            }
                        }
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.sizeMaxAllowed = function (valor) {
                    if (valor.length > HistoricoTarefasController.limitTextExtraInfo) {
                        return true;
                    }
                    return false;
                };
                HistoricoTarefasController.prototype.sliceTextSize = function (valor) {
                    if (valor.length > HistoricoTarefasController.limitTextExtraInfo) {
                        var text = valor.slice(0, HistoricoTarefasController.limitTextExtraInfo);
                        var lastSpace = text.lastIndexOf(" ");
                        return text.slice(0, lastSpace);
                    }
                    return valor;
                };
                HistoricoTarefasController.prototype.openDialogExtraInfo = function (chave, valor) {
                    var dialog = this.$mdDialog.alert()
                        .title(this.convertTextToCapitalize(chave))
                        .ok("Fechar")
                        .textContent(valor);
                    return this.$mdDialog.show(dialog);
                };
                HistoricoTarefasController.prototype.convertTextToCapitalize = function (text) {
                    return text[0].toUpperCase() + text.substr(1);
                };
                HistoricoTarefasController.prototype.formatDateDDMMYYYY = function (date) {
                    return moment(date).format("DD-MM-YYYY");
                };
                HistoricoTarefasController.prototype.exportarResultado = function (ev) {
                    this.$mdDialog.show({
                        controller: "app.tarefas.minhas-tarefas.ExportarTarefasController",
                        controllerAs: "vm",
                        templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/exportar/exportar-tarefas-dialog.html",
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            tasks: this.filteredTasksNoPagination,
                            usersNames: this.usersNames,
                            fromDate: this.formatDateDDMMYYYY(this.fromDate),
                            toDate: this.formatDateDDMMYYYY(this.toDate),
                            fileName: "historico-tarefas"
                        }
                    });
                };
                HistoricoTarefasController.limitTextExtraInfo = 470;
                return HistoricoTarefasController;
            }());
            minhasTarefas.HistoricoTarefasController = HistoricoTarefasController;
            angular
                .module('app.tarefas.minhas-tarefas')
                .controller('app.tarefas.minhas-tarefas.HistoricoTarefasController', HistoricoTarefasController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var details;
        (function (details) {
            "use strict";
            /** @ngInject **/
            config.$inject = ["$translatePartialLoaderProvider", "$stateProvider", "msNavigationServiceProvider"];
            run.$inject = ["$rootScope", "$timeout"];
            function config($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
                $translatePartialLoaderProvider.addPart("app/main/tarefas/details");
                $stateProvider.state('app.tarefas.details', {
                    url: '/id/{context:any}/{id:any}',
                    views: {
                        "content@app.autenticado": {
                            templateUrl: "app/main/tarefas/details/tarefas-details.html",
                            controller: tarefas.TarefasDetailsController,
                            controllerAs: "vm",
                            resolve: {
                                context: /** @ngInject */ ["$stateParams", function ($stateParams) {
                                    return $stateParams["context"];
                                }],
                                id: /** @ngInject */ ["$stateParams", function ($stateParams) {
                                    return $stateParams["id"];
                                }],
                            }
                        }
                    }
                });
            }
            /** @ngInject **/
            function run($rootScope, $timeout) {
            }
            angular
                .module("app.tarefas.details", ["app.tarefas"])
                .config(config)
                .run(run);
        })(details = tarefas.details || (tarefas.details = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        'use strict';
        /** @ngInject * */
        config.$inject = ["$translatePartialLoaderProvider", "$stateProvider", "msNavigationServiceProvider"];
        run.$inject = ["stfBreadcrumbsService", "$rootScope", "messagesService", "$state", "$log", "msNavigationService"];
        function config($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
            $translatePartialLoaderProvider.addPart('app/main/tarefas');
            $stateProvider.state('app.tarefas', {
                abstract: true,
                url: '/tarefas',
                parent: 'app.autenticado'
            });
            // Navigation
            msNavigationServiceProvider.saveItem('tarefas', {
                title: 'TAREFAS',
                translation: 'TAREFAS.TAREFAS',
                group: true,
                weight: 2
            });
        }
        /** @ngInject */
        function run(stfBreadcrumbsService, $rootScope, messagesService, $state, $log, msNavigationService) {
            stfBreadcrumbsService.registerPath({
                id: 'tarefas',
                translation: 'Tarefas',
                uisref: 'app.tarefas.minhas-tarefas'
            });
            $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams, options) {
                if (toState.name.startsWith("app.tarefas")) {
                    if (toParams.hasOwnProperty("task") && toParams["task"] === undefined) {
                        event.preventDefault();
                        messagesService.error("Tarefa não encontrada.");
                        $state.go("app.tarefas.minhas-tarefas");
                    }
                }
            });
            msNavigationService.sort();
            $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
                if (toState.name.startsWith("app.tarefas")) {
                    messagesService.error("Erro ao acessar a tarefa.");
                    $rootScope["loadingProgress"] = false;
                }
                $log.error(error);
            });
        }
        angular
            .module('app.tarefas', ['app.autenticado', 'app.support'])
            .config(config)
            .run(run);
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        "use strict";
        var TarefasDetailsController = /** @class */ (function () {
            /** @ngInject **/
            TarefasDetailsController.$inject = ["$stateParams", "$state", "context", "id", "app.tarefas.minhas-tarefas.MinhasTarefasService", "commandService"];
            function TarefasDetailsController($stateParams, $state, context, id, minhasTarefasService, commandService) {
                var _this = this;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.minhasTarefasService = minhasTarefasService;
                this.commandService = commandService;
                this.minhasTarefasService.get().then(function (tasks) {
                    var task = tasks.find(function (task) { return task.context == context && task.id == id; });
                    if (task) {
                        _this.redirecionar(task);
                    }
                    else {
                        _this.$state.go('app.tarefas');
                    }
                });
            }
            TarefasDetailsController.prototype.redirecionar = function (task) {
                var _this = this;
                this.commandService.findByIdAndContext(task.command, task.context).then(function (command) {
                    var contextTask = angular.copy(task);
                    _this.$state.go(command.route.stateName, Object.assign({ task: contextTask }));
                });
            };
            TarefasDetailsController.prototype.$onInit = function () {
            };
            return TarefasDetailsController;
        }());
        tarefas.TarefasDetailsController = TarefasDetailsController;
        angular
            .module('app.tarefas')
            .controller('app.tarefas.TarefasDetailsController', TarefasDetailsController);
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var websocket;
        (function (websocket) {
            'use strict';
            var WebsocketService = /** @class */ (function () {
                /** ngInject **/
                WebsocketService.$inject = ["$q", "$cookies", "$rootScope"];
                function WebsocketService($q, $cookies, $rootScope) {
                    this.$q = $q;
                    this.$cookies = $cookies;
                    this.$rootScope = $rootScope;
                    this.stomp = null;
                    this.debug = null;
                }
                WebsocketService.prototype.setDebug = function (callback) {
                    this.debug = callback;
                };
                WebsocketService.prototype.connect = function (endpoint, headers, errorCallback) {
                    headers = headers || {};
                    var defer = this.$q.defer();
                    var access_token = this.$cookies.get("access_token");
                    //@ts-ignore
                    this.stomp = Stomp.over(this.websocketFactory(endpoint + "?access_token=" + access_token, errorCallback));
                    this.stomp.debug = this.debug;
                    this.stomp.connect(headers, function (frame) {
                        defer.resolve(frame);
                    }, function (error) {
                        defer.reject(error);
                        if (angular.isFunction(errorCallback)) {
                            errorCallback(error);
                        }
                    });
                    return defer.promise;
                };
                WebsocketService.prototype.disconnect = function () {
                    var defer = this.$q.defer();
                    this.stomp.disconnect(defer.resolve);
                    return defer.promise;
                };
                WebsocketService.prototype.subscribe = function (destination, callback, headers) {
                    var _this = this;
                    headers = headers || {};
                    return this.stomp.subscribe(destination, function (response) {
                        var payload = null;
                        try {
                            payload = angular.fromJson(response.body);
                        }
                        catch (e) {
                            payload = response.body;
                        }
                        finally {
                            if (callback) {
                                callback(payload, response.headers, response);
                                _this.$rootScope.$apply();
                            }
                        }
                    }, headers);
                };
                WebsocketService.prototype.on = function (destination, callback, headers) {
                    return this.subscribe(destination, callback, headers);
                };
                WebsocketService.prototype.unsubscribe = function (subscription) {
                    subscription.unsubscribe();
                };
                WebsocketService.prototype.off = function (subscription) {
                    this.unsubscribe(subscription);
                };
                WebsocketService.prototype.send = function (destination, body, headers) {
                    var defer = this.$q.defer();
                    try {
                        var json = angular.toJson(body);
                        headers = headers || {};
                        this.stomp.send(destination, headers, json);
                        defer.resolve();
                    }
                    catch (error) {
                        defer.reject(error);
                    }
                    return defer.promise;
                };
                WebsocketService.prototype.websocketFactory = function (endpoint, errorCallback) {
                    return function () {
                        var sock = new WebSocket(endpoint);
                        sock.onclose = function () {
                            if (angular.isFunction(errorCallback)) {
                                errorCallback(new Error('Connection broken'));
                            }
                        };
                        return sock;
                    };
                };
                return WebsocketService;
            }());
            websocket.WebsocketService = WebsocketService;
            angular.module('app.support.websocket', []).service('websocketService', WebsocketService);
        })(websocket = support.websocket || (support.websocket = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        'use strict';
        angular.module('app.support', [
            'app.core',
            'app.support.authorization',
            'app.support.messaging',
            'app.support.command',
            'app.support.constants',
            'app.support.suggestion',
            'app.support.websocket',
            'app.support.identidades',
            'app.support.alert'
        ]);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



/**
 * Provider para que provê um decorator para transformação de promises $http de modo a retornar diretamente
 * o response.data em vez do retorno completo da requisição.
 *
 * @author Tomás Godoi
 * @since 1.0.0
 *
 */
var app;
/**
 * Provider para que provê um decorator para transformação de promises $http de modo a retornar diretamente
 * o response.data em vez do retorno completo da requisição.
 *
 * @author Tomás Godoi
 * @since 1.0.0
 *
 */
(function (app) {
    var support;
    (function (support) {
        /** @ngInject */
        httpPromiseTransformationDecorator.$inject = ["$delegate", "$injector"];
        function httpPromiseTransformationDecorator($delegate, $injector) {
            function decorate($injector, obj, func) {
                return angular.extend(function () {
                    var httpPromiseTransformation = $injector.get('httpPromiseTransformation');
                    return httpPromiseTransformation.call(func, obj, arguments);
                }, func);
            }
            for (var prop in $delegate) {
                if (angular.isFunction($delegate[prop])) {
                    $delegate[prop] = decorate($injector, $delegate, $delegate[prop]);
                }
            }
            return $delegate;
        }
        var HttpPromiseTransformationService = /** @class */ (function () {
            /** @ngInject */
            HttpPromiseTransformationService.$inject = ["$q"];
            function HttpPromiseTransformationService($q) {
                this.$q = $q;
            }
            HttpPromiseTransformationService.prototype.call = function (func, self, args) {
                var _this = this;
                var result = func.apply(self, args);
                if (this.isPromise(result)) {
                    return result.then(function (response) {
                        return _this.getResponseData(response);
                    }, function (response) {
                        return _this.$q.reject(_this.getResponseData(response));
                    });
                }
                return result;
            };
            HttpPromiseTransformationService.prototype.getResponseData = function (response) {
                if (response) {
                    return response.hasOwnProperty("headers") ? response.data : response;
                }
                return response;
            };
            HttpPromiseTransformationService.prototype.isPromise = function (possiblePromise) {
                if (possiblePromise && angular.isFunction(possiblePromise.then) && angular.isFunction(possiblePromise['catch'])) {
                    return true;
                }
                else {
                    return false;
                }
            };
            return HttpPromiseTransformationService;
        }());
        support.HttpPromiseTransformationService = HttpPromiseTransformationService;
        var HttpPromiseTransformationProvider = /** @class */ (function () {
            function HttpPromiseTransformationProvider() {
            }
            HttpPromiseTransformationProvider.prototype.decorate = function ($provide, serviceName) {
                $provide.decorator(serviceName, httpPromiseTransformationDecorator);
            };
            /** @ngInject */
            HttpPromiseTransformationProvider.prototype.$get = function ($q) {
                return new HttpPromiseTransformationService($q);
            };
            HttpPromiseTransformationProvider.prototype.$get.$inject = ["$q"];
            return HttpPromiseTransformationProvider;
        }());
        support.HttpPromiseTransformationProvider = HttpPromiseTransformationProvider;
        angular
            .module('app.support')
            .provider('httpPromiseTransformation', HttpPromiseTransformationProvider);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        /**
         * Diretiva stf-toggle-button
         *
         */
        var StfToggleButton = /** @class */ (function () {
            /** @ngInject */
            StfToggleButton.$inject = ["$timeout"];
            function StfToggleButton($timeout) {
                this.$timeout = $timeout;
                this.restrict = 'E';
                this.scope = {
                    'config': '=',
                    'value': '=',
                    'autoFocus': '@',
                    'fieldId': '@',
                    'required': '@',
                    'disabled': '=?',
                    'onValueChange': '&?'
                };
                this.templateUrl = 'app/main/support/toggle/toggle-button.html';
                this.controller = support.StfToggleButtonController;
                this.controllerAs = 'vm';
            }
            StfToggleButton.prototype.link = function ($scope, element, attrs, vm) {
                var _this = this;
                var initializing = true;
                $scope.$watch('value', function (value, oldValue) {
                    vm.value = value;
                    vm.disableButtonByValue();
                    if (!initializing) { // Para não chamar o callback na primeira vez.
                        $scope.$applyAsync(function () {
                            if (vm.onValueChange) {
                                vm.onValueChange({ value: value });
                            }
                        });
                    }
                    else {
                        _this.$timeout(function () { return initializing = false; });
                    }
                });
                $scope.$watchCollection('config', function (newvalue, oldValue) {
                    $scope.$applyAsync(function () {
                        vm.updateListItems();
                    });
                });
                $scope.$watch('disabled', function (value) {
                    vm.disabled = value;
                });
            };
            StfToggleButton.factory = function () {
                return ["$timeout", function ($timeout) {
                    'ngInject';
                    return new StfToggleButton($timeout);
                }];
            };
            return StfToggleButton;
        }());
        angular
            .module('app.support')
            .directive('stfToggleButton', StfToggleButton.factory());
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var StfToggleButtonController = /** @class */ (function () {
            /** @ngInject */
            StfToggleButtonController.$inject = ["$scope"];
            function StfToggleButtonController($scope) {
                this.$scope = $scope;
                this.a = "false";
                this.btnOutrosSelecionado = false;
                this.btnOutrosPrimeiroAcesso = true;
                this.value = this.$scope.value;
                this.listValue = this.value;
                this.config = this.$scope.config;
                this.fieldId = this.$scope.fieldId;
                this.required = this.$scope.required !== null && this.$scope.required !== undefined && this.$scope.required !== 'false';
                this.disabled = this.$scope.disabled;
                this.onValueChange = this.$scope.onValueChange;
                this.autoFocus = this.$scope.autoFocus !== null && this.$scope.autoFocus !== undefined && this.$scope.autoFocus !== 'false';
                this.disableButtonByValue();
                this.setAutoFocus();
                this.listItems = this.config.list;
                this.selectedListItem = this.config.selectedListIndex;
            }
            StfToggleButtonController.prototype.buttonClick = function (evt, id) {
                if (this.disabled) {
                    return;
                }
                this.changeValueById(id);
            };
            StfToggleButtonController.prototype.changeValueById = function (id) {
                if (id === "btnOutros") {
                    this.btnOutrosSelecionado = !this.btnOutrosSelecionado;
                    if (this.btnOutrosPrimeiroAcesso && !!this.selectedListItem) {
                        this.listValue = this.selectedListItem;
                        this.$scope.value = this.selectedListItem;
                        this.btnOutrosPrimeiroAcesso = false;
                    }
                    else if (!!this.listValue) {
                        this.$scope.value = this.listValue;
                    }
                }
                else {
                    if (!this.config.buttons.find(function (b) { return b.id === id; }))
                        throw new Error("Não existe um botão com o id especificado");
                }
                for (var i = 0; i < this.config.buttons.length; i++) {
                    var btn = this.config.buttons[i];
                    if (btn.id === id) {
                        btn.disabled = !btn.disabled;
                        this.btnOutrosSelecionado = false;
                        this.$scope.value = btn.disabled ? btn.value : null;
                    }
                    else {
                        btn.disabled = false;
                    }
                }
            };
            StfToggleButtonController.prototype.disableButtonByValue = function (value) {
                if (value === void 0) { value = this.value; }
                this.enableAllButtons();
                if (!value) {
                    return;
                }
                var btn = this.config.buttons.find(function (btn) { return btn.value === value; });
                if (btn) {
                    btn.disabled = true;
                }
                else {
                    this.listValue = value;
                    this.changeValueByListItem();
                }
            };
            StfToggleButtonController.prototype.changeValueByListItem = function () {
                this.$scope.value = this.listValue;
                this.enableAllButtons();
            };
            StfToggleButtonController.prototype.updateListItems = function () {
                var _this = this;
                if (!this.config.list)
                    return;
                this.listValue = null;
                this.btnOutrosSelecionado = false;
                if (!this.$scope.value)
                    this.enableAllButtons();
                this.listItems = this.config.list.filter(function (item) {
                    return !_this.config.buttons.find(function (btn) {
                        return btn.value.toString().toLowerCase() === item.id.toString().toLowerCase();
                    });
                });
                this.selecionarValorDaListaBotaoOutros();
            };
            StfToggleButtonController.prototype.selecionarValorDaListaBotaoOutros = function () {
                var _this = this;
                var selectedValueBtn = this.config.buttons.find(function (btn) { return btn.value === _this.value; });
                if ((!!this.listItems && this.listItems.length > 0)
                    && !!this.value && selectedValueBtn === undefined) {
                    var listItemsValue = this.listItems.find(function (item) { return item.id === _this.value; });
                    if (!!listItemsValue) {
                        this.btnOutrosSelecionado = true;
                        this.listValue = this.value;
                    }
                }
            };
            StfToggleButtonController.prototype.enableAllButtons = function () {
                for (var i = 0; i < this.config.buttons.length; i++) {
                    this.config.buttons[i].disabled = false;
                }
            };
            StfToggleButtonController.prototype.setAutoFocus = function () {
                for (var i = 0; i < this.config.buttons.length; i++) {
                    this.config.buttons[i].focusIf = (this.autoFocus &&
                        ((i == 0 && !this.config.buttons[i].disabled) || (i == 1 && this.config.buttons[0].disabled))) ? true : false;
                }
            };
            return StfToggleButtonController;
        }());
        support.StfToggleButtonController = StfToggleButtonController;
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var suggestion;
        (function (suggestion) {
            'use strict';
            angular
                .module('app.support.suggestion', ['app.support.constants']);
        })(suggestion = support.suggestion || (support.suggestion = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var suggestion;
        (function (suggestion_1) {
            'use strict';
            var SuggestionService = /** @class */ (function () {
                /** @ngInject **/
                SuggestionService.$inject = ["$http", "properties", "$rootScope", "$q"];
                function SuggestionService($http, properties, $rootScope, $q) {
                    var _this = this;
                    this.$http = $http;
                    this.properties = properties;
                    this.$q = $q;
                    this.loadSuggestions();
                    $rootScope.$on('user:logged', function () { return _this.loadSuggestions(); });
                    $rootScope.$on('user:exited', function () { return _this.resetSuggestions(); });
                }
                SuggestionService.prototype.list = function () {
                    return this.suggestions;
                };
                /**
                 * Pesquisa uma configuração de sugestão por id
                 */
                SuggestionService.prototype.findById = function (id) {
                    var found = this.$q.defer();
                    this.suggestions
                        .then(function (suggestions) {
                        for (var _i = 0, suggestions_1 = suggestions; _i < suggestions_1.length; _i++) {
                            var suggestion_2 = suggestions_1[_i];
                            if (suggestion_2.id === id) {
                                return found.resolve(suggestion_2);
                            }
                        }
                        return found.reject("Identificador não encontrado: " + id);
                    }, function () {
                        found.reject("Erro ao carregar componentes de sugestão!");
                    });
                    return found.promise;
                };
                /**
                 * Carrega os componentes de sugestão
                 */
                SuggestionService.prototype.loadSuggestions = function () {
                    var suggestionsDeferred = this.$q.defer();
                    this.suggestions = suggestionsDeferred.promise;
                    this.$http.get(this.properties.apiUrl + SuggestionService.apiSuggestions)
                        .then(function (response) { return suggestionsDeferred.resolve(response.data); }, function () { return suggestionsDeferred.reject(); });
                };
                /**
                 * Limpa as sugestões carregadas
                 */
                SuggestionService.prototype.resetSuggestions = function () {
                    var suggestionConfigsDeferred = this.$q.defer();
                    this.suggestions = suggestionConfigsDeferred.promise;
                    suggestionConfigsDeferred.resolve([]);
                };
                SuggestionService.apiSuggestions = '/integracoes-modulos/api/queries/suggestions';
                return SuggestionService;
            }());
            suggestion_1.SuggestionService = SuggestionService;
            angular
                .module('app.support.suggestion')
                .service('app.support.suggestion.SuggestionService', SuggestionService);
        })(suggestion = support.suggestion || (support.suggestion = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



/**
 * Diretiva que cria uma caixa de seleção com autocomplete
 *
 * @author Lucas.Rodrigues
 *
 * @since 1.0.0
 */
var app;
/**
 * Diretiva que cria uma caixa de seleção com autocomplete
 *
 * @author Lucas.Rodrigues
 *
 * @since 1.0.0
 */
(function (app) {
    var support;
    (function (support) {
        var suggestion;
        (function (suggestion) {
            'use strict';
            /**
             * Diretiva de sugestao
             * Ex. de uso:
             * &lt;suggestion id="sugerir-processo" ng-model="vm.processo" api="/api/sugestao"
             * search-item="identificacao" item-text="vm.format(item)" use-description="true"&gt;&lt;/suggestion&gt;
             */
            var SuggestionDirective = /** @class */ (function () {
                function SuggestionDirective() {
                    this.restrict = 'AE';
                    this.templateUrl = 'app/main/support/suggestion/suggestion.tpl.html';
                    this.scope = {
                        id: '@',
                        selectedItem: '=ngModel',
                        api: '@',
                        searchItem: '@',
                        itemText: '&',
                        useDescription: '@' //opcional, Boleano que indica se deve usar a descrição como placeholder
                    };
                    this.link = function (scope, el, attrs) {
                        if (angular.isUndefined(scope.id) || angular.isUndefined(scope.selectedItem)
                            || angular.isUndefined(scope.api) || angular.isUndefined(scope.searchItem)) {
                            throw new Error("Parâmetros insuficientes para execução da diretiva de sugestão.");
                        }
                        if (angular.isUndefined(scope.useDescription)) {
                            scope.useDescription = false;
                        }
                        if (angular.isUndefined(attrs.$attr['itemText'])) {
                            scope.itemText = undefined;
                        }
                    };
                    this.controller = suggestion.SuggestionDirectiveController;
                    this.controllerAs = 'vm';
                }
                SuggestionDirective.factory = function () {
                    return function () { return new SuggestionDirective(); };
                };
                return SuggestionDirective;
            }());
            suggestion.SuggestionDirective = SuggestionDirective;
            angular
                .module('app.support.suggestion')
                .directive('suggestion', SuggestionDirective.factory());
        })(suggestion = support.suggestion || (support.suggestion = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var suggestion;
        (function (suggestion_1) {
            var SuggestionDirectiveController = /** @class */ (function () {
                /** @ngInject **/
                SuggestionDirectiveController.$inject = ["$scope", "$http", "app.support.suggestion.SuggestionService"];
                function SuggestionDirectiveController($scope, $http, suggestionService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$http = $http;
                    this.searchText = "";
                    this.items = [];
                    this.placeholder = "Digite aqui para pesquisar";
                    this.suggestion = { description: "" };
                    if (angular.isDefined($scope.id)) {
                        suggestionService.findById($scope.id)
                            .then(function (suggestion) {
                            _this.suggestion = suggestion;
                            if ($scope.useDescription) {
                                _this.placeholder = suggestion.description;
                            }
                        }, function (error) { throw new Error(error); });
                    }
                    if (angular.isFunction($scope.itemText)) {
                        this.itemText = $scope.itemText;
                    }
                    else {
                        this.itemText = this.defaultItemText;
                    }
                }
                SuggestionDirectiveController.prototype.selectedItemChange = function (item) {
                    this.$scope.selectedItem = item;
                };
                SuggestionDirectiveController.prototype.searchTextChange = function () {
                    var _this = this;
                    var _a;
                    var config = {
                        params: (_a = {},
                            _a[this.$scope.searchItem] = this.searchText,
                            _a)
                    };
                    var url = "";
                    if (angular.isDefined(this.suggestion)) {
                        url += "/" + this.suggestion.context;
                    }
                    url += this.$scope.api;
                    this.$http.get(url, config)
                        .success(function (items) { return _this.items = items; });
                };
                SuggestionDirectiveController.prototype.defaultItemText = function (item) {
                    return (angular.isDefined(item)) ? item.toString() : "";
                };
                return SuggestionDirectiveController;
            }());
            suggestion_1.SuggestionDirectiveController = SuggestionDirectiveController;
        })(suggestion = support.suggestion || (support.suggestion = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        "use strict";
        var StylesLoadingService = /** @class */ (function () {
            StylesLoadingService.$inject = ["$q"];
            function StylesLoadingService($q) {
                this.$q = $q;
            }
            StylesLoadingService.prototype.loadStyle = function (styleUrl) {
                var _this = this;
                // Carregamento dos estilos dos contextos.
                var styleUrlTs = this.getUrlWithTimestamp(styleUrl);
                return this.$q(function (resolve) {
                    if (_this.isCssAlreadyPresent(styleUrl)) {
                        resolve();
                    }
                    else {
                        var styleElement = loadCSS(styleUrlTs);
                        onloadCSS(styleElement, function () {
                            resolve();
                        });
                    }
                });
            };
            /**
             * Verifica se um CSS já está presente na tela.
             *
             * @param path
             */
            StylesLoadingService.prototype.isCssAlreadyPresent = function (path) {
                var present = false;
                for (var i = 0; i < document.styleSheets.length; i++) {
                    if (document.styleSheets[i].href && document.styleSheets[i].href.startsWith(path)) {
                        present = true;
                        break;
                    }
                }
                return present;
            };
            /**
             * Monta uma url com um timestamp na querystring.
             *
             * @param url
             */
            StylesLoadingService.prototype.getUrlWithTimestamp = function (url) {
                return url + (url.indexOf("?") === -1 ? "?" : "&") + "ts=" + Date.now().toString();
            };
            return StylesLoadingService;
        }());
        support.StylesLoadingService = StylesLoadingService;
        angular.module('app.support')
            .service('stylesLoadingService', StylesLoadingService);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        "use strict";
        var NumeroUnicoCNJ = /** @class */ (function () {
            function NumeroUnicoCNJ() {
            }
            NumeroUnicoCNJ.prototype.filter = function (value) {
                if (value.length < 20) {
                    return '';
                }
                return value.slice(0, 7) + "-" + value.slice(7, 9) + "." + value.slice(9, 13) + "." + value.slice(13, 14) + "." + value.slice(14, 16) + "." + value.slice(16);
            };
            NumeroUnicoCNJ.factory = function () {
                return function () {
                    'ngInject';
                    return new NumeroUnicoCNJ().filter;
                };
            };
            return NumeroUnicoCNJ;
        }());
        support.NumeroUnicoCNJ = NumeroUnicoCNJ;
        angular.module('app.support')
            .filter('numeroUnicoCNJ', NumeroUnicoCNJ.factory());
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        /** @ngInject */
        configNgSubmitDecorator.$inject = ["$provide"];
        function configNgSubmitDecorator($provide) {
            $provide.decorator('ngSubmitDirective', ["$delegate", "$timeout", function ($delegate, $timeout) {
                var originalCompile = $delegate[0].compile;
                $delegate[0].compile = function (element, attrs, transclude) {
                    if (angular.isString(attrs.stfProcessing)) {
                        var alreadyMadeRequest_1 = false;
                        function handleDuplicateRequests(event) {
                            if (alreadyMadeRequest_1) {
                                event.preventDefault();
                                event.stopImmediatePropagation();
                            }
                            else {
                                alreadyMadeRequest_1 = true;
                                $timeout(function () { alreadyMadeRequest_1 = false; }, 500, false);
                            }
                        }
                        element.on('submit', handleDuplicateRequests);
                        attrs['ngSubmit'] = '$stfDecorateNgSubmitHandler(' + attrs['ngSubmit'] + ')';
                        return originalCompile(element, attrs, transclude);
                    }
                    else {
                        return originalCompile(element, attrs, transclude);
                    }
                };
                return $delegate;
            }]);
        }
        angular.module('app.support').config(configNgSubmitDecorator);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        /**
         * Diretiva para indicar que está se processando algo como consequência do
         * clique de um botão ou submit de form. Ela desabilita o botão enquanto estiver
         * processando a promise e mostra o loader global do sistema.
         *
         * O handler do ng-click ou do ng-submit deve retornar uma promise que indicará o status
         * do processamento.
         */
        var StfProcessing = /** @class */ (function () {
            function StfProcessing($rootScope) {
                this.$rootScope = $rootScope;
            }
            StfProcessing.prototype.link = function ($scope, element, attrs) {
                var _this = this;
                this.$scope = $scope;
                this.element = element;
                this.attrs = attrs;
                $scope.$stfDecorateNgClickHandler = function (promise, event) { return _this.$stfDecorateNgClickHandler(promise, event); };
                $scope.$stfDecorateNgSubmitHandler = function (promise) { return _this.$stfDecorateNgSubmitHandler(promise); };
            };
            StfProcessing.prototype.$stfDecorateNgClickHandler = function (promise, event) {
                var _this = this;
                if (promise) {
                    $(event.currentTarget).prop('disabled', true);
                    this.$rootScope.loadingProgress = true;
                    promise.finally(function () {
                        $(event.currentTarget).prop('disabled', false);
                        _this.$rootScope.loadingProgress = false;
                    });
                }
                return promise;
            };
            StfProcessing.prototype.$stfDecorateNgSubmitHandler = function (promise) {
                var _this = this;
                if (promise) {
                    this.element.find('input[type=submit]').prop('disabled', true);
                    this.$rootScope.loadingProgress = true;
                    promise.finally(function () {
                        _this.element.find('input[type=submit]').prop('disabled', false);
                        _this.$rootScope.loadingProgress = false;
                    });
                }
                return promise;
            };
            StfProcessing.factory = function () {
                return /** @ngInject */ ["$rootScope", function ($rootScope) {
                    return new StfProcessing($rootScope);
                }];
            };
            return StfProcessing;
        }());
        angular.module('app.support').directive('stfProcessing', StfProcessing.factory());
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        /** @ngInject */
        configNgClickDecorator.$inject = ["$provide"];
        function configNgClickDecorator($provide) {
            $provide.decorator('ngClickDirective', ["$delegate", "$timeout", function ($delegate, $timeout) {
                var originalCompile = $delegate[0].compile;
                $delegate[0].compile = function (element, attrs, transclude) {
                    if (angular.isString(attrs.stfProcessing)) {
                        var alreadyMadeRequest_1 = false;
                        function handleDuplicateRequests(event) {
                            if (alreadyMadeRequest_1) {
                                event.preventDefault();
                                event.stopImmediatePropagation();
                            }
                            else {
                                alreadyMadeRequest_1 = true;
                                $timeout(function () { alreadyMadeRequest_1 = false; }, 500, false);
                            }
                        }
                        element.on('click', handleDuplicateRequests);
                        attrs['ngClick'] = '$stfDecorateNgClickHandler(' + attrs['ngClick'] + ', $event)';
                        return originalCompile(element, attrs, transclude);
                    }
                    else {
                        return originalCompile(element, attrs, transclude);
                    }
                };
                return $delegate;
            }]);
        }
        angular.module('app.support').config(configNgClickDecorator);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var PollerService = /** @class */ (function () {
            PollerService.$inject = ["$interval"];
            function PollerService($interval) {
                this.$interval = $interval;
            }
            PollerService.prototype.poll = function (actionFn, dataFn, duration) {
                var _this = this;
                if (duration === void 0) { duration = 5000; }
                var pollingTimer;
                var stopPolling = false;
                var tick = function () {
                    actionFn().then(function (data) {
                        dataFn(data);
                    }).finally(function () {
                        if (!stopPolling) {
                            pollingTimer = _this.$interval(tick, duration, 1);
                        }
                    });
                };
                tick();
                return function () {
                    stopPolling = true;
                };
            };
            return PollerService;
        }());
        support.PollerService = PollerService;
        angular.module("app.support").service("pollerService", PollerService);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var StfNavigationExtension = /** @class */ (function () {
            function StfNavigationExtension() {
            }
            StfNavigationExtension.prototype.link = function (scope, element, attrs) {
                /**
                 * Desabilita a funcionalidade de expandir o menu automaticamente ao passar o mouse.
                 */
                scope.$watch(function () {
                    var expander = element.parent().find("#ms-navigation-fold-expander");
                    if (expander.length > 0) {
                        expander.remove();
                    }
                });
            };
            StfNavigationExtension.factory = function () {
                return function () {
                    return new StfNavigationExtension();
                };
            };
            return StfNavigationExtension;
        }());
        angular.module("app.support").directive("stfNavigationExtension", StfNavigationExtension.factory());
        angular.module("app.support").config(["$provide", function ($provide) {
            $provide.decorator("msNavigationItemDirective", ["$delegate", "$rootScope", "msNavigationService", function ($delegate, $rootScope, msNavigationService) {
                /**
                 * Lógica para esconder os tooltips quando o menu estiver expandido.
                 *
                 * Utiliza a classe expanded combinada com navigation-item-tooltip para
                 * via CSS esconder o tooltip.
                 */
                $rootScope.$watch(function () {
                    if (angular.element(".navigation-item-tooltip").length == 0) {
                        return null; // Não processou a diretiva de tooltip ainda.
                    }
                    return msNavigationService.getFolded(); // Recupera está folded ou não
                }, function (newVal, oldVal) {
                    if (!newVal) {
                        angular.element(".navigation-item-tooltip").addClass("expanded");
                    }
                    else {
                        angular.element(".navigation-item-tooltip").removeClass("expanded");
                    }
                });
                var directive = $delegate[0];
                var originalCompile = directive.compile;
                /**
                 * Seta os atributos no elemento anchor de modo a apresentar tooltips.
                 */
                directive.compile = function (tElement) {
                    var button = tElement.find("a.ms-navigation-button");
                    button.attr("fo-tooltip", "");
                    button.attr("tooltip-class", "navigation-item-tooltip");
                    button.attr("tooltip-position", "right center");
                    button.attr("tooltip-template-str", "{{node.title}}");
                    button.attr("ui-sref-opts", "{reload: '{{ node.state.split('(')[0] }}'}");
                    return originalCompile(tElement);
                };
                return $delegate;
            }]);
        }]);
        var StfNavigationClickExtension = /** @class */ (function () {
            function StfNavigationClickExtension() {
            }
            StfNavigationClickExtension.prototype.link = function (scope, element, attrs) {
            };
            StfNavigationClickExtension.factory = function () {
                return function () {
                    return new StfNavigationClickExtension();
                };
            };
            return StfNavigationClickExtension;
        }());
        angular.module("app.support").directive("stfNavigationClickExtension", StfNavigationClickExtension.factory());
        angular.module("app.support").config(["$provide", function ($provide) {
            $provide.decorator("msNavigationNodeDirective", ["$delegate", "$rootScope", "msNavigationService", "$compile", function ($delegate, $rootScope, msNavigationService, $compile) {
                /**
                 * Lógica expandir o menu quando itens com subitens são clicados
                 * e o menu já não está expandido.
                 */
                var directive = $delegate[0];
                var originalCompile = directive.compile;
                directive.compile = function (tElement) {
                    var postLink = originalCompile(tElement);
                    return function (scope, element, attrs, ctrl) {
                        var originalToggleCollapsed = ctrl.toggleCollapsed;
                        ctrl.toggleCollapsed = function () {
                            originalToggleCollapsed();
                            if (msNavigationService.getFolded()) {
                                msNavigationService.toggleFolded();
                                $rootScope.$broadcast("navigationToggledFolded"); // Para forçar a atualização do ícone do toggle.
                            }
                        };
                        return postLink(scope, element, attrs, ctrl);
                    };
                };
                return $delegate;
            }]);
        }]);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var messaging;
        (function (messaging) {
            'use strict';
            /** ngInject **/
            config.$inject = ["$mdThemingProvider"];
            function config($mdThemingProvider) {
                $mdThemingProvider.theme('error-toast');
                $mdThemingProvider.theme('success-toast');
            }
            angular.module('app.support.messaging', ['ngMaterial']).config(config);
        })(messaging = support.messaging || (support.messaging = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var messaging;
        (function (messaging) {
            'use strict';
            var MessagesService = /** @class */ (function () {
                /** ngInject **/
                MessagesService.$inject = ["$mdToast", "$q"];
                function MessagesService($mdToast, $q) {
                    this.$mdToast = $mdToast;
                    this.promise = $q.resolve();
                }
                /**
                 * Mostra a(s) mensagem(ns) de erro.
                 */
                MessagesService.prototype.error = function (messages, hideDelay, position) {
                    if (angular.isArray(messages)) {
                        for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
                            var message = messages_1[_i];
                            this.showToast(message, MessagesService.ERROR_THEME, hideDelay, position);
                        }
                        return this.promise;
                    }
                    else {
                        return this.showToast(messages, MessagesService.ERROR_THEME, hideDelay, position);
                    }
                };
                /**
                 * Mostra uma mensagem de sucesso.
                 */
                MessagesService.prototype.success = function (message, hideDelay, position) {
                    return this.showToast(message, MessagesService.SUCCESS_THEME, hideDelay, position);
                };
                /**
                 * Mostra uma mensagem de atenção.
                 */
                MessagesService.prototype.warn = function (message, hideDelay, position) {
                    return this.showToast(message, MessagesService.WARNING_THEME, hideDelay, position);
                };
                /**
                 * Mostra uma mensagem de informação.
                 */
                MessagesService.prototype.info = function (message, hideDelay, position) {
                    return this.showToast(message, MessagesService.INFO_THEME, hideDelay, position);
                };
                /**
                 * Mostra uma mensagem ação sobre uma tarefa.
                 */
                MessagesService.prototype.task = function (title, action) {
                    var toastPreset = this.$mdToast
                        .simple()
                        .textContent(title)
                        .action(action)
                        .position(MessagesService.DEFAULT_POSITION)
                        .hideDelay(MessagesService.TASK_HIDE_DELAY);
                    return this.$mdToast.show(toastPreset);
                };
                /**
                 * Esconde a mensagem imadiatamente.
                 */
                MessagesService.prototype.hideMessage = function () {
                    this.$mdToast.hide();
                };
                /**
                 * Mostra uma mensagem.
                 */
                MessagesService.prototype.showToast = function (message, theme, hideDelay, position) {
                    var _this = this;
                    if (hideDelay === void 0) { hideDelay = MessagesService.DEFAULT_HIDE_DELAY; }
                    if (position === void 0) { position = MessagesService.DEFAULT_POSITION; }
                    this.promise = this.promise.finally(function () {
                        var toastPreset = _this.$mdToast
                            .simple()
                            .textContent(message)
                            .position(position)
                            .theme(theme)
                            .hideDelay(hideDelay);
                        if (position !== MessagesService.DEFAULT_POSITION) {
                            toastPreset.parent(MessagesService.PARENT);
                        }
                        return _this.$mdToast.show(toastPreset);
                    });
                    return this.promise;
                };
                MessagesService.DEFAULT_HIDE_DELAY = 10000;
                MessagesService.TASK_HIDE_DELAY = 10000;
                MessagesService.DEFAULT_POSITION = 'bottom left';
                MessagesService.SUCCESS_THEME = 'success-toast';
                MessagesService.WARNING_THEME = 'warn-toast';
                MessagesService.ERROR_THEME = 'error-toast';
                MessagesService.TASK_THEME = 'task-toast';
                MessagesService.INFO_THEME = 'info-toast';
                MessagesService.PARENT = '#content';
                return MessagesService;
            }());
            messaging.MessagesService = MessagesService;
            angular.module('app.support.messaging').service('messagesService', MessagesService);
        })(messaging = support.messaging || (support.messaging = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        'use strict';
        var StfMatches = /** @class */ (function () {
            function StfMatches() {
                this.scope = {
                    stfMatches: '='
                };
                this.require = 'ngModel';
            }
            StfMatches.prototype.link = function ($scope, element, attrs, ctrl) {
                ctrl.$validators.matches = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue) && ctrl.$isEmpty($scope.stfMatches)) {
                        return true;
                    }
                    return (modelValue === $scope.stfMatches);
                };
                $scope.$watch("stfMatches", function () {
                    ctrl.$validate();
                });
            };
            StfMatches.factory = function () {
                return function () {
                    "ngInject";
                    return new StfMatches();
                };
            };
            return StfMatches;
        }());
        support.StfMatches = StfMatches;
        angular
            .module('app.support')
            .directive('stfMatches', StfMatches.factory());
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        configInputDecorator.$inject = ["$provide"];
        function isIntegerChar(ch) {
            return /([0-9]|-|,)/.test(String.fromCharCode(ch));
        }
        var specialKeys = ["Backspace", "Del", "Home", "Tab", "Left", "Right", "Up", "Down", "End"];
        function isSpecialKey(key) {
            return specialKeys.indexOf(key) != -1;
        }
        /** @ngInject */
        function configInputDecorator($provide) {
            $provide.decorator('inputDirective', ["$delegate", "$timeout", function ($delegate, $timeout) {
                var originalCompile = $delegate[0].compile;
                $delegate[0].compile = function (element, attrs, transclude) {
                    if (attrs["type"] && attrs["type"] === "number") {
                        element.on("keypress", function (event) {
                            if (!isSpecialKey(event.key) && !isIntegerChar(event.which)) {
                                event.preventDefault();
                            }
                        });
                    }
                    return originalCompile(element, attrs, transclude);
                };
                return $delegate;
            }]);
        }
        angular.module('app.support').config(configInputDecorator);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var identidades;
        (function (identidades) {
            'use strict';
            angular.module('app.support.identidades', []);
        })(identidades = support.identidades || (support.identidades = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var identidades;
        (function (identidades) {
            "use strict";
            var ConsultarApresentacaoUsuariosQuery = /** @class */ (function () {
                function ConsultarApresentacaoUsuariosQuery() {
                    this.usuarios = [];
                }
                return ConsultarApresentacaoUsuariosQuery;
            }());
            identidades.ConsultarApresentacaoUsuariosQuery = ConsultarApresentacaoUsuariosQuery;
            var IdentidadesService = /** @class */ (function () {
                /** ngInject **/
                IdentidadesService.$inject = ["$http", "$q", "properties"];
                function IdentidadesService($http, $q, properties) {
                    this.$http = $http;
                    this.$q = $q;
                    this.properties = properties;
                    this.loginENomeApresentacaoCache = new Map();
                    this.identidadesApi = this.properties.apiUrl + "/integracoes-identidades/api";
                }
                /**
                 * Busca no backend após normalizar e filtras logins repetidos, faz request apenas com os logins que ainda
                 * não foram consultados e com lowercase.
                 * @param loginUsuarios map de logins com o nome de apresentação, login é retornado como foi consultado upper
                 * ou lower case.
                 */
                IdentidadesService.prototype.getNomeApresentacao = function (loginUsuarios) {
                    var _this = this;
                    var logins = this.filtrarLogins(loginUsuarios);
                    var loginsUpperCase = this.filtrarUpperCase(logins);
                    var resultado = new Map();
                    var cmd = new ConsultarApresentacaoUsuariosQuery();
                    logins.forEach(function (login) {
                        var loginLowerCase = login.toLowerCase();
                        if (Object.keys(_this.loginENomeApresentacaoCache).indexOf(loginLowerCase) === -1) {
                            cmd.usuarios.push(loginLowerCase);
                        }
                        else {
                            resultado[login] = _this.loginENomeApresentacaoCache[loginLowerCase];
                        }
                    });
                    if (cmd.usuarios.length > 0) {
                        var url = this.identidadesApi + "/acessos/recuperar-apresentacao-usuarios";
                        return this.$http.post(url, cmd)
                            .then(function (responseIdentidades) {
                            // @ts-ignore
                            Object.entries(responseIdentidades.data).forEach(function (_a) {
                                var login = _a[0], nomeApresentacao = _a[1];
                                _this.loginENomeApresentacaoCache[login] = nomeApresentacao;
                                var loginBuscado = login;
                                if (loginsUpperCase.indexOf(login.toUpperCase()) !== -1) {
                                    loginBuscado = login.toUpperCase();
                                }
                                resultado[loginBuscado] = _this.loginENomeApresentacaoCache[login];
                            });
                            return resultado;
                        });
                    }
                    else {
                        return this.$q.resolve(resultado);
                    }
                };
                IdentidadesService.prototype.filtrarLogins = function (loginUsuarios) {
                    var logins = new Set();
                    loginUsuarios.filter(function (l) { return Boolean(l); }).forEach(function (login) { return logins.add(login); });
                    return Array.from(logins);
                };
                IdentidadesService.prototype.filtrarUpperCase = function (loginUsuarios) {
                    var loginsUpperCase = [];
                    loginUsuarios.forEach(function (login) {
                        if (login === login.toUpperCase()) {
                            loginsUpperCase.push(login);
                        }
                    });
                    return loginsUpperCase;
                };
                return IdentidadesService;
            }());
            identidades.IdentidadesService = IdentidadesService;
            angular.module("app.support.identidades").service("identidadesService", IdentidadesService);
        })(identidades = support.identidades || (support.identidades = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        /**
         * Diretiva <stf-header>
         *
         * Mostra o cabeçalho padrão para as views. Faz breadcrumbs automaticamente
         * e mostra o título usando o serviço de navegação do FUSE.
         *
         * O conteúdo da tag ficará alinhado do lado direito do header.
         *
         * É possível utilizar o atributo layout-only="true|false" para exibir
         * somente o conteúdo da tag, sem breadcrumb e título.
         */
        var StfHeader = /** @class */ (function () {
            function StfHeader(msNavigationService, $timeout, $rootScope) {
                this.msNavigationService = msNavigationService;
                this.$timeout = $timeout;
                this.$rootScope = $rootScope;
                this.scope = {
                    'layoutOnly': '=',
                    'fabAction': '&',
                    'fabActionId': '@',
                    'fabAriaLabel': '@',
                    'fabIcon': '@',
                    'fabText': '@',
                    'fabActive': '=',
                    'path': '=',
                    'disableAlert': '='
                };
                this.templateUrl = 'app/main/support/header/header.html';
                this.transclude = true;
                this.controller = support.StfHeaderController;
                this.controllerAs = 'vm';
            }
            StfHeader.prototype.link = function ($scope, element, attrs, ctrl, $transclude) {
                var _this = this;
                $scope.hasFabAction = angular.isDefined(attrs.$attr['fabAction']);
                $scope.$watch('fabIcon', function (value) {
                    $scope.mdIconClass = "<md-icon md-font-icon=\"" + value + "\"></md-icon>";
                });
                this.$timeout(function () {
                    if (element.find('.fabHeader')) {
                        angular.element('body').append(element.find('.fabHeader'));
                    }
                    // Remove o fabButton quando tiver mudança no state
                    var off = _this.$rootScope.$on('$stateChangeSuccess', function () {
                        angular.element('.fabHeader').remove();
                        off();
                    });
                });
            };
            StfHeader.factory = function () {
                return ["msNavigationService", "$timeout", "$rootScope", function (msNavigationService, $timeout, $rootScope) {
                    "ngInject";
                    return new StfHeader(msNavigationService, $timeout, $rootScope);
                }];
            };
            return StfHeader;
        }());
        angular.module('app.support').directive('stfHeader', StfHeader.factory());
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var StfHeaderController = /** @class */ (function () {
            /**  @ngInject */
            StfHeaderController.$inject = ["$scope", "stfBreadcrumbsService", "$stateParams", "app.tarefas.minhas-tarefas.MinhasTarefasService", "messagesService", "authService", "$mdDialog", "$state", "$timeout"];
            function StfHeaderController($scope, stfBreadcrumbsService, $stateParams, minhasTarefasService, messagesService, authService, $mdDialog, $state, $timeout) {
                var _this = this;
                this.$scope = $scope;
                this.stfBreadcrumbsService = stfBreadcrumbsService;
                this.$stateParams = $stateParams;
                this.minhasTarefasService = minhasTarefasService;
                this.messagesService = messagesService;
                this.authService = authService;
                this.$mdDialog = $mdDialog;
                this.$state = $state;
                this.tentouExecutarTarefaSemAssumir = false;
                if (this.$scope.path) {
                    this.localBreadcrumbs = this.stfBreadcrumbsService.generateBreadcrumbFromLocalPath(this.$scope.path);
                }
                $scope.$on("tentouExecutarTarefaSemAssumir", function () {
                    _this.tentouExecutarTarefaSemAssumir = true;
                    $timeout(function () {
                        _this.tentouExecutarTarefaSemAssumir = false;
                    }, 1000);
                });
                this.task = this.$stateParams["task"];
                this.loadAssigneeName();
                $scope.$on('task:assigned', function (event, notification) {
                    var task = notification.content;
                    if (_this.task && _this.task.id == task.id) {
                        _this.task.assignee = task.assignee;
                        _this.task.selfAssigned = (_this.task.assignee === _this.authService.getUserLogin());
                        if (!_this.task.selfAssigned && !!task.assignee && !_this.isAlertDisabled()) {
                            _this.minhasTarefasService.getNomesUsuarios([_this.task.assignee]).then(function (resultado) {
                                for (var _i = 0, _a = Object.entries(resultado); _i < _a.length; _i++) {
                                    var _b = _a[_i], key = _b[0], value = _b[1];
                                    _this.assigneeName = value;
                                    _this.messagesService.warn("Aten\u00E7\u00E3o! Esta tarefa foi assumida por \"" + _this.assigneeName + "\".");
                                }
                            });
                        }
                    }
                });
                $scope.$on('task:completed', function (event, notification) {
                    var task = notification.content;
                    if (_this.task && _this.task.id == task.id) {
                        _this.authService.getUser().then(function (user) {
                            _this.task.selfAssigned = (user.login == _this.task.assignee);
                            if (!_this.task.selfAssigned && !_this.isAlertDisabled()) {
                                _this.minhasTarefasService.getNomesUsuarios([_this.task.assignee]).then(function (resultado) {
                                    for (var _i = 0, _a = Object.entries(resultado); _i < _a.length; _i++) {
                                        var _b = _a[_i], key = _b[0], value = _b[1];
                                        _this.assigneeName = value;
                                        var title = "Tarefa finalizada!";
                                        var text = "Esta tarefa j\u00E1 foi realizada por " + _this.assigneeName + ".";
                                        _this.alertAndCloseTask(title, text);
                                    }
                                });
                            }
                        });
                    }
                });
                $scope.$on('task:canceled', function (event, notification) {
                    var task = notification.content;
                    if (_this.task && _this.task.id == task.id) {
                        _this.authService.getUser().then(function (user) {
                            _this.task.selfAssigned = (user.login == _this.task.assignee);
                            if (!_this.task.selfAssigned && !_this.isAlertDisabled()) {
                                _this.minhasTarefasService.getNomesUsuarios([_this.task.assignee]).then(function (resultado) {
                                    for (var _i = 0, _a = Object.entries(resultado); _i < _a.length; _i++) {
                                        var _b = _a[_i], key = _b[0], value = _b[1];
                                        _this.assigneeName = value;
                                        var title = "Tarefa cancelada!";
                                        var text = "Esta tarefa foi cancelada por " + _this.assigneeName + ".";
                                        _this.alertAndCloseTask(title, text);
                                    }
                                });
                            }
                        });
                    }
                });
            }
            StfHeaderController.prototype.hasBreadcrumbs = function () {
                return !this.$scope.layoutOnly &&
                    (this.localBreadcrumbs ||
                        (this.stfBreadcrumbsService.breadcrumbs != this.stfBreadcrumbsService.EMPTY_BREADCRUMB));
            };
            StfHeaderController.prototype.breadcrumbs = function () {
                if (this.localBreadcrumbs) {
                    return this.localBreadcrumbs;
                }
                else {
                    return this.stfBreadcrumbsService.breadcrumbs;
                }
            };
            StfHeaderController.prototype.isTarefaAssumida = function () {
                return this.task && this.task.selfAssigned;
            };
            StfHeaderController.prototype.assumir = function () {
                var _this = this;
                this.minhasTarefasService.assumeTask(this.task).then(function (task) {
                    _this.task = task;
                    _this.loadAssigneeName();
                    _this.messagesService.warn("Tarefa assumida com sucesso.");
                });
            };
            StfHeaderController.prototype.alertAndCloseTask = function (title, text) {
                var _this = this;
                this.task.selfAssigned = false;
                this.$mdDialog.show(this.$mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(false)
                    .hasBackdrop(true)
                    .title(title)
                    .textContent(text)
                    .ok('OK')).then(function () {
                    _this.$state.go("app.tarefas.minhas-tarefas");
                });
            };
            StfHeaderController.prototype.isAlertDisabled = function () {
                return !!this.$scope.disableAlert && this.$scope.disableAlert;
            };
            StfHeaderController.prototype.loadAssigneeName = function () {
                var _this = this;
                if (this.task && this.task.assignee) {
                    this.minhasTarefasService.getNomesUsuarios([this.task.assignee]).then(function (resultado) {
                        for (var _i = 0, _a = Object.entries(resultado); _i < _a.length; _i++) {
                            var _b = _a[_i], key = _b[0], value = _b[1];
                            _this.assigneeName = value;
                        }
                    });
                }
            };
            return StfHeaderController;
        }());
        support.StfHeaderController = StfHeaderController;
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var StfPlaceholder = /** @class */ (function () {
            function StfPlaceholder() {
                this.scope = {
                    'stfPlaceholder': '='
                };
            }
            StfPlaceholder.prototype.link = function ($scope, element, attrs) {
                $scope.$watch('stfPlaceholder', function (value) {
                    element.prop('placeholder', $scope.stfPlaceholder);
                });
            };
            StfPlaceholder.factory = function () {
                return function () {
                    'ngInject';
                    return new StfPlaceholder();
                };
            };
            return StfPlaceholder;
        }());
        support.StfPlaceholder = StfPlaceholder;
        angular.module('app.support')
            .directive('stfPlaceholder', StfPlaceholder.factory());
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        'use strict';
        var ReadableFilesize = /** @class */ (function () {
            function ReadableFilesize() {
            }
            ReadableFilesize.prototype.filter = function (bytes, precision) {
                var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
                if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
                    return '-';
                }
                if (typeof precision === 'undefined') {
                    precision = 1;
                }
                var number = Math.floor(Math.log(bytes) / Math.log(1024));
                return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
            };
            ReadableFilesize.factory = function () {
                return function () {
                    'ngInject';
                    return new ReadableFilesize().filter;
                };
            };
            return ReadableFilesize;
        }());
        support.ReadableFilesize = ReadableFilesize;
        angular
            .module('app.support')
            .filter('readableFilesize', ReadableFilesize.factory());
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        "use strict";
        /**
         * Serviço para abstrair o formato do json
         * que é retornado do backend quando ocorrer
         * um erro. Esse serviço conhece o formato desses
         * objetos e conseguirá extrair informações deles.
         */
        var ErrorService = /** @class */ (function () {
            function ErrorService() {
            }
            ErrorService.prototype.buildErrorMessages = function (apiError) {
                var _this = this;
                if (this.isApiError(apiError)) {
                    var checkedApiError = apiError;
                    return checkedApiError.errors.map(function (error) {
                        if (_this.isError(error)) {
                            return error.userMessage;
                        }
                        else {
                            throw "Formato de erro não reconhecido";
                        }
                    });
                }
                else if (angular.isString(apiError)) {
                    return apiError;
                }
                else {
                    throw "Formato de erro de API não reconhecido";
                }
            };
            ErrorService.prototype.isApiError = function (possibleApiError) {
                if (possibleApiError &&
                    possibleApiError.httpCode &&
                    possibleApiError.errors &&
                    possibleApiError.errors.length > 0) {
                    return true;
                }
                else {
                    return false;
                }
            };
            ErrorService.prototype.isError = function (possibleError) {
                if (possibleError &&
                    possibleError.internalCode &&
                    possibleError.userMessage) {
                    return true;
                }
                else {
                    return false;
                }
            };
            return ErrorService;
        }());
        support.ErrorService = ErrorService;
        angular
            .module("app.support")
            .service("errorService", ErrorService);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



/**
 * Provider do mecanismo de tratamento de erros baseado em https://github.com/pavadeli/angularjs-errorhandling
 * e https://technology.amis.nl/2014/10/06/automatic-error-handling-in-angularjs/
 *
 * Os componentes cujas chamadas de métodos precisam ser monitoradas para tratamento de erro
 * são decorados por meio do provider. A partir desse momento, exceções lançadas durante
 * a chamada do método e não capturadas e promises rejeitadas que sejam retorno dos métodos
 * são situações que serão tratadas automaticamente pelo mecanismo, integrando com o mecanismo
 * de apresentação de mensagens.
 *
 * @author Tomás Godoi
 * @since 1.0.0
 *
 */
var app;
/**
 * Provider do mecanismo de tratamento de erros baseado em https://github.com/pavadeli/angularjs-errorhandling
 * e https://technology.amis.nl/2014/10/06/automatic-error-handling-in-angularjs/
 *
 * Os componentes cujas chamadas de métodos precisam ser monitoradas para tratamento de erro
 * são decorados por meio do provider. A partir desse momento, exceções lançadas durante
 * a chamada do método e não capturadas e promises rejeitadas que sejam retorno dos métodos
 * são situações que serão tratadas automaticamente pelo mecanismo, integrando com o mecanismo
 * de apresentação de mensagens.
 *
 * @author Tomás Godoi
 * @since 1.0.0
 *
 */
(function (app) {
    var support;
    (function (support) {
        /** @ngInject */
        errorHandlerDecorator.$inject = ["$delegate", "$injector"];
        function errorHandlerDecorator($delegate, $injector) {
            var currentThis = null;
            function decorate($injector, obj, func) {
                return angular.extend(function () {
                    var result;
                    var errorHandler = $injector.get('errorHandler');
                    if (!currentThis) {
                        currentThis = obj;
                        try {
                            result = errorHandler.call(func, obj, arguments);
                        }
                        finally {
                            currentThis = null;
                        }
                    }
                    else {
                        result = func.apply(obj, arguments);
                    }
                    return result;
                }, func);
            }
            for (var prop in $delegate) {
                if (angular.isFunction($delegate[prop])) {
                    $delegate[prop] = decorate($injector, $delegate, $delegate[prop]);
                }
            }
            return $delegate;
        }
        var ErrorHandlerService = /** @class */ (function () {
            /** @ngInject */
            ErrorHandlerService.$inject = ["messagesService", "errorService"];
            function ErrorHandlerService(messagesService, errorService) {
                this.messagesService = messagesService;
                this.errorService = errorService;
            }
            ErrorHandlerService.prototype.call = function (func, self, args) {
                var result;
                try {
                    result = func.apply(self, args);
                }
                catch (error) {
                    this.handleError(func, error);
                    throw error;
                }
                var promise = result && result.$promise || result;
                if (promise && angular.isFunction(promise.then) && angular.isFunction(promise['catch'])) {
                    this.handleAsyncError(func, promise);
                }
                return result;
            };
            ErrorHandlerService.prototype.handleError = function (func, err) {
                // TODO Melhorar a detecção de vários tipos de erros.
                this.messagesService.error(err);
            };
            ErrorHandlerService.prototype.handleAsyncError = function (func, promise) {
                var _this = this;
                promise['catch'](function (error) {
                    if (error) {
                        var actualError = void 0;
                        if (error.hasOwnProperty("headers")) {
                            actualError = error.data;
                        }
                        else {
                            actualError = error;
                        }
                        if (!promise["$stfNoErrorMessage"]) {
                            _this.messagesService.error(_this.errorService.buildErrorMessages(actualError));
                        }
                    }
                });
                return promise;
            };
            return ErrorHandlerService;
        }());
        support.ErrorHandlerService = ErrorHandlerService;
        /**
         * Decorator que permite detectar erros e exibir automaticamente a mensagem de erro para todos
         * os métodos de um service.
         *
         * No caso de erros em chamadas assíncronas, pode-se utilizar a propriedade $stfNoErrorMessage
         * na promise de retorno do método para não exibir a mensagem de erro, caso se deseje tratar
         * o erro de forma diferente em algum método específico.
         */
        var ErrorHandlerServiceProvider = /** @class */ (function () {
            function ErrorHandlerServiceProvider() {
            }
            ErrorHandlerServiceProvider.prototype.decorate = function ($provide, service) {
                $provide.decorator(service, errorHandlerDecorator);
            };
            /** @ngInject */
            ErrorHandlerServiceProvider.prototype.$get = function (messagesService, errorService) {
                return new ErrorHandlerService(messagesService, errorService);
            };
            ErrorHandlerServiceProvider.prototype.$get.$inject = ["messagesService", "errorService"];
            return ErrorHandlerServiceProvider;
        }());
        support.ErrorHandlerServiceProvider = ErrorHandlerServiceProvider;
        angular
            .module('app.support')
            .provider('errorHandler', ErrorHandlerServiceProvider);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var dashboards;
        (function (dashboards) {
            "use strict";
            var DashletRegistry = /** @class */ (function () {
                function DashletRegistry() {
                    this.registeredDashlets = [];
                }
                DashletRegistry.prototype.registerDashlet = function (id, definition) {
                    this.registeredDashlets.push({ id: id, definition: definition });
                    return this;
                };
                DashletRegistry.prototype.recoverDashlet = function (id) {
                    for (var _i = 0, _a = this.registeredDashlets; _i < _a.length; _i++) {
                        var dashlet = _a[_i];
                        if (dashlet.id === id) {
                            return dashlet.definition;
                        }
                    }
                    throw new Error("Dashlet " + id + " não foi encontrado.");
                };
                return DashletRegistry;
            }());
            dashboards.DashletRegistry = DashletRegistry;
            angular.module('app.support.dashboards').service('dashletRegistry', DashletRegistry);
        })(dashboards = support.dashboards || (support.dashboards = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var dashboards;
        (function (dashboards_1) {
            'use strict';
            var DashboardService = /** @class */ (function () {
                /** @ngInject **/
                DashboardService.$inject = ["$http", "properties", "$ocLazyLoad", "$q", "dashletRegistry", "stylesLoadingService"];
                function DashboardService($http, properties, $ocLazyLoad, $q, dashletRegistry, stylesLoadingService) {
                    this.$http = $http;
                    this.properties = properties;
                    this.$ocLazyLoad = $ocLazyLoad;
                    this.$q = $q;
                    this.dashletRegistry = dashletRegistry;
                    this.stylesLoadingService = stylesLoadingService;
                }
                DashboardService.prototype.dashboards = function () {
                    return this.$http.get(this.properties.apiUrl + '/integracoes-modulos/api/dashboards', { cache: true })
                        .then(function (response) {
                        return response.data;
                    });
                };
                DashboardService.prototype.loadDashlets = function (dashboard) {
                    var _this = this;
                    var dashlets = dashboard.dashlets;
                    var contextsToBeLoaded = [];
                    var modulesToBeLoaded = [];
                    var dashletsPromises = [];
                    for (var _i = 0, dashlets_1 = dashlets; _i < dashlets_1.length; _i++) {
                        var dashlet = dashlets_1[_i];
                        if (contextsToBeLoaded.indexOf(dashlet.context) === -1) {
                            contextsToBeLoaded.push(dashlet.context);
                        }
                        if (modulesToBeLoaded.indexOf(dashlet.src) === -1) {
                            modulesToBeLoaded.push(dashlet.src);
                        }
                    }
                    if (dashboard.layoutManager) {
                        if (dashboard.layoutManager.src) {
                            var layoutManagerContext = dashboard.layoutManager.src.split("/")[0];
                            if (contextsToBeLoaded.indexOf(layoutManagerContext) === -1) {
                                contextsToBeLoaded.push(layoutManagerContext);
                            }
                            if (modulesToBeLoaded.indexOf(dashboard.layoutManager.src) === -1) {
                                modulesToBeLoaded.push(dashboard.layoutManager.src);
                            }
                        }
                    }
                    return this.$q.all(contextsToBeLoaded.map(function (context) {
                        var bundle = context + '/bundle';
                        var styleUrl = SystemJS.baseURL + context + '/style.css';
                        return _this.$q.all([System.import(bundle), _this.stylesLoadingService.loadStyle(styleUrl)]);
                    })).then(function () {
                        return _this.$q.all(modulesToBeLoaded.map(function (modulePath) {
                            return _this.$q.when(System.import(modulePath).then(function (importedModule) {
                                var newModule = importedModule;
                                if (!importedModule.name) {
                                    var key = Object.keys(importedModule);
                                    newModule = importedModule[key[0]];
                                }
                                return _this.$q.when(_this.$ocLazyLoad.load(newModule));
                            }));
                        }));
                    }).then(function () {
                        return dashlets.map(function (dashlet) {
                            return _this.dashletRegistry.recoverDashlet(dashlet.id);
                        });
                    });
                };
                DashboardService.prototype.hasDashboards = function () {
                    return this.dashboards().then(function (dashboards) {
                        return dashboards.length > 0;
                    });
                };
                return DashboardService;
            }());
            dashboards_1.DashboardService = DashboardService;
            angular
                .module('app.support.dashboards')
                .service('app.support.dashboards.DashboardService', DashboardService);
        })(dashboards = support.dashboards || (support.dashboards = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var dashboards;
        (function (dashboards) {
            var DefaultDashboardLayoutManager = /** @class */ (function () {
                function DefaultDashboardLayoutManager() {
                }
                DefaultDashboardLayoutManager.prototype.layout = function (dashlets) {
                    var layout = {
                        rows: []
                    };
                    if (dashlets && dashlets.length > 0) {
                        var currentRow = void 0;
                        for (var i = 0; i < dashlets.length; i++) { // Monta um layout tabular de duas colunas.
                            if (i % 2 === 0) {
                                currentRow = {
                                    columns: []
                                };
                                layout.rows.push(currentRow);
                                currentRow.columns.push({ dashlet: dashlets[i] });
                            }
                            else {
                                currentRow.columns.push({ dashlet: dashlets[i] });
                            }
                        }
                    }
                    return layout;
                };
                return DefaultDashboardLayoutManager;
            }());
            dashboards.DefaultDashboardLayoutManager = DefaultDashboardLayoutManager;
            var DashboardLayoutManagerRegistry = /** @class */ (function () {
                function DashboardLayoutManagerRegistry() {
                    this.registeredLayoutManagers = [];
                }
                DashboardLayoutManagerRegistry.prototype.registerLayoutManager = function (id, layoutManager) {
                    this.registeredLayoutManagers.push({ id: id, definition: layoutManager });
                    return this;
                };
                DashboardLayoutManagerRegistry.prototype.recoverLayoutManager = function (id) {
                    for (var _i = 0, _a = this.registeredLayoutManagers; _i < _a.length; _i++) {
                        var layoutManagers = _a[_i];
                        if (layoutManagers.id === id) {
                            return layoutManagers.definition;
                        }
                    }
                    throw new Error("Layout Manager " + id + " não foi encontrado.");
                };
                return DashboardLayoutManagerRegistry;
            }());
            dashboards.DashboardLayoutManagerRegistry = DashboardLayoutManagerRegistry;
            angular.module('app.support.dashboards').service('dashboardLayoutManagerRegistry', DashboardLayoutManagerRegistry);
            angular.module('app.support.dashboards').run(["dashboardLayoutManagerRegistry", function (dashboardLayoutManagerRegistry) {
                "ngInject";
                dashboardLayoutManagerRegistry.registerLayoutManager("default", new DefaultDashboardLayoutManager());
            }]);
        })(dashboards = support.dashboards || (support.dashboards = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



/**
 * @author Gabriel Teles
 *
 * @since 1.0.0
 * @since 10.12.2015
 */
var app;
/**
 * @author Gabriel Teles
 *
 * @since 1.0.0
 * @since 10.12.2015
 */
(function (app) {
    var support;
    (function (support) {
        var CPFService = /** @class */ (function () {
            function CPFService() {
            }
            /**
             * Valida um CPF
             *
             * @param string numero O número do cpf, sem ponto ou traço
             * @return boolean Validade do CPF
             */
            CPFService.prototype.validarCPF = function (numero) {
                var soma = 0;
                var resto;
                // Verifica tamanho
                if (numero.length != 11) {
                    return false;
                }
                // Verifica CPF Padrão
                if (this._isCPFPadrao(numero)) {
                    return false;
                }
                // Calcula primeiro dígito verificador
                for (var i = 1; i <= 9; i++) {
                    soma = soma + parseInt(numero.substring(i - 1, i)) * (11 - i);
                }
                resto = (soma * 10) % 11;
                if ((resto == 10) || (resto == 11)) {
                    resto = 0;
                }
                // Verifica primeiro dígito
                if (resto != parseInt(numero.substring(9, 10))) {
                    return false;
                }
                // Calcula segundo dígito verificador
                soma = 0;
                for (i = 1; i <= 10; i++) {
                    soma = soma + parseInt(numero.substring(i - 1, i)) * (12 - i);
                }
                resto = (soma * 10) % 11;
                if ((resto == 10) || (resto == 11)) {
                    resto = 0;
                }
                // Verifica segundo dígito
                if (resto != parseInt(numero.substring(10, 11))) {
                    return false;
                }
                return true;
            };
            // PRIVATE
            /**
             * Verifica se o CPF é padrão
             *
              * @param string numero O número do cpf, sem ponto ou traço
             * @return boolean
             */
            CPFService.prototype._isCPFPadrao = function (numero) {
                return ((numero === "00000000000") ||
                    (numero === "11111111111") ||
                    (numero === "22222222222") ||
                    (numero === "33333333333") ||
                    (numero === "44444444444") ||
                    (numero === "55555555555") ||
                    (numero === "66666666666") ||
                    (numero === "77777777777") ||
                    (numero === "88888888888") ||
                    (numero === "99999999999"));
            };
            return CPFService;
        }());
        support.CPFService = CPFService;
        angular
            .module('app.support')
            .service('cpfService', CPFService);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        'use strict';
        var StfCpf = /** @class */ (function () {
            function StfCpf(cpfService) {
                this.cpfService = cpfService;
                this.require = 'ngModel';
            }
            StfCpf.prototype.link = function ($scope, element, attrs, ctrl) {
                var _this = this;
                ctrl.$validators.cpf = function (modelValue, viewValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return true;
                    }
                    return _this.cpfService.validarCPF(modelValue);
                };
            };
            StfCpf.factory = function () {
                return ["cpfService", function (cpfService) {
                    "ngInject";
                    return new StfCpf(cpfService);
                }];
            };
            return StfCpf;
        }());
        support.StfCpf = StfCpf;
        angular
            .module('app.support')
            .directive('stfCpf', StfCpf.factory());
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var constants;
        (function (constants) {
            'use strict';
            var config = {
                gateway: {
                    url: window.location.protocol + "//" + (window.location.hostname !== 'localhost' ? window.location.hostname : 'docker'),
                    ws: "wss://" + (window.location.hostname !== 'localhost' ? window.location.hostname : 'docker'),
                    port: 8765
                },
                //TODO Remover a necessidade de passar esses valores padrão. Permitir pegar do config, via um profile específico, que seria setado ao rodar como gulp serve
                onlyoffice: {
                    url: "https://onlyofficeqa.stf.jus.br"
                },
                upgraded: {
                    url: "https://localhost:4200/",
                    loadStrategy: "eager"
                },
                msal: {
                    clientId: undefined,
                    tennantId: "common"
                }
            };
            if (window)
                _.merge(config, window.__config); // Utilizando o merge para não sobreescrever a configuração do gateway e onlyoffice todos, o que permite sobreescrever apenas alguma subpropriedade no config.
            var currentLocation = window.location;
            var placeholdersVariables = {
                hash: currentLocation.hash,
                host: currentLocation.host,
                hostname: currentLocation.hostname,
                href: currentLocation.href,
                origin: currentLocation.origin,
                pathname: currentLocation.pathname,
                port: currentLocation.port,
                protocol: currentLocation.protocol,
                search: currentLocation.search
            };
            var expressionRegex = new RegExp("^([^|]*)\\|([^|]*)\\|([^|]*)$");
            var resolveCurrentLocationPlaceholders = function (value) {
                if (typeof value === "number") {
                    return value;
                }
                var formatted = value;
                var placeholderRegex = new RegExp("\\{\\{([^\\}]*)\\}\\}", "g");
                var matches;
                while ((matches = placeholderRegex.exec(value)) !== null) {
                    var expressionFull = matches[0];
                    var expression = matches[1];
                    var expressionMatches = expression.match(expressionRegex);
                    if (expressionMatches) {
                        var controlVariable = expressionMatches[1];
                        if (placeholdersVariables[controlVariable]) {
                            expression = expressionMatches[2];
                        }
                        else {
                            expression = expressionMatches[3];
                        }
                    }
                    if (placeholdersVariables.hasOwnProperty(expression)) {
                        formatted = formatted.replace(expressionFull, placeholdersVariables[expression]);
                    }
                    else {
                        formatted = formatted.replace(expressionFull, expression);
                    }
                }
                return formatted;
            };
            var allowedPlaceholdersConfigs = ["gateway", "onlyoffice", "upgraded", "downgraded"];
            for (var i in config) {
                if (allowedPlaceholdersConfigs.indexOf(i) !== -1) {
                    for (var k in config[i]) {
                        if (typeof config[i][k] === "string") {
                            config[i][k] = resolveCurrentLocationPlaceholders(config[i][k]);
                        }
                    }
                }
            }
            angular.module('app.support.constants', []).constant("properties", {
                url: config.gateway.url,
                port: config.gateway.port,
                apiUrl: config.gateway.url + ":" + config.gateway.port,
                apiWs: config.gateway.ws + ":" + config.gateway.port,
                development: (config.gateway.development ? config.gateway.development : true),
                onlyofficeUrl: config.onlyoffice.url,
                onlyofficeSecure: config.onlyoffice.secure,
                onlyofficePluginsUrl: config.onlyoffice.pluginsUrl,
                upgradedUrl: config.upgraded.url,
                upgradedLoadStrategy: config.upgraded.loadStrategy,
                msalClientId: config.msal.clientId,
                msalTennantId: config.msal.tennantId
            });
        })(constants = support.constants || (support.constants = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        'use strict';
        /**
         * Diretiva que permite a renderização de um componente de um serviço dentro de outro
         * @param stfComponentLoader: uma lista no formato "contexto/modulo-ts-a-ser-carregado-do-contexto"
         * O módulo ts aqui é o arquivo.ts que representa o módulo angular do contexto origem
         */
        var StfComponentLoader = /** @class */ (function () {
            function StfComponentLoader(informacaoService, $compile, $log) {
                this.informacaoService = informacaoService;
                this.$compile = $compile;
                this.$log = $log;
            }
            StfComponentLoader.prototype.link = function ($scope, element, attrs) {
                var _this = this;
                var dependencias = angular.fromJson(attrs["stfComponentLoader"]);
                this.informacaoService
                    .carregarDependencias(dependencias)
                    .then(function () { return element.find("stf-transclude > *:first-child").get(0); })
                    .catch(function (error) { return _this.tryFallback(dependencias, element, error); })
                    .then(function (conteudo) { return _this.append(conteudo, element, $scope); })
                    .catch(function (error) { return _this.$log.error(error); });
            };
            StfComponentLoader.prototype.append = function (conteudo, element, $scope) {
                element.find("> *").remove();
                element.append(this.$compile(conteudo)($scope));
            };
            StfComponentLoader.prototype.tryFallback = function (dependencias, element, error) {
                this.$log.error("Erro ao carregar as dependências: ", dependencias, error);
                return element.find("stf-transclude-fallback  > *:first-child").get(0);
            };
            StfComponentLoader.factory = function () {
                /** @ngInject */
                return function (informacaoService, $compile, $log) {
                    return new StfComponentLoader(informacaoService, $compile, $log);
                };
            };
            return StfComponentLoader;
        }());
        support.StfComponentLoader = StfComponentLoader;
        angular
            .module('app.support')
            .directive('stfComponentLoader', StfComponentLoader.factory());
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var command;
        (function (command) {
            'use strict';
            /** @ngInject **/
            run.$inject = ["commandService", "authService"];
            function run(commandService, authService) {
                commandService.loadCommands();
            }
            angular
                .module('app.support.command', ['ngMaterial', 'app.support.constants', 'app.autenticacao'])
                .run(run);
        })(command = support.command || (support.command = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var command;
        (function (command_1) {
            /**
             * Serviço para manipulação das configurações de comando.
             */
            var CommandService = /** @class */ (function () {
                /** @ngInject **/
                CommandService.$inject = ["$http", "$q", "$log", "$rootScope", "properties", "messagesService", "authService"];
                function CommandService($http, $q, $log, $rootScope, properties, messagesService, authService) {
                    var _this = this;
                    this.$http = $http;
                    this.$q = $q;
                    this.$log = $log;
                    this.properties = properties;
                    this.messagesService = messagesService;
                    this.authService = authService;
                    this.commandValidators = {};
                    this.commandMatchers = {};
                    $rootScope.$on('user:logged', function () { return _this.loadCommands(); });
                    $rootScope.$on('user:exited', function () { return _this.resetCommands(); });
                }
                CommandService.prototype.loadCommands = function () {
                    var _this = this;
                    var commandConfigsDeferred = this.$q.defer();
                    this.commandConfigs = commandConfigsDeferred.promise;
                    this.$http.get(this.properties.apiUrl + '/integracoes-modulos/api/commands')
                        .then(function (response) {
                        if (response.data.length === 0) {
                            _this.authService.isAuthenticated().then(function (isAuthenticated) {
                                if (isAuthenticated) {
                                    _this.messagesService.error("Você não possui papéis associados ao seu usuário.");
                                    _this.messagesService.error("Por favor entre " +
                                        "em contato com seu gestor para que ele lhe conceda os privilégios necessários. ");
                                }
                            });
                        }
                        commandConfigsDeferred.resolve(response.data);
                    }, function (reason) {
                        _this.authService.isAuthenticated().then(function (isAuthenticated) {
                            _this.$log.error("Erro ao carregar comandos:" + reason);
                            _this.messagesService.warn("Não foi possível carregar suas permissões. " +
                                "Entre em contato com o suporte técnico.");
                            commandConfigsDeferred.resolve([]);
                        });
                    });
                };
                CommandService.prototype.resetCommands = function () {
                    var commandConfigsDeferred = this.$q.defer();
                    this.commandConfigs = commandConfigsDeferred.promise;
                    commandConfigsDeferred.resolve([]);
                };
                /**
                 * Lista os comandos
                 */
                CommandService.prototype.list = function () {
                    return this.commandConfigs;
                };
                /**
                 * Adiciona um matcher a uma configuração
                 */
                CommandService.prototype.addMatcher = function (commandId, matcher) {
                    if (!angular.isString(commandId) || commandId.length === 0) {
                        throw new Error("Não foi definido um identificador para o matcher");
                    }
                    var exists = this.commandMatchers.hasOwnProperty(commandId);
                    if (exists) {
                        this.commandMatchers[commandId].push(matcher);
                    }
                    else {
                        this.commandMatchers[commandId] = [matcher];
                    }
                };
                /**
                 * Armazena um validador para verificação
                 */
                CommandService.prototype.addValidator = function (id, validator) {
                    if (!angular.isString(id) || id.length === 0) {
                        throw new Error("Não foi definido um identificador para o validador");
                    }
                    var exists = this.commandValidators.hasOwnProperty(id);
                    if (exists) {
                        throw new Error("Já existe um validador com o id: " + id);
                    }
                    this.commandValidators[id] = validator;
                };
                /**
                 * Lista os comandos que são aplicáveis à lista de alvos.
                 */
                CommandService.prototype.listMatched = function (targets, filter) {
                    var _this = this;
                    var matched = this.$q.defer();
                    this.commandConfigs
                        .then(function (commandsConfig) {
                        matched.resolve(commandsConfig.filter(function (cmd) { return cmd.listable && _this.match(cmd, targets, filter); }));
                    }, function () {
                        matched.reject("Erro ao carregar comandos!");
                    });
                    return matched.promise;
                };
                /**
                 * Verifica se um comando é valido de acordo com sua configuração.
                 * Um validator deve ser criado para realizar a checagem
                 */
                CommandService.prototype.isValid = function (validatorId, commandId, command) {
                    var _this = this;
                    var matched = this.$q.defer();
                    this.findById(commandId)
                        .then(function (commandConfig) {
                        matched.resolve(_this.verify(validatorId, command));
                    }, function () {
                        matched.resolve(false);
                    });
                    return matched.promise;
                };
                /**
                 * Pesquisa uma configuração por id
                 */
                CommandService.prototype.findById = function (id) {
                    var found = this.$q.defer();
                    this.commandConfigs
                        .then(function (commandsConfig) {
                        for (var _i = 0, commandsConfig_1 = commandsConfig; _i < commandsConfig_1.length; _i++) {
                            var commandConfig = commandsConfig_1[_i];
                            if (commandConfig.id === id) {
                                return found.resolve(commandConfig);
                            }
                        }
                        return found.reject("Identificador não encontrado: " + id);
                    }, function () {
                        found.reject("Erro ao carregar comandos!");
                    });
                    return found.promise;
                };
                /**
                 * Pesquisa uma configuração por id e contexto
                 */
                CommandService.prototype.findByIdAndContext = function (id, context) {
                    var found = this.$q.defer();
                    if (!!context) {
                        this.commandConfigs
                            .then(function (commandsConfig) {
                            for (var _i = 0, commandsConfig_2 = commandsConfig; _i < commandsConfig_2.length; _i++) {
                                var commandConfig = commandsConfig_2[_i];
                                if (commandConfig.id === id && commandConfig.context === context) {
                                    return found.resolve(commandConfig);
                                }
                            }
                            return found.reject("Identificador não encontrado: " + id);
                        }, function () {
                            found.reject("Erro ao carregar comandos!");
                        });
                        return found.promise;
                    }
                    else {
                        return this.findById(id);
                    }
                };
                CommandService.prototype.saveTask = function (task, valid, command) {
                    var data = {
                        context: task.context,
                        taskId: task.id,
                        valid: valid,
                        commandId: task.command,
                        commandJson: JSON.stringify(command)
                    };
                    return this.$http.post(this.properties.apiUrl + '/integracoes-modulos/api/tasks/draft', data);
                };
                /**
                 * Verifica se um comando é válido
                 */
                CommandService.prototype.verify = function (validatorId, command) {
                    var exists = this.commandValidators.hasOwnProperty(validatorId);
                    if (exists) {
                        return this.commandValidators[validatorId].isValid(command);
                    }
                    return true;
                };
                /**
                 * Retorna os matchers de um command
                 */
                CommandService.prototype.findMatchersById = function (id) {
                    if (this.commandMatchers.hasOwnProperty(id)) {
                        return this.commandMatchers[id];
                    }
                    else {
                        return [];
                    }
                };
                /**
                 * Varifica se um comando é aplicável ao conjunto de alvos
                 */
                CommandService.prototype.match = function (command, targets, filter) {
                    // match filter
                    if (filter) {
                        if ((filter.targetType && command.target.type !== filter.targetType) ||
                            (filter.context && command.context !== filter.context)) {
                            return false;
                        }
                    }
                    //match mode
                    var length = angular.isArray(targets) ? targets.length : 0;
                    if (!this.isCompatibleMode(command.target.mode, length)) {
                        return false;
                    }
                    var matchers = this.findMatchersById(command.id);
                    //match matchers
                    if (!matchers || matchers.length === 0) {
                        return true;
                    }
                    for (var _i = 0, matchers_1 = matchers; _i < matchers_1.length; _i++) {
                        var matcher = matchers_1[_i];
                        if (!matcher.match(targets)) {
                            return false;
                        }
                    }
                    return true;
                };
                /**
                 * Verifica se o modo do comando é compatível com a quantidade de alvos
                 */
                CommandService.prototype.isCompatibleMode = function (mode, length) {
                    if ((length === 0 && mode === "None") ||
                        (length === 1 && (mode === "One" || mode === "OneOrMany")) ||
                        (length > 1 && (mode === "Many" || mode === "OneOrMany"))) {
                        return true;
                    }
                    return false;
                };
                return CommandService;
            }());
            command_1.CommandService = CommandService;
            angular
                .module('app.support.command')
                .service('commandService', CommandService);
        })(command = support.command || (support.command = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



/**
 * Diretiva que cria um botão com dropdown da lista de ações pertinentes aos
 * recursos, ou desabilita um botão, ou link para uma única ação
 *
 * @author Lucas.Rodrigues
 *
 * @since 1.0.0
 */
var app;
/**
 * Diretiva que cria um botão com dropdown da lista de ações pertinentes aos
 * recursos, ou desabilita um botão, ou link para uma única ação
 *
 * @author Lucas.Rodrigues
 *
 * @since 1.0.0
 */
(function (app) {
    var support;
    (function (support) {
        var command;
        (function (command) {
            'use strict';
            /**
             * Diretiva de lista de comandos
             * Ex. de uso:
             * &lt;commands targets="vm.recursos" context="autuacao" target-type="Processo"&gt;&lt;/commands&gt;
             */
            var CommandListDirective = /** @class */ (function () {
                function CommandListDirective(commandService, $state) {
                    var _this = this;
                    this.commandService = commandService;
                    this.$state = $state;
                    this.restrict = 'AE';
                    this.templateUrl = 'app/main/support/command/commands.tpl.html';
                    this.scope = {
                        targets: '=',
                        targetType: '@',
                        context: '@',
                    };
                    this.link = function ($scope) {
                        var filter = null;
                        if ($scope.context || $scope.targetType) {
                            filter = {
                                context: $scope.context,
                                targetType: $scope.targetType
                            };
                        }
                        //remove undefined property
                        filter = _.pickBy(filter);
                        var listCommands = function () {
                            //serviço que lista os comandos
                            _this.commandService.listMatched($scope.targets, filter)
                                .then(function (commandsConfig) {
                                $scope.commandsConfig = commandsConfig;
                            });
                        };
                        //os comandos devem ser recarregadas sempre que a quantidade de objetos mudar
                        $scope.$watchCollection(function () { return $scope.targets; }, listCommands);
                        //vai para o estado de uma ação selecionada, passando o target como parâmetro
                        $scope.go = function (commandConfig) {
                            var params = {};
                            var targets = $scope.targets;
                            if (angular.isArray(targets) && commandConfig.target.mode !== "One") {
                                params.targets = targets;
                            }
                            else {
                                params.target = angular.isArray(targets) ? targets[0] : targets;
                            }
                            _this.$state.go(commandConfig.route.stateName, params);
                        };
                    };
                }
                CommandListDirective.factory = function () {
                    /** @ngInject **/
                    var directive = function (commandService, $state) { return new CommandListDirective(commandService, $state); };
                    directive.$inject = ["commandService", "$state"];
                    return directive;
                };
                return CommandListDirective;
            }());
            command.CommandListDirective = CommandListDirective;
            /**
             * Bot&atilde;o de um comando espec&iacute;fico
             * Ex. de uso:
             * &lt;button id="registrar" commandId="registrar" command="vm.command" validator="validadorRegistro"&gt;Executar&lt;/button&gt;
             */
            var CommandDirective = /** @class */ (function () {
                function CommandDirective(commandService, $stateParams, messagesService, $rootScope) {
                    var _this = this;
                    this.commandService = commandService;
                    this.$stateParams = $stateParams;
                    this.messagesService = messagesService;
                    this.$rootScope = $rootScope;
                    this.restrict = 'A';
                    this.scope = {
                        command: '=',
                        commandId: '@',
                        validator: '@',
                        id: '@' //obrigatório, id do comando que será validado
                    };
                    this.link = function ($scope, element) {
                        if (angular.isUndefined($scope.command)) {
                            throw new Error("Comando não definido!");
                        }
                        var stopClick = function (event) {
                            event.preventDefault();
                            event.stopPropagation();
                        };
                        $scope.$parent["$checkTask"] = function (expression, $event) {
                            if (_this.$stateParams["task"] && !_this.$stateParams["task"].selfAssigned) {
                                _this.$rootScope.$broadcast("tentouExecutarTarefaSemAssumir");
                                _this.messagesService.error("É necessário assumir a tarefa antes de executá-la.");
                                return false;
                            }
                            else {
                                return $scope.$parent.$eval(expression, { "$event": $event });
                            }
                        };
                        var commandId = angular.isString($scope.commandId) ? $scope.commandId : $scope.id;
                        var validatorId = angular.isString($scope.validator) ? $scope.validator : commandId;
                        if (angular.isString(commandId) && commandId.length > 0) {
                            var task = _this.$stateParams["task"];
                            if (angular.isObject(task)) {
                                $scope.command["taskId"] = task.id;
                            }
                            $scope.$watch('command', function () {
                                _this.commandService.isValid(validatorId, commandId, $scope.command)
                                    .then(function (valid) {
                                    if (valid) {
                                        element.removeAttr('disabled');
                                        element.unbind('click', stopClick);
                                    }
                                    else {
                                        element.attr('disabled', 'disabled');
                                        element.bind('click', stopClick);
                                    }
                                });
                            }, true);
                        }
                    };
                }
                CommandDirective.factory = function () {
                    /** @ngInject **/
                    var directive = function (commandService, $stateParams, messagesService, $rootScope) { return new CommandDirective(commandService, $stateParams, messagesService, $rootScope); };
                    directive.$inject = ["commandService", "$stateParams", "messagesService", "$rootScope"];
                    return directive;
                };
                return CommandDirective;
            }());
            command.CommandDirective = CommandDirective;
            /**
             * Bot&atilde;o de um comando espec&iacute;fico
             * Ex. de uso:
             * &lt;button save-task="vm.command" validator="validadorRegistro"&gt;Salvar&lt;/button&gt;
             */
            var SaveTaskDirective = /** @class */ (function () {
                function SaveTaskDirective(commandService, messagesService, $stateParams, $rootScope, $q) {
                    var _this = this;
                    this.commandService = commandService;
                    this.messagesService = messagesService;
                    this.$stateParams = $stateParams;
                    this.$rootScope = $rootScope;
                    this.$q = $q;
                    this.restrict = 'A';
                    this.scope = {
                        saveTask: '=',
                        preSave: '&',
                        validator: '@' //opcional, validador para o comando, caso não informado procura por um com mesmo id do comando
                    };
                    this.link = function ($scope, element) {
                        if (angular.isUndefined($scope.saveTask)) {
                            throw new Error("Comando não definido!");
                        }
                        var task = _this.$stateParams["task"];
                        if (angular.isObject(task)) {
                            $scope.saveTask["taskId"] = task.id;
                        }
                        var commandId = task.command;
                        var validatorId = angular.isString($scope.validator) ? $scope.validator : commandId;
                        if (angular.isString(commandId) && commandId.length > 0) {
                            var taskValid_1;
                            var saveTaskClick = function () {
                                if (!_this.$stateParams["task"].selfAssigned) {
                                    _this.$rootScope.$broadcast("tentouExecutarTarefaSemAssumir");
                                    _this.messagesService.error("É necessário assumir a tarefa antes de salvá-la.");
                                }
                                else {
                                    _this.$q.when($scope.preSave())
                                        .then(function () {
                                        _this.commandService.saveTask(task, taskValid_1, $scope.saveTask)
                                            .then(function () {
                                            _this.messagesService.success("Tarefa salva com sucesso!");
                                        }, function () {
                                            _this.messagesService.error("Erro ao salvar tarefa!");
                                        });
                                    });
                                }
                            };
                            element.bind('click', saveTaskClick);
                            $scope.$watch('saveTask', function () {
                                _this.commandService.isValid(validatorId, commandId, $scope.saveTask)
                                    .then(function (valid) {
                                    taskValid_1 = valid;
                                });
                            }, true);
                        }
                    };
                }
                SaveTaskDirective.factory = function () {
                    /** @ngInject **/
                    var directive = function (commandService, messagesService, $stateParams, $rootScope, $q) {
                        return new SaveTaskDirective(commandService, messagesService, $stateParams, $rootScope, $q);
                    };
                    directive.$inject = ["commandService", "messagesService", "$stateParams", "$rootScope", "$q"];
                    return directive;
                };
                return SaveTaskDirective;
            }());
            command.SaveTaskDirective = SaveTaskDirective;
            var OpenCommand = /** @class */ (function () {
                function OpenCommand(commandService) {
                    var _this = this;
                    this.commandService = commandService;
                    this.restrict = 'A';
                    this.link = function ($scope, element, attrs) {
                        _this.commandService.findByIdAndContext(attrs['id'], attrs['context']).then(function (commandConfig) {
                            element.show();
                        }, function () {
                            if (attrs['showNotAllowed']) {
                                element.hide();
                            }
                            else {
                                element.attr('disabled', 'disabled');
                            }
                        });
                    };
                }
                OpenCommand.factory = function () {
                    /** @ngInject **/
                    var directive = function (commandService) { return new OpenCommand(commandService); };
                    directive.$inject = ["commandService"];
                    return directive;
                };
                return OpenCommand;
            }());
            command.OpenCommand = OpenCommand;
            var ShowIfHasPermission = /** @class */ (function () {
                function ShowIfHasPermission(authService, commandService) {
                    var _this = this;
                    this.authService = authService;
                    this.commandService = commandService;
                    this.restrict = 'A';
                    this.link = function ($scope, element, attrs) {
                        var search = {
                            context: !!attrs['context'] ? attrs['context'] : null,
                            id: attrs['showIfHasPermission'],
                            readOnly: !!attrs['readOnly'] ? $scope.$eval(attrs['readOnly']) : false
                        };
                        _this.authService.getUser().then(function (user) {
                            var found = user.componentes.find(function (p) { return _this.comparePermission(p, search); });
                            if (found) {
                                element.show();
                            }
                            else {
                                element.hide();
                            }
                        }, function () {
                            _this.commandService.findByIdAndContext(search.id, search.context)
                                .then(function () {
                                element.show();
                            }, function () {
                                element.hide();
                            });
                        });
                    };
                }
                ShowIfHasPermission.factory = function () {
                    /** @ngInject **/
                    var directive = function (authService, commandService) {
                        return new ShowIfHasPermission(authService, commandService);
                    };
                    directive.$inject = ["authService", "commandService"];
                    return directive;
                };
                ShowIfHasPermission.prototype.comparePermission = function (user, search) {
                    return this.compareContext(user.context, search.context) &&
                        user.id === search.id && (!user.readOnly || user.readOnly === search.readOnly);
                };
                ShowIfHasPermission.prototype.compareContext = function (userCtxt, searchCtxt) {
                    if (!!searchCtxt) {
                        return userCtxt === searchCtxt;
                    }
                    else {
                        return true;
                    }
                };
                return ShowIfHasPermission;
            }());
            command.ShowIfHasPermission = ShowIfHasPermission;
            angular
                .module('app.support.command')
                .directive('commands', CommandListDirective.factory())
                .directive('command', CommandDirective.factory())
                .directive('saveTask', SaveTaskDirective.factory())
                .directive('openCommand', OpenCommand.factory())
                .directive('showIfHasPermission', ShowIfHasPermission.factory());
        })(command = support.command || (support.command = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        /** @ngInject */
        configNgClickDecorator.$inject = ["$provide"];
        function configNgClickDecorator($provide) {
            $provide.decorator('ngClickDirective', ["$delegate", "$timeout", function ($delegate, $timeout) {
                var originalCompile = $delegate[0].compile;
                $delegate[0].compile = function (element, attrs, transclude) {
                    if (angular.isString(attrs.command)) {
                        attrs['ngClick'] = "$checkTask('" + attrs['ngClick'] + "', $event)";
                        return originalCompile(element, attrs, transclude);
                    }
                    else {
                        return originalCompile(element, attrs, transclude);
                    }
                };
                return $delegate;
            }]);
        }
        angular.module('app.support.command').config(configNgClickDecorator);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        /** @ngInject */
        filterAccentInsensitiveOrderBy.$inject = ["$filter", "$parse"];
        function filterAccentInsensitiveOrderBy($filter, $parse) {
            return function (array, expression, reverse) {
                return $filter("orderBy")(array, function (item) {
                    return _.deburr($parse(expression)(item));
                }, reverse);
            };
        }
        angular.module('app.support').filter('accentInsensitiveOrderBy', filterAccentInsensitiveOrderBy);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        filterAccentInsensitiveFilter.$inject = ["$filter"];
        function hasCustomToString(obj) {
            return angular.isFunction(obj.toString) && obj.toString !== Object.prototype.toString;
        }
        /** @ngInject */
        function filterAccentInsensitiveFilter($filter) {
            return function (array, expression) {
                return $filter("filter")(array, expression, function (actual, expected) {
                    if (angular.isUndefined(actual)) {
                        // No substring matching against `undefined`
                        return false;
                    }
                    if ((actual === null) || (expected === null)) {
                        // No substring matching against `null`; only match against `null`
                        return actual === expected;
                    }
                    if (angular.isObject(expected) || (angular.isObject(actual) && !hasCustomToString(actual))) {
                        // Should not compare primitives against objects, unless they have custom `toString` method
                        return false;
                    }
                    actual = _.deburr(angular.lowercase('' + actual));
                    expected = _.deburr(angular.lowercase('' + expected));
                    return actual.indexOf(expected) !== -1;
                });
            };
        }
        angular.module('app.support').filter('accentInsensitiveFilter', filterAccentInsensitiveFilter);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var StfBreadcrumbsService = /** @class */ (function () {
            /** @ngInject */
            StfBreadcrumbsService.$inject = ["$rootScope", "$state", "msNavigationService"];
            function StfBreadcrumbsService($rootScope, $state, msNavigationService) {
                var _this = this;
                this.msNavigationService = msNavigationService;
                this.EMPTY_BREADCRUMB = {
                    current: {
                        label: '',
                        link: ''
                    },
                    parents: []
                };
                this.breadcrumbs = this.EMPTY_BREADCRUMB;
                this.registeredPaths = [];
                $rootScope.$watch(function () {
                    return $state.current.name;
                }, function (val) {
                    _this.breadcrumbs = _this._generateBreadcrumbs(val);
                });
            }
            StfBreadcrumbsService.prototype.getRegisteredPath = function (id) {
                return _.find(this.registeredPaths, function (p) { return p.id === id; });
            };
            StfBreadcrumbsService.prototype.registerPath = function (path) {
                var foundPath = this.getRegisteredPath(path.id);
                if (!foundPath) {
                    this.registeredPaths.push(path);
                }
            };
            StfBreadcrumbsService.prototype._generateBreadcrumbs = function (stateName) {
                var navigation = this._navigationObject();
                var recurse = function (nodes) {
                    return _.map(nodes, function (node) {
                        return [
                            node,
                            recurse(node.children)
                        ];
                    });
                };
                var flattenedNavigations = _.flattenDeep(recurse(navigation));
                var stateNameComponents = stateName.split('.');
                var matchedNavigation;
                var componentsLength = stateNameComponents.length;
                for (var i = 0; i < componentsLength; i++) {
                    matchedNavigation = _.find(flattenedNavigations, { 'state': stateNameComponents.join('.') });
                    if (matchedNavigation)
                        break;
                    stateNameComponents.pop();
                }
                if (!matchedNavigation) {
                    // Breadcrumb vazio
                    return this.EMPTY_BREADCRUMB;
                }
                else {
                    return this.getBreadcrumbFromPath(this._getBreadcrumbPath(matchedNavigation._path));
                }
            };
            StfBreadcrumbsService.prototype._navigationObject = function () {
                return this.msNavigationService.getNavigation();
            };
            StfBreadcrumbsService.prototype._getBreadcrumbPath = function (pathStr) {
                var navigation = this._navigationObject();
                var path = pathStr.split('.');
                var completePath = [];
                while (completePath.length < path.length) {
                    var found = false;
                    for (var i = 0; i < navigation.length; i++) {
                        if (navigation[i]._id == path[completePath.length]) {
                            completePath.push(navigation[i]);
                            navigation = navigation[i].children;
                            found = true;
                            break;
                        }
                    }
                }
                return completePath;
            };
            StfBreadcrumbsService.prototype.buildPathArrayRecursively = function (path, pathArray) {
                pathArray.unshift(path);
                if (path.parent) {
                    var parent_1 = _.find(this.registeredPaths, function (p) { return p.id === path.parent; });
                    if (parent_1) {
                        this.buildPathArrayRecursively(parent_1, pathArray);
                    }
                }
                return pathArray;
            };
            StfBreadcrumbsService.prototype.generateBreadcrumbFromLocalPath = function (path) {
                if (!angular.isArray(path) && path.parent) {
                    return this.getBreadcrumbFromPath(this.buildPathArrayRecursively(path, []));
                }
                else {
                    return this.getBreadcrumbFromPath(path);
                }
            };
            StfBreadcrumbsService.prototype.getBreadcrumbFromPath = function (path) {
                var breadcrumbs = {
                    parents: [],
                    current: null
                };
                for (var i = 0; i < path.length; i++) {
                    var parsedPathPart = this._parsePathPart(path[i]);
                    if (i + 1 == path.length) {
                        breadcrumbs.current = parsedPathPart;
                    }
                    else {
                        breadcrumbs.parents.push(parsedPathPart);
                    }
                }
                return breadcrumbs;
            };
            StfBreadcrumbsService.prototype._parsePathPart = function (part) {
                return {
                    label: part.translation,
                    link: part.uisref
                };
            };
            return StfBreadcrumbsService;
        }());
        support.StfBreadcrumbsService = StfBreadcrumbsService;
        angular.module('app.support').service('stfBreadcrumbsService', StfBreadcrumbsService);
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var AutofocusDirective = /** @class */ (function () {
            function AutofocusDirective($timeout) {
                this.$timeout = $timeout;
                this.restrict = "A";
            }
            AutofocusDirective.prototype.link = function (scope, element) {
                this.$timeout(function () {
                    element[0].focus();
                }, 1000);
            };
            AutofocusDirective.factory = function () {
                return ["$timeout", function ($timeout) {
                    'ngInject';
                    return new AutofocusDirective($timeout);
                }];
            };
            return AutofocusDirective;
        }());
        support.AutofocusDirective = AutofocusDirective;
        angular
            .module('app.support')
            .directive('stfAutofocus', AutofocusDirective.factory());
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var authorization;
        (function (authorization) {
            /**
             * Gerenciar um subconjunto de permissões especificadas de algum contexto.
             *
             */
            var PermissionManager = /** @class */ (function () {
                function PermissionManager(context, permissions) {
                    this.context = context;
                    this.permissions = permissions;
                }
                /**
                 * Verifica se possui permissão de leitura, seja porque possui
                 * permissão de execução ou porque possui permissão de apenas
                 * leitura.
                 *
                 * @param idRecurso
                 * @returns
                 */
                PermissionManager.prototype.hasRead = function (idRecurso) {
                    return !!this.permissions.find(function (p) { return p.id === idRecurso; });
                };
                /**
                 * Verifica se possui permissão de execução.
                 *
                 * @param idRecurso
                 * @returns
                 */
                PermissionManager.prototype.hasExecute = function (idRecurso) {
                    return !!this.permissions.find(function (p) { return p.id === idRecurso && p.readOnly === false; });
                };
                /**
                 * Verifica se possui apenas a permissão de leitura, não
                 * possuindo a de execução.
                 *
                 * @param idRecurso
                 * @returns
                 */
                PermissionManager.prototype.hasOnlyRead = function (idRecurso) {
                    var hasRead = false;
                    var hasExecute = false;
                    this.permissions.forEach(function (p) {
                        if (p.id == idRecurso && p.readOnly === true) {
                            hasRead = true;
                        }
                        if (p.id == idRecurso && p.readOnly === false) {
                            hasExecute = true;
                        }
                    });
                    return hasRead && !hasExecute;
                };
                return PermissionManager;
            }());
            authorization.PermissionManager = PermissionManager;
        })(authorization = support.authorization || (support.authorization = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var command;
        (function (command) {
            'use strict';
            angular
                .module('app.support.authorization', ['ngMaterial', 'app.support.constants', 'app.autenticacao']);
        })(command = support.command || (support.command = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var authorization;
        (function (authorization) {
            var AuthorizationService = /** @class */ (function () {
                /** @ngInject */
                AuthorizationService.$inject = ["authService"];
                function AuthorizationService(authService) {
                    this.authService = authService;
                }
                AuthorizationService.prototype.findPermission = function (idRecurso, context, readOnly) {
                    var _this = this;
                    if (readOnly === void 0) { readOnly = true; }
                    return this.userComponents().then(function (componentes) { return componentes.find(function (p) { return _this.comparePermission(p, context, [idRecurso], readOnly); }); });
                };
                /**
                 * Cria um gerenciador de permissões para o contexto especificado e para as permissões especificadas.
                 * Caso nenhuma permissão seja especificada, retorna um gerenciador de permissões para todas as permissões
                 * do contexto especificado.
                 *
                 * @param context
                 * @param idsRecursos
                 * @returns
                 */
                AuthorizationService.prototype.permissionManager = function (context) {
                    var _this = this;
                    var idsRecursos = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        idsRecursos[_i - 1] = arguments[_i];
                    }
                    return this.userComponents().then(function (componentes) { return new authorization.PermissionManager(context, componentes.filter(function (p) { return _this.comparePermission(p, context, idsRecursos); })); });
                };
                /**
                 * Verifica se uma permissão especificada está presente na lista de permissões alvo e
                 * pertence ao contexto alvo.
                 *
                 * @param permission
                 * @param targetContext
                 * @param targetIdRecursos Se for vazio, verificará apenas se a permissão pertence ao contexto
                 * @returns
                 */
                AuthorizationService.prototype.comparePermission = function (permission, targetContext, targetIdRecursos, readOnly) {
                    if (readOnly === void 0) { readOnly = true; }
                    return permission.context === targetContext &&
                        (targetIdRecursos.length === 0 || targetIdRecursos.indexOf(permission.id) !== -1) &&
                        (readOnly || permission.readOnly === readOnly);
                };
                AuthorizationService.prototype.userComponents = function () {
                    return this.authService.getUser().then(function (user) { return user.componentes; });
                };
                return AuthorizationService;
            }());
            authorization.AuthorizationService = AuthorizationService;
            angular
                .module('app.support.authorization')
                .service('authorizationService', AuthorizationService);
        })(authorization = support.authorization || (support.authorization = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var alert;
        (function (alert) {
            "use strict";
            angular
                .module("app.support.alert", []);
        })(alert = support.alert || (support.alert = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var alert;
        (function (alert) {
            "use strict";
            var AlertService = /** @class */ (function () {
                /** @ngInject */
                AlertService.$inject = ["$rootScope", "$http", "messagesService", "properties", "$q"];
                function AlertService($rootScope, $http, messagesService, properties, $q) {
                    this.$http = $http;
                    this.messagesService = messagesService;
                    this.properties = properties;
                    this.$q = $q;
                    this.modulosApi = this.properties.apiUrl + "/integracoes-modulos/api";
                }
                AlertService.prototype.recuperarAlertasNaoLidos = function () {
                    var url = this.modulosApi + "/alerts";
                    return this.$http.get(url)
                        .then(function (response) {
                        // @ts-ignore                        
                        return response.data;
                    });
                };
                AlertService.prototype.atualizarAlertasComoLidos = function (alertas) {
                    var _this = this;
                    var url = this.modulosApi + "/alerts";
                    this.$http.patch(url, alertas)
                        .then(function () { return _this.messagesService.success("Alerta(s) marcado(s) como ciente(s)!"); })
                        .catch(function () { return _this.messagesService.error("Ocorreu um erro ao marcar o(s) alerta(s) como ciente(s)!"); });
                };
                return AlertService;
            }());
            alert.AlertService = AlertService;
            angular
                .module("app.support.alert")
                .service("alertService", AlertService);
        })(alert = support.alert || (support.alert = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        var alert;
        (function (alert) {
            var AlertController = /** @class */ (function () {
                /** @ngInject **/
                AlertController.$inject = ["$mdDialog", "alertService", "alertas"];
                function AlertController($mdDialog, alertService, alertas) {
                    this.$mdDialog = $mdDialog;
                    this.alertService = alertService;
                    this.alertas = alertas;
                    this.gruposAlertas = [];
                    this.gruposAlertas = this.incluirGruposAlertas(alertas);
                }
                AlertController.prototype.definirCiencia = function (grupoAlertas) {
                    var identicadores = [];
                    grupoAlertas.forEach(function (grupo) {
                        grupo.alertas.map(function (alerta) { return identicadores.push(alerta.identificador); });
                    });
                    this.alertService.atualizarAlertasComoLidos(identicadores);
                    this.gruposAlertas = [];
                    this.$mdDialog.hide();
                };
                AlertController.prototype.mostrarIdentificacao = function (alerta) {
                    return JSON.parse(alerta).informacao;
                };
                AlertController.prototype.incluirGruposAlertas = function (alertas) {
                    var agrupado = alertas.reduce(function (agrupador, alerta) {
                        var _a = JSON.parse(alerta.content.toString()), titulo = _a.titulo, mensagem = _a.mensagem, informacao = _a.informacao, observacao = _a.observacao;
                        if (!agrupador[alerta.name]) {
                            agrupador[alerta.name] = {
                                titulo: titulo,
                                mensagem: mensagem,
                                alertas: []
                            };
                        }
                        agrupador[alerta.name].alertas.push({
                            identificador: alerta.identificador,
                            descricao: informacao.toString(),
                            data: alerta.creationDate,
                            observacao: observacao
                        });
                        return agrupador;
                    }, {});
                    var resultado = (function () {
                        var values = [];
                        for (var chave in agrupado) {
                            if (agrupado.hasOwnProperty(chave)) {
                                values.push(agrupado[chave]);
                            }
                        }
                        return values;
                    })();
                    return resultado;
                };
                return AlertController;
            }());
            alert.AlertController = AlertController;
            angular
                .module("app.support.alert")
                .controller("app.support.alert.AlertController", AlertController);
        })(alert = support.alert || (support.alert = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var support;
    (function (support) {
        'use strict';
        /**
         * Diretiva que permite fazer o bind adicional de uma variável
         * quando usado em combinação com o ng-model. Esse bind é apenas
         * one-way, sincronizando o $modelValue atual do ng-model com
         * a variável especificada nessa diretiva.
         */
        var StfAdditionalModel = /** @class */ (function () {
            function StfAdditionalModel() {
                this.scope = {
                    stfAdditionalModel: '='
                };
                this.require = 'ngModel';
            }
            StfAdditionalModel.prototype.link = function ($scope, element, attrs, ngModel) {
                $scope.$watch(function () {
                    return ngModel.$modelValue;
                }, function (modelValue) {
                    $scope.stfAdditionalModel = modelValue;
                });
            };
            StfAdditionalModel.factory = function () {
                return function () {
                    "ngInject";
                    return new StfAdditionalModel();
                };
            };
            return StfAdditionalModel;
        }());
        support.StfAdditionalModel = StfAdditionalModel;
        angular
            .module('app.support')
            .directive('stfAdditionalModel', StfAdditionalModel.factory());
    })(support = app.support || (app.support = {}));
})(app || (app = {}));



var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        'use strict';
        var CriterionDisplayNameFilter = /** @class */ (function () {
            function CriterionDisplayNameFilter() {
            }
            CriterionDisplayNameFilter.getFilter = function ($filter, $translate) {
                return function (criterion) {
                    var date = $filter('date');
                    var name = angular.copy(criterion.value);
                    if (criterion.trait.dataType === 'date') {
                        if (_.isArray(name)) {
                            name[0] = date(name[0], 'dd/MM/yyyy HH:mm');
                            name[1] = date(name[1], 'dd/MM/yyyy HH:mm');
                        }
                        else {
                            name = date(name, 'dd/MM/yyyy HH:mm');
                        }
                    }
                    if (criterion.trait.dataType === 'list') {
                        name = criterion.display;
                    }
                    switch (criterion.comparisonOperator) {
                        case pesquisaAvancada.ComparisonOperator.BETWEEN:
                            name = (name[0] || '') + " " + (name[0] && name[1] ? 'e' : '') + " " + (name[1] || '');
                            break;
                        case pesquisaAvancada.ComparisonOperator.GREATER_THAN:
                            name = name;
                            break;
                        case pesquisaAvancada.ComparisonOperator.LESS_THAN:
                            name = name;
                            break;
                        case pesquisaAvancada.ComparisonOperator.EXISTS:
                            name = "";
                    }
                    return name;
                };
            };
            CriterionDisplayNameFilter.filter = function () {
                /** @ngInject **/
                return function ($filter, $translate) { return CriterionDisplayNameFilter.getFilter($filter, $translate); };
            };
            return CriterionDisplayNameFilter;
        }());
        angular
            .module('app.pesquisa-avancada')
            .filter('criterionDisplayName', CriterionDisplayNameFilter.filter());
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));



var app;
(function (app) {
    var gestao;
    (function (gestao) {
        var meusPaineis;
        (function (meusPaineis) {
            'use strict';
            var PaineisController = /** @class */ (function () {
                /** @ngInject **/
                PaineisController.$inject = ["$state", "dashboards", "$stateParams"];
                function PaineisController($state, dashboards, $stateParams) {
                    this.$state = $state;
                    this.dashboards = dashboards;
                    if ($stateParams['dashboardId']) {
                        this.currentDashboardId = $stateParams['dashboardId'];
                    }
                    else {
                        if (dashboards.length > 0) {
                            this.currentDashboardId = this.dashboards[0].id;
                        }
                    }
                }
                PaineisController.prototype.configure = function () {
                    console.info("// TODO configure");
                };
                PaineisController.prototype.isTabActive = function (dashboardId) {
                    return this.currentDashboardId === dashboardId;
                };
                return PaineisController;
            }());
            meusPaineis.PaineisController = PaineisController;
            angular
                .module('app.gestao.meus-paineis')
                .controller('app.gestao.meus-paineis.PaineisController', PaineisController);
        })(meusPaineis = gestao.meusPaineis || (gestao.meusPaineis = {}));
    })(gestao = app.gestao || (app.gestao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var gestao;
    (function (gestao) {
        var meusPaineis;
        (function (meusPaineis) {
            'use strict';
            var MeusPaineisService = /** @class */ (function () {
                /** @ngInject **/
                MeusPaineisService.$inject = ["$http"];
                function MeusPaineisService($http) {
                    this.$http = $http;
                }
                MeusPaineisService.prototype.loadDashboardWidget = function (widgetName) {
                    var _this = this;
                    var widget = {};
                    this.data()
                        .then(function (data) {
                        angular.copy(_this['get' + widgetName](data), widget);
                    });
                    return widget;
                };
                MeusPaineisService.prototype.data = function () {
                    return this.$http
                        .get(MeusPaineisService.widgetsJson)
                        .then(function (response) {
                        return response.data;
                    });
                };
                MeusPaineisService.prototype.getChart1 = function (data) {
                    return data.chart1;
                };
                MeusPaineisService.prototype.getChart2 = function (data) {
                    return data.chart2;
                };
                MeusPaineisService.prototype.getWidget1 = function (data) {
                    return data.widget1;
                };
                MeusPaineisService.prototype.getWidget2 = function (data) {
                    return data.widget2;
                };
                MeusPaineisService.prototype.getWidget3 = function (data) {
                    return data.widget3;
                };
                MeusPaineisService.prototype.getWidget4 = function (data) {
                    return data.widget4;
                };
                MeusPaineisService.prototype.getWidget5 = function (data) {
                    var widget = {
                        title: data.widget5.title,
                        mainChart: {
                            config: {
                                refreshDataOnly: true,
                                deepWatchData: true
                            },
                            options: {
                                chart: {
                                    type: 'multiBarChart',
                                    color: ['#03a9f4', '#b3e5fc'],
                                    height: 420,
                                    margin: {
                                        top: 8,
                                        right: 16,
                                        bottom: 32,
                                        left: 32
                                    },
                                    clipEdge: true,
                                    groupSpacing: 0.3,
                                    reduceXTicks: false,
                                    stacked: true,
                                    duration: 250,
                                    x: function (d) { return d.x; },
                                    y: function (d) { return d.y; },
                                    yAxis: {
                                        tickFormat: function (d) { return d; }
                                    },
                                    legend: {
                                        margin: {
                                            top: 8,
                                            bottom: 32
                                        }
                                    },
                                    controls: {
                                        margin: {
                                            top: 8,
                                            bottom: 32
                                        }
                                    },
                                    tooltip: {
                                        gravity: 's',
                                        classes: 'gravity-s'
                                    }
                                }
                            },
                            data: []
                        },
                        supporting: {
                            widgets: {
                                created: {
                                    data: data.widget5.supporting.created,
                                    chart: { data: [] }
                                },
                                closed: {
                                    data: data.widget5.supporting.closed,
                                    chart: { data: [] }
                                },
                                reOpened: {
                                    data: data.widget5.supporting.reOpened,
                                    chart: { data: [] }
                                },
                                wontFix: {
                                    data: data.widget5.supporting.wontFix,
                                    chart: { data: [] }
                                },
                                needsTest: {
                                    data: data.widget5.supporting.needsTest,
                                    chart: { data: [] }
                                },
                                fixed: {
                                    data: data.widget5.supporting.fixed,
                                    chart: { data: [] }
                                }
                            },
                            chart: {
                                config: {
                                    refreshDataOnly: true,
                                    deepWatchData: true
                                },
                                options: {
                                    chart: {
                                        type: 'lineChart',
                                        color: ['#03A9F4'],
                                        height: 50,
                                        margin: {
                                            top: 8,
                                            right: 0,
                                            bottom: 0,
                                            left: 0
                                        },
                                        isArea: true,
                                        interpolate: 'cardinal',
                                        clipEdge: true,
                                        duration: 500,
                                        showXAxis: false,
                                        showYAxis: false,
                                        showLegend: false,
                                        useInteractiveGuideline: true,
                                        x: function (d) { return d.x; },
                                        y: function (d) { return d.y; },
                                        yDomain: [0, 9],
                                        xAxis: {
                                            tickFormat: function (d) { return widget.days[d]; }
                                        },
                                        interactiveLayer: {
                                            tooltip: {
                                                gravity: 'e',
                                                classes: 'gravity-e'
                                            }
                                        }
                                    }
                                },
                                data: []
                            }
                        },
                        days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                        ranges: data.widget5.ranges,
                        currentRange: '',
                        changeRange: function (range) {
                            widget.currentRange = range;
                            /**
                             * Update main chart data by iterating through the
                             * chart dataset and separately adding every single
                             * dataset by hand.
                             *
                             * You MUST NOT swap the entire data object by doing
                             * something similar to this:
                             * this.widget.mainChart.data = chartData
                             *
                             * It would be easier but it won't work with the
                             * live updating / animated charts due to how d3
                             * works.
                             *
                             * If you don't need animated / live updating charts,
                             * you can simplify these greatly.
                             */
                            angular.forEach(data.widget5.mainChart, function (chartData, index) {
                                widget.mainChart.data[index] = {
                                    key: chartData.key,
                                    values: chartData.values[range]
                                };
                            });
                            /**
                             * Do the same thing for the supporting widgets but they
                             * only have 1 dataset so we can do [0] without needing to
                             * iterate through in their data arrays
                             */
                            angular.forEach(data.widget5.supporting, function (wg, name) {
                                widget.supporting.widgets[name].chart.data[0] = {
                                    key: wg.chart.key,
                                    values: wg.chart.values[range]
                                };
                            });
                        },
                        init: function () {
                            // Run this function once to initialize widget
                            /**
                             * Update the range for the first time
                             */
                            widget.changeRange('TW');
                        }
                    };
                    widget.init();
                    return widget;
                };
                MeusPaineisService.prototype.getWidget6 = function (data) {
                    var widget = {
                        title: data.widget6.title,
                        mainChart: {
                            config: {
                                refreshDataOnly: true,
                                deepWatchData: true
                            },
                            options: {
                                chart: {
                                    type: 'pieChart',
                                    color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                                    height: 400,
                                    margin: {
                                        top: 0,
                                        right: 0,
                                        bottom: 0,
                                        left: 0
                                    },
                                    donut: true,
                                    clipEdge: true,
                                    cornerRadius: 0,
                                    labelType: 'percent',
                                    padAngle: 0.02,
                                    x: function (d) { return d.label; },
                                    y: function (d) { return d.value; },
                                    tooltip: {
                                        gravity: 's',
                                        classes: 'gravity-s'
                                    }
                                }
                            },
                            data: []
                        },
                        footerLeft: data.widget6.footerLeft,
                        footerRight: data.widget6.footerRight,
                        ranges: data.widget6.ranges,
                        currentRange: '',
                        changeRange: function (range) {
                            widget.currentRange = range;
                            /**
                             * Update main chart data by iterating through the
                             * chart dataset and separately adding every single
                             * dataset by hand.
                             *
                             * You MUST NOT swap the entire data object by doing
                             * something similar to this:
                             * this.widget.mainChart.data = chartData
                             *
                             * It would be easier but it won't work with the
                             * live updating / animated charts due to how d3
                             * works.
                             *
                             * If you don't need animated / live updating charts,
                             * you can simplify these greatly.
                             */
                            angular.forEach(data.widget6.mainChart, function (data, index) {
                                widget.mainChart.data[index] = {
                                    label: data.label,
                                    value: data.values[range]
                                };
                            });
                        },
                        init: function () {
                            // Run this function once to initialize widget
                            /**
                             * Update the range for the first time
                             */
                            widget.changeRange('TW');
                        }
                    };
                };
                MeusPaineisService.prototype.getWidget7 = function (data) {
                    return {
                        title: data.widget7.title,
                        ranges: data.widget7.ranges,
                        schedule: data.widget7.schedule,
                        currentRange: 'T'
                    };
                };
                MeusPaineisService.prototype.getWidget8 = function (data) {
                    return {
                        title: data.widget8.title,
                        mainChart: {
                            options: {
                                chart: {
                                    type: 'pieChart',
                                    color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                                    height: 400,
                                    margin: {
                                        top: 0,
                                        right: 0,
                                        bottom: 0,
                                        left: 0
                                    },
                                    labelType: 'percent',
                                    x: function (d) { return d.label; },
                                    y: function (d) { return d.value; },
                                    tooltip: {
                                        gravity: 's',
                                        classes: 'gravity-s'
                                    }
                                }
                            },
                            data: data.widget8.mainChart
                        }
                    };
                };
                MeusPaineisService.prototype.getWidget9 = function (data) {
                    var widget = {
                        title: data.widget9.title,
                        weeklySpent: {
                            title: data.widget9.weeklySpent.title,
                            count: data.widget9.weeklySpent.count,
                            chartData: []
                        },
                        totalSpent: {
                            title: data.widget9.totalSpent.title,
                            count: data.widget9.totalSpent.count,
                            chartData: []
                        },
                        remaining: {
                            title: data.widget9.remaining.title,
                            count: data.widget9.remaining.count,
                            chartData: []
                        },
                        totalBudget: data.widget9.totalBudget,
                        chart: {
                            config: {
                                refreshDataOnly: true,
                                deepWatchData: true
                            },
                            options: {
                                chart: {
                                    type: 'lineChart',
                                    color: ['#00BCD4'],
                                    height: 50,
                                    margin: {
                                        top: 8,
                                        right: 0,
                                        bottom: 0,
                                        left: 0
                                    },
                                    isArea: true,
                                    interpolate: 'cardinal',
                                    clipEdge: true,
                                    duration: 500,
                                    showXAxis: false,
                                    showYAxis: false,
                                    showLegend: false,
                                    useInteractiveGuideline: true,
                                    x: function (d) { return d.x; },
                                    y: function (d) { return d.y; },
                                    yDomain: [0, 9],
                                    xAxis: {
                                        tickFormat: function (d) { return widget.days[d]; }
                                    },
                                    interactiveLayer: {
                                        tooltip: {
                                            gravity: 'e',
                                            classes: 'gravity-e'
                                        }
                                    }
                                }
                            }
                        },
                        days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                        ranges: data.widget9.ranges,
                        currentRange: '',
                        changeRange: function (range) {
                            widget.currentRange = range;
                            /**
                             * Update mini charts. They only have 1 dataset
                             * so we can do [0] without needing to iterate
                             * through in their data arrays
                             */
                            widget.weeklySpent.chartData[0] = {
                                key: data.widget9.weeklySpent.chart.label,
                                values: data.widget9.weeklySpent.chart.values[range]
                            };
                            widget.totalSpent.chartData[0] = {
                                key: data.widget9.totalSpent.chart.label,
                                values: data.widget9.totalSpent.chart.values[range]
                            };
                            widget.remaining.chartData[0] = {
                                key: data.widget9.remaining.chart.label,
                                values: data.widget9.remaining.chart.values[range]
                            };
                        },
                        init: function () {
                            // Run this function once to initialize widget
                            /**
                             * Update the range for the first time
                             */
                            widget.changeRange('TW');
                        }
                    };
                    widget.init();
                    return widget;
                };
                MeusPaineisService.prototype.getWidget10 = function (data) {
                    return data.widget10;
                };
                MeusPaineisService.prototype.getWidget11 = function (data) {
                    return {
                        title: data.widget11.title,
                        table: data.widget11.table,
                        dtOptions: {
                            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                            pagingType: 'simple',
                            order: [0, 'asc'],
                        }
                    };
                };
                MeusPaineisService.widgetsJson = 'app/data/sample/gestao/meus-paineis/dashboard-widgets.json';
                return MeusPaineisService;
            }());
            meusPaineis.MeusPaineisService = MeusPaineisService;
            angular
                .module('app.gestao.meus-paineis')
                .service('app.gestao.meus-paineis.MeusPaineisService', MeusPaineisService);
        })(meusPaineis = gestao.meusPaineis || (gestao.meusPaineis = {}));
    })(gestao = app.gestao || (app.gestao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var configuracoes;
    (function (configuracoes) {
        var administracao;
        (function (administracao) {
            'use strict';
            /** @ngInject **/
            config.$inject = ["$translatePartialLoaderProvider", "$stateProvider", "msNavigationServiceProvider"];
            function config($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
                $translatePartialLoaderProvider.addPart('app/main/configuracoes/administracao');
                $stateProvider.state('app.configuracoes.administracao', {
                    url: '/administracao',
                    views: {
                        'content@app.autenticado': {
                            templateUrl: 'app/main/configuracoes/administracao/administracao.html'
                        }
                    }
                });
                msNavigationServiceProvider.saveItem('configuracoes.administracao', {
                    title: 'Administração',
                    icon: 'icon-cog',
                    state: 'app.configuracoes.administracao',
                    translation: 'CONFIGURACOES.ADMINISTRACAO.ADMINISTRACAO',
                    weight: 1
                });
            }
            angular
                .module('app.configuracoes.administracao', ['app.configuracoes'])
                .config(config);
        })(administracao = configuracoes.administracao || (configuracoes.administracao = {}));
    })(configuracoes = app.configuracoes || (app.configuracoes = {}));
})(app || (app = {}));



var app;
(function (app) {
    var autenticacao;
    (function (autenticacao) {
        "use strict";
        /** @ngInject **/
        config.$inject = ["$translatePartialLoaderProvider", "$stateProvider"];
        function config($translatePartialLoaderProvider, $stateProvider) {
            $translatePartialLoaderProvider.addPart("app/main/autenticacao/nao-autenticado");
            $stateProvider
                .state("app.nao-autenticado", {
                abstract: true,
                views: {
                    "main@": {
                        templateUrl: "app/custom/layouts/content-only.html",
                        controller: app.MainController,
                        controllerAs: "vm"
                    },
                    "content@app.nao-autenticado": {
                        templateUrl: "app/main/autenticacao/nao-autenticado/nao-autenticado.html"
                    }
                }
            })
                .state("app.publico", {
                abstract: true,
                parent: "app.nao-autenticado",
                url: "/publico"
            });
        }
        angular
            .module("app.nao-autenticado", ["app.autenticacao", "app.navigation"])
            .config(config);
    })(autenticacao = app.autenticacao || (app.autenticacao = {}));
})(app || (app = {}));



/**
 * @author Fabrício Mendonça
 *
 * @since 1.2.0
 * @since 18.10.2016
 */
var app;
/**
 * @author Fabrício Mendonça
 *
 * @since 1.2.0
 * @since 18.10.2016
 */
(function (app) {
    var autenticacao;
    (function (autenticacao) {
        /** @ngInject */
        config.$inject = ["$httpProvider"];
        run.$inject = ["versionService"];
        function config($httpProvider) {
            $httpProvider.defaults.withCredentials = true;
            $httpProvider.interceptors.push("AuthInterceptor");
        }
        /** @ngInject */
        function run(versionService) {
            versionService.loadVersionUser();
        }
        angular
            .module("app.autenticacao", ["app.support"])
            .config(config)
            .run(run);
    })(autenticacao = app.autenticacao || (app.autenticacao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var autenticacao;
    (function (autenticacao) {
        "use strict";
        var VersionService = /** @class */ (function () {
            /** @ngInject */
            VersionService.$inject = ["$http", "$q"];
            function VersionService($http, $q) {
                this.$http = $http;
                this.$q = $q;
                this.version = null;
            }
            VersionService.prototype.loadVersionUser = function () {
                this.version = this.$http.get('/assets/version.json?ts=' + (new Date().getTime()))
                    .then(function (result) {
                    return result.data.version;
                });
            };
            VersionService.prototype.getVersionUser = function () {
                return this.version;
            };
            VersionService.prototype.getVersionServer = function () {
                return this.$http.get('/assets/version.json?ts=' + (new Date().getTime()))
                    .then(function (result) {
                    return result.data.version;
                });
            };
            return VersionService;
        }());
        autenticacao.VersionService = VersionService;
        angular
            .module("app.autenticacao")
            .service("versionService", VersionService);
    })(autenticacao = app.autenticacao || (app.autenticacao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var autenticacao;
    (function (autenticacao) {
        "use strict";
        /** @ngInject **/
        config.$inject = ["$translatePartialLoaderProvider", "$stateProvider"];
        function config($translatePartialLoaderProvider, $stateProvider) {
            $translatePartialLoaderProvider.addPart("app/main/autenticacao/login");
            $stateProvider
                .state("app.login", {
                parent: "app.nao-autenticado",
                url: "/login",
                views: {
                    "form@app.nao-autenticado": {
                        templateUrl: "app/main/autenticacao/login/login.html",
                        controller: autenticacao.LoginController,
                        controllerAs: "vm"
                    }
                },
                resolve: {
                    iframe: ['$q', function ($q) {
                            if (window !== parent) {
                                parent.postMessage({ "type": "iframe", "operation": "signOut" }, "*");
                                return $q.reject('Sair');
                            }
                        }],
                }
            });
        }
        angular
            .module("app.login", ["app.nao-autenticado"])
            .config(config);
    })(autenticacao = app.autenticacao || (app.autenticacao = {}));
})(app || (app = {}));



var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var app;
(function (app) {
    var autenticacao;
    (function (autenticacao) {
        "use strict";
        var FormLogin = /** @class */ (function () {
            function FormLogin() {
            }
            return FormLogin;
        }());
        var LoginController = /** @class */ (function () {
            /** @ngInject **/
            LoginController.$inject = ["$state", "$cookies", "$window", "messagesService", "authService", "versionService"];
            function LoginController($state, $cookies, $window, messagesService, authService, versionService) {
                var _this = this;
                this.$state = $state;
                this.$cookies = $cookies;
                this.$window = $window;
                this.messagesService = messagesService;
                this.authService = authService;
                this.versionService = versionService;
                this.form = new FormLogin();
                Promise.all([this.versionService.getVersionUser(), this.versionService.getVersionServer()])
                    .then(function (_a) {
                    var versionUser = _a[0], versionServer = _a[1];
                    if (versionUser != versionServer) {
                        _this.$window.location.reload();
                    }
                });
                if (!this.isLocal() && (this.isMobile() || this.$window.location.hash)) {
                    this.authService.verifyRedirectAndAuthenticate()
                        .then(function (redirected) {
                        if (redirected) {
                            var originalUrlRequest = _this.$cookies.get("originalUrlRequest");
                            if (!!originalUrlRequest) {
                                _this.$cookies.remove("originalUrlRequest");
                                _this.$window.location.href = originalUrlRequest;
                            }
                            else {
                                return _this.$state.go("app.tarefas.minhas-tarefas");
                            }
                        }
                    });
                }
            }
            LoginController.prototype.isLocal = function () {
                return this.authService.isLocalAuthentication();
            };
            LoginController.prototype.entrar = function () {
                var _this = this;
                if (this.isLocal() || !this.isMobile()) {
                    return this.authService.authenticate(this.form.usuario, this.form.senha, true).then(function () {
                        var originalUrlRequest = _this.$cookies.get("originalUrlRequest");
                        if (!!originalUrlRequest) {
                            _this.$cookies.remove("originalUrlRequest");
                            _this.$window.location.href = originalUrlRequest;
                        }
                        else {
                            return _this.$state.go("app.tarefas.minhas-tarefas");
                        }
                    }).catch(function (erro) { return _this.tratarErro(erro); });
                }
                return this.authService.loginRedirect();
            };
            LoginController.prototype.tratarErro = function (error) {
                var msg;
                if (error.data && error.data.error_description) {
                    var parser = new DOMParser();
                    var dom = parser.parseFromString(error.data.error_description, "text/html");
                    msg = dom.body.textContent;
                }
                this.messagesService.error(msg ? msg : "Usuário ou senha inválido(s).");
            };
            LoginController.prototype.isMobile = function () {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                    navigator.maxTouchPoints > 0;
            };
            return LoginController;
        }());
        autenticacao.LoginController = LoginController;
        var LoginControllerDialog = /** @class */ (function (_super) {
            __extends(LoginControllerDialog, _super);
            /** @ngInject **/
            LoginControllerDialog.$inject = ["$state", "$cookies", "$window", "messagesService", "authService", "versionService", "$mdDialog", "login"];
            function LoginControllerDialog($state, $cookies, $window, messagesService, authService, versionService, $mdDialog, login) {
                var _this = _super.call(this, $state, $cookies, $window, messagesService, authService, versionService) || this;
                _this.$mdDialog = $mdDialog;
                _this.login = login;
                _this.form.usuario = login;
                return _this;
            }
            LoginControllerDialog.prototype.entrar = function () {
                var _this = this;
                return this.authService.authenticate(this.form.usuario, this.form.senha).then(function () {
                    _this.$mdDialog.hide();
                    _this.messagesService.success("Autenticação realizada com sucesso!");
                    if (_this.form.usuario != _this.login) {
                        _this.$window.location.reload(false);
                    }
                }).catch(function (erro) { return _this.tratarErro(erro); });
            };
            LoginControllerDialog.prototype.fechar = function () {
                this.$mdDialog.cancel();
            };
            return LoginControllerDialog;
        }(LoginController));
        autenticacao.LoginControllerDialog = LoginControllerDialog;
        angular.module("app.login")
            .controller("app.login.LoginController", LoginController)
            .controller("app.login.LoginControllerDialog", LoginControllerDialog);
    })(autenticacao = app.autenticacao || (app.autenticacao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var autenticacao;
    (function (autenticacao) {
        "use strict";
        /** @ngInject **/
        config.$inject = ["$translatePartialLoaderProvider", "$stateProvider"];
        function config($translatePartialLoaderProvider, $stateProvider) {
            $translatePartialLoaderProvider.addPart("app/main/autenticacao/autenticado");
            $stateProvider.state("app.autenticado", {
                abstract: true,
                views: {
                    "main@": {
                        templateUrl: "app/custom/layouts/vertical-navigation.html",
                        controller: "app.MainController",
                        controllerAs: "vm"
                    },
                    "toolbar@app.autenticado": {
                        templateUrl: "app/main/toolbar/toolbar.html",
                        controller: "app.ToolbarController",
                        controllerAs: "vm"
                    },
                    "navigation@app.autenticado": {
                        templateUrl: "app/main/navigation/navigation.html",
                        controller: "app.NavigationController",
                        controllerAs: "vm"
                    },
                    "quickPanel@app.autenticado": {
                        templateUrl: "app/main/quick-panel/quick-panel.html",
                        controller: "app.QuickPanelController",
                        controllerAs: "vm"
                    },
                    "upgraded@app.autenticado": {
                        templateUrl: "app/main/upgraded/upgraded.html",
                        controller: "app.upgraded.UpgradedController",
                        controllerAs: "vm"
                    }
                }
            });
        }
        angular
            .module("app.autenticado", ["app.autenticacao", "app.navigation", "app.quick-panel", "app.toolbar", "app.notification"])
            .config(config);
    })(autenticacao = app.autenticacao || (app.autenticacao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var upgraded;
    (function (upgraded) {
        "use strict";
        /** @ngInject **/
        config.$inject = ["$stateProvider", "msNavigationServiceProvider"];
        run.$inject = ["app.upgraded.UpgradedService"];
        function config($stateProvider, msNavigationServiceProvider) {
            $stateProvider.state("app.upgraded", {
                url: "/upgraded/{url:any}",
                parent: "app.autenticado"
            });
        }
        /** @ngInject */
        function run(upgradedService) {
            upgradedService.loadUpgradedMenuItems();
        }
        angular
            .module("app.upgraded", ["app.support"])
            .config(config)
            .run(run);
    })(upgraded = app.upgraded || (app.upgraded = {}));
})(app || (app = {}));



var app;
(function (app) {
    var upgraded;
    (function (upgraded) {
        "use strict";
        var UpgradedService = /** @class */ (function () {
            /** @ngInject **/
            UpgradedService.$inject = ["$rootScope", "$http", "properties", "msNavigationService", "$q"];
            function UpgradedService($rootScope, $http, properties, msNavigationService, $q) {
                var _this = this;
                this.$rootScope = $rootScope;
                this.$http = $http;
                this.properties = properties;
                this.msNavigationService = msNavigationService;
                this.$q = $q;
                this.upgradedMenuItemsCache = [];
                $rootScope.$on("user:logged", function () { return _this.loadUpgradedMenuItems(); });
                $rootScope.$on("user:exited", function () { return _this.logoutFromUpgraded(); });
                $rootScope.$on("user:exited", function () { return _this.resetUpgradedMenuItems(); });
            }
            UpgradedService.prototype.loadUpgradedMenuItems = function () {
                var _this = this;
                this.upgradedMenuItems().then(function (menus) {
                    for (var _i = 0, menus_1 = menus; _i < menus_1.length; _i++) {
                        var menu = menus_1[_i];
                        if (menu.menuItems.length > 0) {
                            var id = "upgraded#" + menu.id;
                            _this.msNavigationService.saveItem(id, {
                                title: menu.description,
                                translation: menu.description,
                                group: true,
                                weight: 5
                            });
                            _this.fillSubmenus(menu.id, id, menu.menuItems);
                        }
                    }
                });
                this.msNavigationService.sort();
            };
            UpgradedService.prototype.fillSubmenus = function (context, parentId, submenus) {
                for (var _i = 0, submenus_1 = submenus; _i < submenus_1.length; _i++) {
                    var submenuItem = submenus_1[_i];
                    var id = parentId + "." + submenuItem.id;
                    var navigationMenu = {
                        title: submenuItem.description,
                        translation: "Consulta"
                    };
                    if (submenuItem.icon) {
                        navigationMenu["icon"] = submenuItem.icon;
                    }
                    if (submenuItem.url) {
                        navigationMenu["state"] = "app.upgraded({url: '" + submenuItem.url + "'})";
                    }
                    this.msNavigationService.saveItem(id, navigationMenu);
                    if (submenuItem.menuItems) {
                        this.fillSubmenus(context, id, submenuItem.menuItems);
                    }
                }
            };
            UpgradedService.prototype.resetUpgradedMenuItems = function () {
                var navigation = this.msNavigationService.getNavigation();
                _.remove(navigation, function (nav) { return nav._id.indexOf("upgraded#") === 0; });
            };
            UpgradedService.prototype.upgradedMenuItems = function () {
                var _this = this;
                if (!this.upgradedMenuItemsCache) {
                    return this.$http.get(this.properties.apiUrl + "/integracoes-modulos/api/upgraded/menus")
                        .then(function (response) {
                        _this.upgradedMenuItemsCache = response.data;
                        return response.data;
                    });
                }
                else {
                    return this.$q.when(this.upgradedMenuItemsCache);
                }
            };
            UpgradedService.prototype.logoutFromUpgraded = function () {
                var _this = this;
                this.upgradedMenuItems().then(function (items) {
                    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                        var legacyMenuItem = items_1[_i];
                        var request = {
                            method: "GET",
                            url: legacyMenuItem.baseUrl + "/" + legacyMenuItem.logoutUrl,
                            headers: _this.emptyHeaders()
                        };
                        _this.$http(request);
                    }
                });
            };
            UpgradedService.prototype.emptyHeaders = function () {
                var headers = angular.copy(this.$http.defaults.headers.common);
                for (var key in headers) {
                    headers[key] = undefined;
                }
                return headers;
            };
            return UpgradedService;
        }());
        upgraded.UpgradedService = UpgradedService;
        angular
            .module("app.upgraded")
            .service("app.upgraded.UpgradedService", UpgradedService);
    })(upgraded = app.upgraded || (app.upgraded = {}));
})(app || (app = {}));



var app;
(function (app) {
    var upgraded;
    (function (upgraded) {
        "use strict";
        var UpgradedController = /** @class */ (function () {
            /** @ngInject **/
            UpgradedController.$inject = ["app.upgraded.UpgradedCommunicationService", "$window", "$rootScope", "$sce", "$timeout", "$stateParams", "$state", "properties"];
            function UpgradedController(upgradedCommunicationService, $window, $rootScope, $sce, $timeout, $stateParams, $state, properties) {
                var _this = this;
                this.upgradedCommunicationService = upgradedCommunicationService;
                this.$window = $window;
                this.$rootScope = $rootScope;
                this.$sce = $sce;
                this.$timeout = $timeout;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.properties = properties;
                this.hide = true;
                this.parentUrl = this.$window.location.origin;
                if ($state.current.name === "app.upgraded") {
                    this.frameUrl = $sce.trustAsResourceUrl("" + this.properties.upgradedUrl + $state.params["url"]); // Carrega a UI2 inicialmente na rota vazia.
                    this.hide = false;
                }
                else {
                    if (this.properties.upgradedLoadStrategy === "eager") { // Eager
                        this.frameUrl = $sce.trustAsResourceUrl(this.properties.upgradedUrl + "empty"); // Carrega a UI2 inicialmente na rota vazia.
                    }
                }
                this.currentStateChangeRequest = this.upgradedCommunicationService.getCurrentStateChangeRequest();
                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
                    // Exibe ou esconde a view upgraded a depender se a rota que foi acessada é upgraded ou não.
                    if (toState.name === "app.upgraded") {
                        _this.hide = false;
                    }
                    else {
                        _this.hide = true;
                    }
                });
                $rootScope.$on('upgraded:frame-url-changed', function (event, newUrl) {
                    console.log(newUrl);
                    _this.frameUrl = $sce.trustAsResourceUrl("" + _this.properties.upgradedUrl + newUrl); // Carrega a UI2 inicialmente na rota vazia.
                });
            }
            return UpgradedController;
        }());
        upgraded.UpgradedController = UpgradedController;
        angular
            .module('app.upgraded')
            .controller('app.upgraded.UpgradedController', UpgradedController);
    })(upgraded = app.upgraded || (app.upgraded = {}));
})(app || (app = {}));



var app;
(function (app) {
    var upgraded;
    (function (upgraded) {
        var UpgradedFrame = /** @class */ (function () {
            function UpgradedFrame(upgradedCommunicationService, $stateParams) {
                this.upgradedCommunicationService = upgradedCommunicationService;
                this.$stateParams = $stateParams;
                this.restrict = "A";
                this.scope = {
                    parentUrl: "=stfUpgradedFrame",
                    stateChangeRequest: "=stfUpgradedFrameStateChangeRequest"
                };
            }
            UpgradedFrame.factory = function () {
                return ["app.upgraded.UpgradedCommunicationService", "$stateParams", function (upgradedCommunicationService, $stateParams) {
                    "ngInject";
                    return new UpgradedFrame(upgradedCommunicationService, $stateParams);
                }];
            };
            UpgradedFrame.prototype.link = function (scope, element, attrs) {
                var _this = this;
                var iframe = element[0];
                var iframeElementContentWindow = function () {
                    return iframe.contentWindow;
                };
                iframe.addEventListener("load", function () {
                    iframeElementContentWindow().postMessage({ "type": "upgraded", "operation": "load-upgraded-css" }, "*");
                    _this.upgradedCommunicationService.setUi2AlreadyLoaded(true);
                });
                scope.$watch("stateChangeRequest.request", function (newVal) {
                    if (newVal) {
                        iframeElementContentWindow().postMessage({ "type": "upgraded", "operation": "changeUrl", "data": newVal.url }, "*");
                    }
                });
                scope.$on("upgraded:callback", function (event, data) {
                    iframeElementContentWindow().postMessage({ "operation": "callback", "data": { id: data.id, data: data.data } }, "*");
                });
            };
            return UpgradedFrame;
        }());
        upgraded.UpgradedFrame = UpgradedFrame;
        angular.module("app.upgraded").directive("stfUpgradedFrame", UpgradedFrame.factory());
    })(upgraded = app.upgraded || (app.upgraded = {}));
})(app || (app = {}));



var app;
(function (app) {
    var upgraded;
    (function (upgraded) {
        "use strict";
        var UpgradedCommunicationService = /** @class */ (function () {
            /** @ngInject **/
            UpgradedCommunicationService.$inject = ["$window", "$rootScope", "$state", "msNavigationService", "$stateParams", "$http", "properties", "$q", "stylesLoadingService", "$ocLazyLoad", "$mdDialog", "$translate", "$injector"];
            function UpgradedCommunicationService($window, $rootScope, $state, msNavigationService, $stateParams, $http, properties, $q, stylesLoadingService, $ocLazyLoad, $mdDialog, $translate, $injector) {
                var _this = this;
                this.$window = $window;
                this.$rootScope = $rootScope;
                this.$state = $state;
                this.msNavigationService = msNavigationService;
                this.$stateParams = $stateParams;
                this.$http = $http;
                this.properties = properties;
                this.$q = $q;
                this.stylesLoadingService = stylesLoadingService;
                this.$ocLazyLoad = $ocLazyLoad;
                this.$mdDialog = $mdDialog;
                this.$translate = $translate;
                this.$injector = $injector;
                this.ui2AlreadyLoaded = false;
                this.currentStateChangeRequest = {
                    request: null
                };
                $window.addEventListener("message", function (event) { return _this.handleMessage(event); }, false);
                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
                    if (toState.name === "app.upgraded") {
                        if ($state.$current["name"] !== "app.upgraded") {
                            if (!_this.hasUi2AlreadyLoaded()) {
                                _this.$rootScope.$broadcast("upgraded:frame-url-changed", toParams.url);
                            }
                        }
                        _this.currentStateChangeRequest.request = {
                            url: toParams.url
                        };
                        _this.updateUrl(toParams.url);
                    }
                    else {
                        if ($state.$current["name"] === "app.upgraded") {
                            _this.currentStateChangeRequest.request = {
                                url: "/empty"
                            };
                        }
                    }
                });
                $rootScope.$on("user:exited", function () {
                    _this.ui2AlreadyLoaded = false;
                });
            }
            UpgradedCommunicationService.prototype.handleMessage = function (message) {
                if (message.data.type === "upgraded") {
                    if (message.data.operation === "startedLoadingRoute") {
                        this.$rootScope["loadingProgress"] = true;
                        this.$rootScope.$apply();
                    }
                    else if (message.data.operation === "finishedLoadingRoute") {
                        this.$rootScope["loadingProgress"] = false;
                        this.$rootScope.$apply();
                        if (message.data.url) {
                            this.updateUrl(message.data.url.slice(1));
                        }
                    }
                    else if (message.data.operation === "changeStfDigitalState") {
                        this.$state.go(message.data.state);
                    }
                    else if (message.data.operation === "eventBroadcast") {
                        this.$rootScope.$broadcast(message.data.event.name, message.data.event.payload);
                    }
                }
            };
            UpgradedCommunicationService.prototype.updateUrl = function (url) {
                if (url === "tarefas") {
                    // TODO Redirecionar para tarefas da UI1.
                }
                else {
                    this.$state.transitionTo("app.upgraded", {
                        url: url
                    }, {
                        location: true,
                        inherit: false,
                        relative: this.$state.$current,
                        notify: false
                    });
                    this.$stateParams["url"] = url;
                    this.$rootScope.$broadcast("upgradedRouteChanged");
                }
            };
            UpgradedCommunicationService.prototype.getCurrentStateChangeRequest = function () {
                return this.currentStateChangeRequest;
            };
            UpgradedCommunicationService.prototype.setUi2AlreadyLoaded = function (value) {
                this.ui2AlreadyLoaded = value;
            };
            UpgradedCommunicationService.prototype.hasUi2AlreadyLoaded = function () {
                return this.ui2AlreadyLoaded;
            };
            return UpgradedCommunicationService;
        }());
        upgraded.UpgradedCommunicationService = UpgradedCommunicationService;
        angular
            .module('app.upgraded')
            .service('app.upgraded.UpgradedCommunicationService', UpgradedCommunicationService);
    })(upgraded = app.upgraded || (app.upgraded = {}));
})(app || (app = {}));



var app;
(function (app) {
    var ultimosAcessos;
    (function (ultimosAcessos) {
        "use strict";
        /** @ngInject **/
        config.$inject = ["$translatePartialLoaderProvider", "$stateProvider", "msNavigationServiceProvider"];
        function config($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
            $translatePartialLoaderProvider.addPart("app/main/ultimos-acessos");
            $stateProvider
                .state("app.ultimos-acessos", {
                url: "/ultimos-acessos",
                views: {
                    "content@app.autenticado": {
                        templateUrl: "app/main/ultimos-acessos/ultimos-acessos.html",
                        controller: ultimosAcessos.UltimosAcessosController,
                        controllerAs: "vm"
                    }
                },
                resolve: {
                    ultimosAcessos: ["app.ultimos-acessos.UltimosAcessosService", function (ultimosAcessosService) {
                            return ultimosAcessosService.acessos();
                        }]
                }
            })
                .state("app.ultimos-acessos.todos", {
                url: "/todos"
            })
                .state("app.ultimos-acessos.peticoes", {
                url: "/peticoes"
            })
                .state("app.ultimos-acessos.processos", {
                url: "/processos"
            })
                .state("app.ultimos-acessos.pecas", {
                url: "/pecas"
            });
            msNavigationServiceProvider.saveItem("ultimos-acessos", {
                title: "Últimos Acessos",
                icon: "icon-history",
                state: "app.ultimos-acessos",
                translation: "ULTIMOS-ACESSOS.ULTIMOS-ACESSOS",
                weight: 6
            });
        }
        angular
            .module("app.ultimos-acessos", [])
            .config(config);
    })(ultimosAcessos = app.ultimosAcessos || (app.ultimosAcessos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var ultimosAcessos;
    (function (ultimosAcessos) {
        'use strict';
        var UltimosAcessosService = /** @class */ (function () {
            /** @ngInject **/
            UltimosAcessosService.$inject = ["$q"];
            function UltimosAcessosService($q) {
                this.$q = $q;
            }
            UltimosAcessosService.prototype.acessos = function () {
                var deferred = this.$q.defer();
                deferred.resolve(UltimosAcessosService.mockAcessos());
                return deferred.promise;
            };
            UltimosAcessosService.mockAcessos = function () {
                return [
                    {
                        "name": "AP 470",
                        "type": {
                            "name": "Processo",
                            "icon": {
                                "name": "icon-folder",
                                "color": "#FFB300"
                            }
                        },
                        "last_update_by": "leandro.rezende",
                        "size": null,
                        "updated_at": 1448892351
                    },
                    {
                        "name": "ADI 100",
                        "type": {
                            "name": "Processo",
                            "icon": {
                                "name": "icon-folder",
                                "color": "#FFB300"
                            }
                        },
                        "last_update_by": "leandro.rezende",
                        "size": null,
                        "updated_at": 1422743429
                    },
                    {
                        "name": "AP 470 Mérito",
                        "type": {
                            "name": "Processo",
                            "icon": {
                                "name": "icon-folder",
                                "color": "#FFB300"
                            }
                        },
                        "last_update_by": "leandro.rezende",
                        "size": null,
                        "updated_at": 1442087478
                    },
                    {
                        "name": "AP 470 - Petição inicial",
                        "type": {
                            "name": "Peça",
                            "icon": {
                                "name": "icon-file-document",
                                "color": "#1565C0"
                            }
                        },
                        "last_update_by": "leandro.rezende",
                        "size": 729434384,
                        "updated_at": 1438505648
                    },
                    {
                        "name": "AP 470 - Prova 3",
                        "type": {
                            "name": "Peça",
                            "icon": {
                                "name": "icon-file-document",
                                "color": "#1565C0"
                            }
                        },
                        "last_update_by": "joao.silva",
                        "size": 751451839,
                        "updated_at": 1420360288
                    },
                    {
                        "name": "2345/2015",
                        "type": {
                            "name": "Petição",
                            "icon": {
                                "name": "icon-table-large",
                                "color": "#4CAF50"
                            }
                        },
                        "last_update_by": "leandro.rezende",
                        "size": 135204823,
                        "updated_at": 1448124630
                    },
                    {
                        "name": "AP 470 - Prova 4",
                        "type": {
                            "name": "Peça",
                            "icon": {
                                "name": "icon-file-document",
                                "color": "#1565C0"
                            }
                        },
                        "last_update_by": "leandro.rezende",
                        "size": 382447739,
                        "updated_at": 1435705066
                    },
                    {
                        "name": "AP 470 - Prova 5",
                        "type": {
                            "name": "Peça",
                            "icon": {
                                "name": "icon-file-document",
                                "color": "#1565C0"
                            }
                        },
                        "last_update_by": "leandro.rezende",
                        "size": 48694542,
                        "updated_at": 1434653523
                    },
                    {
                        "name": "234345/2015",
                        "type": {
                            "name": "Petição",
                            "icon": {
                                "name": "icon-table-large",
                                "color": "#4CAF50"
                            }
                        },
                        "last_update_by": "leandro.rezende",
                        "size": 62740446,
                        "updated_at": 1421683665
                    },
                ];
            };
            return UltimosAcessosService;
        }());
        ultimosAcessos.UltimosAcessosService = UltimosAcessosService;
        angular
            .module('app.ultimos-acessos')
            .service('app.ultimos-acessos.UltimosAcessosService', UltimosAcessosService);
    })(ultimosAcessos = app.ultimosAcessos || (app.ultimosAcessos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var ultimosAcessos;
    (function (ultimosAcessos_1) {
        'use strict';
        var UltimosAcessosController = /** @class */ (function () {
            /** @ngInject **/
            UltimosAcessosController.$inject = ["$filter", "$state", "ultimosAcessos"];
            function UltimosAcessosController($filter, $state, ultimosAcessos) {
                this.$filter = $filter;
                this.$state = $state;
                this.ultimosAcessos = ultimosAcessos;
                this.ultimosAcessosOrig = angular.copy(ultimosAcessos);
                this.ultimosAcessosDtOptions = this.defineUltimosAcessosDtOptions();
            }
            UltimosAcessosController.prototype.foo = function () {
            };
            UltimosAcessosController.prototype.setActiveFilter = function (index) {
                var newActiveFilter = (index !== this.activeFilter);
                this.activeFilter = index;
                if (newActiveFilter) {
                    this.updateFilterObject();
                }
            };
            UltimosAcessosController.prototype.isTabActive = function (stateName, index) {
                var active = this.$state.current.name == stateName;
                if (active) {
                    this.setActiveFilter(index);
                }
                return active;
            };
            UltimosAcessosController.prototype.updateFilterObject = function () {
                switch (this.activeFilter) {
                    case 0:
                        this.filterObject = {};
                        break;
                    case 1:
                        this.filterObject = { type: { name: "Petição" } };
                        break;
                    case 2:
                        this.filterObject = { type: { name: "Processo" } };
                        break;
                    case 3:
                        this.filterObject = { type: { name: "Peça" } };
                        break;
                }
                this.ultimosAcessos = this.$filter(this.ultimosAcessosOrig, this.filterObject);
            };
            UltimosAcessosController.prototype.defineUltimosAcessosDtOptions = function () {
                return {
                    dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                    pagingType: 'simple',
                    autoWidth: true,
                    responsive: false,
                    searching: false,
                    columns: [
                        null,
                        null,
                        null,
                        null,
                        { iDataSort: 5 },
                        { bVisible: false },
                        null,
                        null
                    ]
                };
            };
            return UltimosAcessosController;
        }());
        ultimosAcessos_1.UltimosAcessosController = UltimosAcessosController;
        angular
            .module('app.ultimos-acessos')
            .controller('app.ultimos-acessos.UltimosAcessosController', UltimosAcessosController);
    })(ultimosAcessos = app.ultimosAcessos || (app.ultimosAcessos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var toolbar;
    (function (toolbar) {
        'use strict';
        var ToolbarService = /** @class */ (function () {
            function ToolbarService() {
                this.configurations = [];
            }
            ToolbarService.prototype.pushConfiguration = function (configuration) {
                this.configurations.push(configuration);
            };
            ToolbarService.prototype.clearConfigurations = function () {
                while (this.configurations.length > 0) {
                    this.configurations.pop();
                }
            };
            ToolbarService.prototype.getConfigurations = function () {
                return this.configurations.sort(function (a, b) {
                    if (a.order < b.order)
                        return 1;
                    if (a.order > b.order)
                        return -1;
                    return 0;
                });
            };
            return ToolbarService;
        }());
        toolbar.ToolbarService = ToolbarService;
        angular.module("app.toolbar").service("toolbarService", ToolbarService);
    })(toolbar = app.toolbar || (app.toolbar = {}));
})(app || (app = {}));



var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var app;
(function (app) {
    var toolbar;
    (function (toolbar) {
        'use strict';
        var ToolbarController = /** @class */ (function () {
            /** @ngInject **/
            ToolbarController.$inject = ["$scope", "$state", "$mdSidenav", "$window", "$mdMedia", "$rootScope", "$mdDialog", "msNavigationService", "authService", "$q", "informacaoService", "messagesService", "commandService", "properties", "toolbarService", "app.toolbar.alterar-conta.GestaoContaService"];
            function ToolbarController($scope, $state, $mdSidenav, $window, $mdMedia, $rootScope, $mdDialog, msNavigationService, authService, $q, informacaoService, messagesService, commandService, properties, toolbarService, gestaoContaService) {
                var _this = this;
                this.$state = $state;
                this.$mdSidenav = $mdSidenav;
                this.$window = $window;
                this.$mdMedia = $mdMedia;
                this.$rootScope = $rootScope;
                this.$mdDialog = $mdDialog;
                this.msNavigationService = msNavigationService;
                this.authService = authService;
                this.$q = $q;
                this.informacaoService = informacaoService;
                this.messagesService = messagesService;
                this.commandService = commandService;
                this.properties = properties;
                this.toolbarService = toolbarService;
                this.gestaoContaService = gestaoContaService;
                this.unreadFeed = 0;
                this.searchBar = false;
                this.configuracoes = [];
                this.secondaryAccounts = [];
                this.accounts = [];
                this.bodyEl = angular.element('body');
                $scope.$watch(function () {
                    return $mdMedia('gt-sm');
                }, function () { return _this.updateNavigation(); });
                this.authService.getUser().then(function (user) {
                    _this.nome = user.nome;
                    _this.login = user.login;
                    _this.lotacao = user.lotacao;
                    _this.accounts = user.contas;
                    _this.mainAccount = user.contas.find(function (c) { return user.lotacao === c.codigo; });
                    _this.secondaryAccounts = user.contas.filter(function (c) { return user.lotacao !== c.codigo; });
                    _this.orderSecondaryAccounts();
                });
                this.folded = true;
                $scope.$on("feed", function () {
                    _this.unreadFeed += 1;
                });
                $scope.$on("feed:unread", function (event, unreadFeed) {
                    _this.unreadFeed = unreadFeed;
                });
                $scope.$on("integracoes-identidades:conta-atual-alterada", function (event, notification) {
                    var novaLotacao = notification.content;
                    if (_this.lotacao !== novaLotacao) {
                        _this.authService.clearCache();
                        _this.$window.location.reload();
                    }
                });
                // Verificando se o usuário logado possui permissão para consultar informações judiciais
                this.commandService.findByIdAndContext("pesquisar-informacoes", "integracoes-processos").then(function () {
                    _this.searchBar = true;
                });
                $scope.$on("navigationToggledFolded", function () {
                    _this.updateNavigation();
                });
                $scope.$watch(function () {
                    return _this.toolbarService.getConfigurations().length;
                }, function (length) {
                    if (length) {
                        _this.configuracoes = [];
                        for (var _i = 0, _a = _this.toolbarService.getConfigurations(); _i < _a.length; _i++) {
                            var configuration = _a[_i];
                            _this.configuracoes.unshift(configuration);
                        }
                    }
                });
            }
            ToolbarController.prototype.changeAccount = function (event, conta) {
                var _this = this;
                this.$mdDialog.show({
                    clickOutsideToClose: true,
                    controller: 'app.toolbar.AlterarContaController',
                    locals: {
                        setorId: conta.codigo
                    },
                    controllerAs: 'vm',
                    templateUrl: 'app/main/toolbar/modals/alterar-conta/alterar-conta.html',
                    parent: angular.element(document.body),
                    targetEvent: event
                }).then(function () { return _this.alterarContaAtual(conta); });
            };
            ToolbarController.prototype.alterarContaAtual = function (conta) {
                var _this = this;
                this.definirContaComoAtual(conta);
                this.mainAccount = this.accounts.find(function (c) { return _this.lotacao === c.codigo; });
                this.secondaryAccounts = this.accounts.filter(function (c) { return _this.lotacao !== c.codigo; });
                this.orderSecondaryAccounts();
            };
            ToolbarController.prototype.orderSecondaryAccounts = function () {
                this.secondaryAccounts.sort(function (a, b) { return (a.nome < b.nome) ? -1 : 1; });
            };
            ToolbarController.prototype.definirContaComoAtual = function (conta) {
                this.accounts = this.accounts.map(function (obj) {
                    if (obj.codigo === conta.codigo) {
                        return __assign({}, obj, { atual: true });
                    }
                    return __assign({}, obj, { atual: false });
                });
            };
            ToolbarController.prototype.toggleNavigation = function () {
                if (this.$mdMedia('gt-sm')) {
                    this.msNavigationService.toggleFolded();
                }
                else {
                    this.toggleSidenav('navigation');
                }
                this.updateNavigation();
            };
            ToolbarController.prototype.getFolded = function () {
                if (this.folded === null) {
                    return true;
                }
                return this.folded;
            };
            /**
             * Toggle sidenav
             *
             * @param sidenavId
             */
            ToolbarController.prototype.toggleSidenav = function (sidenavId) {
                var _this = this;
                this.$mdSidenav(sidenavId).toggle()
                    .then(function () {
                    if (_this.unreadFeed) {
                        _this.$rootScope.$broadcast('feed:readed');
                    }
                    _this.unreadFeed = 0;
                });
            };
            ToolbarController.prototype.hasPermission = function () {
                return this.searchBar;
            };
            /**
             * Busca adaptada para encontrar informações processuais
             *
             * <p>Originalmente, era usada pelo template para buscar funcionalidades
             *
             * @param query a identificação da informação
             * @returns {Promise}
             */
            ToolbarController.prototype.search = function (query) {
                var _this = this;
                var navigation = [];
                var deferred = this.$q.defer();
                this.informacaoService.informacoes(query).then(function (informacoes) {
                    if (query.length !== 0) {
                        for (var _i = 0, informacoes_1 = informacoes; _i < informacoes_1.length; _i++) {
                            var informacao = informacoes_1[_i];
                            navigation.push({
                                title: informacao.descricao,
                                description: informacao.tipoDeIdentificacao,
                                icon: informacao.icon,
                                state: informacao.state,
                                id: informacao.identificacao.replace('/', '-'),
                                url: informacao.url
                            });
                        }
                    }
                    else {
                        navigation = null;
                    }
                    deferred.resolve(navigation);
                }, function (error) {
                    deferred.reject(error.status);
                    switch (error.status) {
                        case 404: {
                            _this.messagesService.error("Serviço de consulta temporariamente indisponível.");
                            break;
                        }
                        case 408: {
                            _this.messagesService.warn("A consulta para o termo [" + query + "] está demorando mais do que o permitido, provavelmente devido ao excesso de resultados. Por favor, refine o termo pesquisado.", 12000);
                            break;
                        }
                        case 413: {
                            _this.messagesService.warn("A consulta para o termo [" + query + "] encontrou mais registros do que o permitido para essa funcionalidade. Por favor, refine os termos de sua consulta ou acesse a pesquisa avançada disponível no Pesquisa Acervo Processual.", 12000);
                            break;
                        }
                        default: {
                            _this.messagesService.error("Ocorreu um erro inesperado. Por favor, entre em contato com a STI para reportar o incidente.");
                            break;
                        }
                    }
                });
                return deferred.promise;
            };
            /**
             * Recupera a consultas registradas recentemente.
             *
             * @returns a lista de consultas recentes
             */
            ToolbarController.prototype.searchRecents = function () {
                var recents = [];
                for (var _i = 0, _a = this.informacaoService.getHistorico(); _i < _a.length; _i++) {
                    var informacao = _a[_i];
                    if (informacao.tipo === "processo") {
                        recents.push({
                            title: "Processo " + informacao.descricao,
                            description: "Número",
                            icon: "icon-folder-multiple",
                            state: "app.informacoes.processos",
                            id: informacao.identificacao,
                            url: "informacoes/processos/:id"
                        });
                    }
                    if (informacao.tipo === "peticao") {
                        recents.push({
                            title: "Petição " + informacao.descricao,
                            description: "Número e Ano",
                            icon: "icon-file-document",
                            state: "app.informacoes.peticoes",
                            id: informacao.identificacao,
                            url: "informacoes/peticoes/:id"
                        });
                    }
                    if (informacao.tipo === "protocolo") {
                        recents.push({
                            title: "Protocolo " + informacao.descricao,
                            description: "Número e Ano",
                            icon: "icon-file-document",
                            state: "app.informacoes.protocolos",
                            id: informacao.identificacao,
                            url: "informacoes/protocolos/:id"
                        });
                    }
                }
                return recents;
            };
            /**
             * Search result click action
             *
             * @param item
             */
            ToolbarController.prototype.searchResultClick = function (item) {
                if (!!item) {
                    this.$state.go(item.state, { 'id': item.id });
                }
            };
            /**
             * Sets User Status
             * @param status
             */
            ToolbarController.prototype.setUserStatus = function (status) {
                this.userStatus = status;
            };
            /**
             * Logout Function
             */
            ToolbarController.prototype.logout = function () {
                var _this = this;
                this.authService.logout().then(function () {
                    _this.$state.go('app.login');
                });
            };
            /**
             * Logout Function
             */
            ToolbarController.prototype.logoutAll = function () {
                var _this = this;
                this.authService.logoutAll().then(function () {
                    _this.$state.go('app.login');
                });
            };
            /**
             * Toggle horizontal mobile menu
             */
            ToolbarController.prototype.toggleHorizontalMobileMenu = function () {
                this.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
            };
            ToolbarController.prototype.updateNavigation = function () {
                if (this.$mdMedia('gt-sm')) {
                    this.folded = this.msNavigationService.getFolded();
                }
                else {
                    this.folded = this.$mdSidenav('navigation').isOpen();
                }
            };
            ToolbarController.prototype.openDocs = function () {
                window.open(this.properties.apiUrl + "/integracoes-documentacao/index.html", '_blank');
            };
            ToolbarController.prototype.openProfile = function () {
                this.$state.go("app.configuracoes.gerenciar-usuarios.perfil");
            };
            return ToolbarController;
        }());
        toolbar.ToolbarController = ToolbarController;
        angular
            .module('app.toolbar')
            .controller('app.ToolbarController', ToolbarController);
    })(toolbar = app.toolbar || (app.toolbar = {}));
})(app || (app = {}));



var app;
(function (app) {
    var toolbar;
    (function (toolbar) {
        'use strict';
        var InformacaoService = /** @class */ (function () {
            /** @ngInject */
            InformacaoService.$inject = ["$http", "properties", "$cookies", "$state", "$q", "stylesLoadingService", "$ocLazyLoad", "$rootScope", "$mdSidenav"];
            function InformacaoService($http, properties, $cookies, $state, $q, stylesLoadingService, $ocLazyLoad, $rootScope, $mdSidenav) {
                var _this = this;
                this.$http = $http;
                this.properties = properties;
                this.$cookies = $cookies;
                this.$state = $state;
                this.$q = $q;
                this.stylesLoadingService = stylesLoadingService;
                this.$ocLazyLoad = $ocLazyLoad;
                this.$rootScope = $rootScope;
                this.$mdSidenav = $mdSidenav;
                this.consultas = new Map();
                if (!this.$cookies.get("historico")) {
                    this.$cookies.put("historico", JSON.stringify([]));
                }
                $rootScope.$on("stf:ui1:visualizar-informacao-sidenav", function (event, args) {
                    _this.registrarInformacao(args)
                        .then(function () { return _this.$mdSidenav("info-viewer").open(); });
                });
            }
            /**
             * Recupera a lista de informações para uma data identificação.
             *
             * @param identificacao a identificação da informação desejada
             * @returns {*} a lista de informações
             */
            InformacaoService.prototype.informacoes = function (identificacao) {
                var url = "" + (this.properties.apiUrl + InformacaoService.serviceApi);
                return this.$http
                    .get(url + "?identificacao=" + encodeURIComponent(identificacao))
                    .then(function (response) { return response.data; });
            };
            /**
             * Registra a um determinado tipo de consulta, como a consulta de processo, por exemplo.
             *
             * <p> Usado para viabilizar o mecanismo de consultas rápidas.
             *
             * @param consulta um tipo de consulta
             */
            InformacaoService.prototype.registrarConsulta = function (consulta) {
                var _this = this;
                return this
                    .carregarDependencias(consulta.dependencias)
                    .then(function () { return _this.consultas.set(consulta.tipo, consulta); });
            };
            /**
             * Indica se a consulta rápida está disponível. Estará disponível se um consulta estiver registrada,
             * se uma informação estiver registrada e se a esta consulta não estiver sendo usada pelo
             * usuário no momento.
             */
            InformacaoService.prototype.getConsulta = function () {
                return this.getViewer() && this.getInformacao() && this.$state.current.name !== this.getViewer().state;
            };
            /**
             * Retorna o tipo de viewer registrado.
             */
            InformacaoService.prototype.getViewer = function () {
                if (this.getInformacao()) {
                    return this.consultas.get(this.getInformacao().tipo);
                }
                return null;
            };
            /**
             * Usado para registrar uma informação consultada como, por exemplo, um processo.
             *
             * @param informacao a informação consultada
             */
            InformacaoService.prototype.registrarInformacao = function (informacao) {
                var _this = this;
                var promise = this.carregarDependencias(informacao["dependencias"]);
                return promise.then(function () {
                    // A informação consultada deve ser armazenada em um histórico de informações consultadas recentemente
                    var historico = _this.getHistorico();
                    // Verificando se a informação já está no histórico de consultas recentes
                    var index = historico.findIndex(function (h) { return h["identificacao"] === informacao["identificacao"]; });
                    if (index >= 0) {
                        // Se estiver no histórico, remove e recoloca no topo da lista
                        historico.splice(index, 1);
                        historico.unshift(informacao);
                    }
                    else {
                        // Caso contrário, remove a mais velha,
                        // caso tenha alçado o número máximo de consultas do histórico, e coloca a nova consulta
                        if (historico.length === InformacaoService.TAMANHO_HISTORICO_CONSULTAS) {
                            historico.pop();
                        }
                        historico.unshift(informacao);
                    }
                    // Por fim, atualiza o cookie com a o histórico renovado
                    _this.$cookies.put("historico", JSON.stringify(historico));
                });
            };
            /**
             * Recupera a última informação consultada
             */
            InformacaoService.prototype.getInformacao = function () {
                // Se houver alguma consulta registrada no histórico, recupera a mais recente
                if (this.getHistorico().length > 0) {
                    return this.getHistorico()[0];
                }
                ;
                // Caso contrário, retorna null
                return null;
            };
            /**
             * Retorna o histórico de consultas do cookie correspondente.
             */
            InformacaoService.prototype.getHistorico = function () {
                return JSON.parse(this.$cookies.get("historico"));
            };
            /**
             * Carrega uma lista de módulos demandados pelo cliente.
             *
             * @param dependencias os módulo necessários
             *
             * TODO Rodrigo Barreiros Me parece que esse código quebra a coesão desta service. Acho que uma
             * solução melhor seria centralizar o código responsável pelo mecanismo de modularização
             * em um componente específico.
             */
            InformacaoService.prototype.carregarDependencias = function (dependencias) {
                var _this = this;
                if (dependencias) {
                    return this.$q.all(dependencias.map(function (dependencia) {
                        var contexto = dependencia.split("/")[0];
                        var bundle = contexto + '/bundle';
                        var styleUrl = SystemJS.baseURL + contexto + '/style.css';
                        return _this.$q.all([System.import(bundle), _this.stylesLoadingService.loadStyle(styleUrl)]);
                    })).then(function () {
                        return _this.$q.all(dependencias.map(function (modulePath) {
                            return _this.$q.when(System.import(modulePath).then(function (importedModule) {
                                var newModule = importedModule;
                                if (!importedModule.name) {
                                    var key = Object.keys(importedModule);
                                    newModule = importedModule[key[0]];
                                }
                                return _this.$q.when(_this.$ocLazyLoad.load(newModule));
                            }));
                        }));
                    });
                }
                else {
                    return this.$q.when();
                }
            };
            InformacaoService.serviceApi = "/integracoes-processos/api/processos";
            InformacaoService.TAMANHO_HISTORICO_CONSULTAS = 3;
            return InformacaoService;
        }());
        toolbar.InformacaoService = InformacaoService;
        angular.module("app.toolbar").service("informacaoService", InformacaoService);
    })(toolbar = app.toolbar || (app.toolbar = {}));
})(app || (app = {}));



var app;
(function (app) {
    var toolbar;
    (function (toolbar) {
        'use strict';
        var GestaoContaService = /** @class */ (function () {
            /** @ngInject */
            GestaoContaService.$inject = ["$http", "properties"];
            function GestaoContaService($http, properties) {
                this.$http = $http;
                this.ACCOUNTS_API_URL = properties.apiUrl + "/integracoes-identidades/api/acessos/contas/setores";
            }
            GestaoContaService.prototype.alterarContaAtual = function (setorId) {
                return this.$http.put(this.ACCOUNTS_API_URL + "/" + setorId + "/atual", {});
            };
            return GestaoContaService;
        }());
        toolbar.GestaoContaService = GestaoContaService;
        var SERVICE_NAME = "app.toolbar.alterar-conta.GestaoContaService";
        var config = /** @ngInject */ ["errorHandlerProvider", "$provide", function (errorHandlerProvider, $provide) {
            errorHandlerProvider.decorate($provide, SERVICE_NAME);
        }];
        config.$inject = ["errorHandlerProvider", "$provide"];
        angular.module("app.toolbar").service(SERVICE_NAME, GestaoContaService).config(config);
    })(toolbar = app.toolbar || (app.toolbar = {}));
})(app || (app = {}));



var app;
(function (app) {
    var quickPanel;
    (function (quickPanel) {
        'use strict';
        var QuickPanelController = /** @class */ (function () {
            /** @ngInject **/
            function QuickPanelController() {
            }
            return QuickPanelController;
        }());
        quickPanel.QuickPanelController = QuickPanelController;
        angular
            .module('app.quick-panel')
            .controller('app.QuickPanelController', QuickPanelController);
    })(quickPanel = app.quickPanel || (app.quickPanel = {}));
})(app || (app = {}));



var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        "use strict";
        var SaveSearchCommand = /** @class */ (function () {
            function SaveSearchCommand(uuid, description, context, executable, criteria) {
                this.uuid = uuid;
                this.description = description;
                this.context = context;
                this.executable = executable;
                this.criteria = JSON.stringify(criteria);
            }
            return SaveSearchCommand;
        }());
        var ExportSearchCommand = /** @class */ (function () {
            function ExportSearchCommand(uuid, context, users) {
                this.uuid = uuid;
                this.context = context;
                this.users = users;
            }
            return ExportSearchCommand;
        }());
        var PesquisaAvancadaService = /** @class */ (function () {
            /** @ngInject **/
            PesquisaAvancadaService.$inject = ["$http", "msNavigationService", "$rootScope", "properties", "$q"];
            function PesquisaAvancadaService($http, msNavigationService, $rootScope, properties, $q) {
                var _this = this;
                this.$http = $http;
                this.msNavigationService = msNavigationService;
                this.$rootScope = $rootScope;
                this.properties = properties;
                this.$q = $q;
                this.apiSearchs = "/integracoes-modulos/api/queries/searches";
                this.apiSavedSearchs = "/integracoes-modulos/api/searches";
                this.apiExportSearchs = "/integracoes-modulos/api/searches/export";
                this.badgeValues = {};
                $rootScope.$on("user:logged", function () { return _this.loadQueries(); });
                $rootScope.$on("user:exited", function () { return _this.resetQueries(); });
                this.apiSearchs = this.properties.apiUrl + this.apiSearchs;
                this.apiSavedSearchs = this.properties.apiUrl + this.apiSavedSearchs;
                this.apiExportSearchs = this.properties.apiUrl + this.apiExportSearchs;
            }
            PesquisaAvancadaService.prototype.loadQueries = function () {
                var _this = this;
                this.$http.get(this.apiSearchs)
                    .then(function (response) {
                    response.data
                        .filter(function (pesquisa) { return angular.isObject(pesquisa.route); })
                        .forEach(function (pesquisa) { return _this.addRouteToNavigation(pesquisa); });
                });
            };
            PesquisaAvancadaService.prototype.resetQueries = function () {
                var navigation = this.msNavigationService.getNavigation();
                _.remove(navigation, function (nav) { return nav._id === "pesquisa-avancada"; });
            };
            PesquisaAvancadaService.prototype.executeSearch = function (searchApi, search) {
                var searchData = angular.copy(search);
                searchData.criteria.forEach(function (criterion) {
                    if (criterion.comparisonOperator === pesquisaAvancada.ComparisonOperator.BETWEEN) {
                        criterion.value = JSON.stringify(criterion.value); //Serializa valores de critério em array para padronizar saída
                    }
                });
                return this.$http.post(searchApi, searchData).then(function (response) {
                    return response.data;
                });
            };
            PesquisaAvancadaService.prototype.saveSearch = function (search) {
                var command = new SaveSearchCommand(search.uuid, search.description, search.context, search.executable, search.criteria);
                return this.$http.post(this.apiSavedSearchs, command)
                    .then(function (response) {
                    search.uuid = response.data;
                    return search;
                });
            };
            PesquisaAvancadaService.prototype.deleteSearch = function (search) {
                return this.$http.delete(this.apiSavedSearchs + "/" + search.context + "/" + search.uuid);
            };
            PesquisaAvancadaService.prototype.loadSavedSearchs = function (context) {
                var config = { params: { context: context } };
                return this.$http.get(this.apiSavedSearchs, config)
                    .then(function (response) { return response.data; });
            };
            PesquisaAvancadaService.prototype.exportSearch = function (uuid, context, users) {
                var command = new ExportSearchCommand(uuid, context, users);
                return this.$http.post(this.apiExportSearchs, command);
            };
            PesquisaAvancadaService.prototype.addRouteToNavigation = function (pesquisa) {
                var _this = this;
                if (!this.hasParent()) {
                    this.msNavigationService.saveItem("pesquisa-avancada", {
                        title: "PESQUISA AVANÇADA",
                        group: true,
                        translation: "PESQUISA-AVANCADA.PESQUISA-AVANCADA",
                        weight: 3
                    });
                    this.msNavigationService.sort();
                }
                if (pesquisa.route.apiBadge) {
                    this.$http.get(this.properties.apiUrl + "/" + pesquisa.route.context + "/" + pesquisa.route.apiBadge)
                        .then(function (response) {
                        var qtd = response.data;
                        _this.badgeValues[pesquisa.route.id] = qtd;
                        _this.atualizarBadge(pesquisa, qtd, false);
                    });
                }
                if (pesquisa.route.updateBadgeEventName) {
                    this.$rootScope.$on(pesquisa.route.updateBadgeEventName, function (event, toState, toParams) {
                        var qtd = _this.badgeValues[pesquisa.route.id] + toState.content;
                        _this.badgeValues[pesquisa.route.id] = qtd;
                        _this.atualizarBadge(pesquisa, 0, false);
                        if (qtd > 0) {
                            setTimeout(function () {
                                _this.atualizarBadge(pesquisa, _this.badgeValues[pesquisa.route.id], true);
                            }, 50);
                        }
                    });
                }
                this.criarRoute(pesquisa, null);
            };
            PesquisaAvancadaService.prototype.atualizarBadge = function (pesquisa, valor, alert) {
                var route = pesquisa.route;
                if (valor) {
                    this.msNavigationService.saveItem(route.navigationItem, { badge: { color: 'red', content: valor, alert: alert } });
                }
                else {
                    this.msNavigationService.saveItem(route.navigationItem, { badge: null });
                }
            };
            PesquisaAvancadaService.prototype.criarRoute = function (pesquisa, badge) {
                var route = pesquisa.route;
                var typeUi2 = !!(route.types && route.types.find(function (x) { return x == 'ui2'; }));
                if (!!route.navigationItem) {
                    if (!!route.stateName) {
                        this.msNavigationService.saveItem(route.navigationItem, {
                            title: pesquisa.description,
                            icon: (route["icon"] !== null) ? route["icon"] : "icon-magnify",
                            state: typeUi2 ? "app.upgraded({url: '" + this.removeSlashKeyAtStart(route.url) + "'})" : route.stateName,
                            translation: route.translation,
                            badge: badge
                        });
                    }
                    else {
                        // Se tem navigationItem mas não tem stateName, é um agrupador no menu.
                        this.msNavigationService.saveItem(route.navigationItem, {
                            title: route.translation,
                            group: true,
                            translation: route.translation,
                            weight: this.msNavigationService.getNavigation().length + 1
                        });
                        this.msNavigationService.sort();
                    }
                }
                else if (typeUi2 && !pesquisa.permitAll) {
                    this.msNavigationService.saveItem("pesquisa-avancada." + route.id, {
                        title: pesquisa.description,
                        icon: (route["icon"] !== null) ? route["icon"] : "icon-magnify",
                        state: "app.upgraded({url: '" + this.removeSlashKeyAtStart(route.url) + "'})",
                        translation: route.translation,
                        badge: badge
                    });
                }
            };
            PesquisaAvancadaService.prototype.removeSlashKeyAtStart = function (url) {
                if (!!url && url[0] == '/') {
                    return url.substr(1);
                }
                return url;
            };
            PesquisaAvancadaService.prototype.hasParent = function () {
                var navigation = this.msNavigationService.getNavigation();
                return navigation.filter(function (nav) { return nav._id === "pesquisa-avancada"; }).length > 0;
            };
            return PesquisaAvancadaService;
        }());
        pesquisaAvancada.PesquisaAvancadaService = PesquisaAvancadaService;
        angular
            .module("app.pesquisa-avancada")
            .service("app.pesquisa-avancada.PesquisaAvancadaService", PesquisaAvancadaService);
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));



var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        'use strict';
        var Tab;
        (function (Tab) {
            Tab[Tab["NEW_SEARCH"] = 0] = "NEW_SEARCH";
            Tab[Tab["RESULT"] = 1] = "RESULT";
            Tab[Tab["EDIT_SEARCH"] = 2] = "EDIT_SEARCH";
        })(Tab || (Tab = {}));
        var PesquisaAvancadaController = /** @class */ (function () {
            /** @ngInject **/
            PesquisaAvancadaController.$inject = ["$rootScope", "$scope", "$mdDialog", "$mdSidenav", "$sce", "$http", "$translate", "DTColumnDefBuilder", "app.pesquisa-avancada.PesquisaAvancadaService", "properties", "commandService", "messagesService", "searchConfig"];
            function PesquisaAvancadaController($rootScope, $scope, $mdDialog, $mdSidenav, $sce, $http, $translate, DTColumnDefBuilder, pesquisaAvancadaService, properties, commandService, messagesService, searchConfig) {
                var _this = this;
                this.$rootScope = $rootScope;
                this.$scope = $scope;
                this.$mdDialog = $mdDialog;
                this.$mdSidenav = $mdSidenav;
                this.$sce = $sce;
                this.$http = $http;
                this.$translate = $translate;
                this.DTColumnDefBuilder = DTColumnDefBuilder;
                this.pesquisaAvancadaService = pesquisaAvancadaService;
                this.properties = properties;
                this.commandService = commandService;
                this.messagesService = messagesService;
                this.searchConfig = searchConfig;
                this.selectedTab = Tab.NEW_SEARCH;
                this.fabActive = false;
                this.searchData = {};
                this.searchComplete = false;
                this.editEnabled = false;
                this.searchResults = [];
                this.savedSearchs = [];
                this.resultActionsTemplate = [];
                this.activeSaveAction = false;
                this.defaultSearch = { uuid: null, context: searchConfig.context, description: '', criteria: [] };
                this.newSearch = angular.copy(this.defaultSearch);
                this.search = angular.copy(this.defaultSearch);
                this.configureDatatables();
                this.loadSavedSearchs();
                this.loadResultTemplate();
                commandService.findByIdAndContext('salvar-pesquisa-avancada', 'integracoes-modulos').then(function () { return _this.activeSaveAction = true; });
                this.watchSelectedTab();
                this.watchSearchCriteria();
                this.$rootScope.$on("ui:advancedSearch:doSearch", function () { return _this.searchOnEnter(); });
            }
            /**
             * Executa uma pesquisa por enter em um campo de valor.
             */
            PesquisaAvancadaController.prototype.searchOnEnter = function () {
                if (this.canSearch()) {
                    this.messagesService.hideMessage();
                    this.doSearch();
                }
                else {
                    this.messagesService.error("Os campos da pesquisa precisam estar preenchidos corretamente!");
                }
            };
            /**
             * Verifica se uma pesquisa está válida
             */
            PesquisaAvancadaController.prototype.canSearch = function () {
                var search = (this.selectedTab === Tab.NEW_SEARCH ? this.newSearch : this.search);
                return (search.criteria.length > 0 && search.criteria.every(function (criterion) { return criterion.valid; }));
            };
            /**
             * Realiza uma pesquisa
             */
            PesquisaAvancadaController.prototype.doSearch = function () {
                var _this = this;
                var valid = false;
                if (this.selectedTab === Tab.NEW_SEARCH && this.validate(this.newSearch)) {
                    valid = true;
                    angular.copy(this.newSearch, this.search);
                    angular.copy(this.defaultSearch, this.newSearch);
                }
                else {
                    valid = this.validate(this.search);
                }
                if (valid) {
                    this.setLoadingProgress(true);
                    this.pesquisaAvancadaService.executeSearch(this.searchConfig.api, this.search)
                        .then(function (result) {
                        _this.searchResults = result;
                    }).catch(function () {
                        _this.messagesService.error(_this.$translate.instant("PESQUISA-AVANCADA.PESQUISA-NAO-EXECUTADA"));
                    }).finally(function () {
                        _this.selectedTab = Tab.RESULT;
                        _this.editEnabled = true;
                        _this.searchComplete = true;
                        _this.setLoadingProgress(false);
                        _this.fabActive = _this.activateActionHeader();
                    });
                }
            };
            /**
             * Salva uma pesquisa
             */
            PesquisaAvancadaController.prototype.saveSearch = function (event) {
                var _this = this;
                this.$mdDialog.show({
                    clickOutsideToClose: true,
                    controller: 'app.pesquisa-avancada.SaveSearchController',
                    locals: {
                        search: this.search
                    },
                    controllerAs: 'vm',
                    templateUrl: 'app/main/pesquisa-avancada/modals/save-search/save-search.html',
                    parent: angular.element(document.body),
                    targetEvent: event
                });
                var removeListener = this.$scope.$on('save-search:confirm', function () {
                    var foundIndex = _this.savedSearchs.findIndex(function (savedSearch) { return savedSearch.uuid === _this.search.uuid; });
                    if (foundIndex > -1) {
                        angular.copy(_this.search, _this.savedSearchs[foundIndex]);
                    }
                    else {
                        _this.savedSearchs.unshift(angular.copy(_this.search));
                    }
                    removeListener();
                });
            };
            /**
             * Salva uma pesquisa
             */
            PesquisaAvancadaController.prototype.deleteSearch = function (search) {
                var _this = this;
                this.pesquisaAvancadaService.deleteSearch(search)
                    .then(function (response) {
                    if (_this.search.uuid === search.uuid)
                        _this.reset();
                    var foundIndex = _this.savedSearchs.findIndex(function (savedSearch) { return savedSearch.uuid === search.uuid; });
                    _this.savedSearchs.splice(foundIndex, 1);
                    _this.messagesService.success("Pesquisa excluída com sucesso!");
                }).catch(function () {
                    _this.messagesService.error("Erro ao excluir pesquisa!");
                });
            };
            /**
             * Abre a navegação das pesquisas salvas
             */
            PesquisaAvancadaController.prototype.openSavedSearchs = function () {
                this.$mdSidenav('sidenav-search').open();
            };
            /**
             * Carrega uma pesquisa salva
             */
            PesquisaAvancadaController.prototype.loadSearch = function (savedSearch) {
                angular.copy(savedSearch, this.search);
                this.$mdSidenav('sidenav-search').close();
                this.editEnabled = true;
                this.selectedTab = Tab.EDIT_SEARCH;
                this.searchComplete = false;
                if (this.search.executable) {
                    this.doSearch();
                }
            };
            /**
             * Ativa as ações do header de pesquisa
             */
            PesquisaAvancadaController.prototype.activateActionHeader = function () {
                var active = false;
                if (this.selectedTab === Tab.NEW_SEARCH) {
                    active = this.canSearch();
                }
                else if (this.selectedTab === Tab.RESULT) {
                    active = this.activeSaveAction;
                }
                else {
                    active = this.canSearch();
                }
                return active;
            };
            /**
             * Monta o template da tabela de resultados
             */
            PesquisaAvancadaController.prototype.loadResultTemplate = function () {
                var _this = this;
                var template = "";
                this.tableColumnDefs = [];
                this.searchConfig.resultColumns.forEach(function (column, index) {
                    template += "<td" + ((column.result.css) ? " class='" + column.result.css + "'" : "") + ">"
                        + ((column.result.field) ? ("{{" + column.result.field + "}}") : "")
                        + ((column.result.html) ? column.result.html : "")
                        + ((column.result.actions && column.result.actions.length > 0) ? _this.loadResultActionsTemplate(column.result.actions, _this.resultActionsTemplate.length) : "")
                        + "</td>";
                    if (column.result.type) {
                        _this.tableColumnDefs.push(_this.DTColumnDefBuilder.newColumnDef(index).withOption("sType", column.result.type));
                    }
                });
                this.resultTemplate = this.$sce.trustAsHtml(template);
            };
            /**
             * Monta o template da coluna de ações se existir de resultados
             */
            PesquisaAvancadaController.prototype.loadResultActionsTemplate = function (actions, columnActionIndex) {
                var _this = this;
                this.resultActionsTemplate[columnActionIndex] = "";
                actions.forEach(function (action) {
                    _this.commandService.findByIdAndContext(action.id, action.context)
                        .then(function () { return _this.resultActionsTemplate[columnActionIndex] += action.html; });
                });
                return "<span bind-html-compile='vm.resultActionsTemplate[" + columnActionIndex + "]'></span>";
            };
            /**
             * Reset da tela de pesquisa
             */
            PesquisaAvancadaController.prototype.reset = function () {
                angular.copy(this.defaultSearch, this.search);
                this.selectedTab = Tab.NEW_SEARCH;
                this.searchComplete = false;
                this.editEnabled = false;
            };
            /**
             * Configura o ícone do Fab button de acordo com a tab selecionada
             */
            PesquisaAvancadaController.prototype.setFabIconElement = function () {
                var value = this.selectedTab === Tab.RESULT ? "icon-content-save" : "icon-magnify";
                this.fabIconElement = "<md-icon md-font-icon=\"" + value + "\"></md-icon>";
            };
            /**
             * Watch da tab selecionada para montar o Fab button corretamente
             */
            PesquisaAvancadaController.prototype.watchSelectedTab = function () {
                var _this = this;
                this.$scope.$watch("vm.selectedTab", function () {
                    _this.setFabIconElement();
                    _this.fabActive = _this.activateActionHeader();
                });
            };
            PesquisaAvancadaController.prototype.watchSearchCriteria = function () {
                var _this = this;
                this.$scope.$watch('vm.newSearch', function () {
                    if (_this.selectedTab === Tab.NEW_SEARCH) {
                        _this.fabActive = _this.activateActionHeader();
                    }
                }, true);
                this.$scope.$watch('vm.search', function () {
                    if (_this.selectedTab === Tab.EDIT_SEARCH) {
                        _this.fabActive = _this.activateActionHeader();
                    }
                }, true);
            };
            /**
             * Configura a tabela de resultados
             */
            PesquisaAvancadaController.prototype.configureDatatables = function () {
                this.tableOptions = {
                    dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                    pagingType: 'full_numbers',
                    autoWidth: true,
                    responsive: false,
                    searching: false,
                    language: {
                        "sEmptyTable": "Nenhum registro encontrado",
                        "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(Filtrados de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ".",
                        "sLengthMenu": "_MENU_ resultados por página",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sZeroRecords": "Nenhum registro encontrado",
                        "sSearch": "Pesquisar",
                        "oPaginate": {
                            "sNext": "<i class='icon-chevron-right s10' />",
                            "sPrevious": "<i class='icon-chevron-left s10' />",
                            "sFirst": "<i class='icon-chevron-double-left s10' />",
                            "sLast": "<i class='icon-chevron-double-right s10' />"
                        },
                        "oAria": {
                            "sSortAscending": ": Ordenar colunas de forma ascendente",
                            "sSortDescending": ": Ordenar colunas de forma descendente"
                        }
                    }
                };
            };
            /**
             * Carrega as pesquisa salvas
             */
            PesquisaAvancadaController.prototype.loadSavedSearchs = function () {
                var _this = this;
                this.setLoadingProgress(true);
                this.pesquisaAvancadaService.loadSavedSearchs(this.searchConfig.context)
                    .then(function (searchs) { return _this.savedSearchs = searchs; })
                    .catch(function () { return _this.messagesService.error(_this.$translate.instant("PESQUISA-AVANCADA.PESQUISAS-NAO-CARREGADAS")); })
                    .finally(function () { return _this.setLoadingProgress(false); });
            };
            /**
             * Ativa o efeito do loading
             */
            PesquisaAvancadaController.prototype.setLoadingProgress = function (loading) {
                this.$rootScope["loadingProgress"] = loading;
            };
            /**
             * Valida uma pesquisa
             */
            PesquisaAvancadaController.prototype.validate = function (search) {
                var invalidCriteria = [];
                var repeatedTrait = [];
                if (search.criteria.length > 1) {
                    search.criteria.forEach(function (criterion, criterionIndex) {
                        if (repeatedTrait.indexOf(criterion.trait.id) === -1) {
                            var countMusts_1 = 0, countShoulds_1 = 0;
                            search.criteria.forEach(function (value, valueIndex) {
                                if (value.trait.id === criterion.trait.id && criterionIndex !== valueIndex) {
                                    if (value.logicalOperator === pesquisaAvancada.LogicalOperator.MUST)
                                        countMusts_1++;
                                    if (value.logicalOperator === pesquisaAvancada.LogicalOperator.SHOULD)
                                        countShoulds_1++;
                                }
                            });
                            if ((criterion.logicalOperator === pesquisaAvancada.LogicalOperator.MUST && (countShoulds_1 > 0 || countMusts_1 > 0)) ||
                                (criterion.logicalOperator === pesquisaAvancada.LogicalOperator.SHOULD && countMusts_1 > 0)) {
                                invalidCriteria.push(criterion.trait.name);
                                repeatedTrait.push(criterion.trait.id);
                            }
                        }
                    });
                    if (invalidCriteria.length > 0) {
                        var message_1 = "";
                        invalidCriteria.forEach(function (invalidCriterion, index) { return message_1 += "\"" + invalidCriterion + "\"" + ((index !== (invalidCriteria.length - 1)) ? ", " : "."); });
                        this.messagesService.warn("Crit\u00E9rios combinados incorretamente: " + message_1);
                        return false;
                    }
                }
                else if (search.criteria.length === 1 && search.criteria[0].logicalOperator == pesquisaAvancada.LogicalOperator.SHOULD) {
                    this.messagesService.warn("Adicione mais um crit\u00E9rio com o tipo \"deve\" ou \"pode\"!");
                    return false;
                }
                else if (search.criteria.length === 0) {
                    return false;
                }
                return true;
            };
            return PesquisaAvancadaController;
        }());
        pesquisaAvancada.PesquisaAvancadaController = PesquisaAvancadaController;
        angular
            .module('app.pesquisa-avancada')
            .controller('app.pesquisa-avancada.PesquisaAvancadaController', PesquisaAvancadaController);
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));



var app;
(function (app) {
    var openState;
    (function (openState) {
        "use strict";
        /** @ngInject **/
        config.$inject = ["$stateProvider"];
        function config($stateProvider) {
            $stateProvider.state("app.openState", {
                url: "/open/{idRoute:any}",
                parent: "app.autenticado",
                views: {
                    "content@app.autenticado": {
                        controller: openState.OpenStateController
                    }
                }
            });
        }
        /** @ngInject */
        function run() {
        }
        angular
            .module("app.openState", ["app.support"])
            .config(config)
            .run(run);
    })(openState = app.openState || (app.openState = {}));
})(app || (app = {}));



var app;
(function (app) {
    var openState;
    (function (openState) {
        "use strict";
        var OpenStateController = /** @class */ (function () {
            /** @ngInject **/
            OpenStateController.$inject = ["$state", "$stateParams", "$http", "properties"];
            function OpenStateController($state, $stateParams, $http, properties) {
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.$http = $http;
                this.properties = properties;
                this.hide = false;
            }
            OpenStateController.prototype.$onInit = function () {
                var _this = this;
                var idRoute = this.$stateParams.idRoute;
                this.$http.get(this.properties.apiUrl + "/integracoes-modulos/api/routes", { cache: true }).then(function (routes) {
                    var route = routes.data.find(function (x) { return x.id == idRoute; });
                    _this.$state.go(route.stateName);
                });
            };
            return OpenStateController;
        }());
        openState.OpenStateController = OpenStateController;
        angular
            .module('app.openState')
            .controller('app.openState.OpenStateController', OpenStateController);
    })(openState = app.openState || (app.openState = {}));
})(app || (app = {}));



var app;
(function (app) {
    var novoProcesso;
    (function (novoProcesso) {
        'use strict';
        /** @ngInject */
        config.$inject = ["$translatePartialLoaderProvider", "$stateProvider"];
        run.$inject = ["stfBreadcrumbsService"];
        function config($translatePartialLoaderProvider, $stateProvider) {
            $translatePartialLoaderProvider.addPart('app/main/novo-processo');
            $stateProvider.state('app.novo-processo', {
                parent: 'app.autenticado',
                url: '/novo-processo',
                views: {
                    'content@app.autenticado': {
                        templateUrl: 'app/main/novo-processo/novo-processo.html',
                        controller: novoProcesso.NovoProcessoController,
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    processos: ['app.novo-processo.NovoProcessoService', '$futureState',
                        function (novoProcessoService, $futureState /** // TODO Encontrar typings */) {
                            return novoProcessoService.list().then(function (processos) {
                                // Registra o future state que porventura não tenha sido já registrado.
                                for (var _i = 0, processos_1 = processos; _i < processos_1.length; _i++) {
                                    var processo = processos_1[_i];
                                    var route = processo.route;
                                    if (route) {
                                        route.type = 'load';
                                        $futureState.futureState(route);
                                    }
                                }
                                return processos;
                            });
                        }]
                }
            });
        }
        /** @ngInject */
        function run(stfBreadcrumbsService) {
            stfBreadcrumbsService.registerPath({
                id: 'novo-processo',
                translation: 'Iniciar Processo',
                uisref: 'app.novo-processo'
            });
        }
        angular
            .module('app.novo-processo', ['app.autenticado'])
            .config(config)
            .run(run);
    })(novoProcesso = app.novoProcesso || (app.novoProcesso = {}));
})(app || (app = {}));



var app;
(function (app) {
    var novoProcesso;
    (function (novoProcesso) {
        'use strict';
        var NovoProcessoService = /** @class */ (function () {
            /** @ngInject **/
            NovoProcessoService.$inject = ["$http", "properties", "msNavigationService"];
            function NovoProcessoService($http, properties, msNavigationService) {
                this.$http = $http;
                this.properties = properties;
                this.msNavigationService = msNavigationService;
            }
            NovoProcessoService.prototype.list = function () {
                return this.$http.get(this.properties.url + ":" + this.properties.port + NovoProcessoService.apiProcessos)
                    .then(function (response) {
                    var processos = [];
                    response.data
                        .filter(function (processo) { return angular.isDefined(processo.route) && processo.route != null; })
                        .forEach(function (processo) { return processos.push(processo); });
                    return processos;
                });
            };
            NovoProcessoService.apiProcessos = '/integracoes-modulos/api/commands/start-process';
            return NovoProcessoService;
        }());
        novoProcesso.NovoProcessoService = NovoProcessoService;
        angular
            .module('app.novo-processo')
            .service('app.novo-processo.NovoProcessoService', NovoProcessoService);
    })(novoProcesso = app.novoProcesso || (app.novoProcesso = {}));
})(app || (app = {}));



var app;
(function (app) {
    var novoProcesso;
    (function (novoProcesso) {
        'use strict';
        var NovoProcessoController = /** @class */ (function () {
            /** @ngInject **/
            NovoProcessoController.$inject = ["$scope", "processos"];
            function NovoProcessoController($scope, processos) {
                var _this = this;
                this.$scope = $scope;
                this.processos = processos;
                this.buscaProcesso = "";
                this.$scope.$watch(function () { return _this.buscaProcesso; }, function () { return _this.filtrarProcessos(); });
                this.todosProcessos = angular.copy(processos);
            }
            NovoProcessoController.prototype.filtrarProcessos = function () {
                var busca = this.buscaProcesso.toLowerCase();
                if (busca.length === 0) {
                    this.processos = this.todosProcessos;
                }
                else {
                    this.processos = this.todosProcessos.filter(function (processo) {
                        return (processo.description.toLowerCase().indexOf(busca) !== -1);
                    });
                }
            };
            NovoProcessoController.prototype.getStateName = function (processo) {
                if (processo.route.types && !processo.route.types.includes('ui1') && processo.route.types.includes('ui2')) {
                    return "app.upgraded({url:'" + this.removeSlashKeyAtStart(processo.route.url) + "'})";
                }
                return processo.route.stateName;
            };
            NovoProcessoController.prototype.removeSlashKeyAtStart = function (url) {
                if (!!url && url[0] == '/') {
                    return url.substr(1);
                }
                return url;
            };
            return NovoProcessoController;
        }());
        novoProcesso.NovoProcessoController = NovoProcessoController;
        angular
            .module('app.novo-processo')
            .controller('app.novo-processo.NovoProcessoController', NovoProcessoController);
    })(novoProcesso = app.novoProcesso || (app.novoProcesso = {}));
})(app || (app = {}));



// Adapted from https://github.com/okikio/bundle/blob/main/src/ts/util/WebWorker.ts, which is licensed under the MIT license.
// If the above file is removed or modified, you can access the original state in the following GitHub Gist: https://gist.github.com/okikio/6809cfc0cdbf1df4c0573addaaf7e259
var app;
// Adapted from https://github.com/okikio/bundle/blob/main/src/ts/util/WebWorker.ts, which is licensed under the MIT license.
// If the above file is removed or modified, you can access the original state in the following GitHub Gist: https://gist.github.com/okikio/6809cfc0cdbf1df4c0573addaaf7e259
(function (app) {
    var notification;
    (function (notification) {
        "use strict";
        /**
         * indicates if SharedWorker is supported
         */
        notification.SharedWorkerSupported = typeof (SharedWorker) !== "undefined";
        /**
         * A polyfill class for `SharedWorker`, it accepts a URL/string as well as any other options the spec. allows for `SharedWorker`. It supports all the same methods and properties as the original, except it adds compatibility methods and properties for older browsers that don't support `SharedWorker`, so, it can switch to normal `Workers` instead.
         */
        var SharedWorkerPolyfill = /** @class */ (function () {
            function SharedWorkerPolyfill(url, opts) {
                if (notification.SharedWorkerSupported) {
                    this.ActualWorker = new SharedWorker(url, opts);
                }
                else {
                    this.ActualWorker = new Worker(url, opts);
                }
            }
            Object.defineProperty(SharedWorkerPolyfill.prototype, "onmessage", {
                /**
                 * An EventListener called when MessageEvent of type message is fired on the port—that is, when the port receives a message.
                 */
                get: function () {
                    if (notification.SharedWorkerSupported) {
                        return this.ActualWorker.port.onmessage;
                    }
                    else {
                        return this.ActualWorker.onmessage;
                    }
                },
                set: function (value) {
                    if (notification.SharedWorkerSupported) {
                        this.ActualWorker.port.onmessage = value;
                    }
                    else {
                        this.ActualWorker.onmessage = value;
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(SharedWorkerPolyfill.prototype, "onmessageerror", {
                /**
                 * An EventListener called when a MessageEvent of type MessageError is fired—that is, when it receives a message that cannot be deserialized.
                 */
                get: function () {
                    if (notification.SharedWorkerSupported) {
                        return this.ActualWorker.port.onmessageerror;
                    }
                    else {
                        return this.ActualWorker.onmessageerror;
                    }
                },
                set: function (value) {
                    if (notification.SharedWorkerSupported) {
                        this.ActualWorker.port.onmessageerror = value;
                    }
                    else {
                        this.ActualWorker.onmessageerror = value;
                    }
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Starts the sending of messages queued on the port (only needed when using EventTarget.addEventListener; it is implied when using MessagePort.onmessage.)
             */
            SharedWorkerPolyfill.prototype.start = function () {
                if (notification.SharedWorkerSupported) {
                    return this.ActualWorker.port.start();
                }
            };
            /**
             * Clones message and transmits it to worker's global environment. transfer can be passed as a list of objects that are to be transferred rather than cloned.
             */
            SharedWorkerPolyfill.prototype.postMessage = function (message, transfer) {
                if (notification.SharedWorkerSupported) {
                    return this.ActualWorker.port.postMessage(message, transfer);
                }
                else {
                    return this.ActualWorker.postMessage(message, transfer);
                }
            };
            /**
             * Immediately terminates the worker. This does not let worker finish its operations; it is halted at once. ServiceWorker instances do not support this method.
             */
            SharedWorkerPolyfill.prototype.terminate = function () {
                if (notification.SharedWorkerSupported) {
                    return this.ActualWorker.port.close();
                }
                else {
                    return this.ActualWorker.terminate();
                }
            };
            /**
             * Disconnects the port, so it is no longer active.
             */
            SharedWorkerPolyfill.prototype.close = function () {
                return this.terminate();
            };
            Object.defineProperty(SharedWorkerPolyfill.prototype, "port", {
                /**
                 * Returns a MessagePort object used to communicate with and control the shared worker.
                 */
                get: function () {
                    return (notification.SharedWorkerSupported ? this.ActualWorker.port : this.ActualWorker);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(SharedWorkerPolyfill.prototype, "onerror", {
                /**
                 * Is an EventListener that is called whenever an ErrorEvent of type error event occurs.
                 */
                get: function () { return this.ActualWorker.onerror; },
                set: function (value) {
                    this.ActualWorker.onerror = value;
                },
                enumerable: true,
                configurable: true
            });
            SharedWorkerPolyfill.prototype.addEventListener = function (type, listener, options) {
                if (notification.SharedWorkerSupported && type !== "error") {
                    return this.ActualWorker.port.addEventListener(type, listener, options);
                }
                else {
                    return this.ActualWorker.addEventListener(type, listener, options);
                }
            };
            SharedWorkerPolyfill.prototype.removeEventListener = function (type, listener, options) {
                if (notification.SharedWorkerSupported && type !== "error") {
                    return this.ActualWorker.port.removeEventListener(type, listener, options);
                }
                else {
                    return this.ActualWorker.removeEventListener(type, listener, options);
                }
            };
            /**
             * Dispatches an event to this EventTarget.
             */
            SharedWorkerPolyfill.prototype.dispatchEvent = function (event) {
                return this.ActualWorker.dispatchEvent(event);
            };
            return SharedWorkerPolyfill;
        }());
        notification.SharedWorkerPolyfill = SharedWorkerPolyfill;
    })(notification = app.notification || (app.notification = {}));
})(app || (app = {}));



var app;
(function (app) {
    var notification;
    (function (notification) {
        "use strict";
        /** @ngInject */
        run.$inject = ["$rootScope", "notificationService"];
        function run($rootScope, notificationService) {
            notificationService.init();
            $rootScope.$on("user:logged", function () {
                notificationService.init();
            });
            $rootScope.$on("user:exited", function () {
                notificationService.stop();
            });
        }
        angular
            .module("app.notification", ["app.support", "app.autenticacao"])
            .run(run);
    })(notification = app.notification || (app.notification = {}));
})(app || (app = {}));



var app;
(function (app) {
    var notification;
    (function (notification_1) {
        "use strict";
        var NotificationService = /** @class */ (function () {
            /** @ngInject */
            NotificationService.$inject = ["$rootScope", "$window", "$cookies", "properties", "authService", "$q", "$ocLazyLoad", "stylesLoadingService"];
            function NotificationService($rootScope, $window, $cookies, properties, authService, $q, $ocLazyLoad, stylesLoadingService) {
                var _this = this;
                this.$cookies = $cookies;
                this.properties = properties;
                this.authService = authService;
                this.$q = $q;
                this.$ocLazyLoad = $ocLazyLoad;
                this.stylesLoadingService = stylesLoadingService;
                this.worker = new notification_1.SharedWorkerPolyfill("scripts/event-source-notification.js");
                this.worker.start();
                this.worker.onmessage = function (event) {
                    var notification = angular.fromJson(event.data);
                    _this.authService.getUser().then(function (user) {
                        if (!notification.tenant || user.lotacao === notification.tenant) {
                            if (notification.requiredModules && notification.requiredModules.length > 0) {
                                _this.carregarModulos(notification.requiredModules).then(function () {
                                    $rootScope.$broadcast(notification.name, notification);
                                });
                            }
                            else {
                                $rootScope.$broadcast(notification.name, notification);
                            }
                        }
                    });
                };
                $window.onbeforeunload = function (event) {
                    _this.post({ type: "close" });
                };
            }
            NotificationService.prototype.init = function () {
                var accessToken = this.$cookies.get("access_token");
                if (accessToken) {
                    this.post({ type: "init", accessToken: accessToken, apiUrl: this.properties.apiUrl });
                }
            };
            NotificationService.prototype.stop = function () {
                this.post({ type: "stop" });
            };
            NotificationService.prototype.post = function (message) {
                this.worker.postMessage(angular.toJson(message));
            };
            NotificationService.prototype.carregarModulos = function (modules) {
                var _this = this;
                return this.$q.all(modules.map(function (module) { return _this.carregarModulo(module); }));
            };
            NotificationService.prototype.carregarModulo = function (module) {
                var _this = this;
                var context = module.split("/")[0];
                var modulo = module.split("/")[1];
                var defer = this.$q.defer();
                //Realiza a importação dos arquivos dos módulos
                var bundle = context + "/bundle";
                System.import(bundle).then(function (loaded) {
                    var newModule = loaded;
                    if (!loaded.name) {
                        var key = Object.keys(loaded);
                        newModule = loaded[key[0]];
                    }
                    //Carrega o módulo angular importado
                    _this.$ocLazyLoad.load(newModule);
                });
                var styleUrl = SystemJS.baseURL + context + "/style.css";
                this.$q.all([System.import(bundle), this.stylesLoadingService.loadStyle(styleUrl)]).then(function () {
                    console.log("Módulo carregado:", modulo);
                    System.import(context + "/" + modulo).then(function (loaded) {
                        var newModule = loaded;
                        if (!loaded.name) {
                            var key = Object.keys(loaded);
                            newModule = loaded[key[0]];
                        }
                        //Carrega o módulo angular importado
                        _this.$ocLazyLoad.load(newModule);
                        defer.resolve();
                    });
                });
                return defer.promise;
            };
            return NotificationService;
        }());
        notification_1.NotificationService = NotificationService;
        angular
            .module("app.notification")
            .service("notificationService", NotificationService);
    })(notification = app.notification || (app.notification = {}));
})(app || (app = {}));



var app;
(function (app) {
    var navigation;
    (function (navigation) {
        "use strict";
        /** @ngInject **/
        var config = function ($translatePartialLoaderProvider, $ocLazyLoadProvider, $futureStateProvider, $provide, properties) {
            $translatePartialLoaderProvider.addPart("app/main/navigation");
            /**
             * Define como os estados futuros do ui-router serão carregados
             */
            $futureStateProvider.stateFactory("load", /** @ngInject **/ ["$q", "$ocLazyLoad", "$log", "$mdDialog", "$translate", "$futureState", "$timeout", "futureState", "stylesLoadingService", function ($q, $ocLazyLoad, $log, $mdDialog, $translate, $futureState, $timeout, futureState, stylesLoadingService) {
                var deferredState = $q.defer();
                var alert = $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title($translate.instant("NAVEGACAO.SERVICO_INDISPONIVEL.TITULO"))
                    .textContent($translate.instant("NAVEGACAO.SERVICO_INDISPONIVEL.MSG"))
                    .ariaLabel($translate.instant("NAVEGACAO.SERVICO_INDISPONIVEL.ALERTA"))
                    .ok($translate.instant("NAVEGACAO.SERVICO_INDISPONIVEL.OK"));
                var fnErr = function (err) {
                    $log.error(err);
                    deferredState.reject();
                    $mdDialog.show(alert);
                    //Coloca o estado como futuro, para que tente acessar novamente
                    $timeout(function () {
                        $futureState.futureState(futureState);
                    });
                };
                //Realiza a importação dos arquivos dos módulos
                var context = futureState.src.split("/")[0];
                var bundle = context + "/bundle";
                var styleUrl = SystemJS.baseURL + context + "/style.css";
                $q.all([System.import(bundle), stylesLoadingService.loadStyle(styleUrl)]).then(function () {
                    System.import(futureState.src).then(function (loaded) {
                        var newModule = loaded;
                        if (!loaded.name) {
                            var key = Object.keys(loaded);
                            newModule = loaded[key[0]];
                        }
                        //Carrega o módulo angular importado
                        $ocLazyLoad.load(newModule).then(function () {
                            deferredState.resolve();
                        }, fnErr);
                    }, fnErr);
                });
                return deferredState.promise;
            }]);
            /**
             * Carrega as configurações das rotas dos módulos no FutureState do ui-router
             * possibilitando a garantia de que o estado estará carregado antes da transição
             * de estados ocorrer
             */
            $futureStateProvider.addResolve(/** @ngInject **/ ["$q", "$http", "$rootScope", "$window", "$state", "$timeout", "$cookies", function ($q, $http, $rootScope, $window, $state, $timeout, $cookies) {
                var deferredRoutes = $q.defer();
                var loadFutureRoutes = function () {
                    $http.get(properties.apiUrl + "/integracoes-modulos/api/routes").then(function (response) {
                        response.data = response.data.filter(function (r) { return !!r.stateName; });
                        response.data.sort(function (r1, r2) {
                            return r1.stateName.localeCompare(r2.stateName);
                        });
                        var temToken = $cookies.get("access_token") != null;
                        var publicState = null;
                        var publicStateParams = null;
                        var path = $window.location.pathname;
                        response.data.forEach(function (route) {
                            route.type = "load";
                            $futureStateProvider.futureState(route);
                            if (route.stateName.indexOf("app.publico.") > -1) {
                                var params = route.urlMatcher.exec(path);
                                if (!!params) {
                                    publicState = route.stateName;
                                    publicStateParams = params;
                                }
                            }
                        });
                        if (!!publicState && !temToken) {
                            $timeout(function () { return $state.go(publicState, publicStateParams); });
                        }
                        deferredRoutes.resolve();
                    }, function () {
                        deferredRoutes.reject();
                    });
                };
                loadFutureRoutes();
                $rootScope.$on("user:logged", loadFutureRoutes);
                $rootScope.$on("user:exited", loadFutureRoutes);
                return deferredRoutes.promise;
            }]);
            //Configura o SystemJS para importar os arquivos através do gateway
            System.config({
                baseURL: properties.apiUrl,
                defaultExtension: "js",
                defaultJSExtensions: true,
                map: {
                    "rxjs": document.baseURI + "scripts/rxjs-system-bundle/index.js",
                    "rxjs-compat": document.baseURI + "scripts/rxjs-system-bundle/index.js",
                    "rxjs/operators/": document.baseURI + "scripts/rxjs-system-bundle/index.js"
                }
            });
            System.import("rxjs").catch(function (error) { return console.error("Erro ao carregas RxJS", error); });
            //Adiciona um timestamp na url garantindo que no primeiro carregamento não vai ao cache
            var systemLocate = System.locate;
            System.locate = function (load) {
                var System = this;
                return Promise.resolve(systemLocate.call(this, load)).then(getUrlWithTimestamp);
            };
            if (properties.development) {
                $provide.decorator("$templateFactory", templateFactoryDecorator);
                $ocLazyLoadProvider.config({ debug: false });
            }
        };
        config.$inject = ["$translatePartialLoaderProvider", "$ocLazyLoadProvider", "$futureStateProvider", "$provide", "properties"];
        //Desabilita o cache dos templates de módulos externos no ui-router.
        /** @ngInject **/
        var templateFactoryDecorator = function ($delegate, properties) {
            var fromUrl = angular.bind($delegate, $delegate.fromUrl);
            var gatewayUrl = properties.apiUrl;
            $delegate.fromUrl = function (url, params) {
                if (url !== null && angular.isDefined(url) && angular.isString(url) && url.indexOf(gatewayUrl) !== -1) {
                    url = getUrlWithTimestamp(url);
                }
                return fromUrl(url, params);
            };
            return $delegate;
        };
        templateFactoryDecorator.$inject = ["$delegate", "properties"];
        //Monta uma url com um timestamp na querystring
        var getUrlWithTimestamp = function (url) {
            return url + (url.indexOf("?") === -1 ? "?" : "&") + "ts=" + Date.now().toString();
        };
        angular
            .module("app.navigation", ["oc.lazyLoad", "ui.router", "ct.ui.router.extras", "app.support", "app.support.constants"])
            .config(config);
    })(navigation = app.navigation || (app.navigation = {}));
})(app || (app = {}));



var app;
(function (app) {
    var navigation;
    (function (navigation) {
        'use strict';
        var NavigationController = /** @class */ (function () {
            /** @ngInject **/
            NavigationController.$inject = ["$scope"];
            function NavigationController($scope) {
                this.$scope = $scope;
                this.folded = true;
                this.msScrollOptions = {
                    suppressScrollX: true
                };
                // Close the mobile menu on $stateChangeSuccess
                $scope.$on('$stateChangeSuccess', function () {
                    angular.element('body').removeClass('ms-navigation-horizontal-mobile-menu-active');
                });
            }
            NavigationController.prototype.toggleMsNavigationFolded = function () {
                this.folded = !this.folded;
            };
            return NavigationController;
        }());
        navigation.NavigationController = NavigationController;
        angular
            .module('app.navigation')
            .controller('app.NavigationController', NavigationController);
    })(navigation = app.navigation || (app.navigation = {}));
})(app || (app = {}));



var app;
(function (app) {
    var legacy;
    (function (legacy) {
        "use strict";
        /** @ngInject **/
        config.$inject = ["$stateProvider", "msNavigationServiceProvider"];
        run.$inject = ["app.legacy.LegacyService"];
        function config($stateProvider, msNavigationServiceProvider) {
            $stateProvider.state("app.legacy", {
                url: "/legacy/:context/{url:any}",
                parent: "app.autenticado",
                views: {
                    "content@app.autenticado": {
                        templateUrl: "app/main/legacy/legacy.html",
                        controller: legacy.LegacyController,
                        controllerAs: "vm",
                        resolve: {
                            legacyMenuItems: /** @ngInject */ ["app.legacy.LegacyService", function (legacyService) {
                                return legacyService.legacyMenuItems();
                            }],
                            frameUrl: /** @ngInject */ ["properties", "$stateParams", "$sce", "legacyMenuItems", function (properties, $stateParams, $sce, legacyMenuItems) {
                                for (var _i = 0, legacyMenuItems_1 = legacyMenuItems; _i < legacyMenuItems_1.length; _i++) {
                                    var legacyMenu = legacyMenuItems_1[_i];
                                    if (legacyMenu.id === $stateParams["context"]) {
                                        return $sce.trustAsResourceUrl(properties.apiUrl + "/" + legacyMenu.id + "/#/" + $stateParams["url"]);
                                    }
                                }
                            }],
                            parentUrl: /** @ngInject */ ["$window", function ($window) {
                                return $window.location.origin;
                            }]
                        }
                    }
                }
            });
        }
        /** @ngInject */
        function run(legacyService) {
            legacyService.loadLegacyMenuItems();
        }
        angular
            .module("app.legacy", ["app.support"])
            .config(config)
            .run(run);
    })(legacy = app.legacy || (app.legacy = {}));
})(app || (app = {}));



var app;
(function (app) {
    var legacy;
    (function (legacy) {
        /** @ngInject */
        configUiSrefActiveDecorator.$inject = ["$provide"];
        function configUiSrefActiveDecorator($provide) {
            $provide.decorator('uiSrefDirective', ["$delegate", "$rootScope", function ($delegate, $rootScope) {
                var directive = $delegate[0];
                directive.compile = function () {
                    return function (scope, element, attrs, ctrl) {
                        var linkResult = directive.link(scope, element, attrs, ctrl);
                        $rootScope.$on("legacyRouteChanged", function () {
                            scope.$broadcast("$stateChangeSuccess");
                        });
                        return linkResult;
                    };
                };
                return $delegate;
            }]);
        }
        angular.module('app.legacy').config(configUiSrefActiveDecorator);
    })(legacy = app.legacy || (app.legacy = {}));
})(app || (app = {}));



var app;
(function (app) {
    var legacy;
    (function (legacy) {
        "use strict";
        var LegacyService = /** @class */ (function () {
            /** @ngInject **/
            LegacyService.$inject = ["$rootScope", "$http", "properties", "msNavigationService", "$q"];
            function LegacyService($rootScope, $http, properties, msNavigationService, $q) {
                var _this = this;
                this.$rootScope = $rootScope;
                this.$http = $http;
                this.properties = properties;
                this.msNavigationService = msNavigationService;
                this.$q = $q;
                $rootScope.$on("user:logged", function () { return _this.loadLegacyMenuItems(); });
                $rootScope.$on("user:exited", function () { return _this.logoutFromLegacy(); });
                $rootScope.$on("user:exited", function () { return _this.resetLegacyMenuItems(); });
            }
            LegacyService.prototype.loadLegacyMenuItems = function () {
                var _this = this;
                this.legacyMenuItems().then(function (menus) {
                    for (var _i = 0, menus_1 = menus; _i < menus_1.length; _i++) {
                        var menu = menus_1[_i];
                        if (menu.menuItems.length > 0) {
                            var id = "legacy#" + menu.id;
                            _this.msNavigationService.saveItem(id, {
                                title: menu.description,
                                translation: menu.description,
                                group: true,
                                weight: 5
                            });
                            _this.fillSubmenus(menu.id, id, menu.menuItems);
                        }
                    }
                });
                this.msNavigationService.sort();
            };
            LegacyService.prototype.fillSubmenus = function (context, parentId, submenus) {
                for (var _i = 0, submenus_1 = submenus; _i < submenus_1.length; _i++) {
                    var submenuItem = submenus_1[_i];
                    var id = parentId + "." + submenuItem.id;
                    var navigationMenu = {
                        title: submenuItem.description,
                        translation: "Consulta"
                    };
                    if (submenuItem.icon) {
                        navigationMenu["icon"] = submenuItem.icon;
                    }
                    if (submenuItem.url) {
                        navigationMenu["state"] = "app.legacy({context: '" + context + "', url: '" + submenuItem.url + "'})";
                    }
                    this.msNavigationService.saveItem(id, navigationMenu);
                    if (submenuItem.menuItems) {
                        this.fillSubmenus(context, id, submenuItem.menuItems);
                    }
                }
            };
            LegacyService.prototype.resetLegacyMenuItems = function () {
                var navigation = this.msNavigationService.getNavigation();
                _.remove(navigation, function (nav) { return nav._id.indexOf("legacy#") === 0; });
            };
            LegacyService.prototype.legacyMenuItems = function () {
                var _this = this;
                if (!this.legacyMenuItemsCache) {
                    return this.$http.get(this.properties.apiUrl + "/integracoes-modulos/api/legacy/menus")
                        .then(function (response) {
                        _this.legacyMenuItemsCache = response.data;
                        return response.data;
                    });
                }
                else {
                    return this.$q.when(this.legacyMenuItemsCache);
                }
            };
            LegacyService.prototype.logoutFromLegacy = function () {
                var _this = this;
                this.legacyMenuItems().then(function (items) {
                    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                        var legacyMenuItem = items_1[_i];
                        var request = {
                            method: "GET",
                            url: legacyMenuItem.baseUrl + "/" + legacyMenuItem.logoutUrl,
                            headers: _this.emptyHeaders()
                        };
                        _this.$http(request);
                    }
                });
            };
            LegacyService.prototype.emptyHeaders = function () {
                var headers = angular.copy(this.$http.defaults.headers.common);
                for (var key in headers) {
                    headers[key] = undefined;
                }
                return headers;
            };
            return LegacyService;
        }());
        legacy.LegacyService = LegacyService;
        angular
            .module("app.legacy")
            .service("app.legacy.LegacyService", LegacyService);
    })(legacy = app.legacy || (app.legacy = {}));
})(app || (app = {}));



var app;
(function (app) {
    var legacy;
    (function (legacy) {
        "use strict";
        var LegacyController = /** @class */ (function () {
            /** @ngInject **/
            LegacyController.$inject = ["app.legacy.LegacyCommunicationService", "frameUrl", "parentUrl", "$rootScope", "$sce", "$timeout", "$stateParams", "properties"];
            function LegacyController(legacyCommunicationService, frameUrl, parentUrl, $rootScope, $sce, $timeout, $stateParams, properties) {
                var _this = this;
                this.legacyCommunicationService = legacyCommunicationService;
                this.frameUrl = frameUrl;
                this.parentUrl = parentUrl;
                this.$rootScope = $rootScope;
                this.$sce = $sce;
                this.$timeout = $timeout;
                this.$stateParams = $stateParams;
                this.properties = properties;
                this.hide = false;
                this.currentStateChangeRequest = legacyCommunicationService.getCurrentStateChangeRequest();
                this.$rootScope.$on("legacyRouteChangedToRefresh", function (event, data) {
                    _this.frameUrl = _this.$sce.trustAsResourceUrl(properties.apiUrl + "/" + $stateParams['context'] + "/#/" + data["url"]);
                    _this.hide = true;
                    _this.$timeout(function () {
                        _this.hide = false;
                    }, 1);
                });
            }
            return LegacyController;
        }());
        legacy.LegacyController = LegacyController;
        angular
            .module('app.legacy')
            .controller('app.legacy.LegacyController', LegacyController);
    })(legacy = app.legacy || (app.legacy = {}));
})(app || (app = {}));



var app;
(function (app) {
    var legacy;
    (function (legacy) {
        var LegacyFrame = /** @class */ (function () {
            function LegacyFrame(legacyCommunicationService, $stateParams) {
                this.legacyCommunicationService = legacyCommunicationService;
                this.$stateParams = $stateParams;
                this.restrict = "A";
                this.scope = {
                    parentUrl: "=stfLegacyFrame",
                    stateChangeRequest: "=stfLegacyFrameStateChangeRequest"
                };
            }
            LegacyFrame.factory = function () {
                return ["app.legacy.LegacyCommunicationService", "$stateParams", function (legacyCommunicationService, $stateParams) {
                    "ngInject";
                    return new LegacyFrame(legacyCommunicationService, $stateParams);
                }];
            };
            LegacyFrame.prototype.link = function (scope, element, attrs) {
                var _this = this;
                var iframeElementContentWindow = function () {
                    return element[0].contentWindow;
                };
                scope.$watch("parentUrl", function (newVal) {
                    if (newVal) {
                        _this.legacyCommunicationService.receiveStartedLoadingMessage(function () {
                            _this.hideScroll();
                            iframeElementContentWindow().postMessage({ "operation": "setParentUrl", "data": newVal + "/legacy/" + _this.$stateParams["context"] }, "*");
                        });
                    }
                });
                scope.$watch("stateChangeRequest.request", function (newVal) {
                    if (newVal) {
                        iframeElementContentWindow().postMessage({ "operation": "changeState", "data": newVal.url }, "*");
                    }
                });
                scope.$on("legacy:callback", function (event, data) {
                    iframeElementContentWindow().postMessage({ "operation": "callback", "data": { id: data.id, data: data.data } }, "*");
                });
                scope.$on("$destroy", function () {
                    _this.showScroll();
                });
            };
            LegacyFrame.prototype.hideScroll = function () {
                angular.element(document).find("[legacy-scroll-fix] > .ps-scrollbar-y-rail").css("display", "none");
                angular.element(document).find("[legacy-scroll-fix] > .ps-scrollbar-y-rail > .ps-scrollbar-y").css("display", "none");
            };
            LegacyFrame.prototype.showScroll = function () {
                angular.element(document).find("[legacy-scroll-fix] > .ps-scrollbar-y-rail").css("display", "inherit");
                angular.element(document).find("[legacy-scroll-fix] > .ps-scrollbar-y-rail > .ps-scrollbar-y").css("display", "inherit");
            };
            return LegacyFrame;
        }());
        legacy.LegacyFrame = LegacyFrame;
        angular.module("app.legacy").directive("stfLegacyFrame", LegacyFrame.factory());
    })(legacy = app.legacy || (app.legacy = {}));
})(app || (app = {}));



var app;
(function (app) {
    var legacy;
    (function (legacy) {
        "use strict";
        var LegacyCommunicationService = /** @class */ (function () {
            /** @ngInject **/
            LegacyCommunicationService.$inject = ["$window", "$rootScope", "$state", "msNavigationService", "$stateParams", "$http", "properties", "$q", "stylesLoadingService", "$ocLazyLoad", "$mdDialog", "$translate", "$injector"];
            function LegacyCommunicationService($window, $rootScope, $state, msNavigationService, $stateParams, $http, properties, $q, stylesLoadingService, $ocLazyLoad, $mdDialog, $translate, $injector) {
                var _this = this;
                this.$window = $window;
                this.$rootScope = $rootScope;
                this.$state = $state;
                this.msNavigationService = msNavigationService;
                this.$stateParams = $stateParams;
                this.$http = $http;
                this.properties = properties;
                this.$q = $q;
                this.stylesLoadingService = stylesLoadingService;
                this.$ocLazyLoad = $ocLazyLoad;
                this.$mdDialog = $mdDialog;
                this.$translate = $translate;
                this.$injector = $injector;
                this.currentStateChangeRequest = {
                    request: null
                };
                $window.addEventListener("message", function (event) { return _this.handleMessage(event); }, false);
                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
                    if (toState.name === "app.legacy" && $state.$current["name"] === "app.legacy") {
                        event.preventDefault();
                        _this.currentStateChangeRequest.request = {
                            url: toParams.url
                        };
                        _this.updateUrl(toParams.url);
                        _this.$rootScope.$broadcast("legacyRouteChangedToRefresh", {
                            url: toParams.url
                        });
                    }
                });
            }
            LegacyCommunicationService.prototype.handleMessage = function (event) {
                var _this = this;
                if (event.data.operation === "startedLoading") {
                    this.startedLoadingCallback();
                }
                else if (event.data.operation == "startedLoadingState") {
                    this.$rootScope["loadingProgress"] = true;
                    this.$rootScope.$apply();
                }
                else if (event.data.operation === "finishedLoadingState") {
                    this.$rootScope["loadingProgress"] = false;
                    this.$rootScope.$apply();
                    if (event.data.url) {
                        this.updateUrl(event.data.url);
                    }
                }
                else if (event.data.operation === "changeStfDigitalState") {
                    this.$state.go(event.data.state);
                }
                else if (event.data.operation === "$http.get") {
                    var data_1 = JSON.parse(event.data.data);
                    this.$http.get(this.properties.apiUrl + "/" + this.$stateParams["context"] + "/" + data_1.data.arguments[0], data_1.data.arguments[1]).then(function (response) {
                        _this.$rootScope.$broadcast("legacy:callback", { "id": data_1.id, "data": { "response": { "data": response.data, "status": response.status }, "status": "success" } });
                    }, function (response) {
                        _this.$rootScope.$broadcast("legacy:callback", { "id": data_1.id, "data": { "response": { "data": response.data, "status": response.status }, "status": "error" } });
                    });
                }
                else if (event.data.operation === "$http.post") {
                    var data_2 = JSON.parse(event.data.data);
                    this.$http.post(this.properties.apiUrl + "/" + this.$stateParams["context"] + "/" + data_2.data.arguments[0], data_2.data.arguments[1]).then(function (response) {
                        _this.$rootScope.$broadcast("legacy:callback", { "id": data_2.id, "data": { "response": { "data": response.data, "status": response.status }, "status": "success" } });
                    }, function (response) {
                        _this.$rootScope.$broadcast("legacy:callback", { "id": data_2.id, "data": { "response": { "data": response.data, "status": response.status }, "status": "error" } });
                    });
                }
                else if (event.data.operation === "$http.put") {
                    var data_3 = JSON.parse(event.data.data);
                    this.$http.put(this.properties.apiUrl + "/" + this.$stateParams["context"] + "/" + data_3.data.arguments[0], data_3.data.arguments[1]).then(function (response) {
                        _this.$rootScope.$broadcast("legacy:callback", { "id": data_3.id, "data": { "response": { "data": response.data, "status": response.status }, "status": "success" } });
                    }, function (response) {
                        _this.$rootScope.$broadcast("legacy:callback", { "id": data_3.id, "data": { "response": { "data": response.data, "status": response.status }, "status": "error" } });
                    });
                }
                else if (event.data.operation === "$http.delete") {
                    var data_4 = JSON.parse(event.data.data);
                    this.$http.delete(this.properties.apiUrl + "/" + this.$stateParams["context"] + "/" + data_4.data.arguments[0], data_4.data.arguments[1]).then(function (response) {
                        _this.$rootScope.$broadcast("legacy:callback", { "id": data_4.id, "data": { "response": { "data": response.data, "status": response.status }, "status": "success" } });
                    }, function (response) {
                        _this.$rootScope.$broadcast("legacy:callback", { "id": data_4.id, "data": { "response": { "data": response.data, "status": response.status }, "status": "error" } });
                    });
                }
                else if (event.data.operation === "getBinary") {
                    var data_5 = JSON.parse(event.data.data);
                    var contexto = data_5.data.context ? data_5.data.context : this.$stateParams["context"];
                    this.$http.get(this.properties.apiUrl + "/" + contexto + "/" + data_5.data.arguments[0], { responseType: "arraybuffer" }).then(function (response) {
                        _this.$rootScope.$broadcast("legacy:callback", { "id": data_5.id, "data": { "response": { "data": response.data, "status": response.status }, "status": "success" } });
                    }, function (response) {
                        _this.$rootScope.$broadcast("legacy:callback", { "id": data_5.id, "data": { "response": { "data": response.data, "status": response.status }, "status": "error" } });
                    });
                }
                else if (event.data.operation === "callService") {
                    var data_6 = JSON.parse(event.data.data);
                    this.loadStfDigitalBundle(this.$stateParams["context"]).then(function (loadedModule) {
                        var service = _this.$injector.get(data_6.service);
                        service[data_6.method].apply(service, data_6.params);
                    });
                }
            };
            LegacyCommunicationService.prototype.loadStfDigitalBundle = function (context) {
                var _this = this;
                var deferredState = this.$q.defer();
                var alert = this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(this.$translate.instant('NAVEGACAO.SERVICO_INDISPONIVEL.TITULO'))
                    .textContent(this.$translate.instant('NAVEGACAO.SERVICO_INDISPONIVEL.MSG'))
                    .ariaLabel(this.$translate.instant('NAVEGACAO.SERVICO_INDISPONIVEL.ALERTA'))
                    .ok(this.$translate.instant('NAVEGACAO.SERVICO_INDISPONIVEL.OK'));
                function fnErr(err) {
                    deferredState.reject();
                    this.$mdDialog.show(alert);
                }
                var bundle = context + '/bundle';
                var styleUrl = SystemJS.baseURL + context + '/style.css';
                this.$q.all([System.import(bundle), this.stylesLoadingService.loadStyle(styleUrl)]).then(function () {
                    System.import(context + "/legacy-integration").then(function (loaded) {
                        var newModule = loaded;
                        if (!loaded.name) {
                            var key = Object.keys(loaded);
                            newModule = loaded[key[0]];
                        }
                        //Carrega o módulo angular importado
                        _this.$ocLazyLoad.load(newModule).then(function (loadedModule) {
                            deferredState.resolve(loadedModule);
                        }, fnErr);
                    }, fnErr);
                });
                return deferredState.promise;
            };
            LegacyCommunicationService.prototype.updateUrl = function (url) {
                this.$state.transitionTo("app.legacy", {
                    context: this.$stateParams["context"],
                    url: url
                }, {
                    location: true,
                    inherit: false,
                    relative: this.$state.$current,
                    notify: false
                });
                this.$stateParams["url"] = url;
                this.$rootScope.$broadcast("legacyRouteChanged");
            };
            LegacyCommunicationService.prototype.receiveStartedLoadingMessage = function (callback) {
                this.startedLoadingCallback = callback;
            };
            LegacyCommunicationService.prototype.getCurrentStateChangeRequest = function () {
                return this.currentStateChangeRequest;
            };
            return LegacyCommunicationService;
        }());
        legacy.LegacyCommunicationService = LegacyCommunicationService;
        angular
            .module('app.legacy')
            .service('app.legacy.LegacyCommunicationService', LegacyCommunicationService);
    })(legacy = app.legacy || (app.legacy = {}));
})(app || (app = {}));



var app;
(function (app) {
    var gestao;
    (function (gestao) {
        "use strict";
        /** @ngInject **/
        run.$inject = ["app.support.dashboards.DashboardService", "msNavigationService", "$rootScope"];
        config.$inject = ["$translatePartialLoaderProvider", "$stateProvider", "msNavigationServiceProvider"];
        function run(dashboardService, msNavigationService, $rootScope) {
            function setUpDashboard() {
                dashboardService.hasDashboards().then(function (hasDashboards) {
                    if (hasDashboards)
                        // Navigation
                        msNavigationService.saveItem("gestao", {
                            title: "GESTÃO",
                            translation: "GESTAO.GESTAO",
                            group: true,
                            weight: 1
                        });
                    msNavigationService.sort();
                });
            }
            $rootScope.$on("user:logged", function () {
                setUpDashboard();
            });
            setUpDashboard();
            $rootScope.$on("user:exited", function () {
                var navigation = msNavigationService.getNavigation();
                _.remove(navigation, function (nav) { return nav._id === "gestao"; });
            });
        }
        /** @ngInject **/
        function config($translatePartialLoaderProvider, $stateProvider, msNavigationServiceProvider) {
            $translatePartialLoaderProvider.addPart("app/main/gestao");
            $stateProvider
                .state("app.gestao", {
                abstract: true,
                url: "/gestao",
                parent: "app.autenticado",
            });
        }
        angular
            .module("app.gestao", ["app.autenticado"])
            .config(config)
            .run(run);
    })(gestao = app.gestao || (app.gestao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var documentos;
    (function (documentos) {
        var VisualizadorBasicoDirective = /** @class */ (function () {
            function VisualizadorBasicoDirective($http, $parse, $window, messagesService) {
                this.$http = $http;
                this.$parse = $parse;
                this.$window = $window;
                this.messagesService = messagesService;
                this.restrict = "A";
                this.clickCallback = this.clickCallback.bind(this);
                this.link = this.link.bind(this);
            }
            VisualizadorBasicoDirective.factory = function () {
                return ["$http", "$parse", "$window", "messagesService", "errorService",
                    function ($http, $parse, $window, messagesService) {
                        return new VisualizadorBasicoDirective($http, $parse, $window, messagesService);
                    }];
            };
            VisualizadorBasicoDirective.prototype.link = function (scope, element, attrs) {
                var _this = this;
                element.bind("click", function () { return _this.clickCallback(scope, element, attrs); });
                var apiExpression = attrs["stfVisualizadorBasicoApi"];
                if (apiExpression) {
                    var api = this.$parse(apiExpression)(scope);
                    if (api) {
                        api.open = function () {
                            var newTab;
                            if (!_this.isIE()) {
                                newTab = _this.openWindow();
                            }
                            return {
                                doOpen: function () {
                                    _this.clickCallback(scope, element, attrs, newTab);
                                },
                                close: function () {
                                    if (newTab) {
                                        newTab.close();
                                    }
                                }
                            };
                        };
                    }
                }
            };
            VisualizadorBasicoDirective.prototype.clickCallback = function (scope, element, attrs, existingTab) {
                var _this = this;
                if (existingTab === void 0) { existingTab = null; }
                var conteudo = attrs["stfVisualizadorBasico"];
                var newTab;
                if (conteudo.indexOf('base64') !== -1) {
                    if (this.isIE()) {
                        throw "Base64 não é suportada no IE.";
                    }
                    else {
                        newTab = existingTab ? existingTab : this.openWindow();
                        this.openFileInTabAsBase64(conteudo, newTab);
                    }
                }
                else {
                    var url = this.$parse(conteudo)(scope);
                    if (!this.isIE()) {
                        newTab = existingTab ? existingTab : this.openWindow(); // Necessário abrir a aba durante o evento do usuário para não causar bloqueio de pop-up.
                    }
                    this.$http.get(url, { responseType: "arraybuffer" }).then(function (response) {
                        var blob = _this.buildBlob(response.data);
                        if (_this.isIE()) {
                            _this.openFileIE(blob);
                        }
                        else {
                            _this.openFileInTab(blob, newTab);
                        }
                    }, function (error) {
                        if (newTab) {
                            newTab.close();
                        }
                        _this.messagesService.error("Erro ao carregar o PDF.");
                    });
                }
            };
            VisualizadorBasicoDirective.prototype.isIE = function () {
                return !!this.$window.navigator.msSaveOrOpenBlob;
            };
            VisualizadorBasicoDirective.prototype.openWindow = function () {
                return this.$window.open("", "_blank");
            };
            VisualizadorBasicoDirective.prototype.buildBlob = function (data) {
                return new Blob([data], { type: "application/pdf" });
            };
            VisualizadorBasicoDirective.prototype.openFileInTabAsBase64 = function (base64Data, tab) {
                tab.location.href = base64Data;
            };
            VisualizadorBasicoDirective.prototype.openFileInTab = function (blob, tab) {
                var url = this.$window.URL.createObjectURL(blob);
                tab.location.href = url;
            };
            VisualizadorBasicoDirective.prototype.openFileIE = function (blob) {
                this.$window.navigator.msSaveOrOpenBlob(blob, "conteudo.pdf");
            };
            return VisualizadorBasicoDirective;
        }());
        documentos.VisualizadorBasicoDirective = VisualizadorBasicoDirective;
        angular.module("app.documentos").directive("stfVisualizadorBasico", VisualizadorBasicoDirective.factory());
    })(documentos = app.documentos || (app.documentos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var documentos;
    (function (documentos) {
        var PdfObjectDirective = /** @class */ (function () {
            function PdfObjectDirective($compile, bowser) {
                this.$compile = $compile;
                this.bowser = bowser;
                this.restrict = "E";
            }
            PdfObjectDirective.factory = function () {
                return ["$compile", "bowser", function ($compile, bowser) {
                    "ngInject";
                    return new PdfObjectDirective($compile, bowser);
                }];
            };
            PdfObjectDirective.prototype.link = function (scope, element, attrs) {
                var url = scope.$eval(attrs["src"]);
                if (this.bowser.msie) {
                    element.html("<md-button class=\"md-fab md-accent\" stf-visualizador-basico=\"'" + url + "'\" aria-label=\"Imprimir\">\n    <md-icon md-font-icon=\"icon-printer\"></md-icon>\n</md-button>");
                    var link = this.$compile(element.contents());
                    link(scope);
                }
                else {
                    element.replaceWith("<object type=\"application/pdf\" data=\"" + url + "\" style=\"width: 100%; min-height: 480px;\"></object>");
                }
            };
            return PdfObjectDirective;
        }());
        documentos.PdfObjectDirective = PdfObjectDirective;
        angular.module("app.documentos").directive("stfPdfObject", PdfObjectDirective.factory());
    })(documentos = app.documentos || (app.documentos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var documentos;
    (function (documentos) {
        "use strict";
        var OnlyofficeService = /** @class */ (function () {
            /** @ngInject **/
            OnlyofficeService.$inject = ["$http", "$q", "properties", "$cookies"];
            function OnlyofficeService($http, $q, properties, $cookies) {
                this.$http = $http;
                this.$q = $q;
                this.properties = properties;
                this.$cookies = $cookies;
            }
            OnlyofficeService.prototype.recuperarDocumentoId = function (id, context) {
                return this.$http.get(this.properties.apiUrl + "/" + context + "/api/textos/" + id + "/documento")
                    .then(function (response) {
                    return response.data;
                });
            };
            OnlyofficeService.prototype.criarUrlConteudoDocumento = function (id, temporario, context) {
                var _this = this;
                return this.getBaseUrl(context).then(function (baseUrl) {
                    return baseUrl + "/api/textos/documentos/" + _this.tempUrl(temporario) + id + "/conteudo.docx?" +
                        _this.accessTokenParam();
                });
            };
            OnlyofficeService.prototype.gerarNumeroEdicao = function (id, temporario, context) {
                return this.$http.put(this.properties.apiUrl + "/" + context + "/api/textos/documentos/" + this.tempUrl(temporario) + id + "/numero-edicao", null)
                    .then(function (response) {
                    return response.data;
                });
            };
            OnlyofficeService.prototype.excluirNumeroEdicao = function (id, temporario, context) {
                return this.$http.delete(this.properties.apiUrl + "/" + context + "/api/textos/documentos/" + this.tempUrl(temporario) + id + "/numero-edicao");
            };
            OnlyofficeService.prototype.recuperarNumeroEdicao = function (id, temporario, context) {
                return this.$http.get(this.properties.apiUrl + "/" + context + "/api/textos/documentos/" + this.tempUrl(temporario) + id + "/numero-edicao")
                    .then(function (response) {
                    return response.data;
                });
            };
            OnlyofficeService.prototype.recuperarUrlCallback = function (id, temporario, save, context, omitToken) {
                var _this = this;
                return this.$q.when(this.getBaseUrl(context)).then(function (baseUrl) {
                    return baseUrl + "/api/textos/documentos/" + _this.tempUrl(temporario) + id + "/integracao-onlyoffice?" +
                        ("" + (omitToken ? "" : _this.accessTokenParam()) + _this.saveParam(save));
                });
            };
            OnlyofficeService.prototype.recuperarUrlChanges = function (id, version, context) {
                return this.$q.when(this.properties.apiUrl + "/" + context + "/api/textos/documentos/" + id + "/conteudo.docx/" + version + "/changes.zip?" +
                    ("" + this.accessTokenParam()));
            };
            OnlyofficeService.prototype.existeChanges = function (id, version, context) {
                return this.$http.get(this.properties.apiUrl + "/" + context +
                    ("/api/textos/documentos/" + id + "/conteudo.docx/" + version + "/changes.zip/existe?") +
                    ("" + this.accessTokenParam())).then(function (response) {
                    return response.data;
                });
            };
            OnlyofficeService.prototype.recuperarUrlDocumentVersion = function (id, version, context) {
                var _this = this;
                return this.$q.when(this.getBaseUrl(context)).then(function (baseUrl) {
                    return baseUrl + "/api/textos/documentos/" + id + "/conteudo.docx/" + version + "?" +
                        ("" + _this.accessTokenParam());
                });
            };
            OnlyofficeService.prototype.recuperarUrlArquivoApi = function () {
                return this.properties.onlyofficeUrl + "/web-apps/apps/api/documents/api.js";
            };
            OnlyofficeService.prototype.recuperarUrlPlugins = function (context) {
                return this.$q.when("" + this.properties.onlyofficePluginsUrl);
            };
            OnlyofficeService.prototype.recuperarInfo = function (numeroEdicao, context) {
                return this.$http.get(this.properties.apiUrl + "/" + context + "/api/textos/command-service/" + numeroEdicao + "/info")
                    .then(function (response) {
                    return response.data;
                });
            };
            OnlyofficeService.prototype.removerUsuariosEdicao = function (edicao, context) {
                if (!edicao.usuarios || edicao.usuarios.length === 0) {
                    return this.$q.when({});
                }
                var cmd = {
                    key: edicao.numero,
                    users: edicao.usuarios
                };
                return this.$http({
                    method: "POST",
                    url: this.properties.apiUrl + "/" + context + "/api/textos/command-service/drop",
                    data: cmd,
                    transformResponse: function (data) {
                        return { key: data };
                    }
                }).then(function (response) {
                    return response.data;
                });
            };
            OnlyofficeService.prototype.getBaseUrl = function (context) {
                return this.$http({
                    method: "GET",
                    cache: true,
                    url: this.properties.apiUrl + "/" + context + "/api/textos/url",
                    transformResponse: function (data) {
                        return { url: data };
                    }
                }).then(function (response) {
                    return response.data.url;
                });
            };
            OnlyofficeService.prototype.tempUrl = function (temporario) {
                return temporario ? "temporarios/" : "";
            };
            OnlyofficeService.prototype.accessTokenParam = function () {
                return "access_token=" + this.$cookies.get("access_token");
            };
            OnlyofficeService.prototype.saveParam = function (save) {
                return "&save=" + (save ? "true" : "false");
            };
            OnlyofficeService.prototype.generateJwtToken = function (config, context) {
                return this.$http.post(this.properties.apiUrl + "/" + context + "/api/onlyoffice/jwt", config)
                    .then(function (response) {
                    return response.data;
                });
            };
            OnlyofficeService.prototype.generateJwtTokenHistoryData = function (historyData, context) {
                return this.$http.post(this.properties.apiUrl + "/" + context + "/api/onlyoffice/jwt/history-data", historyData)
                    .then(function (response) {
                    return response.data;
                });
            };
            OnlyofficeService.prototype.recuperarHistorico = function (id, context) {
                return this.$http.get(this.properties.apiUrl + "/" + context + "/api/textos/documentos/" + id + "/historico")
                    .then(function (response) {
                    return response.data;
                });
            };
            OnlyofficeService.prototype.isSecure = function () {
                return this.properties.onlyofficeSecure;
            };
            OnlyofficeService.prototype.isHistoryEnabled = function (context) {
                return this.$http.get(this.properties.apiUrl + "/" + context + "/api/textos/history/enabled")
                    .then(function (response) {
                    return response.data;
                });
            };
            OnlyofficeService.prototype.restaurarVersao = function (id, version, context) {
                return this.$http.post(this.properties.apiUrl + "/" + context + "/api/textos/documentos/" + id + "/restore/" + version, {});
            };
            return OnlyofficeService;
        }());
        documentos.OnlyofficeService = OnlyofficeService;
        angular.module("app.documentos").service("app.documentos.OnlyofficeService", OnlyofficeService);
    })(documentos = app.documentos || (app.documentos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var documentos;
    (function (documentos) {
        var DownloadLinkDirective = /** @class */ (function () {
            function DownloadLinkDirective($parse, $cookies) {
                this.$parse = $parse;
                this.$cookies = $cookies;
                this.restrict = "A";
                this.clickCallback = this.clickCallback.bind(this);
                this.link = this.link.bind(this);
            }
            DownloadLinkDirective.factory = function () {
                return ["$parse", "$cookies", function ($parse, $cookies) {
                        return new DownloadLinkDirective($parse, $cookies);
                    }];
            };
            DownloadLinkDirective.prototype.link = function (scope, element, attrs) {
                var _this = this;
                element.bind("click", function () { return _this.clickCallback(scope, attrs); });
            };
            DownloadLinkDirective.prototype.clickCallback = function (scope, attrs) {
                var conteudo = attrs["downloadLink"];
                var url = this.$parse(conteudo)(scope);
                var urlParams = new URLSearchParams(url);
                var anchor = document.createElement("a");
                if (!!attrs["filename"]) {
                    var nomeArquivo = attrs["filename"];
                    anchor.download = this.$parse(nomeArquivo)(scope);
                }
                if (!urlParams.has("access_token")) {
                    url += url.indexOf("?") === -1 ? "?" : "&";
                    url += "access_token=" + this.$cookies.get("access_token");
                }
                anchor.href = url;
                anchor.hidden = true;
                anchor.target = "_blank";
                anchor.click();
                anchor = null;
            };
            return DownloadLinkDirective;
        }());
        documentos.DownloadLinkDirective = DownloadLinkDirective;
        angular.module("app.documentos").directive("downloadLink", DownloadLinkDirective.factory());
    })(documentos = app.documentos || (app.documentos = {}));
})(app || (app = {}));



var app;
(function (app) {
    var informacoes;
    (function (informacoes) {
        "use strict";
        /** @ngInject * */
        config.$inject = ["$stateProvider"];
        run.$inject = ["stfBreadcrumbsService"];
        function config($stateProvider) {
            $stateProvider.state("app.informacoes", {
                abstract: true,
                url: "/informacoes",
                parent: "app.autenticado"
            });
        }
        /** @ngInject */
        function run(stfBreadcrumbsService) {
            stfBreadcrumbsService.registerPath({
                id: "informacoes",
                translation: "Informações",
                uisref: "app.informacoes"
            });
        }
        angular
            .module("app.informacoes", ["app.autenticado", "app.support"])
            .config(config)
            .run(run);
    })(informacoes = app.informacoes || (app.informacoes = {}));
})(app || (app = {}));



var app;
(function (app) {
    var configuracoes;
    (function (configuracoes) {
        "use strict";
        /** @ngInject **/
        config.$inject = ["$translatePartialLoaderProvider", "$stateProvider", "$futureStateProvider"];
        function config($translatePartialLoaderProvider, $stateProvider, $futureStateProvider) {
            $translatePartialLoaderProvider.addPart("app/main/configuracoes");
            $stateProvider.state("app.configuracoes", {
                abstract: true,
                url: "/configuracoes",
                parent: "app.autenticado"
            });
            $futureStateProvider.addResolve(/** @ngInject **/ ["$q", "$injector", "$rootScope", "app.configuracoes.ConfiguracoesService", function ($q, $injector, $rootScope, configuracoesService) {
                var deferredConfigurationsLoading = $q.defer();
                function loadFutureConfigurations() {
                    configuracoesService.carregarConfiguracoes().then(function (configurations) {
                        for (var _i = 0, configurations_1 = configurations; _i < configurations_1.length; _i++) {
                            var configuration = configurations_1[_i];
                            $futureStateProvider.futureState({
                                type: "load",
                                stateName: configuration.stateName,
                                url: configuration.url,
                                src: configuration.src
                            });
                        }
                        deferredConfigurationsLoading.resolve();
                    }, function () {
                        deferredConfigurationsLoading.reject();
                    });
                }
                loadFutureConfigurations();
                $rootScope.$on("user:logged", function () {
                    configuracoesService.resetConfiguracoes();
                    loadFutureConfigurations();
                });
                $rootScope.$on("user:exited", function () {
                    configuracoesService.resetConfiguracoes();
                });
                return deferredConfigurationsLoading.promise;
            }]);
        }
        function run(stfBreadcrumbsService) {
            stfBreadcrumbsService.registerPath({
                id: "configuracoes",
                translation: "Configurações",
                uisref: "app.configuracoes"
            });
        }
        run.$inject = ["stfBreadcrumbsService"];
        angular
            .module("app.configuracoes", ["app.autenticado", "app.support", "app.toolbar"])
            .config(config)
            .run(run);
    })(configuracoes = app.configuracoes || (app.configuracoes = {}));
})(app || (app = {}));



var app;
(function (app) {
    var configuracoes;
    (function (configuracoes) {
        var ConfiguracoesService = /** @class */ (function () {
            /** @ngInject */
            ConfiguracoesService.$inject = ["$rootScope", "$http", "properties", "toolbarService"];
            function ConfiguracoesService($rootScope, $http, properties, toolbarService) {
                this.$rootScope = $rootScope;
                this.$http = $http;
                this.properties = properties;
                this.toolbarService = toolbarService;
            }
            ConfiguracoesService.prototype.carregarConfiguracoes = function () {
                var _this = this;
                if (!this.configuracoesPromise) {
                    this.configuracoesPromise = this.$http.get(this.properties.apiUrl + "/integracoes-modulos/api/configurations")
                        .then(function (response) {
                        response.data
                            .forEach(function (configuration) { return _this.addConfigurationToNavigation(configuration); });
                        return response.data;
                    });
                }
                return this.configuracoesPromise;
            };
            ConfiguracoesService.prototype.resetConfiguracoes = function () {
                this.configuracoesPromise = null;
                this.toolbarService.clearConfigurations();
            };
            ConfiguracoesService.prototype.addConfigurationToNavigation = function (configuration) {
                this.toolbarService.pushConfiguration(configuration);
            };
            return ConfiguracoesService;
        }());
        configuracoes.ConfiguracoesService = ConfiguracoesService;
        angular.module("app.configuracoes")
            .service("app.configuracoes.ConfiguracoesService", ConfiguracoesService);
    })(configuracoes = app.configuracoes || (app.configuracoes = {}));
})(app || (app = {}));



var app;
(function (app) {
    var certification;
    (function (certification) {
        var SigningManager = /** @class */ (function () {
            function SigningManager($q, cryptoService, signatureService, maximumParallelSignatures, context) {
                this.$q = $q;
                this.cryptoService = cryptoService;
                this.signatureService = signatureService;
                this.maximumParallelSignatures = maximumParallelSignatures;
                this.context = context;
                this.tokens = [];
                this.availableParallelSignatures = maximumParallelSignatures;
            }
            /**
             * Recupera o certificado já selecionado ou
             * pede o usuário para selecionar caso nenhum já tenha sido selecionado.
             *
             */
            SigningManager.prototype.recoverCertificate = function () {
                var _this = this;
                if (!this.certificateDeferred) {
                    this.certificateDeferred = this.$q.defer();
                    this.cryptoService.getCertificate({ lang: "en" }).then(function (certificate) {
                        _this.certificateDeferred.resolve(certificate);
                    }, function (err) {
                        _this.certificateDeferred.reject({ "error": err });
                    });
                }
                if (this.availableParallelSignatures === 0) {
                    var token = this.$q.defer();
                    this.tokens.push(token);
                    return token.promise.then(function () {
                        return _this.certificateDeferred.promise;
                    });
                }
                else {
                    this.availableParallelSignatures--;
                    return this.certificateDeferred.promise;
                }
            };
            SigningManager.prototype.signingFinished = function () {
                if (this.tokens.length > 0) {
                    var token = this.tokens.shift();
                    token.resolve();
                }
                this.availableParallelSignatures++;
            };
            SigningManager.prototype.getAvailableParallelSignatures = function () {
                return this.availableParallelSignatures;
            };
            SigningManager.prototype.createSigner = function () {
                return new certification.Signer(this, this.cryptoService, this.signatureService, this.$q, this.context);
            };
            return SigningManager;
        }());
        certification.SigningManager = SigningManager;
    })(certification = app.certification || (app.certification = {}));
})(app || (app = {}));



var app;
(function (app) {
    var certification;
    (function (certification) {
        var ProgressTracker = /** @class */ (function () {
            function ProgressTracker() {
                this.finishedSteps = 0;
                this.totalSteps = 0;
            }
            ProgressTracker.prototype.incrementTotalSteps = function () {
                this.totalSteps++;
            };
            ProgressTracker.prototype.incrementFinishedSteps = function () {
                this.finishedSteps++;
            };
            ProgressTracker.prototype.currentProgress = function () {
                return this.currentProgressOfTotal(100);
            };
            ProgressTracker.prototype.currentProgressOfTotal = function (totalProgress) {
                return (this.finishedSteps / this.totalSteps) * totalProgress;
            };
            ProgressTracker.prototype.getTotalSteps = function () {
                return this.totalSteps;
            };
            return ProgressTracker;
        }());
        certification.ProgressTracker = ProgressTracker;
        /**
         * Representa uma cadeia de passos a serem executados
         * sequencialmente, encapsulando a passagem de um dado
         * para o próximo passo como resultado do passo atual.
         */
        var StepsChain = /** @class */ (function () {
            function StepsChain($q, progressTracker, data) {
                this.$q = $q;
                this.progressTracker = progressTracker;
                this.data = $q.when(data);
            }
            StepsChain.prototype.chain = function (func) {
                var _this = this;
                this.progressTracker.incrementTotalSteps();
                var promise = this.$q(function (resolve, reject) {
                    _this.data.then(function (dataObj) {
                        func(dataObj).then(function (obj) {
                            _this.progressTracker.incrementFinishedSteps();
                            resolve(obj);
                        }, function (error) {
                            reject(error);
                        });
                    }, function (error) {
                        reject(error);
                    });
                });
                return new StepsChain(this.$q, this.progressTracker, promise);
            };
            StepsChain.prototype.promise = function () {
                return this.data;
            };
            return StepsChain;
        }());
        certification.StepsChain = StepsChain;
        var Signer = /** @class */ (function () {
            function Signer(manager, cryptoService, signatureService, $q, context) {
                this.manager = manager;
                this.cryptoService = cryptoService;
                this.signatureService = signatureService;
                this.$q = $q;
                this.context = context;
            }
            /**
             * Registra um callback a ser chamado quando o signer do
             * backend estiver pronto para a assinatura.
             */
            Signer.prototype.onSignerReady = function (callback) {
                this.signerCreatedCallback = callback;
            };
            /**
             * Registra um callback a ser chamado quando o processo de
             * assinatura tiver sido completado.
             */
            Signer.prototype.onSigningCompleted = function (callback) {
                this.signingCompletedCallback = callback;
            };
            /**
             * Registra um callback a ser chamado quando ocorrer algum
             * erro durante o processo de assinatura.
             */
            Signer.prototype.onErrorCallback = function (callback) {
                this.errorCallback = callback;
            };
            Signer.prototype.saveSignedDocument = function () {
                return this.signatureService.save(this.signer.signerId, this.context);
            };
            Signer.prototype.provideExistingDocument = function (documentId) {
                var _this = this;
                var command = new certification.ProvideToSignCommand(this.signer.signerId, documentId);
                this.signatureService.provideToSign(command, this.context).then(function () {
                    _this.triggerDocumentProvided();
                }, function (error) {
                    _this.errorCallback(new certification.SigningError(error));
                });
            };
            Signer.prototype.getProgressTracker = function () {
                return this.progressTracker;
            };
            Signer.prototype.triggerDocumentProvided = function () {
                if (this.documentUploadDeferred) {
                    this.documentUploadDeferred.resolve(this.signer);
                }
            };
            /**
             * Inicia a cadeia de chamadas para efetuar a assinatura. Esses passos
             * envolvem operações tanto no cliente, quanto no servidor, que precisam
             * ser executados em ordem para gerar um documento assinado com sucesso.
             */
            Signer.prototype.start = function () {
                var _this = this;
                this.progressTracker = new ProgressTracker();
                this.cryptoService.use("auto").then(function (status) {
                    var sc = new StepsChain(_this.$q, _this.progressTracker, null);
                    sc.chain(function () { return _this.requestUserCertificate(); })
                        .chain(function (certificate) { return _this.storeCertificate(certificate); })
                        .chain(function (certificate) { return _this.prepare(certificate); })
                        .chain(function (signer) { return _this.storeSigner(signer); })
                        .chain(function (signer) { return _this.callSignerReadyCallback(signer); })
                        // A chamada acima bloqueará o encadeamento até que o upload seja concluído.
                        .chain(function (signer) { return _this.preSign(signer); })
                        .chain(function (preSignature) { return _this.sign(preSignature); })
                        .chain(function (signature) { return _this.postSign(signature); })
                        .chain(function () { return _this.callSigningCompletedCallback(); })
                        .promise()
                        .catch(function (error) {
                        if (error.error) {
                            if (error.error.message == "no_implementation") {
                                _this.callErrorCallback("O plugin de assinatura não foi encontrado. Por favor instalar em http://www.id.ee/");
                            }
                            else if (error.error.message == "no_certificates") {
                                _this.callErrorCallback("Nenhum certificado encontrado.");
                            }
                            else if (error.error.message == "user_cancel") {
                                _this.callErrorCallback("Usuário cancelou a operação.");
                            }
                            else {
                                console.error(error);
                                _this.callErrorCallback(error.error);
                            }
                        }
                        else {
                            console.error(error);
                            _this.callErrorCallback("Erro desconhecido.");
                        }
                    }).finally(function () {
                        _this.manager.signingFinished();
                    });
                }, function (error) {
                    _this.callErrorCallback("O plugin de assinatura não foi encontrado.");
                });
            };
            Signer.prototype.requestUserCertificate = function () {
                return this.manager.recoverCertificate();
            };
            Signer.prototype.storeCertificate = function (certificate) {
                this.certificate = certificate;
                return this.$q.when(certificate);
            };
            Signer.prototype.storeSigner = function (signer) {
                this.signer = signer;
                return this.$q.when(signer);
            };
            Signer.prototype.prepare = function (certificate) {
                var command = new certification.PrepareCommand(certificate.hex);
                return this.signatureService.prepare(command, this.context);
            };
            /**
             * Chama o callback cadastrado quando o signer já tiver
             * sido preparado no backend.
             */
            Signer.prototype.callSignerReadyCallback = function (signer) {
                this.documentUploadDeferred = this.$q.defer();
                if (this.signerCreatedCallback) {
                    this.signerCreatedCallback(signer);
                }
                else {
                    this.documentUploadDeferred.reject(new certification.SigningError("Callback SignerCreated não definido."));
                }
                return this.documentUploadDeferred.promise;
            };
            Signer.prototype.preSign = function (signer) {
                var command = new certification.PreSignCommand(signer.signerId);
                return this.signatureService.preSign(command, this.context);
            };
            Signer.prototype.sign = function (preSignature) {
                var _this = this;
                return this.$q(function (resolve, reject) {
                    _this.cryptoService.sign(_this.certificate, {
                        data: preSignature.data,
                        type: "SHA-256",
                        hex: preSignature.hash
                    }, {
                        lang: "en"
                    }).then(function (signature) {
                        resolve(signature);
                    });
                });
            };
            Signer.prototype.postSign = function (signature) {
                var command = new certification.PostSignCommand(this.signer.signerId, signature.hex);
                return this.signatureService.postSign(command, this.context);
            };
            Signer.prototype.callSigningCompletedCallback = function () {
                if (this.signingCompletedCallback) {
                    this.signingCompletedCallback();
                }
                return this.$q.when();
            };
            Signer.prototype.callErrorCallback = function (error) {
                if (this.errorCallback) {
                    this.errorCallback(new certification.SigningError(error));
                }
            };
            return Signer;
        }());
        certification.Signer = Signer;
    })(certification = app.certification || (app.certification = {}));
})(app || (app = {}));



var app;
(function (app) {
    var certification;
    (function (certification) {
        "use strict";
        angular.module("app.certification", ["app.autenticado"]);
    })(certification = app.certification || (app.certification = {}));
})(app || (app = {}));



var app;
(function (app) {
    var certification;
    (function (certification) {
        var SigningError = /** @class */ (function () {
            function SigningError(error) {
                this.error = error;
            }
            return SigningError;
        }());
        certification.SigningError = SigningError;
        var PrepareCommand = /** @class */ (function () {
            function PrepareCommand(certificateAsHex) {
                this.certificateAsHex = certificateAsHex;
            }
            return PrepareCommand;
        }());
        certification.PrepareCommand = PrepareCommand;
        var PreSignCommand = /** @class */ (function () {
            function PreSignCommand(signerId) {
                this.signerId = signerId;
            }
            return PreSignCommand;
        }());
        certification.PreSignCommand = PreSignCommand;
        var ProvideToSignCommand = /** @class */ (function () {
            function ProvideToSignCommand(signerId, documentId) {
                this.signerId = signerId;
                this.documentId = documentId;
            }
            return ProvideToSignCommand;
        }());
        certification.ProvideToSignCommand = ProvideToSignCommand;
        var PostSignCommand = /** @class */ (function () {
            function PostSignCommand(signerId, signatureAsHex) {
                this.signerId = signerId;
                this.signatureAsHex = signatureAsHex;
            }
            return PostSignCommand;
        }());
        certification.PostSignCommand = PostSignCommand;
        var SignatureService = /** @class */ (function () {
            /** @ngInject **/
            SignatureService.$inject = ["properties", "$http", "$q", "app.certification.CryptoService"];
            function SignatureService(properties, $http, $q, cryptoService) {
                this.properties = properties;
                this.$http = $http;
                this.$q = $q;
                this.cryptoService = cryptoService;
            }
            SignatureService.prototype.prepare = function (command, context) {
                var url = this.properties.apiUrl + "/" + context + "/" + SignatureService.apiSignature;
                return this.$http.post(url, command)
                    .then(function (response) { return response.data; });
            };
            SignatureService.prototype.provideToSign = function (command, context) {
                var url = this.properties.apiUrl + "/" + context + "/" + SignatureService.apiSignature +
                    ("/" + command.signerId + "/associacao-documento");
                return this.$http.post(url, command)
                    .then(function () { return null; });
            };
            SignatureService.prototype.preSign = function (command, context) {
                var url = this.properties.apiUrl + "/" + context + "/" + SignatureService.apiSignature +
                    ("/" + command.signerId + "/pre-assinatura");
                return this.$http.post(url, command)
                    .then(function (response) { return response.data; });
            };
            SignatureService.prototype.postSign = function (command, context) {
                var url = this.properties.apiUrl + "/" + context + "/" + SignatureService.apiSignature +
                    ("/" + command.signerId + "/pos-assinatura");
                return this.$http.post(url, command)
                    .then(function () { return null; });
            };
            SignatureService.prototype.save = function (signerId, context) {
                var url = this.properties.apiUrl + "/" + context + "/" + SignatureService.apiSignature +
                    ("/" + signerId + "/documento-assinado");
                return this.$http.post(url, {})
                    .then(function (response) { return response.data; });
            };
            SignatureService.prototype.signingManager = function (maximumParallelSignatures, context) {
                if (maximumParallelSignatures === void 0) { maximumParallelSignatures = 2; }
                return new certification.SigningManager(this.$q, this.cryptoService, this, maximumParallelSignatures, context);
            };
            SignatureService.apiSignature = "api/assinadores";
            return SignatureService;
        }());
        certification.SignatureService = SignatureService;
        angular.module("app.certification").service("signatureService", SignatureService);
    })(certification = app.certification || (app.certification = {}));
})(app || (app = {}));



var hwcrypto;
(function (hwcrypto) {
})(hwcrypto || (hwcrypto = {}));
var app;
(function (app) {
    var certification;
    (function (certification) {
        "use strict";
        var CryptoService = /** @class */ (function () {
            function CryptoService() {
            }
            CryptoService.prototype.use = function (backend) {
                return hwcrypto.use(backend);
            };
            CryptoService.prototype.getCertificate = function (options) {
                return hwcrypto.getCertificate(options);
            };
            CryptoService.prototype.sign = function (certificate, data, options) {
                return hwcrypto.sign(certificate, { type: data.type, hex: data.hex }, options);
            };
            return CryptoService;
        }());
        certification.CryptoService = CryptoService;
        angular.module("app.certification").service("app.certification.CryptoService", CryptoService);
    })(certification = app.certification || (app.certification = {}));
})(app || (app = {}));



var app;
(function (app) {
    var cadastro;
    (function (cadastro) {
        "use strict";
        /** @ngInject **/
        config.$inject = ["$translatePartialLoaderProvider", "$stateProvider"];
        function config($translatePartialLoaderProvider, $stateProvider) {
            $translatePartialLoaderProvider.addPart("app/main/cadastro");
            $stateProvider.state("app.cadastro", {
                parent: "app.nao-autenticado",
                url: "/cadastro",
                views: {
                    "form@app.nao-autenticado": {
                        templateUrl: "app/main/cadastro/cadastro.html",
                        controller: cadastro.CadastroController,
                        controllerAs: "vm"
                    }
                }
            });
        }
        angular
            .module("app.cadastro", ["app.nao-autenticado", "ngMask"])
            .config(config);
    })(cadastro = app.cadastro || (app.cadastro = {}));
})(app || (app = {}));



var app;
(function (app) {
    var cadastro;
    (function (cadastro) {
        "use strict";
        var CadastroController = /** @class */ (function () {
            function CadastroController() {
                //this.form.tipoCadastro = 1;
            }
            CadastroController.prototype.cadastrar = function () {
                console.info("TODO: Fazer cadastro. Detalhes do usuário: ", this.form);
            };
            return CadastroController;
        }());
        cadastro.CadastroController = CadastroController;
        angular
            .module("app.cadastro")
            .controller("app.cadastro.CadastroController", CadastroController);
    })(cadastro = app.cadastro || (app.cadastro = {}));
})(app || (app = {}));



var app;
(function (app) {
    var autenticacao;
    (function (autenticacao) {
        "use strict";
        var InformacaoDirective = /** @class */ (function () {
            function InformacaoDirective($timeout, informacaoService, $compile) {
                var _this = this;
                this.$timeout = $timeout;
                this.informacaoService = informacaoService;
                this.$compile = $compile;
                this.restrict = "E";
                this.scope = {
                    value: "=",
                    tipo: "=",
                    params: "@"
                };
                this.link = function (scope, element, attrs) {
                    scope.$watchGroup([function () { return scope.value; }, function () { return scope.tipo; }, function () { return scope.params; }], function (newValue, oldValue) {
                        var consulta = _this.informacaoService.getViewer();
                        var processo = newValue;
                        var controller = consulta.controller;
                        var params = processo.pop().replace(/"/g, "'");
                        var template = consulta.template;
                        var alias = consulta.controllerAs;
                        if (!params) {
                            params = "''";
                        }
                        var directiveHtml = "<div data-ng-controller=\"" + controller + " as " + alias + "\" ng-init=\"" + alias + ".init('" + processo + "', " + params + ")\">" + template + "</div>";
                        element.html(directiveHtml);
                        var link = _this.$compile(element.contents());
                        link(scope);
                    });
                };
            }
            InformacaoDirective.factory = function () {
                return ["$timeout", "informacaoService", "$compile", function ($timeout, informacaoService, $compile) {
                    "ngInject";
                    return new InformacaoDirective($timeout, informacaoService, $compile);
                }];
            };
            return InformacaoDirective;
        }());
        angular.module("app.autenticacao").directive("informacao", InformacaoDirective.factory());
    })(autenticacao = app.autenticacao || (app.autenticacao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var autenticacao;
    (function (autenticacao) {
        "use strict";
        var InstanaService = /** @class */ (function () {
            /** @ngInject **/
            function InstanaService() {
            }
            InstanaService.prototype.registerUser = function (user) {
                if (this.registeredUserLogin !== user.login) {
                    if (this.isInstanaEUMDefined()) {
                        ineum('user', user.login, user.nome, user.email);
                    }
                    this.registeredUserLogin = user.login;
                }
            };
            InstanaService.prototype.unregisterUser = function () {
                if (this.registeredUserLogin) {
                    if (this.isInstanaEUMDefined()) {
                        ineum('user', null, null, null);
                    }
                    this.registeredUserLogin = null;
                }
            };
            InstanaService.prototype.isInstanaEUMDefined = function () {
                return typeof ineum !== 'undefined';
            };
            return InstanaService;
        }());
        autenticacao.InstanaService = InstanaService;
        angular
            .module("app.autenticacao")
            .service("instanaService", InstanaService);
    })(autenticacao = app.autenticacao || (app.autenticacao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var autenticacao;
    (function (autenticacao) {
        "use strict";
        var AuthService = /** @class */ (function () {
            /** @ngInject **/
            AuthService.$inject = ["$http", "$cookies", "$httpParamSerializer", "$q", "$rootScope", "properties", "$cacheFactory", "$window", "instanaService"];
            function AuthService($http, $cookies, $httpParamSerializer, $q, $rootScope, properties, $cacheFactory, $window, instanaService) {
                this.$http = $http;
                this.$cookies = $cookies;
                this.$httpParamSerializer = $httpParamSerializer;
                this.$q = $q;
                this.$rootScope = $rootScope;
                this.properties = properties;
                this.$cacheFactory = $cacheFactory;
                this.$window = $window;
                this.instanaService = instanaService;
                this.AUTH_POST_CONTENT_TYPE = "application/x-www-form-urlencoded; charset=utf-8";
                this.ACCESS_TOKEN = "access_token";
                this.user = null;
                this.msalInstance = null;
                this.msalConfig = {
                    auth: {
                        clientId: this.properties.msalClientId,
                        authority: "https://login.microsoftonline.com/" + this.properties.msalTennantId,
                        navigateToLoginRequestUrl: true
                    },
                    cache: {
                        cacheLocation: "sessionStorage",
                        storeAuthStateInCookie: true,
                        secureCookies: true,
                        claimsBasedCachingEnabled: true
                    }
                };
                this.msalScopes = [this.properties.msalClientId + "/.default"];
                this.msalAccount = null;
                this.USER_QUERY_URL = properties.apiUrl + "/integracoes-identidades/api/user";
                this.OAUTH_TOKEN_URL = properties.apiUrl + "/integracoes-identidades/oauth/token";
                this.OAUTH_REVOKE_TOKEN_URL = properties.apiUrl + "/integracoes-identidades/oauth/access-token";
                this.msalInstance = new msal.PublicClientApplication(this.msalConfig);
                this.msalInstance.initialize();
            }
            /**
             * Verifica o tipo de autenticação
             */
            AuthService.prototype.isLocalAuthentication = function () {
                return this.properties.msalClientId === undefined;
            };
            /**
             * Verifica se o usuário já se autenticou no sistema. A verificação aqui checa se o token de acesso previamente
             * armazenado (durante o login do usuário) ainda está válido no servidor.
             */
            AuthService.prototype.isAuthenticated = function () {
                return this.$http.get(this.USER_QUERY_URL).then(function (response) {
                    return response.data;
                });
            };
            /**
             * Retorna os dados do usuário logado.
             */
            AuthService.prototype.getUser = function (useCache) {
                var _this = this;
                if (useCache === void 0) { useCache = true; }
                if (this.$cookies.get(this.ACCESS_TOKEN)) {
                    var params = {};
                    if (!useCache) {
                        params["ts"] = new Date().getTime();
                    }
                    return this.$http.get(this.USER_QUERY_URL, { cache: useCache, params: params }).then(function (response) {
                        _this.instanaService.registerUser(response.data);
                        return _this.user = response.data;
                    });
                }
                return this.$q.reject("Usuário ainda não foi carregado!");
            };
            /**
             * Utiliza a API fornecida pelo Oauth2 para solicitar um token de acesso. Utiliza "password"
             * como grant type e Basic Authorization para informar as credenciais do cliente.
             */
            AuthService.prototype.authenticate = function (login, password, selectAccount) {
                var _this = this;
                if (selectAccount === void 0) { selectAccount = false; }
                this.clear();
                if (this.isLocalAuthentication()) {
                    return this.authentication(login, password);
                }
                else {
                    var promise = null;
                    if (selectAccount) {
                        promise = this.msalInstance.loginPopup({ scopes: this.msalScopes, prompt: "select_account", forceRefresh: true });
                    }
                    else {
                        promise = this.msalInstance.acquireTokenSilent({ scopes: this.msalScopes, account: this.msalAccount, forceRefresh: true })
                            .then(function (response) { return response; }, function (error) {
                            console.error("Silent Error: " + error);
                            return _this.msalInstance.acquireTokenPopup({ scopes: _this.msalScopes, account: _this.msalAccount });
                        });
                    }
                    return promise.then(function (response) {
                        _this.msalAccount = response.account;
                        login = response.account.username;
                        password = response.idToken;
                        return _this.authentication(login, password);
                    });
                }
            };
            /**
             * Invalida a seção no serviço de autenticação e remove o cookie com o token de acesso.
             */
            AuthService.prototype.logout = function () {
                return this.localLogout();
            };
            AuthService.prototype.logoutAll = function () {
                var _this = this;
                if (this.isLocalAuthentication()) {
                    return this.localLogout();
                }
                else {
                    var logoutRequest_1 = {
                        logoutHint: this.msalAccount.idTokenClaims.login_hint
                    };
                    return this.localLogout()
                        .then(function () { return _this.msalInstance.logoutPopup(logoutRequest_1); });
                }
            };
            AuthService.prototype.getUserLogin = function () {
                return !!this.user ? this.user.login : null;
            };
            AuthService.prototype.clearCache = function () {
                var httpCache = this.$cacheFactory.get("$http");
                if (httpCache) {
                    httpCache.removeAll();
                }
            };
            AuthService.prototype.verifyRedirectAndAuthenticate = function () {
                var _this = this;
                return this.msalInstance.handleRedirectPromise()
                    .then(function (response) {
                    if (!!response) {
                        _this.msalAccount = response.account;
                        return _this.authentication(response.account.username, response.idToken)
                            .then(function () { return true; });
                    }
                    else {
                        return false;
                    }
                }, function (error) {
                    console.error("Erro ao verificar se houve redirecionamento: " + error);
                    return false;
                });
            };
            /**
             * Nenhum código será executado após a chamada a este método.
             */
            AuthService.prototype.loginRedirect = function () {
                return this.msalInstance.loginRedirect({
                    scopes: this.msalScopes,
                    prompt: "select_account"
                });
            };
            AuthService.prototype.clear = function () {
                this.clearCache();
                this.$window.localStorage.removeItem("searchData");
                this.$window.localStorage.removeItem("searchHistoricData");
                this.$cookies.remove(this.ACCESS_TOKEN);
                this.user = null;
                this.msalAccount = null;
                this.instanaService.unregisterUser();
            };
            AuthService.prototype.authentication = function (usuario, senha) {
                var _this = this;
                var data = { username: usuario, password: senha, grant_type: "password" };
                var request = {
                    method: "POST",
                    url: this.OAUTH_TOKEN_URL,
                    headers: {
                        "Authorization": "Basic " + btoa("userinterface:userinterface"),
                        "Content-type": this.AUTH_POST_CONTENT_TYPE
                    },
                    data: this.$httpParamSerializer(data)
                };
                return this.$http(request).then(function (response) {
                    var authInfo = response.data;
                    _this.$cookies.put(_this.ACCESS_TOKEN, authInfo.access_token, { path: "/", secure: true });
                    _this.$rootScope.$broadcast("user:logged");
                    // window.clarity("identify", usuario); // Descomentar se o clarity for reativado em algum momento
                    return authInfo;
                });
            };
            AuthService.prototype.localLogout = function () {
                var _this = this;
                return this.$http.delete(this.OAUTH_REVOKE_TOKEN_URL)
                    .then(function () {
                    _this.clear();
                    _this.$rootScope.$broadcast("user:exited");
                    _this.$window.location.href = "/login";
                });
            };
            return AuthService;
        }());
        autenticacao.AuthService = AuthService;
        angular
            .module("app.autenticacao")
            .service("authService", AuthService);
    })(autenticacao = app.autenticacao || (app.autenticacao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var autenticacao;
    (function (autenticacao) {
        "use strict";
        var AuthInterceptor = /** @class */ (function () {
            /** @ngInject **/
            AuthInterceptor.$inject = ["$q", "$window", "$cookies", "$injector"];
            function AuthInterceptor($q, $window, $cookies, $injector) {
                this.$q = $q;
                this.$window = $window;
                this.$cookies = $cookies;
                this.$injector = $injector;
                this.loginDialogOpen = false;
                this.request = this.request.bind(this);
                this.responseError = this.responseError.bind(this);
            }
            AuthInterceptor.prototype.request = function (config) {
                var accessToken = this.$cookies.get("access_token");
                var csrfToken = this.$cookies.get("XSRF-TOKEN");
                if (csrfToken) {
                    config.headers["X-XSRF-TOKEN"] = csrfToken;
                }
                if (accessToken) {
                    config.headers.Authorization = "Bearer " + accessToken;
                }
                config.headers["X-Forwarded-Prefix"] = "gateway";
                return config;
            };
            AuthInterceptor.prototype.responseError = function (response) {
                var path = this.$window.location.pathname;
                if (!this.loginDialogOpen && !!path && !path.startsWith("/publico/")) {
                    if (response.status === 401) {
                        var accessToken = this.$cookies.get("access_token");
                        if (accessToken && response.headers("WWW-Authenticate")) {
                            this.$cookies.remove("access_token");
                            if (path === "/") {
                                this.$window.location.href = "/login";
                            }
                            else {
                                return this.loginDialog(response);
                            }
                        }
                        else if (!accessToken && path !== "/login") {
                            if (path !== "/") {
                                this.$cookies.put("originalUrlRequest", path);
                            }
                            this.$window.location.href = "/login";
                        }
                    }
                }
                return this.$q.reject(response);
            };
            AuthInterceptor.prototype.loginDialog = function (response) {
                var _this = this;
                return this.$injector.invoke(/** @ngInject*/ ["$http", "$mdDialog", "authService", function ($http, $mdDialog, authService) {
                    var promise = null;
                    _this.loginDialogOpen = true;
                    if (authService.isLocalAuthentication()) {
                        promise = $mdDialog.show({
                            controller: autenticacao.LoginControllerDialog,
                            controllerAs: "vm",
                            templateUrl: "app/main/autenticacao/login/login-dialog.html",
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            escapeToClose: true,
                            hasBackdrop: true,
                            locals: {
                                login: authService.getUserLogin()
                            }
                        });
                    }
                    else {
                        promise = authService.authenticate();
                    }
                    return promise
                        .then(function () { return $http(response.config); }, function () {
                        _this.$window.location.href = "/login";
                        return _this.$q.reject(response);
                    })
                        .finally(function () { return _this.loginDialogOpen = false; });
                }]);
            };
            return AuthInterceptor;
        }());
        autenticacao.AuthInterceptor = AuthInterceptor;
        angular
            .module("app.autenticacao").service("AuthInterceptor", AuthInterceptor);
    })(autenticacao = app.autenticacao || (app.autenticacao = {}));
})(app || (app = {}));



var app;
(function (app) {
    var acoes;
    (function (acoes) {
        "use strict";
        /** @ngInject * */
        config.$inject = ["$stateProvider"];
        run.$inject = ["stfBreadcrumbsService"];
        function config($stateProvider) {
            $stateProvider.state("app.acoes", {
                abstract: true,
                url: "/acoes",
                parent: "app.autenticado"
            });
        }
        /** @ngInject */
        function run(stfBreadcrumbsService) {
            stfBreadcrumbsService.registerPath({
                id: "acoes",
                translation: "Ações",
                uisref: "app.acoes"
            });
        }
        angular
            .module("app.acoes", ["app.autenticado", "app.support"])
            .config(config)
            .run(run);
    })(acoes = app.acoes || (app.acoes = {}));
})(app || (app = {}));



var app;
(function (app) {
    var acessibilidade;
    (function (acessibilidade) {
        "use strict";
        angular
            .module("app.acessibilidade", []);
    })(acessibilidade = app.acessibilidade || (app.acessibilidade = {}));
})(app || (app = {}));



var app;
(function (app) {
    var acessibilidade;
    (function (acessibilidade) {
        var LibrasDirective = /** @class */ (function () {
            function LibrasDirective() {
                this.restrict = 'AE';
                this.scope = {};
            }
            LibrasDirective.prototype.link = function (scope, el, attrs) {
                jQuery("#vlibras-wrapper").show();
                scope.$on("$destroy", function () {
                    jQuery("#vlibras-wrapper").hide();
                });
            };
            LibrasDirective.factory = function () {
                return function () {
                    return new LibrasDirective();
                };
            };
            return LibrasDirective;
        }());
        angular.module('app.acessibilidade').directive('libras', LibrasDirective.factory());
    })(acessibilidade = app.acessibilidade || (app.acessibilidade = {}));
})(app || (app = {}));



(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('app', [

            // Core
            'app.core',

            "app.custom"
        ]);
})();
var app;
(function (app) {
    "use strict";
    var MainController = /** @class */ (function () {
        /** @ngInject **/
        MainController.$inject = ["$scope", "$rootScope", "$mdSidenav", "informacaoService"];
        function MainController($scope, $rootScope, $mdSidenav, informacaoService) {
            this.$mdSidenav = $mdSidenav;
            this.informacaoService = informacaoService;
            $scope.$on("$viewContentAnimationEnded", function (event) {
                if (event.targetScope.$id === $scope.$id) {
                    $rootScope.$broadcast("msSplashScreen::remove");
                }
            });
        }
        MainController.prototype.openSavedSearchs = function () {
            this.$mdSidenav("info-viewer").open();
        };
        MainController.prototype.getConsulta = function () {
            return this.informacaoService.getConsulta();
        };
        MainController.prototype.getInformacao = function () {
            return this.informacaoService.getInformacao();
        };
        MainController.prototype.isInfoNavOpen = function () {
            return this.$mdSidenav("info-viewer").isOpen();
        };
        return MainController;
    }());
    app.MainController = MainController;
    angular
        .module("app")
        .controller("app.MainController", MainController);
})(app || (app = {}));



tinymce.addI18n('pt_BR',{
"Redo": "Refazer",
"Undo": "Desfazer",
"Cut": "Recortar",
"Copy": "Copiar",
"Paste": "Colar",
"Select all": "Selecionar tudo",
"New document": "Novo documento",
"Ok": "Ok",
"Cancel": "Cancelar",
"Visual aids": "Ajuda visual",
"Bold": "Negrito",
"Italic": "It\u00e1lico",
"Underline": "Sublinhar",
"Strikethrough": "Riscar",
"Superscript": "Sobrescrito",
"Subscript": "Subscrever",
"Clear formatting": "Limpar formata\u00e7\u00e3o",
"Align left": "Alinhar \u00e0 esquerda",
"Align center": "Centralizar",
"Align right": "Alinhar \u00e0 direita",
"Justify": "Justificar",
"Bullet list": "Lista n\u00e3o ordenada",
"Numbered list": "Lista ordenada",
"Decrease indent": "Diminuir recuo",
"Increase indent": "Aumentar recuo",
"Close": "Fechar",
"Formats": "Formatos",
"Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X\/C\/V keyboard shortcuts instead.": "Seu navegador n\u00e3o suporta acesso direto \u00e0 \u00e1rea de transfer\u00eancia. Por favor use os atalhos Ctrl+X - C - V do teclado",
"Headers": "Cabe\u00e7alhos",
"Header 1": "Cabe\u00e7alho 1",
"Header 2": "Cabe\u00e7alho 2",
"Header 3": "Cabe\u00e7alho 3",
"Header 4": "Cabe\u00e7alho 4",
"Header 5": "Cabe\u00e7alho 5",
"Header 6": "Cabe\u00e7alho 6",
"Headings": "Cabe\u00e7alhos",
"Heading 1": "Cabe\u00e7alho 1",
"Heading 2": "Cabe\u00e7alho 2",
"Heading 3": "Cabe\u00e7alho 3",
"Heading 4": "Cabe\u00e7alho 4",
"Heading 5": "Cabe\u00e7alho 5",
"Heading 6": "Cabe\u00e7alho 6",
"Preformatted": "Preformatado",
"Div": "Div",
"Pre": "Pre",
"Code": "C\u00f3digo",
"Paragraph": "Par\u00e1grafo",
"Blockquote": "Aspas",
"Inline": "Em linha",
"Blocks": "Blocos",
"Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "O comando colar est\u00e1 agora em modo texto plano. O conte\u00fado ser\u00e1 colado como texto plano at\u00e9 voc\u00ea desligar esta op\u00e7\u00e3o.",
"Font Family": "Fonte",
"Font Sizes": "Tamanho",
"Class": "Classe",
"Browse for an image": "Procure uma imagem",
"OR": "OU",
"Drop an image here": "Arraste uma imagem aqui",
"Upload": "Carregar",
"Block": "Bloco",
"Align": "Alinhamento",
"Default": "Padr\u00e3o",
"Circle": "C\u00edrculo",
"Disc": "Disco",
"Square": "Quadrado",
"Lower Alpha": "a. b. c. ...",
"Lower Greek": "\u03b1. \u03b2. \u03b3. ...",
"Lower Roman": "i. ii. iii. ...",
"Upper Alpha": "A. B. C. ...",
"Upper Roman": "I. II. III. ...",
"Anchor": "\u00c2ncora",
"Name": "Nome",
"Id": "Id",
"Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "Id deve come\u00e7ar com uma letra, seguido apenas por letras, n\u00fameros, tra\u00e7os, pontos, dois pontos ou sublinhados.",
"You have unsaved changes are you sure you want to navigate away?": "Voc\u00ea tem mudan\u00e7as n\u00e3o salvas. Voc\u00ea tem certeza que deseja sair?",
"Restore last draft": "Restaurar \u00faltimo rascunho",
"Special character": "Caracteres especiais",
"Source code": "C\u00f3digo fonte",
"Insert\/Edit code sample": "Inserir\/Editar c\u00f3digo de exemplo",
"Language": "Idioma",
"Code sample": "Exemplo de c\u00f3digo",
"Color": "Cor",
"R": "R",
"G": "G",
"B": "B",
"Left to right": "Da esquerda para a direita",
"Right to left": "Da direita para a esquerda",
"Emoticons": "Emoticons",
"Document properties": "Propriedades do documento",
"Title": "T\u00edtulo",
"Keywords": "Palavras-chave",
"Description": "Descri\u00e7\u00e3o",
"Robots": "Rob\u00f4s",
"Author": "Autor",
"Encoding": "Codifica\u00e7\u00e3o",
"Fullscreen": "Tela cheia",
"Action": "A\u00e7\u00e3o",
"Shortcut": "Atalho",
"Help": "Ajuda",
"Address": "Endere\u00e7o",
"Focus to menubar": "Foco no menu",
"Focus to toolbar": "Foco na barra de ferramentas",
"Focus to element path": "Foco no caminho do elemento",
"Focus to contextual toolbar": "Foco na barra de ferramentas contextual",
"Insert link (if link plugin activated)": "Inserir link (se o plugin de link estiver ativado)",
"Save (if save plugin activated)": "Salvar (se o plugin de salvar estiver ativado)",
"Find (if searchreplace plugin activated)": "Procurar (se o plugin de procurar e substituir estiver ativado)",
"Plugins installed ({0}):": "Plugins instalados ({0}):",
"Premium plugins:": "Plugins premium:",
"Learn more...": "Saiba mais...",
"You are using {0}": "Voc\u00ea est\u00e1 usando {0}",
"Plugins": "Plugins",
"Handy Shortcuts": "Atalhos \u00fateis",
"Horizontal line": "Linha horizontal",
"Insert\/edit image": "Inserir\/editar imagem",
"Image description": "Inserir descri\u00e7\u00e3o",
"Source": "Endere\u00e7o da imagem",
"Dimensions": "Dimens\u00f5es",
"Constrain proportions": "Manter propor\u00e7\u00f5es",
"General": "Geral",
"Advanced": "Avan\u00e7ado",
"Style": "Estilo",
"Vertical space": "Espa\u00e7amento vertical",
"Horizontal space": "Espa\u00e7amento horizontal",
"Border": "Borda",
"Insert image": "Inserir imagem",
"Image": "Imagem",
"Image list": "Lista de Imagens",
"Rotate counterclockwise": "Girar em sentido hor\u00e1rio",
"Rotate clockwise": "Girar em sentido anti-hor\u00e1rio",
"Flip vertically": "Virar verticalmente",
"Flip horizontally": "Virar horizontalmente",
"Edit image": "Editar imagem",
"Image options": "Op\u00e7\u00f5es de Imagem",
"Zoom in": "Aumentar zoom",
"Zoom out": "Diminuir zoom",
"Crop": "Cortar",
"Resize": "Redimensionar",
"Orientation": "Orienta\u00e7\u00e3o",
"Brightness": "Brilho",
"Sharpen": "Aumentar nitidez",
"Contrast": "Contraste",
"Color levels": "N\u00edveis de cor",
"Gamma": "Gama",
"Invert": "Inverter",
"Apply": "Aplicar",
"Back": "Voltar",
"Insert date\/time": "Inserir data\/hora",
"Date\/time": "data\/hora",
"Insert link": "Inserir link",
"Insert\/edit link": "Inserir\/editar link",
"Text to display": "Texto para mostrar",
"Url": "Url",
"Target": "Alvo",
"None": "Nenhum",
"New window": "Nova janela",
"Remove link": "Remover link",
"Anchors": "\u00c2ncoras",
"Link": "Link",
"Paste or type a link": "Cole ou digite um Link",
"The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?",
"The URL you entered seems to be an external link. Do you want to add the required http:\/\/ prefix?": "A URL que voc\u00ea informou parece ser um link externo. Deseja incluir o prefixo http:\/\/?",
"Link list": "Lista de Links",
"Insert video": "Inserir v\u00eddeo",
"Insert\/edit video": "Inserir\/editar v\u00eddeo",
"Insert\/edit media": "Inserir\/editar imagem",
"Alternative source": "Fonte alternativa",
"Poster": "Autor",
"Paste your embed code below:": "Insira o c\u00f3digo de incorpora\u00e7\u00e3o abaixo:",
"Embed": "Incorporar",
"Media": "imagem",
"Nonbreaking space": "Espa\u00e7o n\u00e3o separ\u00e1vel",
"Page break": "Quebra de p\u00e1gina",
"Paste as text": "Colar como texto",
"Preview": "Pr\u00e9-visualizar",
"Print": "Imprimir",
"Save": "Salvar",
"Find": "Localizar",
"Replace with": "Substituir por",
"Replace": "Substituir",
"Replace all": "Substituir tudo",
"Prev": "Anterior",
"Next": "Pr\u00f3ximo",
"Find and replace": "Localizar e substituir",
"Could not find the specified string.": "N\u00e3o foi poss\u00edvel encontrar o termo especificado",
"Match case": "Diferenciar mai\u00fasculas e min\u00fasculas",
"Whole words": "Palavras inteiras",
"Spellcheck": "Corretor ortogr\u00e1fico",
"Ignore": "Ignorar",
"Ignore all": "Ignorar tudo",
"Finish": "Finalizar",
"Add to Dictionary": "Adicionar ao Dicion\u00e1rio",
"Insert table": "Inserir tabela",
"Table properties": "Propriedades da tabela",
"Delete table": "Excluir tabela",
"Cell": "C\u00e9lula",
"Row": "Linha",
"Column": "Coluna",
"Cell properties": "Propriedades da c\u00e9lula",
"Merge cells": "Agrupar c\u00e9lulas",
"Split cell": "Dividir c\u00e9lula",
"Insert row before": "Inserir linha antes",
"Insert row after": "Inserir linha depois",
"Delete row": "Excluir linha",
"Row properties": "Propriedades da linha",
"Cut row": "Recortar linha",
"Copy row": "Copiar linha",
"Paste row before": "Colar linha antes",
"Paste row after": "Colar linha depois",
"Insert column before": "Inserir coluna antes",
"Insert column after": "Inserir coluna depois",
"Delete column": "Excluir coluna",
"Cols": "Colunas",
"Rows": "Linhas",
"Width": "Largura",
"Height": "Altura",
"Cell spacing": "Espa\u00e7amento da c\u00e9lula",
"Cell padding": "Espa\u00e7amento interno da c\u00e9lula",
"Caption": "Legenda",
"Left": "Esquerdo",
"Center": "Centro",
"Right": "Direita",
"Cell type": "Tipo de c\u00e9lula",
"Scope": "Escopo",
"Alignment": "Alinhamento",
"H Align": "Alinhamento H",
"V Align": "Alinhamento V",
"Top": "Superior",
"Middle": "Meio",
"Bottom": "Inferior",
"Header cell": "C\u00e9lula cabe\u00e7alho",
"Row group": "Agrupar linha",
"Column group": "Agrupar coluna",
"Row type": "Tipo de linha",
"Header": "Cabe\u00e7alho",
"Body": "Corpo",
"Footer": "Rodap\u00e9",
"Border color": "Cor da borda",
"Insert template": "Inserir modelo",
"Templates": "Modelos",
"Template": "Modelo",
"Text color": "Cor do texto",
"Background color": "Cor do fundo",
"Custom...": "Personalizado...",
"Custom color": "Cor personalizada",
"No color": "Nenhuma cor",
"Table of Contents": "\u00edndice de Conte\u00fado",
"Show blocks": "Mostrar blocos",
"Show invisible characters": "Exibir caracteres invis\u00edveis",
"Words: {0}": "Palavras: {0}",
"{0} words": "{0} palavras",
"File": "Arquivo",
"Edit": "Editar",
"Insert": "Inserir",
"View": "Visualizar",
"Format": "Formatar",
"Table": "Tabela",
"Tools": "Ferramentas",
"Powered by {0}": "Distribu\u00eddo por  {0}",
"Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "\u00c1rea de texto formatado. Pressione ALT-F9 para exibir o menu, ALT-F10 para exibir a barra de ferramentas ou ALT-0 para exibir a ajuda"
});
tinymce.addI18n('en',{
"Redo": "Refazer",
"Undo": "Desfazer",
"Cut": "Recortar",
"Copy": "Copiar",
"Paste": "Colar",
"Select all": "Selecionar tudo",
"New document": "Novo documento",
"Ok": "Ok",
"Cancel": "Cancelar",
"Visual aids": "Ajuda visual",
"Bold": "Negrito",
"Italic": "It\u00e1lico",
"Underline": "Sublinhar",
"Strikethrough": "Riscar",
"Superscript": "Sobrescrito",
"Subscript": "Subscrever",
"Clear formatting": "Limpar formata\u00e7\u00e3o",
"Align left": "Alinhar \u00e0 esquerda",
"Align center": "Centralizar",
"Align right": "Alinhar \u00e0 direita",
"Justify": "Justificar",
"Bullet list": "Lista n\u00e3o ordenada",
"Numbered list": "Lista ordenada",
"Decrease indent": "Diminuir recuo",
"Increase indent": "Aumentar recuo",
"Close": "Fechar",
"Formats": "Formatos",
"Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X\/C\/V keyboard shortcuts instead.": "Seu navegador n\u00e3o suporta acesso direto \u00e0 \u00e1rea de transfer\u00eancia. Por favor use os atalhos Ctrl+X - C - V do teclado",
"Headers": "Cabe\u00e7alhos",
"Header 1": "Cabe\u00e7alho 1",
"Header 2": "Cabe\u00e7alho 2",
"Header 3": "Cabe\u00e7alho 3",
"Header 4": "Cabe\u00e7alho 4",
"Header 5": "Cabe\u00e7alho 5",
"Header 6": "Cabe\u00e7alho 6",
"Headings": "Cabe\u00e7alhos",
"Heading 1": "Cabe\u00e7alho 1",
"Heading 2": "Cabe\u00e7alho 2",
"Heading 3": "Cabe\u00e7alho 3",
"Heading 4": "Cabe\u00e7alho 4",
"Heading 5": "Cabe\u00e7alho 5",
"Heading 6": "Cabe\u00e7alho 6",
"Preformatted": "Preformatado",
"Div": "Div",
"Pre": "Pre",
"Code": "C\u00f3digo",
"Paragraph": "Par\u00e1grafo",
"Blockquote": "Aspas",
"Inline": "Em linha",
"Blocks": "Blocos",
"Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "O comando colar est\u00e1 agora em modo texto plano. O conte\u00fado ser\u00e1 colado como texto plano at\u00e9 voc\u00ea desligar esta op\u00e7\u00e3o.",
"Font Family": "Fonte",
"Font Sizes": "Tamanho",
"Class": "Classe",
"Browse for an image": "Procure uma imagem",
"OR": "OU",
"Drop an image here": "Arraste uma imagem aqui",
"Upload": "Carregar",
"Block": "Bloco",
"Align": "Alinhamento",
"Default": "Padr\u00e3o",
"Circle": "C\u00edrculo",
"Disc": "Disco",
"Square": "Quadrado",
"Lower Alpha": "a. b. c. ...",
"Lower Greek": "\u03b1. \u03b2. \u03b3. ...",
"Lower Roman": "i. ii. iii. ...",
"Upper Alpha": "A. B. C. ...",
"Upper Roman": "I. II. III. ...",
"Anchor": "\u00c2ncora",
"Name": "Nome",
"Id": "Id",
"Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "Id deve come\u00e7ar com uma letra, seguido apenas por letras, n\u00fameros, tra\u00e7os, pontos, dois pontos ou sublinhados.",
"You have unsaved changes are you sure you want to navigate away?": "Voc\u00ea tem mudan\u00e7as n\u00e3o salvas. Voc\u00ea tem certeza que deseja sair?",
"Restore last draft": "Restaurar \u00faltimo rascunho",
"Special character": "Caracteres especiais",
"Source code": "C\u00f3digo fonte",
"Insert\/Edit code sample": "Inserir\/Editar c\u00f3digo de exemplo",
"Language": "Idioma",
"Code sample": "Exemplo de c\u00f3digo",
"Color": "Cor",
"R": "R",
"G": "G",
"B": "B",
"Left to right": "Da esquerda para a direita",
"Right to left": "Da direita para a esquerda",
"Emoticons": "Emoticons",
"Document properties": "Propriedades do documento",
"Title": "T\u00edtulo",
"Keywords": "Palavras-chave",
"Description": "Descri\u00e7\u00e3o",
"Robots": "Rob\u00f4s",
"Author": "Autor",
"Encoding": "Codifica\u00e7\u00e3o",
"Fullscreen": "Tela cheia",
"Action": "A\u00e7\u00e3o",
"Shortcut": "Atalho",
"Help": "Ajuda",
"Address": "Endere\u00e7o",
"Focus to menubar": "Foco no menu",
"Focus to toolbar": "Foco na barra de ferramentas",
"Focus to element path": "Foco no caminho do elemento",
"Focus to contextual toolbar": "Foco na barra de ferramentas contextual",
"Insert link (if link plugin activated)": "Inserir link (se o plugin de link estiver ativado)",
"Save (if save plugin activated)": "Salvar (se o plugin de salvar estiver ativado)",
"Find (if searchreplace plugin activated)": "Procurar (se o plugin de procurar e substituir estiver ativado)",
"Plugins installed ({0}):": "Plugins instalados ({0}):",
"Premium plugins:": "Plugins premium:",
"Learn more...": "Saiba mais...",
"You are using {0}": "Voc\u00ea est\u00e1 usando {0}",
"Plugins": "Plugins",
"Handy Shortcuts": "Atalhos \u00fateis",
"Horizontal line": "Linha horizontal",
"Insert\/edit image": "Inserir\/editar imagem",
"Image description": "Inserir descri\u00e7\u00e3o",
"Source": "Endere\u00e7o da imagem",
"Dimensions": "Dimens\u00f5es",
"Constrain proportions": "Manter propor\u00e7\u00f5es",
"General": "Geral",
"Advanced": "Avan\u00e7ado",
"Style": "Estilo",
"Vertical space": "Espa\u00e7amento vertical",
"Horizontal space": "Espa\u00e7amento horizontal",
"Border": "Borda",
"Insert image": "Inserir imagem",
"Image": "Imagem",
"Image list": "Lista de Imagens",
"Rotate counterclockwise": "Girar em sentido hor\u00e1rio",
"Rotate clockwise": "Girar em sentido anti-hor\u00e1rio",
"Flip vertically": "Virar verticalmente",
"Flip horizontally": "Virar horizontalmente",
"Edit image": "Editar imagem",
"Image options": "Op\u00e7\u00f5es de Imagem",
"Zoom in": "Aumentar zoom",
"Zoom out": "Diminuir zoom",
"Crop": "Cortar",
"Resize": "Redimensionar",
"Orientation": "Orienta\u00e7\u00e3o",
"Brightness": "Brilho",
"Sharpen": "Aumentar nitidez",
"Contrast": "Contraste",
"Color levels": "N\u00edveis de cor",
"Gamma": "Gama",
"Invert": "Inverter",
"Apply": "Aplicar",
"Back": "Voltar",
"Insert date\/time": "Inserir data\/hora",
"Date\/time": "data\/hora",
"Insert link": "Inserir link",
"Insert\/edit link": "Inserir\/editar link",
"Text to display": "Texto para mostrar",
"Url": "Url",
"Target": "Alvo",
"None": "Nenhum",
"New window": "Nova janela",
"Remove link": "Remover link",
"Anchors": "\u00c2ncoras",
"Link": "Link",
"Paste or type a link": "Cole ou digite um Link",
"The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?",
"The URL you entered seems to be an external link. Do you want to add the required http:\/\/ prefix?": "A URL que voc\u00ea informou parece ser um link externo. Deseja incluir o prefixo http:\/\/?",
"Link list": "Lista de Links",
"Insert video": "Inserir v\u00eddeo",
"Insert\/edit video": "Inserir\/editar v\u00eddeo",
"Insert\/edit media": "Inserir\/editar imagem",
"Alternative source": "Fonte alternativa",
"Poster": "Autor",
"Paste your embed code below:": "Insira o c\u00f3digo de incorpora\u00e7\u00e3o abaixo:",
"Embed": "Incorporar",
"Media": "imagem",
"Nonbreaking space": "Espa\u00e7o n\u00e3o separ\u00e1vel",
"Page break": "Quebra de p\u00e1gina",
"Paste as text": "Colar como texto",
"Preview": "Pr\u00e9-visualizar",
"Print": "Imprimir",
"Save": "Salvar",
"Find": "Localizar",
"Replace with": "Substituir por",
"Replace": "Substituir",
"Replace all": "Substituir tudo",
"Prev": "Anterior",
"Next": "Pr\u00f3ximo",
"Find and replace": "Localizar e substituir",
"Could not find the specified string.": "N\u00e3o foi poss\u00edvel encontrar o termo especificado",
"Match case": "Diferenciar mai\u00fasculas e min\u00fasculas",
"Whole words": "Palavras inteiras",
"Spellcheck": "Corretor ortogr\u00e1fico",
"Ignore": "Ignorar",
"Ignore all": "Ignorar tudo",
"Finish": "Finalizar",
"Add to Dictionary": "Adicionar ao Dicion\u00e1rio",
"Insert table": "Inserir tabela",
"Table properties": "Propriedades da tabela",
"Delete table": "Excluir tabela",
"Cell": "C\u00e9lula",
"Row": "Linha",
"Column": "Coluna",
"Cell properties": "Propriedades da c\u00e9lula",
"Merge cells": "Agrupar c\u00e9lulas",
"Split cell": "Dividir c\u00e9lula",
"Insert row before": "Inserir linha antes",
"Insert row after": "Inserir linha depois",
"Delete row": "Excluir linha",
"Row properties": "Propriedades da linha",
"Cut row": "Recortar linha",
"Copy row": "Copiar linha",
"Paste row before": "Colar linha antes",
"Paste row after": "Colar linha depois",
"Insert column before": "Inserir coluna antes",
"Insert column after": "Inserir coluna depois",
"Delete column": "Excluir coluna",
"Cols": "Colunas",
"Rows": "Linhas",
"Width": "Largura",
"Height": "Altura",
"Cell spacing": "Espa\u00e7amento da c\u00e9lula",
"Cell padding": "Espa\u00e7amento interno da c\u00e9lula",
"Caption": "Legenda",
"Left": "Esquerdo",
"Center": "Centro",
"Right": "Direita",
"Cell type": "Tipo de c\u00e9lula",
"Scope": "Escopo",
"Alignment": "Alinhamento",
"H Align": "Alinhamento H",
"V Align": "Alinhamento V",
"Top": "Superior",
"Middle": "Meio",
"Bottom": "Inferior",
"Header cell": "C\u00e9lula cabe\u00e7alho",
"Row group": "Agrupar linha",
"Column group": "Agrupar coluna",
"Row type": "Tipo de linha",
"Header": "Cabe\u00e7alho",
"Body": "Corpo",
"Footer": "Rodap\u00e9",
"Border color": "Cor da borda",
"Insert template": "Inserir modelo",
"Templates": "Modelos",
"Template": "Modelo",
"Text color": "Cor do texto",
"Background color": "Cor do fundo",
"Custom...": "Personalizado...",
"Custom color": "Cor personalizada",
"No color": "Nenhuma cor",
"Table of Contents": "\u00edndice de Conte\u00fado",
"Show blocks": "Mostrar blocos",
"Show invisible characters": "Exibir caracteres invis\u00edveis",
"Words: {0}": "Palavras: {0}",
"{0} words": "{0} palavras",
"File": "Arquivo",
"Edit": "Editar",
"Insert": "Inserir",
"View": "Visualizar",
"Format": "Formatar",
"Table": "Tabela",
"Tools": "Ferramentas",
"Powered by {0}": "Distribu\u00eddo por  {0}",
"Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "\u00c1rea de texto formatado. Pressione ALT-F9 para exibir o menu, ALT-F10 para exibir a barra de ferramentas ou ALT-0 para exibir a ajuda"
});
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',

                /**
                 * Parte do mecanismo de paginação. Permite a customização do template de paginação usado
                 * na visualização de resultados em lista.
                 * 
                 * Adicionado inicialmente para suprir demanda do processos por paginação no backend.
                 * 
                 * @autor Rodrigo Barreiros
                 */
                'angularUtils.directives.dirPagination',
                
                /**
                 * Parte do mecanismo de inserção de documentos. Permite o upload de arquivos do cliente
                 * para o servidor.
                 * 
                 * Adicionado inicialmente para suprir demanda do processos por inclusão de peças.
                 * 
                 * @autor Rodrigo Barreiros
                 */
                'angularFileUpload',

                /**
                 * Parte do mecanismo de visualização em árvore. Permite a customização de templates 
                 * relacionados à estrutura da árvore.
                 * 
                 * Adicionado inicialmente para suprir demanda do processos por visualização 
                 * hierárquica da cadeia de incidentes.
                 * 
                 * @autor Rodrigo Barreiros
                 */
                'ivh.treeview'

            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout, $state)
    {
        var vm = this;

        // Data
        vm.collapsed = false;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.recents = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.handleInputClick = handleInputClick;
        vm.handleChangeRoute = handleChangeRoute;
        vm.handleNewTab = handleNewTab;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }

            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Esvazia a consultas recentes ao esconder a lista resultado
            vm.recents = null;
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Trata o clique no campo de pesquisa rápida. Em caso de cliques neste campo,
         * devemos apresentar as consultas recentes realizadas.
         */
        function handleInputClick()
        {
            var onInputClickEvaluated = $scope.$parent.$eval(vm.onInputClick);

            vm.recents = onInputClickEvaluated;
        }

        /**
         * Trata a mudança de estado a partir da barra de resultados da pesquisa rápida.
         * 
         * @param {*} state 
         */
        function handleChangeRoute(state)
        {
            $state.go(state);
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
        
        function handleNewTab(url)
        {
        	if (!!url)
        	{
        		window.open(url, "_blank");
        	}
        	vm.collapse();
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onInputClick : '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.materialIcon = undefined;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            if (vm.node.icon && vm.node.icon.includes("material-icons:")) {
                vm.materialIcon = true;
                vm.node.icon = vm.node.icon.replace("material-icons:", "");
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
/**
 * Created by João Vitor e Tomás
 */


 (function(angular){
    "use strict";

    angular.module("md-virtual-repeat-scrollbar", [])

    .directive('mdVirtualRepeatScrollbar', function ($compile, $timeout) {
        return {
          restrict: 'A',
          replace: false, 
          compile: function compile(element, attrs) {
              element.removeAttr("md-virtual-repeat-scrollbar"); 
              element.removeAttr("data-md-virtual-repeat-scrollbar"); 
            return {
              pre: function preLink(scope, iElement, iAttrs, controller) { },
              post: function postLink(scope, iElement, iAttrs, controller) {  
                  var count = 0;
                  var stopWatch = scope.$watch(
                      function () { return iElement.find('.md-virtual-repeat-scroller'); },
                      function (newValue, oldValue) {
                      if (newValue !== oldValue) {
                          var scroller = iElement.find('.md-virtual-repeat-scroller');
                          
                          var ps = PerfectScrollbar.initialize(scroller[0]);
                          stopWatch();
                      }
                  });
              }
            };
          }
        };
      });

})(angular);

/**
 * Created by Tomás
 * 
 * Esse fix foi necessário para resolver a issue SDAPPECAS-740.
 * 
 */
(function(angular){
    "use strict";

    var NUM_EXTRA = 3;

    angular.module("md-virtual-repeat-scroll-fix", [])
    .config(["$provide", function($provide) {
        $provide.decorator('mdVirtualRepeatContainerDirective', function($delegate, $interval) {
            var directive = $delegate[0];
            var originalCompile = directive.compile;
            var originalCtrl = directive.controller;
            /**
             * Trouxe parte da implementação alterada no seguinte commit https://github.com/angular/material/commit/3cf4d7440289187ff57f1f341ec78c15941141d4
             * É possível que essa alteração corrija o bug.
             */
            originalCtrl.prototype.handleScroll_ = function() {
                var ltr = document.dir != 'rtl' && document.body.dir != 'rtl';
                if(!ltr && !this.maxSize) {
                  this.scroller.scrollLeft = this.scrollSize;
                  this.maxSize = this.scroller.scrollLeft;
                }
                var offset = this.isHorizontal() ?
                    (ltr?this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
                    : this.scroller.scrollTop;
                if (this.scrollSize < this.size) return;
                if (offset > this.scrollSize - this.size) {
                    offset = this.scrollSize - this.size;
                }
                if (offset === this.scrollOffset) return;
              
                var itemSize = this.repeater.getItemSize();
                if (!itemSize) return;
              
                var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);
              
                var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
                    (!this.isHorizontal() || ltr ? (numItems * itemSize) : - (numItems * itemSize))  + 'px)';
              
                this.scrollOffset = offset;
                this.offsetter.style.webkitTransform = transform;
                this.offsetter.style.transform = transform;
              
                if (this.bindTopIndex) {
                  var topIndex = Math.floor(offset / itemSize);
                  if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
                    this.topIndex = topIndex;
                    this.bindTopIndex.assign(this.$scope, topIndex);
                    if (!this.$rootScope.$$phase) this.$scope.$digest();
                  }
                }
              
                this.repeater.containerUpdated();
            };

            /**
             * Aparentemente, dependendo do momento em que o scroll é feito,
             * pode ser que o cálculo de quais itens devem ser exibidos fique
             * errado. Desse modo, é necessário forçar a atualização desse
             * cálculo a cada 100ms. Isso está ativável condicionalmente para
             * podermos validar se realmente é necessário ou não.
             */
            directive.compile = function virtualRepeatContainerCompile($element, $attrs) {
                originalCompile.call(this, $element, $attrs);
                return function(scope, element, attrs, ctrl) {
                    if (window.forceVirtualRepeatContainerUpdate) {
                        var stop = $interval(function() {
                            ctrl.repeater.containerUpdated();
                        }, 100);
                        scope.$on("$destroy", function() {
                            $interval.cancel(stop);
                        });
                    }

                    if (window.forceVirtualRepeatContainerUpdateAndHandleScroll) {
                        var stop = $interval(function() {
                            ctrl.handleScroll_();
                            ctrl.repeater.containerUpdated();
                        }, 100);
                        scope.$on("$destroy", function() {
                            $interval.cancel(stop);
                        });
                    }
                };
            };
            
            return $delegate;
        });
    }]);

})(angular);

/**
 * Created by Alireza Mirian (alireza.mirian@gmail.com) on 05/24/2016.
 */


(function(angular){
    "use strict";

    var MAX_TRIES = 5;
    var TRY_INTERVAL = 100;

    /**
     * @ngdoc module
     * @name chrome-autofill-fix
     * @module chrome-autofill-fix
     * @description
     * A tiny fix for chrome problems regarding auto-filled passwords
     *
     */
    angular.module("chrome-autofill-fix", [])
        /**
         * @ngdoc directive
         * @module chrome-autofill-fix
         * @name mdInputContainer
         * Prevents floating label collapsing in [angular-material](https://material.angularjs.org/latest/demo/input) inputs
         *
         */
        .directive('mdInputContainer', ['$interval', mdInputContainerDirective])
        /**
         * @ngdoc directive
         * @module chrome-autofill-fix
         * @name required
         * Overrides the default `required` validator to take Chrome auto-filling into account
         */
        .directive("required", ['$interval', '$log', requiredDirective]);

    function requiredDirective($interval, $log) {
        return {
            priority: 100,
            require: "?ngModel",
            link: linkFn
        };
        function linkFn(scope, elem, attrs, ngModel) {
            if(!isChrome()){
                // ignore other browsers
                return;
            }
            if(!ngModel){
                // no ngModel, nothing to do!
                return;
            }
            if(elem[0].tagName !== 'INPUT'){
                // ignore non-input components
                return;
            }
            var originalValidator = ngModel.$validators.required;
            ngModel.$validators.required = validator;

            // try validating until
            var tries = 0;
            var timer = $interval(function () {
                tries++;
                if (tries > MAX_TRIES) {
                    $interval.cancel(timer);
                }
                ngModel.$validate();
            }, TRY_INTERVAL);

            function validator(modelValue, viewValue) {

                if (isChrome() && elem[0].matches("input[type=password]:-webkit-autofill, input[type=text]:-webkit-autofill")) {
                    $log.info("bypassing required validator because of Chrome auto-filling");
                    $interval.cancel(timer);
                    return true;
                }
                return originalValidator(modelValue, viewValue);
            }
        }
    }

    function mdInputContainerDirective($interval) {
        return {
            restrict: "E",
            link: linkFn
        };
        function linkFn($scope, elem) {
            if (isChrome() && elem[0].querySelector('input')) {
                var tries = 0;
                var timer = $interval(function () {
                    tries++;
                    if (tries > MAX_TRIES) {
                        $interval.cancel(timer);
                    }
                    if (elem[0].querySelector('input[type=password]:-webkit-autofill, input[type=text]:-webkit-autofill')) {
                        elem.addClass('md-input-has-value');
                        $interval.cancel(timer);
                    }
                }, TRY_INTERVAL);
            }
        }
    }


    function isChrome(){
        return navigator.userAgent.match(/chrome/i) && !navigator.userAgent.match(/edge/i);
    }
    
    /**
     * element.matches() pollyfill
     */
    Element && function(ElementPrototype) {
        ElementPrototype.matches = ElementPrototype.matchesSelector ||
            ElementPrototype.mozMatchesSelector ||
            ElementPrototype.msMatchesSelector ||
            ElementPrototype.oMatchesSelector ||
            ElementPrototype.webkitMatchesSelector ||
            function (selector) {
                var node = this, nodes = (node.parentNode || node.document).querySelectorAll(selector), i = -1;

                while (nodes[++i] && nodes[i] != node);

                return !!nodes[i];
            };
    }(Element.prototype);
})(angular);

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    "use strict";

    angular
        .module('app.custom',
            [
                "angular-chartist",
                "chart.js",
                "datatables",
                "gridshore.c3js.chart",
                "nvd3",
                "timer",
                "ct.ui.router.extras",
                "oc.lazyLoad",
                "ui.sortable",
                "ng-sortable",
                "xeditable",
                "ui.select",
                "angular-bind-html-compile",
                "ui.mask",
                "jlareau.bowser",
                "foTooltip",
                "material.components.expansionPanels",
                "focus-if",
                "angular-uri",
                "angular.filter",
                "chrome-autofill-fix",
                "md-virtual-repeat-scrollbar",
                "md-virtual-repeat-scroll-fix",
                "bb.scrollWhen",
                
                // Módulos do STF Digital
                "app.login",
                "app.cadastro",
                "app.novo-processo",
                "app.gestao",
                "app.gestao.meus-paineis",
                "app.pesquisa-avancada",
                "app.documentos",
                "app.tarefas.minhas-tarefas",
                "app.tarefas.details",
                "app.configuracoes",
                "app.acoes",
                "app.informacoes",
                "app.legacy",
                "app.upgraded",
                "app.openState",
                "ui.tinymce",
                "ivh.treeview"
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.custom')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $translate, $timeout, $state, $log, $cookies, authService)
    {	
    	var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {

            $rootScope.loadingProgress = true;

            if ($cookies.get('access_token')) {
	            // Se já está logado e solicita a página de login, deve ser redirecionado para o inbox de tarefas    
	            if (toState.name === 'app.login') {
	                event.preventDefault();
	                $state.go('app.tarefas.minhas-tarefas');
	            }
            } else {
				// Se não está logado e solicita uma página protegida, deve ser redirecionado para a página de login     
				if (toState.name !== 'app.login' && !toState.name.startsWith('app.publico.') && toState.url !== '/cadastro') {
				    event.preventDefault();
				    $state.go('app.login');                    
				}
            }

        });

        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {
            $timeout(function () {
                if (toState.name !== 'app.legacy') {
                    $rootScope.loadingProgress = false;
                }
            });
        });
        
        var stateChangeErrorEvent = $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
        	$log.error(error);
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
            stateChangeErrorEvent();
        });
    	
        $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
        	$translate.refresh();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.custom')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);
        $urlRouterProvider.otherwise('/tarefas');

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.custom')
        .config(config);

    /** @ngInject */
    function config(fuseConfigProvider, $translateProvider, $sceDelegateProvider, uiSelectConfig, $mdDateLocaleProvider, $httpProvider, $translatePartialLoaderProvider, $compileProvider, properties)
    {
        $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';

        // Adiciona o conjunto de strings de tradução
        $translatePartialLoaderProvider.addPart('app/main');
        $compileProvider.debugInfoEnabled(false);
    	
        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;
        
        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('pt-br');
        $translateProvider.useSanitizeValueStrategy('escape');

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });
        
        $sceDelegateProvider.resourceUrlWhitelist([
			'self',
			properties.apiUrl + '/**'
		]);
        
        uiSelectConfig.theme = 'select2';
        
        // TODO: configurar usando o $translate
        $mdDateLocaleProvider.months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
        $mdDateLocaleProvider.shortMonths = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
        $mdDateLocaleProvider.days = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
        $mdDateLocaleProvider.shortDays = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

        // Example uses moment.js to parse and format dates.
        $mdDateLocaleProvider.parseDate = function(dateString) {
          var m = moment(dateString, "DD/MM/YYYY", true);
          return m.isValid() ? m.toDate() : new Date();
        };

        $mdDateLocaleProvider.formatDate = function(date) {
          var m = moment(date);
          return m.isValid() ? m.format("DD/MM/YYYY") : '';
        };

        // In addition to date display, date components also need localized messages
        // for aria-labels for screen-reader users.
        $mdDateLocaleProvider.msgCalendar = "Calendário";
        $mdDateLocaleProvider.msgOpenCalendar = "Abrir o calendário";
        
        streamSaver.mitm = window.location.origin + "/mitm.html";
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        window.addEventListener("message", function(event) {   
            if (event.data.type === "iframe") {
                if (event.data.operation === "load-iframe-css") {
                    var link = window.document.createElement("link");
                    link.href = "assets/styles/iframe-styles.css";
                    link.rel = "stylesheet";
                    link.type = "text/css"; 
    
                    window.document.head.appendChild(link);
                } else if (event.data.operation === "abrir-tarefas") {
                    $state.go('app.tarefas.minhas-tarefas');
                } else if (event.data.operation === "signOut") {
                    $state.go('app.login');
                }
            }
        });
    }
})();





(function ()
{
    'use strict';

    angular
        .module('app')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app');
})();

(function ()
{
    'use strict';

    angular.module('app').config(config);

    /** @ngInject */
    function config($translateProvider, paginationTemplateProvider, ivhTreeviewOptionsProvider) {
        
        /**
         * Configuração do mecanismo de paginação. Permite a customização do template de paginação usado
         * na visualização de resultados em lista.
         * 
         * Adicionado inicialmente para suprir demanda do processos por paginação no backend.
         * 
         * @autor Rodrigo Barreiros
         * 
         * @see core.module.js
         */
        paginationTemplateProvider.setPath('app/custom/templates/pagination.tpl.html');

        /**
         * Configuração do mecanismo de visualização em árvore. Permite a customização de templates 
         * relacionados à estrutura da árvore.
         * 
         * Adicionado inicialmente para suprir demanda do processos por visualização 
         * hierárquica da cadeia de incidentes.
         * 
         * @autor Rodrigo Barreiros
         * 
         * @see core.module.js
         */
        ivhTreeviewOptionsProvider.set({
            twistieCollapsedTpl: '<span class="icon-chevron-down s16 arrow md-accent-fg"></span>',
            twistieExpandedTpl: '<span class="icon-chevron-right s16 arrow md-accent-fg"></span>',
            twistieLeafTpl: '<span class="icon-checkbox-blank-circle-outline md-accent-fg twistie-leaf"></span>'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex=\"\"></md-content><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex=\"\"><div id=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex=\"\"></div></div><div id=\"content-container\" flex=\"\" layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div id=\"main-container\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div id=\"main-container\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" class=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap=\"\" ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button ng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">Color Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap=\"\"><md-button ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" layout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" ng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" ng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/custom/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/custom/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><div ng-if=\"vm.getConsulta() && false\" class=\"ms-theme-options\" style=\"overflow: visible;\"><div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"vm.openSavedSearchs()\" style=\"top: 63px; right: 330px; width: 130px; height: 32px; line-height: 32px; border-radius: 0px 0px 5px 5px;\"><md-icon md-font-icon=\"icon-star\" class=\"white-text s16\"></md-icon><span>{{vm.getInformacao().identificacao}}</span></div></div><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-fade-in-out md-hue-2\" ms-scroll=\"\" legacy-scroll-fix=\"\" ui-view=\"content\" flex=\"\"></md-content><md-content id=\"upgraded\" class=\"animate-fade-in-out md-hue-2\" ms-scroll=\"\" legacy-scroll-fix=\"\" ui-view=\"upgraded\" flex=\"\" ng-show=\"!vm.hide\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav><md-sidenav id=\"info-viewer\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"info-viewer\" style=\"width: 87.5vw; min-width: 87.5vw; max-width: 87.5vw; z-index: 79;\"><informacao ng-if=\"vm.getConsulta() && vm.isInfoNavOpen()\" tipo=\"vm.getInformacao().tipo\" value=\"vm.getInformacao().identificacao\" params=\"{{vm.getInformacao().params}}\"></informacao></md-sidenav></div>");
$templateCache.put("app/custom/templates/pagination.tpl.html","<div class=\"bottom\"><div class=\"left\"><div class=\"info\"><div class=\"dataTables_info\">Encontrados {{range.total}} registros</div></div></div><div class=\"right\"><div class=\"info\"><div class=\"dataTables_info\">Apresentando de {{range.lower}} até {{range.upper}} registros</div></div><div class=\"pagination\"><div class=\"dataTables_paginate paging_simple\"><a class=\"paginate_button previous\" ng-click=\"setCurrent(pagination.current - 1)\" ng-class=\"{ disabled : pagination.current == 1 }\">Anterior</a> <a class=\"paginate_button next\" ng-click=\"setCurrent(pagination.current + 1)\" ng-class=\"{ disabled : pagination.current == pagination.last }\">Próximo</a></div></div></div></div>");
$templateCache.put("app/main/cadastro/cadastro.html","<div id=\"cadastro-form\"><div class=\"logo\" hide-gt-sm=\"\"><span><img src=\"/custom_assets/images/logos/stfdigital.png\"></span></div><div class=\"title\" translate=\"CADASTRO.TITULO\">Crie sua conta no STF Digital</div><form name=\"cadastroForm\" ng-submit=\"vm.cadastrar()\" novalidate=\"\"><div class=\"md-light-blue-50-bg md-hue-3 cadastro-user-type\"><label>Como você deseja se identificar?</label><md-radio-group ng-model=\"vm.form.tipoCadastro\"><md-radio-button value=\"1\"><span translate=\"PLATAFORMA.TERMO.CIDADAO\">Cidadão</span></md-radio-button><md-radio-button value=\"2\"><span translate=\"PLATAFORMA.TERMO.ADVOGADO\">Advogado</span></md-radio-button></md-radio-group></div><md-input-container class=\"md-block\"><label translate=\"PLATAFORMA.CAMPO.NOME\">Nome</label> <input type=\"text\" name=\"nome\" ng-model=\"vm.form.nome\" required=\"\"><div ng-messages=\"cadastroForm.nome.$error\" ng-show=\"cadastroForm.nome.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"CADASTRO.ERRO.NOME_REQUERIDO\">Nome é um campo obrigatório.</span></div></div></md-input-container><div layout=\"row\"><md-input-container flex=\"\" class=\"md-block\"><label translate=\"PLATAFORMA.CAMPO.USUARIO\">Usuário</label> <input type=\"text\" name=\"usuario\" ng-model=\"vm.form.usuario\" required=\"\"><div ng-messages=\"cadastroForm.usuario.$error\" ng-show=\"cadastroForm.usuario.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"CADASTRO.ERRO.USUARIO_REQUERIDO\">Usuário é um campo obrigatório.</span></div></div></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label translate=\"PLATAFORMA.CAMPO.EMAIL\">Email</label> <input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"cadastroForm.email.$error\" ng-show=\"cadastroForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\"><span translate=\"PLATAFORMA.ERRO.EMAIL_INVALIDO\">E-mail inválido</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-block\"><label translate=\"PLATAFORMA.CAMPO.TELEFONE\">Telefone</label> <input type=\"text\" name=\"telefone\" ng-model=\"vm.form.telefone\" mask=\"(99) 9?9999-9999\" mask-clean=\"true\" mask-restrict=\"reject\"><div ng-messages=\"cadastroForm.telefone.$error\" ng-show=\"cadastroForm.telefone.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"mask\"><span translate=\"PLATAFORMA.ERRO.TELEFONE_INVALIDO\">Telefone inválido</span></div></div></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label translate=\"PLATAFORMA.CAMPO.CPF\">CPF</label> <input type=\"text\" name=\"cpf\" ng-model=\"vm.form.cpf\" mask=\"999.999.999-99\" mask-clean=\"true\" mask-restrict=\"reject\" stf-cpf=\"\"><div ng-messages=\"cadastroForm.cpf.$error\" ng-show=\"cadastroForm.cpf.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"cpf\"><span translate=\"PLATAFORMA.ERRO.CPF_INVALIDO\">CPF inválido</span></div></div></md-input-container></div><div class=\"animate-slide-up\" ng-show=\"vm.form.tipoCadastro == 2\"><md-input-container class=\"md-block\"><label translate=\"PLATAFORMA.CAMPO.OAB\">OAB</label> <input type=\"text\" name=\"oab\" ng-model=\"vm.form.oab\" mask=\"@@999999?\" mask-clean=\"true\" mask-restrict=\"reject\" required=\"{{vm.form.tipoCadastro == 2}}\" ng-if=\"vm.form.tipoCadastro == 2\"><div ng-messages=\"cadastroForm.oab.$error\" ng-show=\"cadastroForm.oab.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"CADASTRO.ERRO.OAB_REQUERIDO\">OAB é obrigatório para advogados.</span></div><div ng-message=\"mask\"><span translate=\"PLATAFORMA.ERRO.OAB_FORMATO_INVALIDO\">OAB em formato inválido</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"\" class=\"md-block\"><label translate=\"PLATAFORMA.CAMPO.SENHA\">Senha</label> <input type=\"password\" name=\"senha\" ng-model=\"vm.form.senha\" required=\"\"><div ng-messages=\"cadastroForm.senha.$error\" ng-show=\"cadastroForm.senha.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"CADASTRO.ERRO.SENHA_REQUERIDA\">Senha é um campo obrigatório.</span></div></div></md-input-container><md-input-container flex=\"\" class=\"md-block\"><label translate=\"CADASTRO.CAMPO.REPETIR_SENHA\">Repetir senha</label> <input type=\"password\" name=\"repetir_senha\" ng-model=\"vm.form.repetir_senha\" required=\"\" stf-matches=\"vm.form.senha\"><div ng-messages=\"cadastroForm.repetir_senha.$error\" ng-show=\"cadastroForm.repetir_senha.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"CADASTRO.ERRO.REPETIR_SENHA_REQUERIDA\">É obrigatório repetir a senha.</span></div><div ng-message=\"matches\"><span translate=\"CADASTRO.ERRO.REPETIR_SENHA_INCORRETA\">As senhas são diferentes.</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-checkbox ng-model=\"vm.form.aceitoTermos\" aria-label=\"Eu li e aceito os termos e condições\"><span translate=\"CADASTRO.LI_E_ACEITO\">Eu li e aceito</span> <a class=\"clickable link\" translate=\"CADASTRO.TERMOS_E_CONDICOES\">os termos e condições</a></md-checkbox></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"ENTRAR\" ng-disabled=\"cadastroForm.$invalid || cadastroForm.$pristine || !vm.form.aceitoTermos\" translate=\"CADASTRO.CRIAR_CONTA\" translate-attr-aria-label=\"CADASTRO.CRIAR_CONTA\">Quero criar minha conta</md-button></form><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"CADASTRO.JA_TEM_CONTA\">Já tem uma conta?</span> &nbsp; <a class=\"clickable link\" ui-sref=\"app.login\" translate=\"CADASTRO.ENTRE_AGORA\">Entre agora!</a></div></div>");
$templateCache.put("app/main/legacy/legacy.html","<iframe id=\"stf-legacy-frame\" ng-src=\"{{vm.frameUrl}}\" stf-legacy-frame=\"vm.parentUrl\" ng-if=\"!vm.hide\" stf-legacy-frame-state-change-request=\"vm.currentStateChangeRequest\" frameborder=\"0\" style=\"width: 100%; height: 100%;\"></iframe>");
$templateCache.put("app/main/navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img src=\"../custom_assets/images/logos/stfdigital.png\"></span> <span class=\"logo-text\">STF Digital</span></div></md-toolbar><div class=\"scrollable\" ms-scroll=\"vm.msScrollOptions\"><div class=\"call-to-action\"><md-button class=\"md-raised md-float md-accent primary-action md-center md-call-to-action large\" ms-nav-button=\"\" md-ink-ripple=\"\" translate=\"NAVEGACAO.INICIAR_PROCESSO\" aria-label=\"Iniciar Atividade\" translate-attr-aria-label=\"NAVEGACAO.INICIAR_PROCESSO\" ui-sref=\"app.novo-processo\" ui-sref-opts=\"{reload: \'app.novo-processo\'}\">Iniciar Atividade</md-button><md-button class=\"md-fab md-mini md-accent primary-action md-center md-call-to-action small\" aria-label=\"Iniciar Atividade\" translate-attr-aria-label=\"NAVEGACAO.INICIAR_PROCESSO\" ui-sref=\"app.novo-processo\" ui-sref-opts=\"{reload: \'app.novo-processo\'}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><ms-navigation folded=\"vm.folded\" stf-navigation-extension=\"vm.folded\"></ms-navigation></div>");
$templateCache.put("app/main/novo-processo/novo-processo.html","<div id=\"novo-processo\" class=\"md-accent-bg\" layout=\"column\"><div layout=\"column\"><md-input-container id=\"processo-search\" class=\"text-center\"><md-icon class=\"s32 ml-16 mr-16\" md-font-icon=\"icon-magnify\"></md-icon><label translate=\"NOVO-PROCESSO.QUAL-SOLICITACAO-INICIAR\">Qual aitividade você deseja iniciar?</label> <input class=\"bn\" ng-model=\"vm.buscaProcesso\" ng-model-options=\"{ debounce: 500 }\" tabindex=\"1\"></md-input-container></div><div id=\"processo-selector\" layout=\"column\" layout-align=\"start center\"><div class=\"processo-list\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><button class=\"processo-list-item\" ng-if=\"vm.processos.length > 0\" ng-repeat=\"processo in vm.processos | orderBy: \'description\' track by processo.id\" ng-click=\"vm.itemClick(processo.id)\" layout=\"column\" layout-align=\"center center\" layout-wrap=\"\" ng-attr-ui-sref=\"{{vm.getStateName(processo)}}\" tabindex=\"{{$index + 2}}\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"icon s64\"></md-icon><div class=\"processo-name\">{{processo.description}}</div></button><div ng-if=\"vm.processos.length === 0 && vm.buscaProcesso.length === 0\"><h1 translate=\"NOVO-PROCESSO.ATIVIDADE-NAO-DISPONIVEL\">Nenhuma atividade disponível.</h1></div><div ng-if=\"vm.processos.length === 0 && vm.buscaProcesso.length > 0\"><h1 translate=\"NOVO-PROCESSO.ATIVIDADE-NAO-ENCONTRADA\">Nenhuma atividade encontrada.</h1></div></div></div></div>");
$templateCache.put("app/main/pesquisa-avancada/pesquisa-avancada.html","<div id=\"pesquisa-avancada\" class=\"page-layout simple\"><div class=\"content\" ms-scroll=\"\" layout=\"column\"><stf-header><div class=\"text-right header-saved-search-button\"><md-button class=\"md-raised\" ng-click=\"vm.openSavedSearchs()\"><md-icon md-font-icon=\"icon-folder\" class=\"s20\"></md-icon><small>Pesquisas Salvas</small></md-button></div></stf-header><div class=\"tab-content\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"vm.selectedTab\"><md-tab label=\"{{ \'PESQUISA-AVANCADA.NOVA-PESQUISA\' | translate }}\" class=\"scrollable\" ms-scroll=\"\"><criteria-summary class=\"md-whiteframe-1dp md-block\" criteria=\"vm.newSearch.criteria\"></criteria-summary><div><search-builder traits=\"vm.searchConfig.traits\" search=\"vm.newSearch\"></search-builder></div></md-tab><md-tab label=\"{{ \'PESQUISA-AVANCADA.RESULTADOS\' | translate }}\" ng-disabled=\"!vm.searchComplete\"><criteria-summary class=\"md-whiteframe-1dp md-block\" criteria=\"vm.search.criteria\"></criteria-summary><div class=\"white-bg md-whiteframe-4dp mb-32 ml-32 mr-80\"><div class=\"dataTables_noTop mt-8\"><table class=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.tableOptions\" dt-column-defs=\"vm.tableColumnDefs\"><thead><tr><th ng-repeat=\"rc in vm.searchConfig.resultColumns track by $index\" class=\"secondary-text\"><div class=\"table-header\"><span ng-class=\"\'column-title \' + rc.header.css\" translate=\"{{rc.header.translate}}\">{{rc.header.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"result in vm.searchResults\" bind-html-compile=\"vm.resultTemplate\"></tr></tbody></table></div></div></md-tab><md-tab label=\"{{ \'PESQUISA-AVANCADA.EDITAR-CRITERIOS\' | translate }}\" ng-disabled=\"!vm.editEnabled\"><criteria-summary class=\"md-whiteframe-1dp md-block\" criteria=\"vm.search.criteria\"></criteria-summary><search-builder traits=\"vm.searchConfig.traits\" search=\"vm.search\"></search-builder></md-tab></md-tabs></div></div><md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" md-component-id=\"sidenav-search\" ms-scroll=\"{suppressScrollX: true}\" ms-sidenav-helper=\"\" ng-include=\"\'app/main/pesquisa-avancada/sidebar-direita/sidebar-direita.html\'\"></md-sidenav><div class=\"fab\"><md-button class=\"md-accent md-fab\" ng-click=\"vm.selectedTab == 1 ? vm.saveSearch($event) : vm.doSearch()\" ng-disabled=\"!vm.fabActive\" aria-label=\"{{ \'PESQUISA-AVANCADA.\' + (vm.selectedTab == 1 ? \'SALVAR-PESQUISA\' : \'BUSCAR\') | translate }}\" title=\"{{ \'PESQUISA-AVANCADA.\' + (vm.selectedTab == 1 ? \'SALVAR-PESQUISA\' : \'BUSCAR\') | translate }}\"><span bind-html-compile=\"vm.fabIconElement\"></span></md-button></div><div ui-view=\"modal\"></div></div>");
$templateCache.put("app/main/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination=\"\" md-swipe-content=\"\" md-stretch-tabs=\"always\"><span ng-include=\"\'app/main/quick-panel/tabs/feed/feed.html\'\" ng-controller=\"app.quick-panel.FeedController as vm\"></span></md-tabs></md-content>");
$templateCache.put("app/main/toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleNavigation()\" aria-label=\"Alternar navegação\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.ALTERNAR_NAVEGACAO\"><md-icon class=\"fold-toggle\" md-font-icon=\"icon-backburger\" ng-class=\"{\'folded\': vm.getFolded()}\"></md-icon></md-button><div flex=\"\" id=\"navigation-search\" ng-show=\"false\"><div ng-show=\"vm.$mdMedia(\'gt-sm\')\" class=\"md-inline\"><md-icon class=\"ml-16 mr-16\" md-font-icon=\"icon-magnify\"></md-icon><input class=\"bn s18\" ng-model=\"vm.termoBusca\" placeholder=\"{{ (\'TOOLBAR.PESQUISA.PLACEHOLDER_\' + (vm.tipoBusca == 1 ? \'PROCESSO\' : \'PETICAO\' ) + (vm.$mdMedia(\'gt-sm\') ? \'\' : \'_REDUZIDO\')) | translate }}\" ng-keyup=\"vm.teclaPressionadaBusca($event)\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"Alternar pesquisa\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.ALTERNAR_PESQUISA\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button translate=\"TOOLBAR.PESQUISA.PESQUISAR_PROCESSO\" ng-click=\"vm.alterarBusca(1)\">Pesquisar Processos</md-button></md-menu-item><md-menu-item><md-button translate=\"TOOLBAR.PESQUISA.PESQUISAR_PETICAO\" ng-click=\"vm.alterarBusca(2)\">Pesquisar Petições</md-button></md-menu-item></md-menu-content></md-menu></div><md-button class=\"md-accent\" translate=\"TOOLBAR.PESQUISA.PESQUISA_AVANCADA\">Pesquisa Acervo Processual</md-button></div></div><div layout=\"row\" layout-align=\"start center\" flex=\"\"><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" on-input-click=\"vm.searchRecents()\" debounce=\"300\" ng-if=\"vm.hasPermission()\" class=\"expanded\"></ms-search-bar><div ng-if=\"!vm.hasPermission()\" flex=\"\"></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent mr-15\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\" class=\"pr-0\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"../custom_assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide-xs=\"\">{{vm.nome}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s20\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.configuracoes.meu-perfil\" aria-label=\"Visualizar perfil\"><md-icon md-font-icon=\"icon-account\" class=\"icon s20\"></md-icon><md-button>Meu Perfil</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\" ng-click=\"vm.openDocs()\" aria-label=\"Ajuda Documentação Negocial\"><md-icon md-font-icon=\"icon-help\" class=\"icon s20\"></md-icon><md-button>Ajuda</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon s20\"></md-icon><md-button ng-click=\"vm.logout()\">Sair</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu-bar id=\"menu-conta\" class=\"pr-0\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User Accounts\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"conta-principal font-size-12\" hide-xs=\"\">{{vm.mainAccount.nome}} ({{vm.mainAccount.sigla}})</span> <span ng-if=\"vm.mainAccount.principal\" class=\"badge-main-account\">P<md-tooltip md-direction=\"bottom\">Setor principal</md-tooltip></span><md-icon md-font-icon=\"icon-chevron-down\" ng-show=\"vm.secondaryAccounts.length\" class=\"icon s20\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\" ng-show=\"vm.secondaryAccounts.length\" class=\"account-items font-size-12\"><md-menu-item class=\"md-indent md-conta-item\" ng-repeat=\"account in vm.secondaryAccounts\"><md-icon md-font-icon=\"icon-account\" class=\"icon s20\"></md-icon><md-button ng-click=\"vm.changeAccount($event, account)\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"font-size-12\">{{account.nome}} ({{account.sigla}})</span> <span ng-if=\"account.principal\" class=\"badge-main-account ml-10\">P</span></div></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div layout=\"row\" ng-if=\"vm.configuracoes.length\"><md-menu-bar id=\"configuration-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\" style=\"min-width: 63px;\"><md-icon md-font-icon=\"icon-cog\" class=\"icon s24\"></md-icon><md-tooltip md-direction=\"bottom\">Configurações</md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"configuracao in vm.configuracoes | orderBy: \'translation\'\" class=\"md-indent\" ui-sref=\"{{configuracao.stateName}}\"><md-icon md-font-icon=\"{{configuracao.icon}}\" class=\"icon s20\"></md-icon><md-button>{{configuracao.translation}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button w-60\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon s24\"></md-icon><md-tooltip md-direction=\"bottom\">Notificações</md-tooltip><div class=\"md-accent-bg unread-message-count\">{{vm.unreadFeed}}</div></md-button></div></div>");
$templateCache.put("app/main/ultimos-acessos/ultimos-acessos.html","<stf-header fab-action=\"vm.foo()\" fab-icon=\"icon-cog\"></stf-header><div class=\"content\" layout=\"column\" ms-scroll=\"\"><md-tabs md-dynamic-height=\"\" flex=\"\" layout=\"column\"><md-tab label=\"{{ \'ULTIMOS-ACESSOS.TODOS\' | translate }}\" ui-sref=\"app.ultimos-acessos.todos\" md-active=\"vm.isTabActive(\'app.ultimos-acessos.todos\', 0)\" ng-click=\"vm.setActiveFilter(0)\"><div class=\"bt\"></div></md-tab><md-tab label=\"{{ \'ULTIMOS-ACESSOS.PETICOES\' | translate }}\" ui-sref=\"app.ultimos-acessos.peticoes\" md-active=\"vm.isTabActive(\'app.ultimos-acessos.peticoes\', 1)\" ng-click=\"vm.setActiveFilter(1)\"><div class=\"bt\"></div></md-tab><md-tab label=\"{{ \'ULTIMOS-ACESSOS.PROCESSOS\' | translate }}\" ui-sref=\"app.ultimos-acessos.processos\" md-active=\"vm.isTabActive(\'app.ultimos-acessos.processos\', 2)\" ng-click=\"vm.setActiveFilter(2)\"><div class=\"bt\"></div></md-tab><md-tab label=\"{{ \'ULTIMOS-ACESSOS.PECAS\' | translate }}\" ui-sref=\"app.ultimos-acessos.pecas\" md-active=\"vm.isTabActive(\'app.ultimos-acessos.pecas\', 3)\" ng-click=\"vm.setActiveFilter(3)\"><div class=\"bt\"></div></md-tab></md-tabs><div class=\"dataTables_noTop\"><table class=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.ultimosAcessosDtOptions\"><thead><tr><th></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ULTIMOS-ACESSOS.PROCESSO\">Processo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ULTIMOS-ACESSOS.TIPO\">Tipo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ULTIMOS-ACESSOS.ULTIMA-ALTERACAO-POR\">Última alteração por</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ULTIMOS-ACESSOS.TAMANHO\">Tamanho</span></div></th><th ng-hide=\"true\"></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ULTIMOS-ACESSOS.ULTIMA-ALTERACAO-EM\">Última alteração em</span></div></th><th></th></tr></thead><tbody><tr ng-repeat=\"row in vm.ultimosAcessos\"><td><md-icon md-font-icon=\"{{ row.type.icon.name }}\" ng-style=\"{ color : row.type.icon.color }\"></md-icon></td><td>{{ row.name }}</td><td>{{ row.type.name }}</td><td>{{ row.last_update_by }}</td><td>{{ row.size | readableFilesize:2 }}</td><td ng-hide=\"true\">{{ row.size }}</td><td>{{ row.updated_at * 1000 | date:\'longDate\' }}</td><td><md-menu><md-button class=\"md-icon-button\" aria-label=\"{{ \'TRAITS.UI.OPTIONS\' | translate}}\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button><md-icon md-menu-align-target=\"\" md-font-icon=\"icon-trash\"></md-icon>Opção 1</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/upgraded/upgraded.html","<iframe id=\"stf-upgraded-frame\" ng-src=\"{{vm.frameUrl}}\" stf-upgraded-frame=\"vm.parentUrl\" ng-if=\"vm.frameUrl && vm.parentUrl\" stf-upgraded-frame-state-change-request=\"vm.currentStateChangeRequest\" frameborder=\"0\" style=\"width: 100%; height: 100%;\"></iframe>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div id=\"ms-info-bar-message\" ng-transclude=\"\" flex=\"\"></div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon md-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdMenu.open($event)\"><ms-color-picker-button><md-button aria-label=\"Row Color\" md-menu-origin=\"\" ng-click=\"$mdMenu.open($event)\" ng-class=\"vm.selectedColor.class\"><span ng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}}</span> <span ng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column=\"\"><header ng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\"><md-button md-prevent-menu-close=\"\" ng-click=\"vm.activateHueSelection(false,false)\" class=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}}</span> <span ng-if=\"!vm.selectedColor.palette\">Select Color</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\"><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll=\"\"><div ng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap=\"\"><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" layout-align=\"start end\" md-prevent-menu-close=\"\" md-ink-ripple=\"\"><span class=\"label\">{{palette}}</span></div></div><div ng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap=\"\"><div class=\"color\" ng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" ng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple=\"\"><span class=\"label\">{{hue}}</span> <i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" class=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex=\"\" layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button class=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" ng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" ng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></div></label> <input id=\"ms-search-bar-input\" type=\"text\" placeholder=\"Informe o Processo, Petição ou Protocolo\" flex=\"\" ng-click=\"MsSearchBar.handleInputClick()\" ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" ng-blur=\"MsSearchBar.collapse();\" ng-keydown=\"MsSearchBar.handleKeydown($event);\" autocomplete=\"off\"><md-button ng-if=\"false\" class=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\"><md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" ng-if=\"MsSearchBar.results || MsSearchBar.recents\" ms-scroll=\"\"><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">Nenhum Resultado!</div><div class=\"result-title\" ng-if=\"MsSearchBar.results.length > 0\">Resultados Principais</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" style=\"border-top: 1px solid rgba(0, 0, 0, 0.12);\" ng-click=\"MsSearchBar.handleResultClick(result)\" ng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" ng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple=\"\"><div layout=\"row\" layout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">{{result.description}}</div><span class=\"pl-10\" ng-click=\"MsSearchBar.handleNewTab(result.url.replace(\':id\', result.id)); $event.stopPropagation();\"><i class=\"icon-launch s16 icon-arrow-top-right\"></i><md-tooltip md-direction=\"top\">Abrir {{result.title}} em Nova Aba</md-tooltip></span></div></div><div class=\"result-title\" ng-if=\"MsSearchBar.recents.length > 0\">Consultas Recentes</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.recents\" style=\"border-top: 1px solid rgba(0, 0, 0, 0.12);\" ng-click=\"MsSearchBar.handleResultClick(result)\" ng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" ng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple=\"\"><div layout=\"row\" layout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">{{result.description}}</div><span class=\"pl-10\" ng-click=\"MsSearchBar.handleNewTab(result.url.replace(\':id\', result.id)); $event.stopPropagation();\"><i class=\"icon-launch s16 icon-arrow-top-right\"></i><md-tooltip md-direction=\"top\">Abrir {{result.title}} em Nova Aba</md-tooltip></span></div></div><div class=\"result\" show-if-has-permission=\"pesquisar-processos\" style=\"border-top: 1px solid rgba(0, 0, 0, 0.12);\" ng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" ng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" ng-click=\"MsSearchBar.handleChangeRoute(\'app.informacoes.pesquisa-processos\')\" md-ink-ripple=\"\"><div layout=\"row\" layout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i class=\"icon icon-magnify\"></i></div><div class=\"title\">Pesquisa Acervo Processual</div><span class=\"pl-10\" ng-click=\"MsSearchBar.handleNewTab(\'informacoes/processos/pesquisa\')\"><i class=\"icon-launch s16 icon-arrow-top-right\"></i><md-tooltip md-direction=\"top\">Abrir em Nova Aba</md-tooltip></span></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex=\"\" ng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll=\"\" ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div ng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button class=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">Click to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div class=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" layout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target=\"\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" layout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" md-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex=\"\" ng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" ng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll=\"\"><div class=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" ng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" ng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" ng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" md-ink-ripple=\"\"><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" class=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" ng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div><md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" ng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin=\"\" md-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/autenticacao/login/login-dialog.html","<md-dialog aria-label=\"Autenticação\" style=\"width:310px\"><form name=\"loginForm\" ng-submit=\"vm.entrar()\" stf-processing=\"\" novalidate=\"\"><md-dialog-content layout-padding=\"\"><h2 class=\"md-title mb-10\">Autenticação expirou!</h2><div class=\"mb-20\">Entre com o usuário e senha para continuar navegando.</div><md-input-container class=\"md-block mb-0 pb-0\"><label>Usuário</label> <input type=\"text\" name=\"usuario\" ng-model=\"vm.form.usuario\" required=\"\"><div ng-messages=\"loginForm.usuario.$error\" ng-show=\"loginForm.usuario.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Esse campo é obrigatório. Por favor preencha.</span></div></div></md-input-container><md-input-container class=\"md-block mb-0 pb-0\"><label>Senha</label> <input type=\"password\" name=\"senha\" ng-model=\"vm.form.senha\" required=\"\"><div ng-messages=\"loginForm.senha.$error\" ng-show=\"loginForm.senha.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Esse campo é obrigatório. Por favor preencha.</span></div></div></md-input-container></md-dialog-content><md-dialog-actions><span flex=\"\"></span><md-button aria-label=\"Fechar\" ng-click=\"vm.fechar()\">Fechar</md-button><md-button type=\"submit\" aria-label=\"Entrar\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\">Entrar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/autenticacao/login/login.html","<div id=\"login-form\"><div class=\"logo\" hide-gt-sm=\"\"><span><img src=\"/custom_assets/images/logos/stfdigital.png\"></span></div><div class=\"title\">STF Digital</div><div class=\"description\">Todos os serviços do STF em um único lugar</div><form name=\"loginForm\" ng-submit=\"vm.entrar()\" stf-processing=\"\" novalidate=\"\"><md-input-container class=\"md-block\" ng-if=\"vm.isLocal()\"><label>Usuário</label> <input type=\"text\" name=\"usuario\" ng-model=\"vm.form.usuario\" required=\"\"><div ng-messages=\"loginForm.usuario.$error\" ng-show=\"loginForm.usuario.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Esse campo é obrigatório. Por favor preencha.</span></div></div></md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.isLocal()\"><label>Senha</label> <input type=\"password\" name=\"senha\" ng-model=\"vm.form.senha\" required=\"\"><div ng-messages=\"loginForm.senha.$error\" ng-show=\"loginForm.senha.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Esse campo é obrigatório. Por favor preencha.</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"ENTRAR\" ng-disabled=\"vm.isLocal() && (loginForm.$invalid || loginForm.$pristine)\">ENTRAR</md-button></form></div>");
$templateCache.put("app/main/autenticacao/nao-autenticado/nao-autenticado.html","<div id=\"nao-autenticado\" layout=\"row\" layout-align=\"start\"><div id=\"nao-autenticado-intro\" flex=\"\" hide=\"\" show-gt-sm=\"\"><div class=\"logo\"><span><img src=\"/custom_assets/images/logos/stfdigital.png\"></span></div><div class=\"title\" translate=\"NAO-AUTENTICADO.TITULO\">Bem-vindo ao STF Digital</div><div class=\"description\" translate=\"NAO-AUTENTICADO.DESCRICAO\">Toda a tecnologia do STF reunida em um único lugar para você se preocupar com o que realmente importa: julgar mais, com mais qualidade e segurança.</div></div><div id=\"nao-autenticado-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll=\"\"><div id=\"nao-autenticado-form\"><div ui-view=\"form\" class=\"animate-slide-up\"></div></div></div></div>");
$templateCache.put("app/main/configuracoes/administracao/administracao.html","ADMINISTRAÇÃO");
$templateCache.put("app/main/gestao/meus-paineis/meus-paineis.html","<stf-header></stf-header><div class=\"content\"><md-tabs md-dynamic-height=\"\"><md-tab ng-repeat=\"dashboard in vm.dashboards\" label=\"{{ dashboard.nome }}\" ui-sref=\"app.gestao.meus-paineis.dashboard({\'dashboardId\': dashboard.id})\" md-active=\"vm.isTabActive(dashboard.id)\"><dashboard ng-if=\"vm.isTabActive(dashboard.id)\" value=\"dashboard\"></dashboard></md-tab></md-tabs></div>");
$templateCache.put("app/main/pesquisa-avancada/sidebar-direita/sidebar-direita.html","<div class=\"sidebar\"><div class=\"p-16\"><md-input-container md-no-float=\"\" class=\"sidebar-search-search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><input placeholder=\"Buscar pesquisa salva\" ng-model=\"vm.searchSearch\"></md-input-container></div><md-divider></md-divider><md-content><md-list><md-list-item class=\"md-1-line\" ng-repeat=\"search in vm.savedSearchs | orderBy: \'uuid\' : true | filter: {description: vm.searchSearch} track by $index\"><div class=\"md-list-item-text\"><p>{{ search.description }}</p></div><md-button class=\"md-secondary md-accent md-icon-button\" ng-click=\"vm.loadSearch(search)\" aria-label=\"Restore search: {{ search.description }}\"><md-icon md-font-icon=\"icon-restore\"></md-icon></md-button><md-button class=\"md-secondary md-accent md-icon-button\" ng-click=\"vm.deleteSearch(search)\" aria-label=\"Delete search: {{ search.description }}\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></div>");
$templateCache.put("app/main/support/alert/alert-dialog.html","<md-dialog id=\"alert-dialog\" aria-label=\"Alerta de Notificação\"><md-toolbar class=\"md-toolbar-tools\" layout=\"column\"><div id=\"titulo-alert-dialog\" class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Alertas do STF Digital</span></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block\"><div ng-repeat=\"grupo in vm.gruposAlertas\"><h3>{{ grupo.titulo }}</h3><p>{{ grupo.mensagem }}</p><div class=\"pb-10 scrollable\" ms-scroll=\"\"><div class=\"table-container\"><hr><table class=\"table-alerta\"><thead><tr><th class=\"column-descricao\"><span>Descrição</span></th><th class=\"column-data\"><span>Data da ação</span></th><th><span>Observação</span></th></tr></thead><tbody><tr ng-repeat=\"alerta in grupo.alertas\"><td><span class=\"text-truncate\">{{alerta.descricao}}</span></td><td><span class=\"text-truncate\">{{alerta.data | date:\'dd/MM/yyyy\'}}</span></td><td><span class=\"text-truncate\" ng-if=\"alerta.observacao\">{{alerta.observacao}}<md-tooltip>{{alerta.observacao}}</md-tooltip></span> <span class=\"text-truncate\" ng-if=\"!alerta.observacao\"></span></td></tr></tbody></table><hr></div></div></div></md-input-container></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.definirCiencia(vm.gruposAlertas)\" id=\"marcar-ciente\" class=\"md-accent md-raised\"><span aria-label=\"Ciente\">Ciente</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/support/command/commands.tpl.html","<md-menu><md-button aria-label=\"Comandos\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin=\"\" md-svg-icon=\"custom_assets/icons/more_vert.svg\"></md-icon></md-button><md-menu-content><md-menu-item ng-repeat=\"config in commandsConfig | orderBy: \'description\' track by config.id\"><md-button ng-click=\"go(config)\"><span md-menu-align-target=\"\">{{config.description}}</span></md-button></md-menu-item><md-menu-item ng-if=\"commandsConfig.length == 0\"><span md-menu-align-target=\"\">Nenhuma ação disponível</span></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/main/support/header/header.html","<div class=\"stf-header md-accent-bg\"><div class=\"header-content\" ng-if=\"!layoutOnly\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\"><div ng-if=\"vm.hasBreadcrumbs()\" class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span ng-repeat-start=\"item in vm.breadcrumbs().parents\" class=\"parent\" translate=\"{{ item.label }}\" ng-if=\"item.link.length == 0\"></span> <span class=\"parent\" translate=\"{{ item.label }}\" ng-attr-ui-sref=\"{{ item.link }}\" ng-if=\"item.link.length != 0\"></span><md-icon ng-repeat-end=\"\" md-font-icon=\"icon-chevron-right\" class=\"s16 separator mr-8 ml-8\"></md-icon><span class=\"current\" flex=\"\" translate=\"{{ vm.breadcrumbs().current.label }}\" ng-attr-ui-sref=\"{{ vm.breadcrumbs().current.link.length == 0 ? undefined : vm.breadcrumbs().current.link }}\"></span></div><span ng-if=\"vm.hasBreadcrumbs()\" class=\"md-display-1 font-weight-400\" translate=\"{{ vm.breadcrumbs().current.label }}\"></span></div><div flex=\"\" ng-transclude=\"\"></div><div layout=\"column\" ng-if=\"vm.task\" layout-align=\"start center\"><div layout=\"row\"><md-tooltip ng-if=\"vm.assigneeName\">{{ vm.assigneeName }} ({{ vm.task.assignee }})</md-tooltip><span ng-if=\"vm.assigneeName\">Responsável: {{vm.assigneeName}}</span> <span ng-if=\"!vm.assigneeName && vm.task.assignee\">Responsável: {{vm.task.assignee}}</span> <span ng-if=\"!vm.task.assignee\">Sem responsável</span></div><div layout=\"row\"><md-button class=\"md-raised md-background\" ng-click=\"vm.assumir()\" aria-label=\"Assumir\" ng-show=\"!vm.isTarefaAssumida()\" scroll-when=\"vm.tentouExecutarTarefaSemAssumir\" scroll-watch-enabled=\"true\" scroll-container=\"#content\">Assumir</md-button></div></div></div><div class=\"fab fabHeader\" ng-if=\"hasFabAction\"><md-button class=\"md-accent md-fab\" ng-click=\"fabAction()\" aria-label=\"fabAriaLabel\" ng-disabled=\"!fabActive\" title=\"{{ fabText }}\"><span bind-html-compile=\"mdIconClass\"></span></md-button></div></div>");
$templateCache.put("app/main/support/suggestion/suggestion.tpl.html","<md-autocomplete md-input-id=\"input-{{id}}\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-search-text-change=\"vm.searchTextChange()\" md-search-text=\"vm.searchText\" md-items=\"item in vm.items\" md-item-text=\"vm.itemText(item)\" md-min-length=\"3\" md-delay=\"500\" md-menu-class=\"autocomplete-custom-template\" md-floating-label=\"{{vm.placeholder}}\" flex=\"\"><md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{vm.itemText(item)}}</span></md-item-template><md-not-found>Nenhum item encontrado com o texto: \"{{vm.searchText}}\"</md-not-found></md-autocomplete>");
$templateCache.put("app/main/support/toggle/toggle-button.html","<div class=\"stf-toggle-button\" ng-class=\"{disabled: vm.disabled}\"><div class=\"mask\"></div><input type=\"hidden\" id=\"{{vm.fieldId}}\" name=\"{{vm.fieldId}}\" ng-model=\"vm.value\" ng-required=\"vm.required\"><md-button id=\"{{btn.id}}\" class=\"m-0\" title=\"{{btn.label}}\" aria-label=\"{{btn.label}}\" focus-if=\"{{btn.focusIf}}\" ng-repeat=\"btn in vm.config.buttons\" ng-disabled=\"btn.disabled\" ng-click=\"vm.buttonClick($event, btn.id)\"><md-icon md-svg-src=\"{{btn.icon.svg}}\" md-font-icon=\"{{btn.icon.font}}\" ng-show=\"{{!!btn.icon}}\" aria-label=\"btn.label\"></md-icon>{{btn.label}}</md-button><md-button ng-show=\"!!vm.listItems.length\" id=\"btnOutros\" class=\"m-0\" title=\"OUTROS\" aria-label=\"OUTROS\" ng-disabled=\"vm.btnOutrosSelecionado\" ng-click=\"vm.buttonClick($event, \'btnOutros\')\"><md-icon md-font-icon=\"icon-dots-horizontal\" aria-label=\"OUTROS\"></md-icon>Outros</md-button><md-input-container class=\"outras-opcoes\" ng-show=\"vm.btnOutrosSelecionado\" layout=\"row\"><md-select ng-change=\"vm.changeValueByListItem()\" ng-model=\"vm.listValue\" flex=\"100\"><md-option ng-value=\"item.id\" ng-repeat=\"(index, item) in vm.listItems\" tabindex=\"{{$index}}\">{{item.nome}}</md-option></md-select></md-input-container></div>");
$templateCache.put("app/main/tarefas/details/tarefas-details.html","");
$templateCache.put("app/main/tarefas/minhas-tarefas/historico.html","<div id=\"todo\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"true\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/tarefas/minhas-tarefas/sidenavs/main/historico-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"search-wrapper md-whiteframe-4dp\" flex=\"\" layout=\"row\" layout-align=\"start center\"><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"true\" ng-if=\"!vm.searchTask\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></md-button><md-button ng-click=\"vm.searchTask = \'\'\" ng-if=\"!!vm.searchTask\"><md-icon md-font-icon=\"icon-broom\" class=\"icon s24\"><md-tooltip>Limpar pesquisa</md-tooltip></md-icon></md-button><input id=\"searchTask\" flex=\"\" ng-model=\"vm.searchTask\" type=\"text\" placeholder=\"Buscar tarefa\" ng-model-options=\"{ debounce: 1000 }\" translate=\"\" stf-autofocus=\"\" translate-attr-placeholder=\"TAREFAS.MINHAS-TAREFAS.BUSCA.CODIGO\"><md-switch ng-model=\"vm.exactlySearch\" aria-label=\"Busca exata\">Busca {{ vm.exactlySearch ? \'exata\' : \'termos\' }}</md-switch><md-switch ng-if=\"!vm.exactlySearch\" ng-model=\"vm.searchCondition\" class=\"search-condition\" ng-false-value=\"0\" ng-true-value=\"1\" aria-label=\"Condição de busca\">{{vm.searchCondition ? \'OU\' : \'E\'}}</md-switch></div></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" id=\"tarefas-toolbar\" flex=\"\"><div layout=\"row\" layout-align=\"start center\"><span class=\"mh-15\">de</span><md-datepicker ng-model=\"vm.fromDate\" md-placeholder=\"Data inicial\" md-hide-icons=\"calendar\" ng-change=\"vm.openToDate = true\"></md-datepicker><span class=\"mh-15\">a</span><md-datepicker ng-model=\"vm.toDate\" md-placeholder=\"Data final\" md-hide-icons=\"calendar\" ng-change=\"vm.searchHistoricTasks()\" auto-open=\"vm.openToDate\"></md-datepicker><span class=\"mh-15\"></span><md-select class=\"simplified\" ng-model=\"vm.filterDefault\" ng-model-options=\"{ debounce : 500 }\" placeholder=\"Pesquisa\"><md-option value=\"true\" translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.PADRAO\">Padrão</md-option><md-option value=\"false\" translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.DATA-DE-CRIACAO\">Data de Criação</md-option></md-select></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button md-small md-primary\" ng-disabled=\"vm.pagination.currentPage == 0\" ng-click=\"vm.paginationFirst()\" aria-label=\"Primeira\"><md-icon md-font-icon=\"\" class=\"icon-chevron-double-left s24\"></md-icon><md-tooltip md-direction=\"top\"><span>Primeira</span></md-tooltip></md-button><md-button class=\"md-icon-button md-small md-primary\" ng-disabled=\"vm.pagination.currentPage == 0\" ng-click=\"vm.paginationPrevious()\" aria-label=\"Anterior\"><md-icon md-font-icon=\"\" class=\"icon-chevron-left s24\"></md-icon><md-tooltip md-direction=\"top\"><span>Anterior</span></md-tooltip></md-button><span>{{ vm.pagination.currentPage + 1 }}/{{ vm.pagination.numberOfPages }}</span><md-button class=\"md-icon-button md-small md-primary\" ng-disabled=\"vm.pagination.currentPage >= vm.pagination.total/vm.pagination.pageSize - 1\" ng-click=\"vm.paginationNext()\" aria-label=\"Próximo\"><md-icon md-font-icon=\"\" class=\"icon-chevron-right s24\"></md-icon><md-tooltip md-direction=\"top\"><span>Próximo</span></md-tooltip></md-button><md-button class=\"md-icon-button md-small md-primary\" ng-disabled=\"vm.pagination.currentPage >= vm.pagination.total/vm.pagination.pageSize - 1\" ng-click=\"vm.paginationLast()\" aria-label=\"Última\"><md-icon md-font-icon=\"\" class=\"icon-chevron-double-right s24\"></md-icon><md-tooltip md-direction=\"top\"><span>Última</span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\"><md-select class=\"simplified\" ng-model=\"vm.pagination.pageSize\" md-selected-text=\"vm.pagination.pageSize\"><md-select-header><input ng-model=\"vm.pagination.pageSize\" ng-model-options=\"{ debounce: 500 }\" type=\"number\" min=\"1\" ng-keydown=\"$event.stopPropagation();\" aria-label=\"Tamanho da página\"></md-select-header><md-option ng-value=\"length\" ng-repeat=\"length in [10, 20, 30, 50, 100, 200, 400, 500]\">{{ ::length }}</md-option></md-select><div hide=\"\" show-xs=\"\">/<strong>{{ vm.pagination.total }}</strong></div><div layout=\"row\" layout-align=\"end center\" hide=\"\" show-gt-xs=\"\"><div layout=\"row\" layout-align=\"start center\" class=\"pr-10 mr-10 h-40 br\"><span>de <strong>{{ vm.pagination.total }}</strong> {{ \'encontrada\' + vm.pagination.total > 1 ? \'s\' : \'\' }}</span></div><div layout=\"row\" layout-align=\"start center\" class=\"pr-10 mr-10 h-40 br\"><md-select class=\"simplified\" ng-model=\"vm.taskOrder\" ng-model-options=\"{ debounce : 500 }\" placeholder=\"Ordenação\"><md-option value=\"startDate\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.DATA-DE-CRIACAO\">Data de Criação</md-option><md-option value=\"claimDate\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.DATA-DE-ATRIBUICAO\">Data de Atribuição</md-option><md-option value=\"completedDate\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.DATA-DE-CONCLUSAO\">Data de Conclusão</md-option><md-option value=\"cancellation.canceledDate\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.DATA-DE-CANCELAMENTO\">Data de Cancelamento</md-option><md-option value=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.TITULO\">Título</md-option><md-option value=\"assignee\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.RESPONSAVEL\">Responsável</md-option><md-option value=\"cancellation.canceledBy\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.RESPONSAVEL-CANCELAMENTO\">Responsável pelo Cancelamento</md-option></md-select><md-button class=\"md-icon-button\" ng-click=\"vm.taskOrderDescending = !vm.taskOrderDescending\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.ORDEM-{{ vm.taskOrderDescending ? \'DECRESCENTE\': \'CRESCENTE\' }}\"><md-icon md-font-icon=\"\" class=\"s20 icon-sort-{{ vm.taskOrderDescending ? \'descending\' : \'ascending\' }}\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.ORDEM-{{ vm.taskOrderDescending ? \'DECRESCENTE\': \'CRESCENTE\' }}\">Decrescente</span></md-tooltip></md-button></div><md-button class=\"md-icon-button md-small no-border-radius br\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ACOES.EXPORTAR\" ng-click=\"vm.exportarResultado($event)\"><md-icon md-font-icon=\"\" class=\"s20 icon-download\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.EXPORTAR\">Exportar</span></md-tooltip></md-button><md-button class=\"md-icon-button md-small no-border-radius\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ACOES.{{ vm.taskViewExpanded ? \'COMPACTAR\' : \'EXPANDIR\' }}-TAREFAS\" ng-click=\"vm.taskViewExpanded = !vm.taskViewExpanded\"><md-icon md-font-icon=\"\" class=\"s20 icon-arrow-{{ vm.taskViewExpanded ? \'collapse\' : \'expand\' }}\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.{{ vm.taskViewExpanded ? \'COMPACTAR\' : \'EXPANDIR\' }}-TAREFAS\">Expandir</span></md-tooltip></md-button></div></div></div><div class=\"content\" layout=\"row\" flex=\"\"><md-content class=\"todo-list-pane\" ms-scroll=\"vm.msScrollOptions\" flex=\"\" ng-include=\"\'app/main/tarefas/minhas-tarefas/views/list/historico-list.html\'\"></md-content></div></div></div></div>");
$templateCache.put("app/main/tarefas/minhas-tarefas/minhas-tarefas.html","<div id=\"todo\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"true\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/tarefas/minhas-tarefas/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"search-wrapper md-whiteframe-4dp\" flex=\"\" layout=\"row\" layout-align=\"start center\"><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"true\" ng-if=\"!vm.searchTask\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s20\"></md-icon></md-button><md-button ng-click=\"vm.searchTask = \'\'\" ng-if=\"!!vm.searchTask\"><md-icon md-font-icon=\"icon-broom\" class=\"icon s24\"><md-tooltip>Limpar pesquisa</md-tooltip></md-icon></md-button><input id=\"searchTask\" flex=\"\" ng-model=\"vm.searchTask\" type=\"text\" placeholder=\"Pesquise uma tarefa\" ng-model-options=\"{ debounce: 1000 }\" translate=\"\" stf-autofocus=\"\" translate-attr-placeholder=\"TAREFAS.MINHAS-TAREFAS.BUSCA.CODIGO\" ng-keypress=\"vm.exactlySearch && $event.keyCode === 13 ? vm.openTaskWithSearchableId() : null\"><md-switch ng-model=\"vm.exactlySearch\" aria-label=\"Exata\">{{vm.exactlySearch ? \'Exata\' : \'Por termos\'}}</md-switch><md-switch ng-if=\"!vm.exactlySearch\" ng-model=\"vm.searchCondition\" class=\"search-condition\" ng-false-value=\"0\" ng-true-value=\"1\" aria-label=\"Condição de busca\">{{vm.searchCondition ? \'OU\' : \'E\'}}</md-switch></div></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" id=\"tarefas-toolbar\" flex=\"\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label s20\" ng-model=\"selectedAll\" ng-init=\"selectedAll=false\" ng-click=\"vm.selectAllFilteredTasks(!selectedAll)\" ng-checked=\"vm.isAllFilteredTasksSelected()\" aria-label=\"selectedAll\"></md-checkbox><md-button class=\"md-primary md-icon-button\" ng-disabled=\"!vm.hasAssumableSelectedTasks()\" show-if-has-permission=\"assumir-tarefas\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ACOES.ASSUMIR\" ng-click=\"vm.assumeTasks()\"><md-icon md-font-icon=\"\" class=\"icon-account s20\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.ASSUMIR\">Assumir</span></md-tooltip></md-button><md-button class=\"md-primary md-icon-button\" ng-disabled=\"!vm.hasSelectedTasks()\" show-if-has-permission=\"atribuir-tarefas\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ACOES.ATRIBUIR\" ng-click=\"vm.assignTasks()\"><md-icon md-font-icon=\"\" class=\"icon-account-search s20\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.ATRIBUIR\">Atribuir</span></md-tooltip></md-button><md-button class=\"md-primary md-icon-button\" ng-disabled=\"!vm.hasSelectedTasks()\" show-if-has-permission=\"atribuir-tarefas-grupo\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ACOES.ATRIBUIR-GRUPO\" ng-click=\"vm.assignGroupTasks()\"><md-icon md-font-icon=\"\" class=\"icon-account-multiple s20\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.ATRIBUIR-GRUPO\">Atribuir grupo</span></md-tooltip></md-button><md-button class=\"md-primary md-icon-button\" ng-disabled=\"!vm.hasCancelableSelectedTasks()\" show-if-has-permission=\"cancelar-tarefas\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ACOES.CANCELAR\" ng-click=\"vm.cancelTasks()\"><md-icon md-font-icon=\"\" class=\"icon-cancel s20\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.CANCELAR\">Cancelar</span></md-tooltip></md-button><md-button class=\"md-primary md-icon-button\" ng-disabled=\"!vm.hasSelectedTasks()\" ng-if=\"vm.canTag\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ACOES.ATRIBUIR-ROTULO\" ng-click=\"vm.assignTagTasks()\"><md-icon md-font-icon=\"icon-plus\" class=\"s20\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.ATRIBUIR-ROTULO\">Atribuir Rótulo</span></md-tooltip></md-button><md-button class=\"md-primary md-icon-button\" ng-disabled=\"!vm.hasSelectedTasks()\" ng-if=\"vm.canTag\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ACOES.REMOVER-ROTULO\" ng-click=\"vm.unassignTagTasks()\"><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.REMOVER-ROTULO\">Remover Rótulo</span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button md-small md-primary\" ng-disabled=\"vm.pagination.currentPage == 0\" ng-click=\"vm.paginationFirst()\" aria-label=\"Primeira\"><md-icon md-font-icon=\"\" class=\"icon-chevron-double-left s24\"></md-icon><md-tooltip md-direction=\"top\"><span>Primeira</span></md-tooltip></md-button><md-button class=\"md-icon-button md-small md-primary\" ng-disabled=\"vm.pagination.currentPage == 0\" ng-click=\"vm.paginationPrevious()\" aria-label=\"Anterior\"><md-icon md-font-icon=\"\" class=\"icon-chevron-left s24\"></md-icon><md-tooltip md-direction=\"top\"><span>Anterior</span></md-tooltip></md-button><span>{{vm.pagination.currentPage + 1}}/{{vm.pagination.numberOfPages}}</span><md-button class=\"md-icon-button md-small md-primary\" ng-disabled=\"vm.pagination.currentPage >= vm.pagination.total/vm.pagination.pageSize - 1\" ng-click=\"vm.paginationNext()\" aria-label=\"Próximo\"><md-icon md-font-icon=\"\" class=\"icon-chevron-right s24\"></md-icon><md-tooltip md-direction=\"top\"><span>Próximo</span></md-tooltip></md-button><md-button class=\"md-icon-button md-small md-primary\" ng-disabled=\"vm.pagination.currentPage >= vm.pagination.total/vm.pagination.pageSize - 1\" ng-click=\"vm.paginationLast()\" aria-label=\"Última\"><md-icon md-font-icon=\"\" class=\"icon-chevron-double-right s24\"></md-icon><md-tooltip md-direction=\"top\"><span>Última</span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"end center\"><span hide=\"\" show-gt-xs=\"\" class=\"mr-5\">Mostrar</span><md-select class=\"simplified\" ng-model=\"vm.pagination.pageSize\" md-selected-text=\"vm.pagination.pageSize\"><md-select-header><input ng-model=\"vm.pagination.pageSize\" ng-model-options=\"{ debounce: 500 }\" type=\"number\" min=\"1\" ng-keydown=\"$event.stopPropagation();\" aria-label=\"Tamanho da página\" class=\"w-70\"></md-select-header><md-option ng-value=\"length\" ng-repeat=\"length in [10, 20, 30, 50, 100, 200, 400, 500]\">{{::length}}</md-option></md-select><div hide=\"\" show-xs=\"\">/<strong>{{vm.pagination.total}}</strong></div><div layout=\"row\" layout-align=\"end center\" hide=\"\" show-gt-xs=\"\"><div layout=\"row\" layout-align=\"start center\" class=\"pr-10 mr-10 h-40 br\"><span>de <strong>{{vm.pagination.total}}</strong> {{\'encontrada\' + (vm.pagination.total > 1 ? \'s\' : \'\')}}</span></div><div layout=\"row\" layout-align=\"start center\" class=\"pr-10 mr-10 h-40 br\"><md-select class=\"simplified\" ng-model=\"vm.taskOrder\" ng-model-options=\"{ debounce : 500 }\" placeholder=\"Ordenação\"><md-option value=\"startDate\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.DATA-DE-CRIACAO\">Criação</md-option><md-option value=\"claimDate\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.DATA-DE-ATRIBUICAO\">Atribuição</md-option><md-option value=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.TITULO\">Título</md-option><md-option value=\"assignee\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.RESPONSAVEL\">Responsável</md-option></md-select><md-button class=\"md-icon-button\" ng-click=\"vm.taskOrderDescending = !vm.taskOrderDescending\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.ORDEM-{{vm.taskOrderDescending ? \'DECRESCENTE\': \'CRESCENTE\'}}\"><md-icon md-font-icon=\"\" class=\"s20 icon-sort-{{vm.taskOrderDescending ? \'descending\' : \'ascending\'}}\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.ORDEM-{{vm.taskOrderDescending ? \'DECRESCENTE\': \'CRESCENTE\'}}\">Decrescente</span></md-tooltip></md-button></div><div layout=\"row\" layout-align=\"start center\" class=\"pr-10 h-40 br\"><md-select class=\"simplified\" ng-model=\"vm.taskDateFilter\" ng-model-options=\"{ debounce : 500 }\"><md-option value=\"startDate\" translate=\"TAREFAS.MINHAS-TAREFAS.ORDENACAO.DATA-DE-CRIACAO\">Criação</md-option></md-select><span class=\"mr-15\">de</span><md-datepicker ng-model=\"vm.fromDateFilter\" md-min-date=\"vm.minDateFilter\" md-max-date=\"vm.maxDateFilter\" md-placeholder=\"Data inicial\" md-hide-icons=\"calendar\" ng-required=\"true\"></md-datepicker><span class=\"ml-15 mr-15\">a</span><md-datepicker ng-model=\"vm.toDateFilter\" md-min-date=\"vm.minDateFilter\" md-max-date=\"vm.maxDateFilter\" md-placeholder=\"Data final\" md-hide-icons=\"calendar\" ng-required=\"true\"></md-datepicker></div><md-button class=\"md-icon-button md-small no-border-radius br\" ng-disabled=\"!vm.hasSelectedTasks()\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ACOES.EXPORTAR\" ng-click=\"vm.exportarResultado($event)\"><md-icon md-font-icon=\"\" class=\"s20 icon-download\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.EXPORTAR\">Exportar</span></md-tooltip></md-button><md-button class=\"md-icon-button md-small\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ACOES.{{vm.taskViewExpanded ? \'COMPACTAR\' : \'EXPANDIR\'}}-TAREFAS\" ng-click=\"vm.taskViewExpanded = !vm.taskViewExpanded\"><md-icon md-font-icon=\"\" class=\"s20 icon-arrow-{{vm.taskViewExpanded ? \'collapse\' : \'expand\'}}\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.{{vm.taskViewExpanded ? \'COMPACTAR\' : \'EXPANDIR\'}}-TAREFAS\">Expandir</span></md-tooltip></md-button></div></div></div><div class=\"content\" layout=\"row\" flex=\"\"><md-content class=\"todo-list-pane\" ms-scroll=\"vm.msScrollOptions\" flex=\"\" ng-include=\"\'app/main/tarefas/minhas-tarefas/views/list/list.html\'\"></md-content></div></div></div></div>");
$templateCache.put("app/main/tarefas/painel-de-fases/painel-de-fases.html","<div id=\"painel-de-fases\" class=\"md-accent-bg\" layout=\"column\"><div id=\"painel-selector\" layout=\"column\" layout-align=\"start center\" flex=\"\"><h1 translate=\"TAREFAS.PAINEL-DE-FASES.QUAL-PAINEL-VISUALIZAR\" class=\"text-center\">Qual painel deseja visualizar?</h1><div class=\"painel-list\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div ng-repeat=\"board in vm.BoardList\" class=\"painel-list-item\" layout=\"column\" layout-align=\"center center\" layout-wrap=\"\" ng-attr-ui-sref=\"{{ \'app.tarefas.painel-de-fases.\' + board.id }}\"><md-icon md-font-icon=\"icon-trello\" class=\"icon s64\"></md-icon><div class=\"painel-name\" ng-attr-translate=\"{{ \'TAREFAS.PAINEL-DE-FASES.\' + board.id.toUpperCase() }}\">{{ board.name }}</div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul class=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-horizontal-nested.html\"><div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\"> <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\" ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </div> <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren && !vm.isHidden()\"> <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\"><div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\"> <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon && !vm.materialIcon\"></i> <i class=\"icon s16 material-symbols-sharp\" ng-if=\"node.icon && vm.materialIcon\">{{node.icon}}</i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </div> <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon && !vm.materialIcon\"></i> <i class=\"icon s16 material-symbols-sharp\" ng-if=\"node.icon && vm.materialIcon\">{{node.icon}}</i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg {{node.badge.alert ? \'badge-alert\' : \'\'}}\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren && !vm.isHidden()\"> <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/main/documentos/directives/editor/editor.tpl.html","<div layout=\"column\"><div ng-if=\"showMaximizeButton\" layout=\"row\" layout-gt-xs=\"row\"><md-button class=\"md-raised\" ng-if=\"vm.documento\" onclick=\"+function(a,b){+function(c){c.call(a)}(a[\'moz\'+b]||a[\'webkit\'+b]||a[\'msRequestFullscreen\'])}($(\'[onlyoffice-editor] iframe\')[0],\'RequestFullScreen\')\" style=\"min-height: 23px !important; min-width: 46px !important; font-size: 10px !important; line-height: 0px; margin-left: 1px; margin-right: 1px;\"><md-icon md-font-icon=\"icon-fullscreen\"></md-icon>Maximizar Editor</md-button></div><div class=\"editor-directive\" ng-class=\"{\'edicao-iniciada\': vm.edicaoIniciada}\" ng-style=\"editorHeight ? {height: editorHeight} : \'\'\" layout-fill=\"\"><div ng-if=\"vm.showEditor\" onlyoffice=\"vm.config\" save=\"save(url, close)\" read-only=\"readOnly\" history-enabled=\"historyEnabled\" class=\"onlyoffice-iframe-container\" layout-fill=\"\" contexto=\"{{vm.contexto}}\" api=\"vm.api\" config-override=\"configOverride\"></div><div ng-if=\"vm.showProgress\"><div class=\"loadmask\"><div class=\"loader-page\"><div class=\"asc-loadmask-body\" role=\"presentation\" tabindex=\"-1\"><div class=\"asc-loadmask-image\"></div><div class=\"asc-loadmask-title\">Salvando documento</div></div></div></div></div></div></div>");
$templateCache.put("app/main/gestao/meus-paineis/autuacoes/autuacoes.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget8.title}}</div><md-divider></md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget9.title}}</div><md-divider></md-divider><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.weeklySpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.weeklySpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex=\"\"><nvd3 class=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.weeklySpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.totalSpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.totalSpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex=\"\"><nvd3 class=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.totalSpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.remaining.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.remaining.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex=\"\"><nvd3 class=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.remaining.chartData\"></nvd3></div></div><div class=\"pv-24 mh-24 border-top\"><div class=\"h4 secondary-text\">{{vm.widget9.totalBudget.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.totalBudget.count}}</span></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"simple-table-container\" ms-responsive-table=\"\"><div class=\"table-title\">{{vm.widget10.title}}</div><table class=\"simple\"><thead><tr><th ng-repeat=\"column in vm.widget10.table.columns\">{{column.title}}</th></tr></thead><tbody><tr ng-repeat=\"row in vm.widget10.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">{{cell.value}}</span> <i ng-if=\"cell.icon\" class=\"icon {{cell.icon}}\"></i></td></tr></tbody></table></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/gestao/meus-paineis/peticoes/peticoes.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\" layout-align=\"space-between\"><ms-widget flex=\"100\" flex-gt-xs=\"33\" class=\"h-170\" layout=\"column\" layout-padding=\"\"><ms-widget-front class=\"light-blue-bg\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text text-uppercase\" translate=\"GESTAO.MEUS-PAINEIS.PETICOES-VIEW.PETICOES\">Petições ADI, ADC, ADO e ADPF</div></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"md-display-2 font-weight-100\" layout=\"row\" layout-align=\"start center\"><span>{{ 342 | number }}</span></div><div layout=\"row\" layout-align=\"start center\"><span><span translate=\"GESTAO.MEUS-PAINEIS.PETICOES-VIEW.ULTIMA-SEMANA\">Última Semana:</span> {{ 30002 | number }}</span> <span class=\"text-boxed-light\">+ 1,12%</span></div></div></ms-widget-front></ms-widget><ms-widget flex=\"100\" flex-gt-xs=\"33\" class=\"h-170\" layout=\"column\" layout-padding=\"\"><ms-widget-front class=\"green-bg\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text text-uppercase\" translate=\"GESTAO.MEUS-PAINEIS.PETICOES-VIEW.PROCESSOS-PETICIONADOS\">Processos Peticionados</div></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"md-display-2 font-weight-100\" layout=\"row\" layout-align=\"start center\"><span>{{ 800 | number }}</span><md-icon md-font-icon=\"icon-trending-up\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span translate=\"GESTAO.MEUS-PAINEIS.PETICOES-VIEW.VEJA-MAIS-DETALHES\">Veja mais detalhes</span></div></div></ms-widget-front></ms-widget><ms-widget flex=\"100\" flex-gt-xs=\"33\" class=\"h-170\" layout=\"column\" layout-padding=\"\"><ms-widget-front class=\"blue-grey-bg\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text text-uppercase\" translate=\"GESTAO.MEUS-PAINEIS.PETICOES-VIEW.PROCESSOS-AUTUADOS\">Processos Autuados</div></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"md-display-2 font-weight-100\" layout=\"row\" layout-align=\"start center\"><span>65%</span><md-icon md-font-icon=\"icon-trending-down\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span><span translate=\"GESTAO.MEUS-PAINEIS.PETICOES-VIEW.ULTIMA-SEMANA\">Última Semana:</span> 70%</span> <span class=\"text-boxed-light\">- 5%</span></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\" layout-align=\"space-between\"><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"66\" layout-padding=\"\"><ms-widget-front class=\"p-16 white-bg\"><div layout=\"row\" layout-align=\"space-between\"><div class=\"mr-16\"><div class=\"h4 weight-500 pb-8\" translate=\"GESTAO.MEUS-PAINEIS.PETICOES-VIEW.ENTRADA-DE-PROCESSOS\">Entrada de Processos</div><div class=\"h1 secondary-text\">{{1342 | number}}</div><div class=\"pt-8\" layout=\"row\" layout-align=\"start center\"><div>US: {{540 | number}}</div><div class=\"text-boxed\">+ 1,12%</div></div></div><c3chart flex=\"\" bindto-id=\"entrada-de-processos\"><chart-column ng-repeat=\"column in vm.chart1.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-legend show-legend=\"false\"><chart-bar width=\"10\"><chart-size chart-height=\"240\"><chart-axes values-x=\"x\" y=\"processos\"><chart-axis><chart-axis-x axis-position=\"outer-center\" axis-type=\"category\"></chart-axis-x></chart-axis></chart-axes></chart-size></chart-bar></chart-legend></chart-column></c3chart></div></ms-widget-front></ms-widget><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"33\" layout-padding=\"\"><ms-widget-front class=\"p-16 white-bg\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"mr-16\"><div class=\"h4 weight-500 pb-8\" translate=\"GESTAO.MEUS-PAINEIS.PETICOES-VIEW.PETICIONADOS-NOS-ULTIMOS-5-MESES\">Petcionados nos últimnos 5 meses</div><div class=\"h1 secondary-text\">{{5369 | number}}</div></div><c3chart flex=\"\" bindto-id=\"peticionados-ultimos-meses\"><chart-column ng-repeat=\"column in vm.chart2.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-points point-radius=\"5\" show-point=\"true\" point-expand-enabled=\"true\" point-expand-radius=\"10\"><chart-legend show-legend=\"false\"><chart-size chart-height=\"180\"><chart-axes values-x=\"x\" y=\"processos\"><chart-axis><chart-axis-x axis-position=\"outer-center\" axis-type=\"category\"></chart-axis-x><chart-axis-y show=\"false\"></chart-axis-y></chart-axis></chart-axes></chart-size></chart-legend></chart-points></chart-column></c3chart></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/gestao/meus-paineis/principal/principal.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.widget1.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget1.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">{{vm.widget2.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget2.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{vm.widget4.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap=\"\"><div class=\"pv-8 h3\">{{vm.widget5.title}}</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" ng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" ng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\"><nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" data=\"vm.widget5.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" layout-wrap=\"\"><div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\" ng-repeat=\"(name, widget) in vm.widget5.supporting.widgets\"><div class=\"h4 secondary-text\">{{widget.data.label}}</div><div class=\"md-display-1\">{{widget.data.count[vm.widget5.currentRange]}}</div><nvd3 class=\"h-50\" config=\"vm.widget5.supporting.chart.config\" options=\"vm.widget5.supporting.chart.options\" data=\"widget.chart.data\"></nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget6.currentRange\" ng-change=\"vm.widget6.changeRange(vm.widget6.currentRange)\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div class=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" data=\"vm.widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerRight.title}}</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget7.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"event in vm.widget7.schedule[vm.widget7.currentRange]\"><div><div class=\"h3\">{{event.title}}</div><div><span class=\"secondary-text\">{{event.time}}</span> <span ng-if=\"event.location\">, {{event.location}}</span></div></div><md-button class=\"md-icon-button\" aria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/gestao/meus-paineis/produtividade-do-time/produtividade-do-time.html","<div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 mb-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">{{vm.widget11.title}}</div><div class=\"text-boxed red-bg white-fg m-0\">{{vm.widget11.table.rows.length}} members</div></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget11.dtOptions\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in ::vm.widget11.table.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ::vm.widget11.table.rows\"><td ng-repeat=\"cell in row\"><span>{{cell}}</span></td></tr></tbody></table></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/pesquisa-avancada/directives/criteria-summary/criteria-summary.html","<div class=\"criteria-summary md-white-bg\" ms-scroll=\"\" ng-if=\"criteria\"><div class=\"criteria-thumbs-container flex-scrollable\" ms-scroll=\"\" flex=\"\" layout=\"row\" layout-nowrap=\"\"><div ng-repeat=\"criterion in criteria\" class=\"criteria-thumb\" flex=\"none\" ng-if=\"criterion.value || criterion.comparisonOperator === \'EXISTS\'\"><div layout=\"column\" layout-align=\"center center\"><div class=\"data-type\"><span class=\"name\">{{ criterion.trait.name }}</span></div><div class=\"divider\" operator-color=\"criterion.logicalOperator\" flex=\"\"></div><div class=\"data-type\">{{\'PESQUISA-AVANCADA.OPERADOR-LOGICO.TEXT.\' + criterion.logicalOperator | translate}} {{\'PESQUISA-AVANCADA.OPERADOR-COMPARACAO.TEXT.\' + criterion.comparisonOperator | translate}} <span class=\"name\">{{criterion | criterionDisplayName}}</span></div></div></div></div></div>");
$templateCache.put("app/main/pesquisa-avancada/directives/criterion-value-input/criterion-value-input.html","<div ng-if=\"criterion.comparisonOperator !== \'EXISTS\' && criterion.trait.dataType !== \'constant\'\" flex=\"\"><div ng-if=\"criterion.comparisonOperator !== \'BETWEEN\' && criterion.trait.dataType !== \'list\' && criterion.trait.dataType !== \'date\'\"><md-input-container md-no-float=\"\"><input placeholder=\"Valor\" ng-model=\"criterion.value\" type=\"text\" ng-keypress=\"vm.ifEnterDoSearch($event)\" autofocus=\"\"></md-input-container></div><div ng-if=\"criterion.comparisonOperator === \'BETWEEN\' && criterion.trait.dataType !== \'date\'\"><md-input-container md-no-float=\"\"><input placeholder=\"Valor\" ng-model=\"criterion.value[0]\" autofocus=\"\" ng-keypress=\"vm.ifEnterDoSearch($event)\"></md-input-container><span class=\"connector\">e</span><md-input-container md-no-float=\"\"><input placeholder=\"Valor\" ng-model=\"criterion.value[1]\" ng-keypress=\"vm.ifEnterDoSearch($event)\"></md-input-container></div><div ng-if=\"criterion.trait.dataType === \'list\'\"><md-autocomplete md-items=\"item in vm.filterItems(criterion.trait.values, searchText)\" md-item-text=\"item.value\" md-selected-item=\"criterion.selectedItem\" md-search-text=\"searchText\" md-require-match=\"\" md-min-length=\"0\" md-clear-button=\"true\" placeholder=\"Escolha...\" ng-click=\"vm.cleanSelection($event)\" ng-keypress=\"vm.ifEnterDoSearch($event)\" flex=\"\"><md-item-template><span>{{item.value}}</span></md-item-template></md-autocomplete></div><div ng-if=\"criterion.trait.dataType === \'date\'\"><div ng-if=\"criterion.comparisonOperator === \'BETWEEN\'\"><md-datepicker flex=\"\" ng-model=\"date[0]\" ng-init=\"vm.initBetween(0)\" ng-change=\"vm.changeCriterionValue(vm.dateToStr(date[0], true), 0)\" md-placeholder=\"Escolha...\" ng-keypress=\"vm.ifEnterDoSearch($event)\"></md-datepicker><span class=\"connector\">e</span><md-datepicker flex=\"\" ng-model=\"date[1]\" ng-init=\"vm.initBetween(1)\" ng-change=\"vm.changeCriterionValue(vm.dateToStr(date[1], false), 1)\" md-placeholder=\"Escolha...\" ng-keypress=\"vm.ifEnterDoSearch($event)\"></md-datepicker></div><div ng-if=\"criterion.comparisonOperator === \'GREATER_THAN\'\"><md-datepicker flex=\"\" ng-model=\"date\" ng-init=\"date = vm.strToDate(criterion.value); vm.changeCriterionValue(vm.dateToStr(date, false));\" ng-change=\"vm.changeCriterionValue(vm.dateToStr(date, false))\" md-placeholder=\"Escolha...\" ng-keypress=\"vm.ifEnterDoSearch($event)\"></md-datepicker></div><div ng-if=\"criterion.comparisonOperator === \'LESS_THAN\'\"><md-datepicker flex=\"\" ng-model=\"date\" ng-init=\"date = vm.strToDate(criterion.value); vm.changeCriterionValue(vm.dateToStr(date, true))\" ng-change=\"vm.changeCriterionValue(vm.dateToStr(date, true))\" md-placeholder=\"Escolha...\" ng-keypress=\"vm.ifEnterDoSearch($event)\"></md-datepicker></div></div></div>");
$templateCache.put("app/main/pesquisa-avancada/directives/search-builder/search-builder.html","<div class=\"builder\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-autocomplete md-selected-item=\"vm.newCriterion.trait\" md-search-text-change=\"vm.searchTextChange(vm.traitSearchText)\" md-search-text=\"vm.traitSearchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.querySearch(vm.traitSearchText)\" md-item-text=\"item.name\" md-min-length=\"0\" md-menu-class=\"trait-autocomplete-menu\" placeholder=\"Digite uma característica para pesquisar\" ng-click=\"vm.cleanSelection($event)\" flex=\"\"><md-item-template><span md-highlight-text=\"vm.traitSearchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>Nenhuma característica encontrada com <strong>\"{{vm.traitSearchText}}\"</strong></md-not-found></md-autocomplete></div></div></div><div class=\"criteria-list md-white-bg md-whiteframe-2dp\"><div class=\"criteria-item pt-8\" ng-repeat=\"criterion in vm.search.criteria\"><div class=\"fade\" layout-gt-xs=\"row\" layout-xs=\"column\"><div class=\"criteria-item-color\" operator-color=\"criterion.logicalOperator\"></div><div class=\"ml-16\" layout=\"row\" layout-align=\"start center\"><div class=\"name ml-16 mt-8\">{{criterion.trait.name}}</div><div class=\"mr-16 comparison-operator\"><md-input-container><md-select placeholder=\"Operador lógico\" ng-model=\"criterion.logicalOperator\"><md-option ng-repeat=\"op in ::vm.logicalOperators\" ng-value=\"op\"><div layout=\"row\" layout-align=\"start center\"><span>{{\'PESQUISA-AVANCADA.OPERADOR-LOGICO.TEXT.\' + op | translate}}</span></div></md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" flex=\"\"><div class=\"ml-16 mr-16 comparison-operator\"><md-input-container><md-select placeholder=\"Operador\" ng-model=\"criterion.comparisonOperator\" ng-disabled=\"criterion.trait.dataType === \'constant\'\"><md-option ng-repeat=\"op in vm.getComparisonOperators(criterion.trait.dataType)\" value=\"{{op}}\"><div layout=\"row\" layout-align=\"start center\"><span>{{ \'PESQUISA-AVANCADA.OPERADOR-COMPARACAO.TEXT.\' + op | translate }}</span></div></md-option></md-select></md-input-container></div><div class=\"value\" ng-class=\"criterion.trait.dataType || \'string\'\" layout=\"row\" flex=\"\" layout-align=\"start center\"><criterion-value-input criterion=\"criterion\" flex=\"\"></criterion-value-input></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button md-primary remove\" aria-label=\"Remover\" ng-click=\"vm.removeCriterion($index)\"><md-icon class=\"icon\" md-font-icon=\"icon-close\"></md-icon></md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/pesquisa-avancada/modals/save-search/save-search.html","<div class=\"p-16\" layout=\"column\"><h3 translate=\"PESQUISA-AVANCADA.SALVAR-PESQUISA\">Salvar pesquisa</h3><md-input-container class=\"m-0\"><label for=\"searchName\" translate=\"PESQUISA-AVANCADA.MODAL-SALVAR-PESQUISA.NOME-PESQUISA\">Nome da pesquisa</label> <input type=\"text\" ng-model=\"vm.search.description\"></md-input-container><md-input-container class=\"m-0\"><md-checkbox ng-model=\"vm.search.executable\" aria-label=\"{{ \'PESQUISA-AVANCADA.MODAL-SALVAR-PESQUISA.EXECUCAO-AUTOMATICA\' | translate }}\">{{ \'PESQUISA-AVANCADA.MODAL-SALVAR-PESQUISA.EXECUCAO-AUTOMATICA\' | translate }}</md-checkbox></md-input-container><div layout=\"row\" layout-align=\"center right\"><md-button class=\"md-raised\" ng-click=\"vm.cancel()\"><span translate=\"PESQUISA-AVANCADA.MODAL-SALVAR-PESQUISA.CANCELAR\">Cancelar</span></md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.confirm()\" ng-disabled=\"!vm.search.description\"><span translate=\"PESQUISA-AVANCADA.MODAL-SALVAR-PESQUISA.SALVAR\">Salvar</span></md-button></div></div>");
$templateCache.put("app/main/quick-panel/tabs/feed/feed.html","<md-tab><md-tab-label translate=\"QUICKPANEL.NOTIFICATIONS\">NOTIFICAÇÕES</md-tab-label><md-tab-body><md-content class=\"feed-tab scrollable\" ms-scroll=\"\"><md-list><md-list-item><div class=\"md-list-item-text\"><h3 translate=\"QUICKPANEL.CLEAR\">Limpar</h3><md-button class=\"md-secondary md-accent md-icon-button\" ng-click=\"vm.removeAll()\" aria-label=\"Remove todos os itens do feed\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><md-divider></md-divider></md-list-item><md-list-item class=\"md-4-line\" ng-repeat=\"item in vm.feed track by item.uuid\"><div class=\"md-list-item-text\"><h3>{{::item.title}}</h3><p>{{::item.description}}</p><md-tooltip ng-if=\"item.sender && vm.usersNames.has(item.sender.toLowerCase())\">{{ ::vm.usersNames.get(item.sender.toLowerCase()) }} ({{ ::item.sender }})</md-tooltip><p ng-if=\"item.sender && vm.usersNames.has(item.sender.toLowerCase())\">Por {{ ::vm.usersNames.get(item.sender.toLowerCase()) }} em {{::item.creationDate | date : \"dd/MM/yyyy HH:mm:ss\"}}</p><p ng-if=\"!item.sender || !vm.usersNames.has(item.sender.toLowerCase())\">Por {{ ::item.sender }} em {{::item.creationDate | date : \"dd/MM/yyyy HH:mm:ss\"}}</p></div><md-button class=\"md-secondary md-accent md-icon-button\" ng-click=\"vm.remove(item)\" aria-label=\"Remove feed\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-divider></md-divider></md-list-item><md-list-item><div class=\"md-list-item-text\"><h3 translate=\"QUICKPANEL.LOAD_MORE\">Carregar mais</h3><md-button class=\"md-secondary md-accent md-icon-button\" ng-click=\"vm.loadMore()\" aria-label=\"Carrega mais itens do feed\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></div></md-list-item></md-list></md-content></md-tab-body></md-tab>");
$templateCache.put("app/main/support/dashboards/directives/dashboard.tpl.html","<div ng-repeat=\"row in vm.layout.rows\" class=\"widget-group p-8\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><div ng-repeat=\"column in row.columns\" flex=\"\"><dashlet value=\"column.dashlet.id\"></dashlet></div></div>");
$templateCache.put("app/main/tarefas/minhas-tarefas/directives/notas.tpl.html","<md-button class=\"md-icon-button\" md-no-ink=\"\" ng-click=\"vm.setNotas()\" show-if-has-permission=\"anotar-tarefa\" aria-label=\"Notas\"><md-icon md-font-icon=\"icon-comment-plus-outline\" class=\"s18\" ng-if=\"!vm.tarefa.notes\"></md-icon><md-tooltip md-direction=\"top\" ng-if=\"!vm.tarefa.notes\">Adicionar nota</md-tooltip><md-icon md-font-icon=\"icon-comment-text-outline\" class=\"s18 yellow-800-fg\" ng-if=\"!!vm.tarefa.notes\" fo-tooltip=\"\" tooltip-template-url=\"tooltip-notas.html\" tooltip-position=\"right center\"></md-icon></md-button><script id=\"tooltip-notas.html\" type=\"text/ng-template\"><span ng-bind=\"vm.tarefa.notes\"></span></script>");
$templateCache.put("app/main/tarefas/painel-de-fases/painel/painel.html","<div id=\"scrumboard\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"column\"><div class=\"header-content\" layout=\"row\" layout-align=\"space-between\" layout-wrap=\"\" flex=\"\"><div layout=\"row\" layout-align=\"center center\" flex-order=\"1\" flex-order-xs=\"2\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" ng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" ng-click=\"vm.boardSelectorVisible = !vm.boardSelectorVisible\" aria-label=\"boards button\" translate=\"\" translate-attr-aria-label=\"SB.BOARDS_BUTTON\"><md-icon md-font-icon=\"icon-trello\" class=\"icon\"></md-icon><span translate=\"TAREFAS.PAINEL-DE-FASES.PAINEIS\">PAINEIS</span></md-button></div><div class=\"header-board-name\" layout=\"row\" layout-align=\"center center\" flex-order=\"2\" flex-order-xs=\"1\" flex-xs=\"100\"><i ng-if=\"vm.board.settings.subscribed\" class=\"board-subscribe s16 icon-eye\"></i> <span>{{vm.board.name}}</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" flex-order=\"3\"><md-button ng-if=\"vm.filteringIsOn()\" class=\"md-icon-button\" ng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate=\"\" translate-attr-aria-label=\"SB.CLEAR_FILTERS\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"TAREFAS.PAINEL-DE-FASES.LIMPAR-FILTROS\">Limpar Filtros</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate=\"\" translate-attr-aria-label=\"SB.FILTER_CARDS\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip><span translate=\"TAREFAS.PAINEL-DE-FASES.FILTRAR-CARTOES\">Filtrar Cartões</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" aria-label=\"Settings\" translate=\"\" translate-attr-aria-label=\"SB.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip><span translate=\"TAREFAS.PAINEL-DE-FASES.CONFIGURACOES\">Configurações</span></md-tooltip></md-button></div></div></div><div ng-show=\"vm.boardSelectorVisible\" id=\"board-selector\" class=\"md-accent-bg animate-slide-down board-list md-whiteframe-3dp\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"row\" layout-align=\"start center\"><div class=\"board-list-item\" ng-repeat=\"board in vm.BoardList\" ng-attr-ui-sref=\"{{ \'app.tarefas.painel-de-fases.\' + board.id }}\" layout=\"column\" layout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex=\"\" class=\"board-name\">{{board.name}}</div><div ng-if=\"board.id === vm.board.id\" class=\"selected-icon green-bg\"><i class=\"icon-check s24\"></i></div></div></div><md-backdrop class=\"board-selector-backdrop md-dialog-backdrop md-opaque\" ng-show=\"vm.boardSelectorVisible\" ng-click=\"vm.boardSelectorVisible = false\" aria-hidden=\"true\"></md-backdrop><div id=\"board\" ng-class=\"vm.board.settings.color+\'-100-bg\'\" ui-sortable=\"vm.sortableListOptions\" ng-model=\"vm.board.lists\" layout=\"row\"><div class=\"list-wrapper\" ng-repeat=\"list in vm.board.lists track by list.id\"><div class=\"list md-whiteframe-1dp\" layout=\"column\"><div class=\"list-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"list-header-name\"><span>{{ list.name }}</span></div></div><div class=\"list-content\" ms-scroll=\"\"><div class=\"list-cards\" ui-sortable=\"vm.sortableCardOptions\" ng-model=\"list.idCards\"><div ng-if=\"cardId\" class=\"list-card md-whiteframe-3dp\" ng-repeat=\"cardId in list.idCards | filter: vm.cardFilter track by $index\" ng-click=\"vm.openCardDialog($event, cardId)\"><div ng-if=\"vm.board.settings.cardCoverImages && vm.board.cards.getById(cardId).idAttachmentCover\" class=\"list-card-cover\"><img ng-src=\"{{vm.board.cards.getById(cardId).attachments.getById(vm.board.cards.getById(cardId).idAttachmentCover).src}}\"></div><div class=\"list-card-details\"><div class=\"list-card-sort-handle\"><md-icon md-font-icon=\"icon-cursor-move\" class=\"icon s16\"></md-icon></div><div ng-if=\"vm.board.cards.getById(cardId).idLabels.length > 0\" class=\"list-card-labels\" layout=\"row\" layout-wrap=\"\"><span class=\"list-card-label\" ng-class=\"\'md-\'+vm.board.labels.getById(labelId).color+\'-bg\'\" ng-repeat=\"labelId in vm.board.cards.getById(cardId).idLabels\"><md-tooltip>{{vm.board.labels.getById(labelId).name}}</md-tooltip></span></div><div class=\"list-card-name md-accent-bg\">{{vm.board.cards.getById(cardId).name}}</div><div ng-if=\"vm.board.cards.getById(cardId).due || vm.board.cards.getById(cardId).checkItems\" class=\"list-card-badges\" layout=\"row\" layout-align=\"start center\"><span class=\"badge due-date\" ng-class=\"{\'overdue\': vm.isOverdue(vm.board.cards.getById(cardId).due)}\" ng-if=\"vm.board.cards.getById(cardId).due\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-clock s16\"></i> <span>{{vm.board.cards.getById(cardId).due | date}}</span></span><span ng-if=\"vm.board.cards.getById(cardId).checkItems\" class=\"badge check-items\" ng-class=\"{\'completed\': vm.board.cards.getById(cardId).checkItemsChecked === vm.board.cards.getById(cardId).checkItems}\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked-circle s16\"></i> <span>{{vm.board.cards.getById(cardId).checkItemsChecked}}</span> <span>/</span> <span>{{vm.board.cards.getById(cardId).checkItems}}</span></span></div><div ng-if=\"vm.board.cards.getById(cardId).idMembers.length > 0\" class=\"list-card-members\" layout=\"row\"><div class=\"list-card-member\" ng-repeat=\"memberId in vm.board.cards.getById(cardId).idMembers | limitTo:3\"><img class=\"list-card-member-avatar\" ng-src=\"{{vm.board.members.getById(memberId).avatar}}\"><md-tooltip><div class=\"name\">{{ vm.board.members.getById(memberId).name }}</div></md-tooltip></div><div ng-if=\"vm.board.cards.getById(cardId).idMembers.length > 3\" class=\"pt-8 secondary-text\"><span>+ {{ vm.board.cards.getById(cardId).idMembers.length - 3 }}</span> <span translate=\"TAREFAS.PAINEL-DE-FASES.OUTRO_S\" translate-values=\"{count: vm.board.cards.getById(cardId).idMembers.length - 3}\">outro{{ vm.board.cards.getById(cardId).idMembers.length - 3 == 1 ? \'\' : \'s\'}}</span><md-tooltip><span ng-repeat=\"memberId in vm.board.cards.getById(cardId).idMembers | limitTo: vm.board.cards.getById(cardId).idMembers.length | limitTo: 3 - vm.board.cards.getById(cardId).idMembers.length track by $index\">{{ vm.board.members.getById(memberId).name }}{{ ($index + 4) < vm.board.cards.getById(cardId).idMembers.length ? \', \' : \'\'}}</span></md-tooltip></div></div><div ng-if=\"vm.board.cards.getById(cardId).additionalInfo && (vm.board.cards.getById(cardId).additionalInfo.icon || vm.board.cards.getById(cardId).additionalInfo.left || vm.board.cards.getById(cardId).additionalInfo.right)\" class=\"list-card-addition-info\" layout=\"row\"><div flex=\"\"><i class=\"icon s18 {{ vm.board.cards.getById(cardId).additionalInfo.icon }}\"></i> <span>{{ vm.board.cards.getById(cardId).additionalInfo.left }}</span></div><div flex=\"\" class=\"text-right\"><span>{{ vm.board.cards.getById(cardId).additionalInfo.right }}</span></div></div></div><div class=\"list-card-footer\" layout=\"row\"><div layout=\"row\" layout-align=\"start center\"><span ng-if=\"vm.board.cards.getById(cardId).subscribed\" class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-eye s18\"></i></span><span ng-if=\"vm.board.cards.getById(cardId).description !== \'\'\" class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-document s18\"></i></span></div><div flex=\"\"><div ng-if=\"vm.board.cards.getById(cardId).additionalInfo.footer\" layout=\"row\"><img class=\"list-card-footer-location-avatar m-8\" ng-if=\"vm.board.cards.getById(cardId).additionalInfo.footer.avatar\" ng-src=\"{{ vm.board.cards.getById(cardId).additionalInfo.footer.avatar }}\"><div><div class=\"list-card-footer-additional-info-container\"><span>{{ vm.board.cards.getById(cardId).additionalInfo.footer.name }}</span></div></div></div></div><div layout=\"row\" layout-align=\"end center\"><span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).attachments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"value\">{{vm.board.cards.getById(cardId).attachments.length}}</span></span><span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).comments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"value\">{{vm.board.cards.getById(cardId).comments.length}}</span></span></div></div></div></div></div></div></div></div><md-sidenav class=\"settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" ng-include=\"\'app/main/tarefas/painel-de-fases/sidenavs/settings/settings-sidenav.html\'\" ng-controller=\"SettingsSidenavController as vm\" ms-sidenav-helper=\"\"></md-sidenav><md-sidenav class=\"filters-sidenav md-sidenav-right\" md-component-id=\"filters-sidenav\" ng-include=\"\'app/main/tarefas/painel-de-fases/sidenavs/filters/filters-sidenav.html\'\" ng-controller=\"FiltersSidenavController as vm\" ms-sidenav-helper=\"\"></md-sidenav></div>");
$templateCache.put("app/main/toolbar/modals/alterar-conta/alterar-conta.html","<div class=\"p-16\" layout=\"column\"><h3 translate=\"TOOLBAR.ALTERAR_CONTA.TITLE\">Confirmar alteração</h3><h6 translate=\"TOOLBAR.ALTERAR_CONTA.MESSAGE\">Confirma a alteração de setor? O STFDigital será recarregado em todas abas/janelas conforme o setor informado.</h6><div layout=\"row\" layout-align=\"center right\"><md-button class=\"md-raised\" ng-click=\"vm.cancel()\" translate=\"TOOLBAR.ALTERAR_CONTA.CANCELAR_ALTERACAO\">Cancelar</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.confirm()\" translate=\"TOOLBAR.ALTERAR_CONTA.CONFIRMAR_ALTERACAO\">Confirmar</md-button></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div class=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-11/template-11.html","<div class=\"template-11\" layout=\"column\" layout-align=\"center center\"><div class=\"header-card\" layout=\"column\" layout-align=\"center start\" style=\"padding: 8px\" flex=\"\"><div layout=\"row\" class=\"info\"><div class=\"title\" ng-if=\"card.title\" ng-class=\"{\'secondary-text\': !card.valid}\">{{card.title}} <span ng-if=\"card.text\" class=\"secondary-text\">(<b>Observação Interna:</b> {{card.text}})</span></div><div layout=\"row\" ng-if=\"card.publicacoes.length\"><md-menu><md-button class=\"md-icon-button\" ng-mouseenter=\"$mdMenu.open()\" style=\"margin: 0px; padding: 0px; height: 24px; line-height: 24px; min-height: 24px;\"><md-icon md-font-icon=\"icon-attachment\" class=\"s24\"></md-icon></md-button><md-menu-content width=\"4\" ng-mouseleave=\"$mdMenu.close()\"><md-menu-item ng-repeat=\"publicacao in card.publicacoes\"><md-button class=\"mt-0\" ng-disabled=\"!card.valid\" stf-visualizador-basico=\"publicacao.url\" ng-if=\"publicacao.visualizar\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"s16\"></md-icon>{{publicacao.nome}}</md-button><md-button class=\"mt-0\" ng-disabled=\"!card.valid\" download-link=\"publicacao.url\" ng-if=\"!publicacao.visualizar\" target=\"_blank\"><md-icon md-font-icon=\"icon-download\" class=\"s16\"></md-icon>{{publicacao.nome}}</md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-if=\"!card.valid || card.julgador\" class=\"mt-10\"><span ng-if=\"!card.valid\" class=\"text-boxed-light md-grey-bg m-0\" style=\"color: white; height: 23px;\"><b>Lançamento Indevido</b></span> <span ng-if=\"card.julgador\" class=\"text-boxed-light md-warn-bg m-0\" style=\"height: 23px;\"><b>{{card.julgador}}</b></span></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button class=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" layout-align=\"space-between\" layout-fill=\"\" flex=\"\"><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" ng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" layout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" ng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" ng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" ng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span ng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}}</span> <span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i class=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" translate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude=\"\"></div><div class=\"ms-stepper-controls\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span ng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" ng-transclude=\"\"></div></div>");
$templateCache.put("app/main/tarefas/minhas-tarefas/dialogs/assignee/assignee.html","<md-dialog class=\"assignee-dialog\" aria-label=\"Atribuir Tarefa\"><md-dialog-content><md-input-container class=\"md-block\"><md-switch ng-model=\"vm.filterBySetor\" ng-change=\"vm.changeFilterBySetor()\">{{vm.filterBySetor ? \'Usuários do meu setor\' : \'Todos os usuários\'}}</md-switch></md-input-container><md-input-container class=\"md-block\"><md-autocomplete md-no-cache=\"\" md-items=\"user in vm.filterUsers(searchText) | orderBy: \'nome\'\" md-item-text=\"user.nome\" md-selected-item=\"vm.assignee\" md-search-text=\"searchText\" md-require-match=\"\" md-min-length=\"0\" md-clear-button=\"true\" md-autofocus=\"false\" placeholder=\"Nenhum usuário selecionado\" md-selected-item-change=\"vm.changeAssignee()\" flex=\"\"><md-item-template><span ng-bind=\"user.nome\"></span></md-item-template><md-not-found><span>Nenhum usuário encontrado</span></md-not-found></md-autocomplete></md-input-container></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.FECHAR\">Fechar</span></md-button><md-button ng-click=\"vm.assignTasks()\" id=\"atribuir-tarefas\" command=\"vm.cmd\" class=\"md-accent md-raised\" focus-if=\"vm.assignee\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.ATRIBUIR\">Atribuir</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tarefas/minhas-tarefas/dialogs/assignee-group/assignee-group.html","<md-dialog class=\"assignee-dialog\" aria-label=\"Atribuir Grupo\"><md-dialog-content><md-autocomplete md-items=\"group in vm.filterGroups(searchText) | orderBy: \'nomeArvore\'\" md-item-text=\"group.nomeArvore\" md-selected-item=\"vm.assigneeGroup\" md-search-text=\"searchText\" md-require-match=\"\" md-min-length=\"0\" md-clear-button=\"true\" md-autofocus=\"false\" placeholder=\"Nenhum grupo selecionado\" md-selected-item-change=\"vm.changeAssigneeGroup()\" flex=\"\"><md-item-template><span ng-bind=\"group.nomeArvore\"></span></md-item-template><md-not-found><span>Nenhum grupo encontrado</span></md-not-found></md-autocomplete></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.FECHAR\">FECHAR</span></md-button><md-button ng-click=\"vm.assignGroupTasks()\" id=\"atribuir-tarefas-grupo\" command=\"vm.cmd\" class=\"md-accent md-raised\" focus-if=\"vm.assigneeGroup\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.ATRIBUIR-GRUPO\">Atribuir grupo</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tarefas/minhas-tarefas/dialogs/cancellation/cancellation.html","<md-dialog class=\"cancellation-dialog\" aria-label=\"Cancelar Tarefa\"><md-dialog-content><div class=\"mt-16 mb-0\" layout=\"column\"><md-input-container class=\"labelJustificativa\"><textarea name=\"reason\" ng-model=\"vm.cmd.reason\" placeholder=\"Justificativa do cancelamento\" aria-label=\"Justificativa do cancelamento\" id=\"iptReason\" md-maxlength=\"500\" maxlength=\"500\" required=\"\">\n					</textarea></md-input-container></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.FECHAR\">Fechar</span></md-button><md-button ng-click=\"vm.cancelTasks()\" id=\"cancelar-tarefas\" command=\"vm.cmd\" class=\"mr-0 md-raised md-accent\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.CANCELAR-TAREFAS\">Confirmar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tarefas/minhas-tarefas/dialogs/exportar/exportar-tarefas-dialog.html","<md-dialog id=\"dialog-exportar-pesquisa\" style=\"max-height: 100%;\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Exportar Resultados</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.fechar()\"><md-icon aria-label=\"fechar\" md-svg-src=\"custom_assets/icons/ic_close_24px.svg\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"pb-10 pt-15\"><div layout=\"column\" layout-gt-xs=\"column\" layout-align=\"right right\"><label>Tipo de Exportação:</label><md-input-container><md-radio-group ng-model=\"vm.formato\" layout=\"row\" layout-align=\"center center\"><md-radio-button value=\"CSV\"><md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon>CSV</md-radio-button><md-radio-button value=\"Excel\" class=\"md-primary\"><md-icon md-font-icon=\"icon-file-excel\" class=\"icon\"></md-icon>Excel</md-radio-button></md-radio-group></md-input-container></div><div layout=\"column\" layout-gt-xs=\"column\" layout-align=\"right right\" style=\"min-width: 400px;\"><md-list ng-cloak=\"\"><md-subheader class=\"md-no-sticky\">Campos para Exportação:</md-subheader><md-list-item ng-repeat=\"item in vm.camposExportacao\"><p class=\"pr-20\">{{item.descricao}}</p><md-checkbox class=\"md-secondary\" ng-model=\"item.isAtivo\" ng-model-options=\"{trackBy: \'$value.descricao\'}\"></md-checkbox></md-list-item></md-list></div><div class=\"mb-8 mt-8\" layout=\"row\" layout-align=\"end center\" layout-wrap=\"\"><div ng-if=\"vm.exportando\" layout=\"row\" layout-align=\"center center\" flex=\"\"><div class=\"progress-container\"><md-progress-circular class=\"md-hue-2 indicator\" md-diameter=\"30px\"></md-progress-circular></div></div><md-button class=\"mr-0 md-raised\" id=\"fechar\" ng-click=\"vm.fechar()\">Cancelar</md-button><md-button class=\"mr-0 md-raised md-accent\" id=\"exportar-historico-tarefas\" ng-click=\"vm.exportarHistoricoTarefas(vm.formato)\" ng-disabled=\"!vm.isValid()\" stf-processing=\"\">Exportar</md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/tarefas/minhas-tarefas/dialogs/notes/notes.html","<md-dialog class=\"notes-dialog\" aria-label=\"Anotar Tarefa\"><md-dialog-content><div class=\"mt-16 mb-0\" layout=\"column\"><md-input-container class=\"labelNota\"><textarea name=\"notes\" ng-model=\"vm.cmd.notes\" placeholder=\"Anotação\" aria-label=\"Anotação\" id=\"iptNotes\" md-maxlength=\"500\" maxlength=\"500\" required=\"\">\n                    </textarea></md-input-container></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.FECHAR\">Fechar</span></md-button><md-button ng-click=\"vm.deleteTaskNotes()\" class=\"md-warn md-raised\" ng-if=\"vm.canDelete\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.EXCLUIR\">Excluir</span></md-button><md-button ng-click=\"vm.annotateTask()\" id=\"anotar-tarefa\" command=\"vm.cmd\" class=\"mr-0 md-accent md-raised\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.SALVAR\">Salvar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tarefas/minhas-tarefas/dialogs/tags/assign-tags.html","<md-dialog class=\"tags-dialog\" aria-label=\"Rotular Tarefas\"><h2 class=\"md-title ml-20\">Adicionar rótulos</h2><md-dialog-content><div class=\"mt-16 mb-0\" layout=\"column\"><md-input-container class=\"labelNota\"><md-select ng-model=\"vm.cmd.tags\" placeholder=\"Rótulos\" class=\"md-no-underline\" multiple=\"\" ng-disabled=\"(vm.tags | filter:{ origem: \'!AUTOMATICA\' }).length === 0\"><md-option ng-value=\"tag.id\" ng-repeat=\"tag in ::vm.tags | filter:{ origem: \'!AUTOMATICA\' }\">{{tag.name}}</md-option></md-select><ng-messages ng-if=\"(vm.tags | filter:{ origem: \'!AUTOMATICA\' }).length === 0\">Nenhum rótulo para selecionar</ng-messages></md-input-container></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.FECHAR\">Fechar</span></md-button><md-button ng-click=\"vm.addtagsTasks()\" id=\"assign-tasks\" class=\"mr-0 md-accent md-raised\"><span>Adicionar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tarefas/minhas-tarefas/dialogs/tags/create-tag.html","<md-dialog class=\"tags-dialog\" aria-label=\"Criar rótulo\"><h2 class=\"md-title ml-20\">Criar novo rótulo</h2><md-dialog-content><div class=\"mt-16 mb-0\" layout=\"column\"><div><input type=\"color\" ng-required=\"true\" ng-model=\"vm.color\"></div><md-input-container class=\"labelName\"><label>Nome</label> <input maxlength=\"20\" ng-required=\"true\" ng-model=\"vm.name\"></md-input-container><md-input-container class=\"labelTooltip\"><label>Descrição</label> <input type=\"text\" ng-model=\"vm.tooltip\" ng-required=\"false\" maxlength=\"200\"></md-input-container><md-input-container show-if-has-permission=\"rotulador-multiplo-setores\"><md-select ng-model=\"vm.tenantsSelects\" style=\"width: 100%;\" md-on-close=\"vm.nameTenant = \'\';\" multiple=\"\" placeholder=\"Setores\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.tenants | filter:vm.nameTenant\">{{item.codigo}} - {{item.nome}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.FECHAR\">Fechar</span></md-button><md-button ng-click=\"vm.createTag()\" ng-disabled=\"!vm.name || vm.name.length === 0\" id=\"criar-rotulo-tarefa\" class=\"mr-0 md-accent md-raised\"><span>Criar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tarefas/minhas-tarefas/dialogs/tags/remove-tags.html","<md-dialog class=\"tags-dialog\" aria-label=\"Remover rótulos\"><h2 class=\"md-title ml-20\">Remover rótulos</h2><md-dialog-content><div class=\"mt-16 mb-0\" layout=\"column\"><md-input-container class=\"labelTag\"><md-select ng-model=\"vm.selectedTags\" placeholder=\"Rótulos\" class=\"md-no-underline\" multiple=\"\" ng-disabled=\"(vm.tags | filter:{ origem: \'!AUTOMATICA\' }).length === 0\"><md-option ng-value=\"tag.id\" ng-repeat=\"tag in ::vm.tags | filter:{ origem: \'!AUTOMATICA\' }\">{{tag.name}}</md-option></md-select><ng-messages ng-if=\"(vm.tags | filter:{ origem: \'!AUTOMATICA\' }).length === 0\">Nenhum rótulo para selecionar</ng-messages></md-input-container></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.FECHAR\">Fechar</span></md-button><md-button ng-click=\"vm.removeTags()\" id=\"rotular-tarefa\" ng-disabled=\"vm.selectedTags.length === 0\" class=\"mr-0 md-accent md-raised\"><span>Remover</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tarefas/minhas-tarefas/dialogs/tags/tags.html","<md-dialog class=\"tags-dialog\" aria-label=\"Rotular Tarefa\"><h2 class=\"md-title ml-20\">Adicionar rótulos na tarefa</h2><md-dialog-content><div class=\"mt-16 mb-0\" layout=\"column\"><md-input-container class=\"labelNota\"><md-select ng-model=\"vm.cmd.tags\" placeholder=\"Rótulos\" class=\"md-no-underline\" multiple=\"\" ng-disabled=\"(vm.tags | filter:{ origem: \'!AUTOMATICA\' }).length === 0\"><md-option ng-value=\"tag.id\" ng-repeat=\"tag in ::vm.tags | filter:{ origem: \'!AUTOMATICA\' }\">{{tag.name}}</md-option></md-select><ng-messages ng-if=\"(vm.tags | filter:{ origem: \'!AUTOMATICA\' }).length === 0\">Nenhum rótulo para selecionar</ng-messages></md-input-container></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.FECHAR\">Fechar</span></md-button><md-button ng-click=\"vm.tagTask()\" id=\"rotular-tarefa\" command=\"vm.cmd\" class=\"mr-0 md-accent md-raised\"><span>Adicionar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tarefas/minhas-tarefas/dialogs/tags/unassign-tags.html","<md-dialog class=\"tags-dialog\" aria-label=\"Remover rótulo Tarefa\"><h2 class=\"md-title ml-20\">Remover rótulos</h2><md-dialog-content><div class=\"mt-16 mb-0\" layout=\"column\"><md-input-container class=\"labelNota\"><md-select ng-model=\"vm.cmd.tags\" placeholder=\"Rótulos\" class=\"md-no-underline\" multiple=\"\" ng-disabled=\"(vm.tags | filter:{ origem: \'!AUTOMATICA\' }).length === 0\"><md-option ng-value=\"tag.id\" ng-repeat=\"tag in ::vm.tags | filter:{ origem: \'!AUTOMATICA\' }\">{{tag.name}}</md-option></md-select><ng-messages ng-if=\"(vm.tags | filter:{ origem: \'!AUTOMATICA\' }).length === 0\">Nenhum rótulo para selecionar</ng-messages></md-input-container></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.FECHAR\">Fechar</span></md-button><md-button ng-click=\"vm.unassigntagsTasks()\" id=\"unassign-tasks\" class=\"mr-0 md-accent md-raised\"><span>Remover</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tarefas/minhas-tarefas/dialogs/tags/update-tags.html","<md-dialog class=\"tags-dialog\" aria-label=\"Alterar rótulo\"><h2 class=\"md-title ml-20\">Alterar rótulo</h2><md-dialog-content><div class=\"mt-16 mb-0\" layout=\"column\"><md-input-container class=\"labelTag\"><md-select ng-model=\"vm.selectedTag\" ng-change=\"vm.selectTag()\" placeholder=\"Rótulos\" class=\"md-no-underline\" ng-disabled=\"(vm.tags | filter:{ origem: \'!AUTOMATICA\' }).length === 0\"><md-option ng-value=\"tag\" ng-repeat=\"tag in ::vm.tags | filter:{ origem: \'!AUTOMATICA\' }\">{{tag.name}}</md-option></md-select><ng-messages ng-if=\"(vm.tags | filter:{ origem: \'!AUTOMATICA\' }).length === 0\">Nenhum rótulo para selecionar</ng-messages></md-input-container></div><div ng-if=\"!!vm.selectedTag\" layout=\"column\"><div><input type=\"color\" ng-model=\"vm.color\" ng-required=\"true\"></div><md-input-container><label>Nome</label> <input type=\"text\" ng-model=\"vm.name\" ng-required=\"true\" maxlength=\"20\"></md-input-container><md-input-container><label>Descrição</label> <input type=\"text\" ng-model=\"vm.tooltip\" ng-required=\"false\" maxlength=\"200\"></md-input-container></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.closeDialog()\" class=\"md-primary\"><span translate=\"TAREFAS.MINHAS-TAREFAS.ACOES.FECHAR\">Fechar</span></md-button><md-button ng-click=\"vm.updateTag()\" id=\"editar-rotulo-tarefa\" ng-disabled=\"!vm.selectedTag\" class=\"mr-0 md-accent md-raised\"><span>Alterar</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/tarefas/minhas-tarefas/sidenavs/main/historico-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\" translate=\"TAREFAS.MINHAS-TAREFAS.HISTORICO\">Histórico</span></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"navigation-simple\" layout=\"column\" id=\"filtros\"><div class=\"mt-10\"></div><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ATIVAS\" ng-click=\"vm.openActiveTasks()\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-refresh\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.ATIVAS\">Tarefas ativas</span></div></md-button><div class=\"item subheader clear\" layout=\"row\" layout-align=\"space-between center\" flex=\"\"><span translate=\"TAREFAS.MINHAS-TAREFAS.FILTROS\">Filtros</span><md-button ng-click=\"vm.clearFilters()\"><md-icon md-font-icon=\"icon-broom\" class=\"s16\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.LIMPAR\">Limpar</span></md-tooltip></md-button></div><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.MINHAS-TAREFAS\" ng-click=\"vm.toggleArrayFilter(\'assignee\', vm.userLogged)\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assignee\', vm.userLogged)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.MINHAS-TAREFAS\">Minhas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assignee: vm.userLogged}, true) }}</span></div></md-button><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.PRIORIZADAS\" ng-click=\"vm.toggleFilter(\'priority\', true)\" ng-class=\"{\'selected\':vm.taskFilters.priority.active}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"red-600-fg s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.PRIORIZADAS\">Priorizadas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({priority: true}) }}</span></div></md-button><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.NAO-ATRIBUIDAS\" ng-click=\"vm.toggleArrayFilter(\'assignee\', null)\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assignee\', null)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-outline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.NAO-ATRIBUIDAS\">Não Atribuídas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assignee: null}) }}</span></div></md-button><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ATRIBUIDAS\" ng-click=\"vm.toggleArrayFilter(\'assignee\', \'!!\')\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assignee\', \'!!\')}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.ATRIBUIDAS\">Atribuídas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assignee: \'!!\'}) }}</span></div></md-button><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.NAO-AGRUPADAS\" ng-click=\"vm.toggleArrayFilter(\'assigneeGroup\', null)\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assigneeGroup\', null)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple-outline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.NAO-AGRUPADAS\">Não Agrupadas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assigneeGroup: null}) }}</span></div></md-button><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.AGRUPADAS\" ng-click=\"vm.toggleArrayFilter(\'assigneeGroup\', \'!!\')\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assigneeGroup\', \'!!\')}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.AGRUPADAS\">Agrupadas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assigneeGroup: \'!!\'}) }}</span></div></md-button><md-button class=\"item\" aria-label=\"Concluídas\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.CONCLUIDAS\" ng-click=\"vm.toggleFilter(\'completed\', true)\" ng-class=\"{\'selected\':vm.taskFilters.completed.active}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-check\" class=\"green-600-fg s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.CONCLUIDAS\">Concluídas</span> <span flex=\"\" layout=\"row\" layout-align=\"end center\" ng-if=\"!vm.isTasksCompletedLoaded\"><md-progress-circular id=\"tasks-completed-progress\" class=\"md-primary\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular></span> <span flex=\"\" class=\"secondary-text h5 text-right\" ng-if=\"vm.isTasksCompletedLoaded\">{{ vm.countTasksWithFilter({completed: true}) }}</span></div></md-button><md-button class=\"item\" aria-label=\"Canceladas\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.CANCELADAS\" ng-click=\"vm.toggleFilter(\'cancellation\', \'!!\')\" ng-class=\"{\'selected\':vm.taskFilters.cancellation.active}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cancel\" class=\"black-fg s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.CANCELADAS\">Canceladas</span> <span flex=\"\" layout=\"row\" layout-align=\"end center\" ng-if=\"!vm.isTasksCanceledLoaded\"><md-progress-circular id=\"tasks-canceled-progress\" class=\"md-primary\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular></span> <span flex=\"\" class=\"secondary-text h5 text-right\" ng-if=\"vm.isTasksCanceledLoaded\">{{ vm.countTasksWithFilter({cancellation: {$:\'\'} }) }}</span></div></md-button><div class=\"item subheader\" ng-init=\"vm.showGroups = vm.hasFilteredItems(\'assigneeGroup\', vm.userGroups)\" ng-click=\"vm.showGroups = !vm.showGroups\" ng-if=\"vm.userGroups.length > 0\" layout=\"row\" layout-align=\"start center\"><i class=\"s16\" ng-class=\"{\'icon-minus\': vm.showGroups, \'icon-plus\': !vm.showGroups}\"></i> <span translate=\"TAREFAS.MINHAS-TAREFAS.GRUPOS\">Grupos</span></div><md-button class=\"item\" ng-if=\"vm.showGroups\" ng-repeat=\"group in vm.userGroups track by group.id\" ng-click=\"vm.toggleArrayFilter(\'assigneeGroup\', group.id)\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assigneeGroup\', group.id)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"black-fg s16\"></md-icon><span class=\"title\">{{ ::group.nome }}</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assigneeGroup: group.id}, true) }}</span></div><md-tooltip ng-if=\"vm.groupNameParent(group)\" md-direction=\"right\">Grupo pai: {{ ::vm.groupNameParent(group) }}</md-tooltip></md-button><div class=\"item subheader\" ng-init=\"vm.showUsers = vm.hasFilteredItems(\'assignee\', vm.users)\" ng-click=\"vm.showUsers = !vm.showUsers\" ng-if=\"vm.users.length > 0\" layout=\"row\" layout-align=\"start center\"><i class=\"s16\" ng-class=\"{\'icon-minus\': vm.showUsers, \'icon-plus\': !vm.showUsers}\"></i> <span translate=\"TAREFAS.MINHAS-TAREFAS.USUARIOS\">Usuários</span></div><md-button class=\"item\" ng-if=\"vm.showUsers\" ng-repeat=\"user in vm.users\" ng-click=\"vm.toggleArrayFilter(\'assignee\', user)\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assignee\', user)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" class=\"black-fg s16\"></md-icon><md-tooltip ng-if=\"vm.usersNames.has(user)\">{{ ::vm.usersNames.get(user) }} ({{ ::user }})</md-tooltip><span class=\"title\" ng-if=\"vm.usersNames.has(user)\">{{ ::vm.usersNames.get(user) }}</span> <span class=\"title\" ng-if=\"!vm.usersNames.has(user)\">{{ ::user }}</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assignee: user}, true) }}</span></div></md-button><div class=\"item subheader\" ng-repeat-start=\"(type, value) in vm.tags | groupBy: \'type\'\" ng-init=\"vm.showTags[type] = vm.hasFilteredItems(\'tags\', value, true)\" ng-click=\"vm.showTags[type] = !vm.showTags[type]\" ng-if=\"vm.tags.length > 0\" layout=\"row\" layout-align=\"start center\"><i class=\"s16\" ng-class=\"{\'icon-minus\': vm.showTags[type], \'icon-plus\': !vm.showTags[type]}\"></i> <span>Rótulos {{ type !== \'AAA\' ? \'- \' + type : \'\' }}</span></div><md-button ng-repeat-end=\"\" class=\"tag item\" ng-if=\"vm.showTags[type]\" ng-repeat=\"tag in value track by tag.id\" ng-click=\"vm.toggleArrayFilter(\'tags\', tag, true)\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'tags\', tag, true)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : tag.color}\"></md-icon><span class=\"title\">{{ ::tag.name }}</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({tags: { id: tag.id } }, true) }}</span></div></md-button></div></md-content>");
$templateCache.put("app/main/tarefas/minhas-tarefas/sidenavs/main/main-sidenav.html","<div class=\"header\"><div class=\"logo\"><span class=\"logo-text text-left\" translate=\"TAREFAS.TAREFAS\">Tarefas</span><md-button class=\"md-icon-button\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.RECARREGAR\" ng-click=\"vm.refreshTasks()\"><md-icon md-font-icon=\"icon-refresh\" class=\"white-fg s16\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.RECARREGAR\">Recarregar</span></md-tooltip></md-button></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"navigation-simple\" layout=\"column\" id=\"filtros\"><div class=\"mt-10\"></div><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.HISTORICO\" ng-click=\"vm.openHistoricTasks()\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-history\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.HISTORICO\">Histórico</span></div></md-button><md-button class=\"item\" ng-click=\"vm.createTag()\" show-if-has-permission=\"criar-rotulo\" context=\"integracoes-tarefas\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-plus\" class=\"s16\"></md-icon><span class=\"title\">Criar rótulo</span></div></md-button><md-button class=\"item\" ng-click=\"vm.updateTags()\" show-if-has-permission=\"criar-rotulo\" context=\"integracoes-tarefas\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-pen\" class=\"s16\"></md-icon><span class=\"title\">Editar rótulos</span></div></md-button><md-button class=\"item\" ng-click=\"vm.removeTags()\" show-if-has-permission=\"excluir-rotulo\" context=\"integracoes-tarefas\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span class=\"title\">Remover rótulos</span></div></md-button><div class=\"item subheader clear\" layout=\"row\" layout-align=\"space-between center\" flex=\"\"><span translate=\"TAREFAS.MINHAS-TAREFAS.FILTROS\">Filtros</span><md-button ng-click=\"vm.clearFilters()\"><md-icon md-font-icon=\"icon-broom\" class=\"s16\"></md-icon><md-tooltip md-direction=\"top\"><span translate=\"TAREFAS.MINHAS-TAREFAS.LIMPAR\">Limpar</span></md-tooltip></md-button></div><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.MINHAS-TAREFAS\" ng-click=\"vm.toggleArrayFilter(\'assignee\', vm.userLogged)\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assignee\', vm.userLogged)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.MINHAS-TAREFAS\">Minhas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assignee: vm.userLogged}, true) }}</span></div></md-button><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.PRIORIZADAS\" ng-click=\"vm.toggleFilter(\'priority\', true)\" ng-class=\"{\'selected\':vm.taskFilters.priority.active}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"red-600-fg s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.PRIORIZADAS\">Priorizadas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({priority: true}) }}</span></div></md-button><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.NAO-ATRIBUIDAS\" ng-click=\"vm.toggleArrayFilter(\'assignee\', null)\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assignee\', null)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-outline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.NAO-ATRIBUIDAS\">Não Atribuídas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assignee: null}) }}</span></div></md-button><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ATRIBUIDAS\" ng-click=\"vm.toggleArrayFilter(\'assignee\', \'!!\')\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assignee\', \'!!\')}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.ATRIBUIDAS\">Atribuídas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assignee: \'!!\'}) }}</span></div></md-button><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.NAO-AGRUPADAS\" ng-click=\"vm.toggleArrayFilter(\'assigneeGroup\', null)\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assigneeGroup\', null)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple-outline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.NAO-AGRUPADAS\">Não Agrupadas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assigneeGroup: null}) }}</span></div></md-button><md-button class=\"item\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.AGRUPADAS\" ng-click=\"vm.toggleArrayFilter(\'assigneeGroup\', \'!!\')\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assigneeGroup\', \'!!\')}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TAREFAS.MINHAS-TAREFAS.AGRUPADAS\">Agrupadas</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assigneeGroup: \'!!\'}) }}</span></div></md-button><div class=\"item subheader\" ng-init=\"vm.showGroups = vm.hasFilteredItems(\'assigneeGroup\', vm.userGroups)\" ng-click=\"vm.showGroups = !vm.showGroups\" ng-if=\"vm.userGroups.length > 0\" layout=\"row\" layout-align=\"start center\"><i class=\"s16\" ng-class=\"{\'icon-minus\': vm.showGroups, \'icon-plus\': !vm.showGroups}\"></i> <span translate=\"TAREFAS.MINHAS-TAREFAS.GRUPOS\">Grupos</span></div><md-button class=\"item\" ng-if=\"vm.showGroups\" ng-repeat=\"group in vm.userGroups track by group.id\" ng-click=\"vm.toggleArrayFilter(\'assigneeGroup\', group.id)\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assigneeGroup\', group.id)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"black-fg s16\"></md-icon><span class=\"title\">{{ ::group.nome }}</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assigneeGroup: group.id}, true) }}</span></div><md-tooltip ng-if=\"vm.groupNameParent(group)\" md-direction=\"right\">Grupo pai: {{ ::vm.groupNameParent(group) }}</md-tooltip></md-button><div class=\"item subheader\" ng-init=\"vm.showUsers = vm.hasFilteredItems(\'assignee\', vm.users)\" ng-click=\"vm.showUsers = !vm.showUsers\" ng-if=\"vm.users.length > 0\" layout=\"row\" layout-align=\"start center\"><i class=\"s16\" ng-class=\"{\'icon-minus\': vm.showUsers, \'icon-plus\': !vm.showUsers}\"></i> <span translate=\"TAREFAS.MINHAS-TAREFAS.USUARIOS\">Usuários</span></div><md-button class=\"item\" ng-if=\"vm.showUsers\" ng-repeat=\"user in vm.users\" ng-click=\"vm.toggleArrayFilter(\'assignee\', user)\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'assignee\', user)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" class=\"black-fg s16\"></md-icon><md-tooltip ng-if=\"vm.usersNames.has(user)\">{{ ::vm.usersNames.get(user) }} ({{ ::user }})</md-tooltip><span class=\"title\" ng-if=\"vm.usersNames.has(user)\">{{ ::vm.usersNames.get(user) }}</span> <span class=\"title\" ng-if=\"!vm.usersNames.has(user)\">{{ ::user }}</span> <span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({assignee: user}, true) }}</span></div></md-button><div class=\"item subheader\" ng-repeat-start=\"(type, value) in vm.tags | orderBy: \'type\' | groupBy: \'type\'\" ng-init=\"vm.showTags[type] = vm.hasFilteredItems(\'tags\', value, true)\" ng-click=\"vm.showTags[type] = !vm.showTags[type]\" ng-if=\"vm.tags.length > 0\" layout=\"row\" layout-align=\"start center\"><i class=\"s16\" ng-class=\"{\'icon-minus\': vm.showTags[type], \'icon-plus\': !vm.showTags[type]}\"></i> <span>Rótulos {{ type !== \'AAA\' ? \'- \' + type : \'\' }}</span></div><md-button ng-repeat-end=\"\" class=\"tag item\" ng-if=\"vm.showTags[type]\" ng-repeat=\"tag in value | orderBy: \'name\' track by tag.id\" ng-class=\"{\'selected\':vm.isArrayFilterExists(\'tags\', tag, true)}\" ng-click=\"vm.toggleArrayFilter(\'tags\', tag, true)\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : tag.color}\"></md-icon><span class=\"title\">{{ ::tag.name }}</span><md-tooltip ng-if=\"!!tag.tooltip\">{{ ::tag.tooltip }}</md-tooltip><span flex=\"\" class=\"secondary-text h5 text-right\">{{ vm.countTasksWithFilter({tags: { id: tag.id } }, true) }}</span></div></md-button></div></md-content>");
$templateCache.put("app/main/tarefas/minhas-tarefas/views/list/historico-list.html","<div class=\"todo-items\"><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"task in vm.filteredTasks track by vm.taskTrack(task)\"><div layout=\"row\" layout-align=\"start start\" flex=\"\"><div class=\"mr-30\"></div><div class=\"info\" flex=\"\" ng-class=\"{\'completed\': task.completed, \'canceled\': task.cancellation}\"><div class=\"title\"><span flex=\"\" class=\"task-description\" data-task-title=\"{{ ::task.title }}\" data-task-information-id=\"{{ ::task.informationId }}\">{{ ::task.title }}</span><md-button class=\"md-icon-button\" md-no-ink=\"\" ng-if=\"!!task.notes\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.NOTAS\" aria-label=\"Notas\"><md-icon md-font-icon=\"icon-comment-text-outline\" class=\"s18 yellow-800-fg\" fo-tooltip=\"\" tooltip-template-url=\"tooltip-list-notes.html\" tooltip-position=\"right center\"></md-icon></md-button></div><div class=\"notes\" layout=\"row\" layout-align=\"start start\" flex=\"\"><div class=\"flex-45 layout-column\"><div><span><b>Criada em:</b> {{ ::vm.formatDate(task.startDate) }}</span></div><div ng-if=\"!!task.assignee\" layout-gt-md=\"row\" layout=\"column\"><span class=\"mr-10\" ng-if=\"!!task.claimDate\"><b>Atribuída em:</b> {{ vm.formatDate(task.claimDate) }}<span ng-if=\"!!task.assignor\">&nbsp;por {{ vm.getUserName(task.assignor) }}<md-tooltip ng-if=\"vm.usersNames.has(task.assignor)\">{{ vm.usersNames.get(task.assignor) }} ({{ task.assignor }})</md-tooltip></span></span> <span class=\"mr-10\"><b>Responsável:</b> {{ vm.getUserName(task.assignee) }}<md-tooltip ng-if=\"vm.usersNames.has(task.assignee)\">{{ vm.usersNames.get(task.assignee) }} ({{ task.assignee }})</md-tooltip></span></div><div ng-if=\"!!task.assigneeGroup\"><span><b>Grupo:</b> {{ vm.groupName(task.assigneeGroup) }}</span></div><div ng-if=\"!!task.completedDate && !task.cancellation\"><span class=\"mr-10\"><b>Completada em:</b> {{ ::vm.formatDate(task.completedDate) }}</span></div><div ng-if=\"!!task.cancellation\"><md-tooltip ng-if=\"vm.usersNames.has(task.cancellation.canceledBy)\">{{ vm.usersNames.get(task.cancellation.canceledBy) }} ({{ task.cancellation.canceledBy }})</md-tooltip><span><b>Cancelada em:</b> {{ ::vm.formatDate(task.cancellation.canceledDate) }} por {{ ::vm.getUserName(task.cancellation.canceledBy) }}</span></div><div ng-if=\"!!task.cancellation\"><span><b>Justificativa:</b> {{ ::task.cancellation.reason }}</span></div></div><div layout=\"column\" layout-align=\"start start\" ng-if=\"!!task.extraInfo\" class=\"info\" flex=\"\"><span ng-repeat=\"(chave, valor) in task.extraInfo\" ng-if=\"valor !== null && valor !== \'\'\"><b class=\"extraInfoTitle\">{{ ::chave }}:&nbsp;</b> <span class=\"extraInfo\" ng-if=\"vm.sizeMaxAllowed(valor)\">{{vm.sliceTextSize(valor)}}<span class=\"badgedExtraInfo\" ng-click=\"vm.openDialogExtraInfo(chave, valor)\">...<md-tooltip md-direction=\"top\" class=\"badgetTooltip\">{{vm.convertTextToCapitalize(\'Visualizar \' + chave)}}</md-tooltip></span></span> <span class=\"extraInfo\" ng-if=\"!vm.sizeMaxAllowed(valor)\">{{valor}}</span></span></div></div><div class=\"tags\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.taskViewExpanded && task.tags.length > 0\"><div class=\"tag\" layout=\"row\" layout-align=\"start center\" data-ng-repeat=\"tag in task.tags track by tag.id\"><div class=\"tag-color\" ng-style=\"{\'background-color\': tag.color}\"></div><div class=\"tag-label\">{{ ::tag.name }}</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"task.completed\" class=\"md-icon-button\" ng-disabled=\"true\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.CONCLUIDA\" aria-label=\"Concluída\"><md-icon md-font-icon=\"icon-check\" class=\"green-600-fg\"></md-icon><md-tooltip md-direction=\"top\">Realizada</md-tooltip></md-button><md-button ng-if=\"!!task.cancellation\" class=\"md-icon-button\" ng-disabled=\"true\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.CANCELADA\" aria-label=\"Cancelada\"><md-icon md-font-icon=\"icon-cancel\" class=\"black-fg\"></md-icon><md-tooltip md-direction=\"top\">Cancelada</md-tooltip></md-button></div></div></div></div><script id=\"tooltip-list-notes.html\" type=\"text/ng-template\"><span ng-bind=\"task.notes\"></span></script>");
$templateCache.put("app/main/tarefas/minhas-tarefas/views/list/list.html","<div class=\"todo-items\" ng-hide=\"vm.loadingTasks\"><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"task in vm.filteredTasks track by vm.taskTrack(task)\"><div layout=\"row\" layout-align=\"start start\" flex=\"\"><div><md-checkbox class=\"no-label pt-8\" ng-model=\"task.selected\" aria-label=\"selected\"></md-checkbox></div><div class=\"info\" flex=\"\" ng-class=\"{\'not-completed\': !task.priority, \'prioritized\': task.priority}\"><div class=\"title\"><span flex=\"\" class=\"task-description\" data-task-title=\"{{ ::task.title }}\" data-task-information-id=\"{{ ::task.informationId }}\">{{ ::task.title }}</span><md-button class=\"md-icon-button\" md-no-ink=\"\" ng-click=\"vm.setNotes(task)\" ng-if=\"!!task.notes || vm.canAnnotate\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.NOTAS\" aria-label=\"Notas\" ng-disabled=\"!!task.restricted\"><md-icon md-font-icon=\"icon-comment-plus-outline\" class=\"s18\" ng-if=\"!task.notes\"></md-icon><md-tooltip md-direction=\"top\" ng-if=\"!task.notes\">Adicionar nota</md-tooltip><md-icon md-font-icon=\"icon-comment-text-outline\" class=\"s18 yellow-800-fg\" ng-if=\"!!task.notes\" fo-tooltip=\"\" tooltip-template-url=\"tooltip-list-notes.html\" tooltip-position=\"right center\"></md-icon></md-button></div><div class=\"notes\" layout=\"row\" layout-align=\"start start\" flex=\"\"><div class=\"flex-45 layout-column\"><div><span><b>Criada em:</b> {{ ::vm.formatDate(task.startDate) }}</span></div><div ng-if=\"!!task.assignee\" layout-gt-md=\"row\" layout=\"column\"><span class=\"mr-10\" ng-if=\"!!task.claimDate\"><b>Atribuída em:</b> {{ vm.formatDate(task.claimDate) }} <span ng-if=\"!!task.assignor\">&nbsp;por {{ vm.getUserName(task.assignor) }}<md-tooltip ng-if=\"vm.usersNames.has(task.assignor)\">{{ vm.usersNames.get(task.assignor) }} ({{ task.assignor }})</md-tooltip></span></span> <span class=\"mr-10\"><b>Responsável:</b> {{ vm.getUserName(task.assignee) }}<md-tooltip ng-if=\"vm.usersNames.has(task.assignee)\">{{ vm.usersNames.get(task.assignee) }} ({{ task.assignee }})</md-tooltip></span></div><div ng-if=\"!!task.assigneeGroup\"><span><b>Grupo:</b> {{ vm.groupName(task.assigneeGroup) }}</span></div><div ng-if=\"!!task.draft\"><md-tooltip ng-if=\"vm.usersNames.has(task.draft.modifiedBy)\">{{ vm.usersNames.get(task.draft.modifiedBy) }} ({{ task.draft.modifiedBy }})</md-tooltip><span><b>Salva em:</b> {{ vm.formatDate(task.draft.modifiedDate) }} por {{ vm.getUserName(task.draft.modifiedBy) }}</span></div></div><div layout=\"column\" layout-align=\"start start\" ng-if=\"!!task.extraInfo\" class=\"info\" flex=\"\"><span ng-repeat=\"(chave, valor) in task.extraInfo\" ng-if=\"valor !== null && valor !== \'\'\"><b class=\"extraInfoTitle\">{{ ::chave }}:&nbsp;</b> <span class=\"extraInfo\" ng-if=\"vm.sizeMaxAllowed(valor)\">{{vm.sliceTextSize(valor)}}<span class=\"badgedExtraInfo\" ng-click=\"vm.openDialogExtraInfo(chave, valor)\">...<md-tooltip md-direction=\"top\" class=\"badgetTooltip\">{{vm.convertTextToCapitalize(\'Visualizar \' + chave)}}</md-tooltip></span></span> <span class=\"extraInfo\" ng-if=\"!vm.sizeMaxAllowed(valor)\">{{valor}}</span></span></div></div><div class=\"tags\" layout=\"row\" layout-wrap=\"\" layout-align=\"start center\" ng-if=\"vm.taskViewExpanded && task.tags.length > 0\"><div class=\"tag\" layout=\"column\" layout-align=\"start center\" data-ng-repeat=\"tag in task.tags track by tag.id\"><span layout=\"row\" layout-align=\"start center\" ng-if=\"tag.type !== \'Manuais\' || !vm.canRemoveTags\"><div class=\"tag-color\" ng-style=\"{\'background-color\': tag.color}\"></div><div class=\"tag-label\">{{ ::tag.name }}</div></span> <span layout=\"row\" layout-align=\"center center\" ng-if=\"tag.type === \'Manuais\' && vm.canRemoveTags\" ng-init=\"task.tagsActions[tag.id] = false\" ng-mouseleave=\"task.tagsActions[tag.id] = false\" ng-mouseenter=\"task.tagsActions[tag.id] = true\"><div class=\"tag-color\" ng-style=\"{\'background-color\': tag.color, \'opacity\': task.tagsActions[tag.id] ? 0 : 1}\"></div><div class=\"tag-label\" ng-style=\"{\'opacity\': task.tagsActions[tag.id] ? 0 : 1}\">{{ ::tag.name }}</div><span style=\"position: absolute;\" ng-show=\"task.tagsActions[tag.id]\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\" ng-click=\"vm.removeTag(task, tag)\"></md-icon></span></span></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.canTag\"><md-button class=\"md-icon-button\" aria-label=\"Adicionar tag\" ng-click=\"vm.setTags(task)\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon><md-tooltip md-direction=\"top\">Adicionar tag</md-tooltip></md-button></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.setPriority(task)\" ng-disabled=\"!vm.canPrioritize\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.PRIORIZADA\" aria-label=\"Priorizada\"><md-icon md-font-icon=\"icon-alert-circle\" ng-class=\"{\'red-600-fg\': task.priority}\"></md-icon><md-tooltip md-direction=\"top\">{{ task.priority ? \'Priorizada\' : \'Despriorizada\' }}</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.viewTask(task)\" ng-if=\"task.assignee != vm.userLogged && !task.restricted\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.VISUALIZAR\" aria-label=\"Visualizar tarefa\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip md-direction=\"top\">Visualizar tarefa sem assumir</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.openTask(task)\" ng-if=\"!task.readOnly && !task.restricted\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.ABRIR\" aria-label=\"Abrir tarefa\"><md-icon md-font-icon=\"icon-login\" class=\"blue-600-fg\"></md-icon><md-tooltip md-direction=\"top\">Abrir</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"!!task.restricted\" translate=\"\" translate-attr-aria-label=\"TAREFAS.MINHAS-TAREFAS.RESTRITA\" aria-label=\"Tarefa restrita\"><md-icon md-font-icon=\"icon-lock\"></md-icon><md-tooltip md-direction=\"top\">Tarefa restrita</md-tooltip></md-button></div></div></div></div><div class=\"loadmask\" ng-show=\"vm.loadingTasks\"><div class=\"loader-page\"><div class=\"asc-loadmask-body\" role=\"presentation\" tabindex=\"-1\"><div class=\"asc-loadmask-image\"></div><div class=\"asc-loadmask-title\">Carregando Tarefas</div></div></div></div><script id=\"tooltip-list-notes.html\" type=\"text/ng-template\"><span ng-bind=\"task.notes\"></span></script>");
$templateCache.put("app/main/tarefas/painel-de-fases/dialogs/card/card-dialog.html","<md-dialog class=\"card-dialog\" aria-label=\"Card Dialog\" ng-cloak=\"\"><md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-datepicker class=\"due-date-picker\" ng-model=\"vm.card.due\" ng-change=\"vm.calculateOverdue()\" md-placeholder=\"Due date\"></md-datepicker><md-menu md-offset=\"0 48\" class=\"labels\"><md-button class=\"md-icon-button\" aria-label=\"Label\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ROTULOS\" ng-click=\"vm.labelTabIndex = 0;$mdMenu.open($event)\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-label-outline\"></md-icon></md-button><md-menu-content class=\"labels-menu-content\" width=\"4\" ms-scroll=\"\"><md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height=\"\"><md-tab><md-tab-body><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Buscar rótulos...\" type=\"text\" ng-model=\"vm.labelSearchText\" autocomplete=\"off\" translate=\"\" translate-attr-placeholder=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.BUSCAR-ROTULOS\"></md-input-container></md-menu-item><md-menu-item class=\"label\" ng-repeat=\"label in vm.labels | filter: vm.filterLabel\"><md-button class=\"label-toggle-button\" md-prevent-menu-close=\"\" ng-class=\"\'md-\'+label.color+\'-bg\'\" ng-click=\"vm.toggleInArray(label.id, vm.card.idLabels)\" aria-label=\"Alternar rótulo\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ALTERNAR-ROTULO\"><div layout=\"row\" layout-align=\"space-between center\"><span>{{label.name}}</span> <i ng-if=\"vm.exists(label.id, vm.card.idLabels)\" class=\"icon-check s16\"></i></div></md-button><md-button class=\"md-icon-button label-edit-button\" md-prevent-menu-close=\"\" ng-click=\"vm.editLabelId = label.id; vm.labelTabIndex = 2\" aria-label=\"Editar rótulo\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.EDITAR-ROTULO\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button class=\"add-label-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 1\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ADICIONAR-NOVO-ROTULO\">Adicionar novo rótulo</span></md-button></md-menu-item></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"add-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 0\" aria-label=\"Back\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.VOLTAR\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex=\"\" translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ADICIONAR-NOVO-ROTULO\">Adicionar novo rótulo</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\"><form ng-submit=\"vm.addNewLabel(); vm.labelTabIndex = 0\" layout=\"column\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Nome do rótulo\" type=\"text\" ng-model=\"vm.newLabelName\" translate=\"\" translate-attr-placeholder=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.NOME-ROTULO\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i class=\"icon-check s18\" ng-if=\"vm.newLabelColor === palette\"></i></label></div><md-button type=\"submit\" md-prevent-menu-close=\"\" class=\"create-button md-accent md-raised\" aria-label=\"Criar\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.CRIAR\"><span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.CRIAR\">Criar</span></md-button></form></div></div></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 0\" aria-label=\"back\" translate=\"\" translate-attr-aria-label=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex=\"\" translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.EDITAR-ROTULO\">Edit Label</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.board.labels.getById(vm.editLabelId).name\" translate=\"\" translate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.board.labels.getById(vm.editLabelId).color\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i ng-if=\"vm.board.labels.getById(vm.editLabelId).color === palette\" class=\"icon-check s18\"></i></label></div><div layout=\"row\" layout-align=\"end center\" flex=\"\"><md-button class=\"remove-button md-icon-button\" type=\"submit\" md-prevent-menu-close=\"\" ng-click=\"vm.removeLabel(); vm.labelTabIndex=0\" aria-label=\"Remover\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div></md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><md-menu md-offset=\"0 48\" class=\"members\"><md-button class=\"md-icon-button\" aria-label=\"Membros\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.MEMBROS\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-account-multiple\"></md-icon></md-button><md-menu-content class=\"members-menu-content\" width=\"4\" ms-scroll=\"\"><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Procurar membro...\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.memberSearchText\" translate=\"\" translate-attr-placeholder=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.PROCURAR-MEMBRO\"></md-input-container></md-menu-item><md-menu-item class=\"member\" ng-repeat=\"member in vm.members | filter: vm.filterMember\"><md-button ng-click=\"vm.toggleInArray(member.id, vm.card.idMembers)\" md-prevent-menu-close=\"\" aria-label=\"toggle member\" translate=\"\" translate-attr-aria-label=\"SB.TOGGLE_MEMBER\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"avatar\"><p class=\"member-name\">{{ member.name }}</p></div><i class=\"icon-check s16\" ng-if=\"vm.exists(member.id, vm.card.idMembers)\"></i></div></md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"\" aria-label=\"Anexos\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ANEXOS\"><md-icon md-font-icon=\"icon-attachment\"></md-icon></md-button><md-menu md-offset=\"0 48px\" class=\"checklist\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"checklist\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.CHECKLIST\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-menu-content class=\"checklist-menu-content\" width=\"4\"><form ng-submit=\"vm.createCheckList()\" layout=\"column\" layout-align=\"start end\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Título da checklist\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.newCheckListTitle\" translate=\"\" translate-attr-placeholder=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.TITULO-CHECKLIST\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Adicionar Checklist\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ADICIONAR-CHECKLIST\"><span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ADICIONAR-CHECKLIST\">Adicionar Checklist</span></md-button></form></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"subscribe\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Inscricao\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.INSCRICAO\"><md-icon md-menu-origin=\"\" ng-if=\"vm.card.subscribed\" md-font-icon=\"icon-eye\"></md-icon><md-icon md-menu-origin=\"\" ng-if=\"!vm.card.subscribed\" md-font-icon=\"icon-eye-off\"></md-icon></md-button><md-menu-content class=\"subscribe-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.card.subscribed = !vm.card.subscribed\" aria-label=\"Inscrição\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.INSCRICAO\"><span ng-if=\"!vm.card.subscribed\" translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.INSCREVER\">Inscrever-se</span> <span ng-if=\"vm.card.subscribed\" translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.DESINSCREVER\">Desinscrever-se</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"options\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Options\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.OPCOES\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.removeCard()\" aria-label=\"Remover cartão\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-CARTAO\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target=\"\"></md-icon><span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-CARTAO\">Remover cartão</span></md-button></md-menu-item></md-menu-content></md-menu><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Fechar Diálogo\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.FECHAR-DIALOGO\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div class=\"card-breadcrumb\" layout=\"row\" layout-align=\"start center\"><span>{{vm.board.name}}</span> <i class=\"icon-menu-right\"></i> <span>{{vm.getCardList().name}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.card.subscribed\" class=\"card-subscribe s18\" md-font-icon=\"icon-eye\"></md-icon><div class=\"card-name\"><span editable-text=\"vm.card.name\">{{vm.card.name}}</span></div></div></div><md-datepicker ng-if=\"vm.card.due\" class=\"due-date-picker\" ng-model=\"vm.card.due\" ng-change=\"vm.calculateOverdue()\" md-placeholder=\"Due date\"></md-datepicker></div><div class=\"description\"><md-input-container class=\"md-block\"><label translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.DESCRICAO\">Descrição</label> <textarea ng-model=\"vm.card.description\" columns=\"1\" md-maxlength=\"150\" rows=\"5\"></textarea></md-input-container></div><div class=\"sections\"><div ng-if=\"vm.card.idLabels[0] || vm.card.idMembers[0]\" class=\"section\" layout=\"row\"><div ng-if=\"vm.card.idLabels[0]\" flex=\"\" class=\"labels\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-label-outline s18\"></i> <span class=\"section-title\" translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ROTULOS\">Rótulos</span></div><div class=\"section-content\"><md-chips class=\"label-chips\" ng-model=\"vm.card.idLabels\" md-autocomplete-snap=\"\" md-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedLabel\" md-search-text=\"vm.searchLabelText\" md-items=\"label in vm.labelQuerySearch(vm.searchLabelText)\" md-item-text=\"label.name\" placeholder=\"Buscar por um rótulo...\"><span md-highlight-text=\"vm.searchLabelText\">{{label.name}}</span></md-autocomplete><md-chip-template class=\"label-chip\" ng-class=\"\'md-\'+vm.board.labels.getById($chip).color+\'-bg\'\"><span>{{vm.board.labels.getById($chip).name}}</span></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div><div ng-if=\"vm.card.idMembers[0]\" flex=\"\" class=\"members\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span class=\"section-title\" translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.MEMBROS\">Membros</span></div><div class=\"section-content\"><md-chips class=\"member-chips\" ng-model=\"vm.card.idMembers\" md-autocomplete-snap=\"\" md-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedMember\" md-search-text=\"vm.searchText\" md-items=\"member in vm.memberQuerySearch(vm.searchText)\" md-item-text=\"member.name\" placeholder=\"Buscar por um membro...\"><span md-highlight-text=\"vm.searchText\">{{member.name}}</span></md-autocomplete><md-chip-template class=\"member-chip\"><img class=\"member-chip-avatar\" ng-src=\"{{vm.board.members.getById($chip).avatar}}\"><md-tooltip>{{vm.board.members.getById($chip).name}}</md-tooltip></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div></div><div ng-if=\"vm.card.attachments[0]\" class=\"section\"><div class=\"attachments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"section-title\" translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ANEXOS\">Anexos</span></div><div class=\"section-content\"><div class=\"attachment\" ng-repeat=\"item in vm.card.attachments\" ng-switch=\"item.type\"><div ng-switch-when=\"image\" layout=\"row\"><div class=\"attachment-preview md-whiteframe-2dp\" ng-style=\"{\'background-image\': \'url({{item.src}})\'}\"></div><div class=\"attachment-content\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span class=\"attachment-name\">{{item.name}}</span> <i ng-if=\"vm.card.idAttachmentCover === item.id\" class=\"icon-star yellow-700-fg attachment-is-cover s18\"></i></div><span class=\"attachment-time\">{{item.time}}</span><md-menu><md-button class=\"md-raised attachment-actions-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"attachment actions\"><span layout=\"row\" layout-align=\"center center\"><span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ACOES\">Ações</span> <i class=\"icon-chevron-down s20\"></i></span></md-button><md-menu-content><md-menu-item><md-button ng-click=\"vm.toggleCoverImage(item.id)\" aria-label=\"Alternar imagem de capa\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ALTERNAR-IMAGEM-CAPA\"><span ng-if=\"vm.card.idAttachmentCover !== item.id\" translate=\"\">Tornar imagem de capa</span> <span ng-if=\"vm.card.idAttachmentCover === item.id\" translate=\"\">Remover imagem de capa</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.removeAttachment(item)\" aria-label=\"Remover anexo\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-ANEXO\"><span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-ANEXO\">Remover Anexo</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-switch-when=\"link\" layout=\"row\"><div class=\"attachment-preview md-whiteframe-2dp\" layout=\"column\" layout-align=\"center center\"><span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.LINK\">LINK</span></div><div class=\"attachment-content\" layout=\"column\"><span class=\"attachment-url\">{{item.url}}</span> <span class=\"attachment-time\">{{item.time}}</span></div></div></div><md-button class=\"add-attachment-button\" aria-label=\"Adicionar Anexo\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ADICIONAR-ANEXO\"><div layout=\"row\" layout-align=\"start center\"><i class=\"icon-plus s20\"></i> <span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ADICIONAR-ANEXO\">Adicionar Anexo</span></div></md-button></div></div></div><div ng-if=\"vm.card.checklists\" class=\"section\" ng-repeat=\"checklist in vm.card.checklists\"><div class=\"checklist\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked s18\"></i> <span flex=\"\" class=\"section-title\" editable-text=\"checklist.name\">{{checklist.name}}</span><md-menu md-offset=\"0 48px\" class=\"options\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.removeChecklist(checklist)\" aria-label=\"Remover Checklist\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-CHECKLIST\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target=\"\"></md-icon><span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.REMOVER-CHECKLIST\">Remover Checklist</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"section-content\"><div class=\"checklist-progress\" layout=\"row\" layout-align=\"start center\"><span class=\"checklist-progress-value\">{{checklist.checkItemsChecked}} / {{checklist.checkItems.length}}</span><md-progress-linear class=\"md-accent checklist-progressbar\" md-mode=\"determinate\" value=\"{{100 * checklist.checkItemsChecked / checklist.checkItems.length}}\"></md-progress-linear></div><div class=\"check-items\"><div class=\"check-item\" ng-repeat=\"checkItem in checklist.checkItems\"><md-checkbox ng-model=\"checkItem.checked\" ng-change=\"vm.updateCheckedCount(checklist)\" aria-label=\"{{checkItem.name}}\">{{checkItem.name}}</md-checkbox></div></div><form name=\"newCheckItemForm\" class=\"new-check-item-form\" ng-submit=\"vm.addCheckItem(vm[checklist.id].newCheckItem, checklist);vm[checklist.id].newCheckItem = \'\'\" layout=\"row\" layout-align=\"space-between center\"><md-input-container flex=\"\"><label layout=\"row\" layout-align=\"center\"><i class=\"icon-plus s18\"></i> <span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ADICIONAR-UM-ITEM\">Adicionar um item</span></label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm[checklist.id].newCheckItem\" md-maxlength=\"150\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Add\" translate=\"\" translate-attr-aria-label=\"SB.ADD\"><span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ADICIONAR\">Adicionar</span></md-button></form></div></div></div><div class=\"section\"><div class=\"comments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"section-title\" translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.COMENTARIOS\">Comentários</span></div><div class=\"section-content\"><form name=\"cardCommentForm\" ng-submit=\"vm.addNewComment(vm.newCommentText); vm.newCommentText =\'\'\" class=\"comment new-comment\" layout=\"column\" layout-align=\"start end\" no-validate=\"\"><div layout-fill=\"\" layout=\"row\"><img class=\"comment-member-avatar\" src=\"custom_assets/images/avatars/profile.jpg\"><md-input-container flex=\"\" md-no-float=\"\"><textarea ms-scroll=\"\" placeholder=\"Escreva um comentário\" ng-model=\"vm.newCommentText\" required=\"\" translate=\"\" translate-attr-placeholder=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ESCREVA-UM-COMENTARIO\"></textarea></md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"cardCommentForm.$invalid || cardCommentForm.$pristine\" aria-label=\"Adicionar\" translate=\"\" translate-attr-aria-label=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ADICIONAR\"><span translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ADICIONAR\">Adicionar</span></md-button></form><div class=\"comment\" layout=\"row\" ng-repeat=\"comment in vm.card.comments\"><img class=\"comment-member-avatar\" ng-src=\"{{vm.board.members.getById(comment.idMember).avatar}}\"><div layout=\"column\"><div class=\"comment-member-name\">{{vm.board.members.getById(comment.idMember).name}}</div><div class=\"comment-bubble\">{{comment.message}}</div><div class=\"comment-time secondary-text\">{{comment.time}}</div></div></div></div></div></div><div ng-if=\"vm.card.activities[0]\" class=\"section\"><div class=\"activities\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-format-list-bulleted s18\"></i> <span class=\"section-title\" translate=\"TAREFAS.PAINEL-DE-FASES.DIALOGO.ATIVIDADE\">Atividade</span></div><div class=\"section-content\"><div class=\"activity\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"activity in vm.card.activities\"><img class=\"activity-member-avatar\" ng-src=\"{{vm.board.members.getById(activity.idMember).avatar}}\"><div class=\"activity-member-name\">{{vm.board.members.getById(activity.idMember).name}}</div><div class=\"activity-message\">{{activity.message}}</div><div class=\"activity-time secondary-text\">{{activity.time}}</div></div></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/tarefas/painel-de-fases/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><span flex=\"\" class=\"menu-title\" translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.TITULO.FILTRAR-CARTOES\">Filtrar cartões</span><md-button ng-if=\"vm.filteringIsOn()\" ng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.FILTRO.LIMPAR-FILTROS\">Limpar filtros</span></md-tooltip></md-button></div></md-toolbar><md-content class=\"\" ms-scroll=\"\"><md-list><md-subheader class=\"md-no-sticky\" translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.FILTRO.POR-NOME\">Filtrar pelo nome</md-subheader><md-list-item><input flex=\"\" placeholder=\"Type Card Name\" type=\"text\" ng-model=\"vm.cardFilters.name\" translate=\"\" translate-attr-placeholder=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.FILTRO.DIGITE-NOME\"></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\" translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.FILTRO.POR-ROTULO\">Filtrar por rótulos</md-subheader><md-list-item class=\"label\" ng-repeat=\"label in vm.labels\" ng-click=\"vm.toggleInArray(label.id, vm.cardFilters.labels)\"><md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i class=\"icon-check s16\" ng-if=\"vm.exists(label.id, vm.cardFilters.labels)\"></i></md-list-item></md-list></md-content>");
$templateCache.put("app/main/tarefas/painel-de-fases/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button ng-hide=\"vm.selectedMenu === \'CONFIGURACOES\'\" class=\"md-icon-button\" ng-click=\"vm.selectedMenu = \'CONFIGURACOES\'\" aria-label=\"back\" translate=\"\" translate-attr-aria-label=\"SB.BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span flex=\"\" class=\"menu-title\" ng-attr-translate=\"{{ \'TAREFAS.PAINEL-DE-FASES.SIDEBAR.TITULO.\' + vm.selectedMenu }}\"></span></div></md-toolbar><md-content ng-show=\"vm.selectedMenu === \'CONFIGURACOES\'\" class=\"animate-slide-right settings\" ms-scroll=\"\" ms-sidenav-helper=\"\"><md-list><md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'COR-DO-PAINEL\'\"><md-icon md-font-icon=\"icon-format-color-fill\" class=\"s18\"></md-icon><p class=\"title\" translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.TITULO.COR-DO-PAINEL\">Cor do Painel</p></md-list-item><md-divider></md-divider><md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'ROTULOS\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-label\" class=\"s18\"></md-icon><p class=\"title\" translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.TITULO.ROTULOS\">Rótulos</p></md-list-item><md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'MEMBROS\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s18\"></md-icon><p class=\"title\" translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.TITULO.MEMBROS\">Membros</p></md-list-item></md-list></md-content><md-content ng-show=\"vm.selectedMenu === \'COR-DO-PAINEL\'\" class=\"animate-slide-left board-color-selection\"><div layout=\"column\" layout-fill=\"\" ng-include=\"\'app/main/tarefas/painel-de-fases/sidenavs/settings/menus/color/color-menu.html\'\" ng-controller=\"ColorMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'ROTULOS\'\" class=\"animate-slide-left labels\"><div layout=\"column\" layout-fill=\"\" ng-include=\"\'app/main/tarefas/painel-de-fases/sidenavs/settings/menus/labels/labels-menu.html\'\" ng-controller=\"LabelsMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'MEMBROS\'\" class=\"animate-slide-left members\"><div layout=\"column\" layout-fill=\"\" ng-include=\"\'app/main/tarefas/painel-de-fases/sidenavs/settings/menus/members/members-menu.html\'\" ng-controller=\"MembersMenuController as vm\"></div></md-content>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" ng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" ng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" ng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span ng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i class=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i></span> <span ng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i class=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" ng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude=\"\"></div><div class=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/tarefas/painel-de-fases/sidenavs/settings/menus/color/color-menu.html","<div class=\"header md-whiteframe-2dp\"><md-list><md-list-item class=\"selected-color\"><p class=\"title\" flex=\"\" translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.COR-DO-PAINEL.COR-SELECIONADA\">Cor selecionada:</p><div ng-if=\"!vm.board.settings.color\" class=\"preview md-background-bg md-hue-1\"></div><div ng-if=\"vm.board.settings.color\" class=\"preview\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\">{{vm.board.settings.color}}</div><md-button class=\"md-icon-button\" ng-click=\"vm.board.settings.color = \'\'\" aria-label=\"Default Color\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button></md-list-item></md-list></div><div flex=\"\" class=\"content\" ms-scroll=\"\" ms-sidenav-helper=\"\"><md-list><md-list-item class=\"color\" ng-repeat=\"(paletteName, palette) in vm.palettes\" ng-click=\"vm.board.settings.color = paletteName\" ng-class=\"\'md-\'+paletteName+\'-bg\'\" aria-label=\"color select\"><p flex=\"\">{{paletteName}}</p><i class=\"icon-check s16\" ng-if=\"paletteName === vm.board.settings.color\"></i></md-list-item></md-list></div>");
$templateCache.put("app/main/tarefas/painel-de-fases/sidenavs/settings/menus/labels/labels-menu.html","<md-list><md-subheader class=\"md-no-sticky\"><span translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.ROTULOS.ADICIONAR-ROTULO\">Adicionar rótulo</span></md-subheader><md-list-item class=\"label\"><div layout=\"row\" layout-align=\"start center\"><md-menu md-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" ng-class=\"vm.newLabelColor+\'-fg\'\" class=\"label-icon\"></md-icon></md-button><md-menu-content class=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" aria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i></label></div></md-menu-content></md-menu><span editable-text=\"vm.newLabelName\" e-form=\"newLabelForm\" onaftersave=\"vm.addNewLabel()\"></span><p flex=\"\" class=\"title new-label-form-button\" ng-click=\"newLabelForm.$show()\" ng-hide=\"newLabelForm.$visible\" translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.ROTULOS.DIGITE-NOVO-ROTULO\">Digite um novo rótulo</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"label\" ng-repeat=\"label in vm.board.labels\"><div layout=\"row\" layout-align=\"start center\"><md-menu md-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon></md-button><md-menu-content class=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"label.color\" ng-value=\"palette\" aria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i></label></div></md-menu-content></md-menu><p flex=\"\" class=\"title\" editable-text=\"label.name\">{{label.name}}</p><md-button ng-click=\"vm.removeLabel($event, label.id);\" class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-list-item></md-list>");
$templateCache.put("app/main/tarefas/painel-de-fases/sidenavs/settings/menus/members/members-menu.html","<md-list><md-subheader class=\"md-no-sticky\"><span translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.MEMBROS.ADICIONAR-NOVO-MEMBRO\">Adicionar novo membro</span></md-subheader><md-list-item class=\"add-new-member\"><form ng-submit=\"vm.newMember()\" layout=\"row\" layout-align=\"start center\"><input flex=\"\" placeholder=\"Digite o nome\" translate=\"\" translate-attr-placeholder=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.MEMBROS.DIGITE-NOME\" type=\"text\" ng-model=\"vm.newMemberSearchInput\"><md-button type=\"submit\" class=\"md-accent md-raised\" aria-label=\"Add New Member\" translate=\"TAREFAS.PAINEL-DE-FASES.SIDEBAR.MEMBROS.ADICIONAR\">Adicionar</md-button></form></md-list-item><md-divider></md-divider><md-list-item class=\"member\" ng-repeat=\"member in vm.board.members\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p class=\"member-name\">{{ member.name }}</p><md-button ng-click=\"vm.removeMember($event, member.id);\" class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></md-list-item></md-list>");}]);